/* tslint:disable */
/* eslint-disable */
/**
 * Raven CommodityManagement Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig, AxiosResponse } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError } from './base';

import { LoadingState } from '../../Types';

/**
 * 
 * @export
 * @interface ActualModel
 */
export interface ActualModel {
    /**
     * 
     * @type {number}
     * @memberof ActualModel
     */
    'actualId': number;
    /**
     * 
     * @type {CommodityModel}
     * @memberof ActualModel
     */
    'commodity': CommodityModel;
    /**
     * 
     * @type {CounterpartyModel}
     * @memberof ActualModel
     */
    'counterparty': CounterpartyModel;
    /**
     * 
     * @type {LocationModel}
     * @memberof ActualModel
     */
    'location': LocationModel;
    /**
     * 
     * @type {Array<ActualPriceModel>}
     * @memberof ActualModel
     */
    'actualPrices': Array<ActualPriceModel>;
    /**
     * 
     * @type {number}
     * @memberof ActualModel
     */
    'price': number;
    /**
     * 
     * @type {number}
     * @memberof ActualModel
     */
    'volume': number;
    /**
     * 
     * @type {Unit}
     * @memberof ActualModel
     */
    'unit': Unit;
}
/**
 * 
 * @export
 * @interface ActualPriceModel
 */
export interface ActualPriceModel {
    /**
     * 
     * @type {number}
     * @memberof ActualPriceModel
     */
    'actualPriceId': number;
    /**
     * 
     * @type {ComponentType}
     * @memberof ActualPriceModel
     */
    'componentType': ComponentType;
    /**
     * 
     * @type {number}
     * @memberof ActualPriceModel
     */
    'price': number;
    /**
     * 
     * @type {Unit}
     * @memberof ActualPriceModel
     */
    'unit': Unit;
}
/**
 * 
 * @export
 * @interface AddCommodityManagementSiteResponse
 */
export interface AddCommodityManagementSiteResponse {
    /**
     * 
     * @type {CommodityManagementSiteModel}
     * @memberof AddCommodityManagementSiteResponse
     */
    'site'?: CommodityManagementSiteModel;
}
/**
 * 
 * @export
 * @interface AddCommodityResponse
 */
export interface AddCommodityResponse {
    /**
     * 
     * @type {CommodityModel}
     * @memberof AddCommodityResponse
     */
    'commodity'?: CommodityModel;
}
/**
 * 
 * @export
 * @interface AddCompanyRequest
 */
export interface AddCompanyRequest {
    /**
     * 
     * @type {string}
     * @memberof AddCompanyRequest
     */
    'name': string;
    /**
     * 
     * @type {Array<MarketViewApplication>}
     * @memberof AddCompanyRequest
     */
    'marketViewApplications'?: Array<MarketViewApplication> | null;
    /**
     * 
     * @type {Array<CompanyProductAccessEntryModel>}
     * @memberof AddCompanyRequest
     */
    'productAccess'?: Array<CompanyProductAccessEntryModel> | null;
}
/**
 * 
 * @export
 * @interface AddCompanyResponse
 */
export interface AddCompanyResponse {
    /**
     * 
     * @type {CompanyModel}
     * @memberof AddCompanyResponse
     */
    'company'?: CompanyModel;
}
/**
 * 
 * @export
 * @interface AddCounterpartyResponse
 */
export interface AddCounterpartyResponse {
    /**
     * 
     * @type {CounterpartyModel}
     * @memberof AddCounterpartyResponse
     */
    'counterparty'?: CounterpartyModel;
}
/**
 * 
 * @export
 * @interface AddHedgePlanSeasonRequest
 */
export interface AddHedgePlanSeasonRequest {
    /**
     * 
     * @type {number}
     * @memberof AddHedgePlanSeasonRequest
     */
    'hedgePlanId': number;
}
/**
 * 
 * @export
 * @interface AddHedgePlanSeasonResponse
 */
export interface AddHedgePlanSeasonResponse {
    /**
     * 
     * @type {Array<HedgePlanSeasonModel>}
     * @memberof AddHedgePlanSeasonResponse
     */
    'rows'?: Array<HedgePlanSeasonModel> | null;
    /**
     * 
     * @type {HedgePlanSeasonModel}
     * @memberof AddHedgePlanSeasonResponse
     */
    'nextSeason'?: HedgePlanSeasonModel;
    /**
     * 
     * @type {Array<HedgePlanSeasonModel>}
     * @memberof AddHedgePlanSeasonResponse
     */
    'previousSeasons'?: Array<HedgePlanSeasonModel> | null;
}
/**
 * 
 * @export
 * @interface AddLocationResponse
 */
export interface AddLocationResponse {
    /**
     * 
     * @type {LocationModel}
     * @memberof AddLocationResponse
     */
    'location'?: LocationModel;
}
/**
 * 
 * @export
 * @interface AddMarketViewSavedQueryResponse
 */
export interface AddMarketViewSavedQueryResponse {
    /**
     * 
     * @type {MarkItViewSavedQueryModel}
     * @memberof AddMarketViewSavedQueryResponse
     */
    'savedQuery'?: MarkItViewSavedQueryModel;
}
/**
 * 
 * @export
 * @interface AddMarketViewUserFavoritedProductRequest
 */
export interface AddMarketViewUserFavoritedProductRequest {
    /**
     * 
     * @type {number}
     * @memberof AddMarketViewUserFavoritedProductRequest
     */
    'productId': number;
}
/**
 * 
 * @export
 * @interface AddMarketViewUserRequest
 */
export interface AddMarketViewUserRequest {
    /**
     * 
     * @type {string}
     * @memberof AddMarketViewUserRequest
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof AddMarketViewUserRequest
     */
    'stoneXUserGuid'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AddMarketViewUserRequest
     */
    'firstName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AddMarketViewUserRequest
     */
    'lastName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AddMarketViewUserRequest
     */
    'companyGuid'?: string | null;
    /**
     * 
     * @type {Array<MarketViewApplication>}
     * @memberof AddMarketViewUserRequest
     */
    'marketViewApplications'?: Array<MarketViewApplication> | null;
    /**
     * 
     * @type {Array<UserSiteAccessAddModel>}
     * @memberof AddMarketViewUserRequest
     */
    'commodityManagementUserSiteAccesses'?: Array<UserSiteAccessAddModel> | null;
}
/**
 * 
 * @export
 * @interface AddMarketViewUserResponse
 */
export interface AddMarketViewUserResponse {
    /**
     * 
     * @type {MarketViewUserModel}
     * @memberof AddMarketViewUserResponse
     */
    'user'?: MarketViewUserModel;
}
/**
 * 
 * @export
 * @interface AddMarketViewVolumeResponse
 */
export interface AddMarketViewVolumeResponse {
    /**
     * 
     * @type {number}
     * @memberof AddMarketViewVolumeResponse
     */
    'volumeId'?: number;
}
/**
 * 
 * @export
 * @interface AddNoteRequest
 */
export interface AddNoteRequest {
    /**
     * 
     * @type {string}
     * @memberof AddNoteRequest
     */
    'content': string;
}
/**
 * 
 * @export
 * @interface AddNoteResponse
 */
export interface AddNoteResponse {
    /**
     * 
     * @type {NoteModel}
     * @memberof AddNoteResponse
     */
    'note'?: NoteModel;
}
/**
 * 
 * @export
 * @interface AddPortfolioResponse
 */
export interface AddPortfolioResponse {
    /**
     * 
     * @type {PortfolioModel}
     * @memberof AddPortfolioResponse
     */
    'portfolio'?: PortfolioModel;
}
/**
 * 
 * @export
 * @interface AddTierResponse
 */
export interface AddTierResponse {
    /**
     * 
     * @type {TierModel}
     * @memberof AddTierResponse
     */
    'tier'?: TierModel;
}
/**
 * 
 * @export
 * @interface AgreeToMarketViewTermsAndConditionsRequest
 */
export interface AgreeToMarketViewTermsAndConditionsRequest {
    /**
     * 
     * @type {boolean}
     * @memberof AgreeToMarketViewTermsAndConditionsRequest
     */
    'agree': boolean;
    /**
     * 
     * @type {number}
     * @memberof AgreeToMarketViewTermsAndConditionsRequest
     */
    'version'?: number | null;
}
/**
 * 
 * @export
 * @interface Allocation
 */
export interface Allocation {
    /**
     * 
     * @type {number}
     * @memberof Allocation
     */
    'allocationId'?: number;
    /**
     * 
     * @type {string}
     * @memberof Allocation
     */
    'siteGuid': string;
    /**
     * 
     * @type {number}
     * @memberof Allocation
     */
    'allocationGroupId': number;
    /**
     * 
     * @type {number}
     * @memberof Allocation
     */
    'positionId': number;
    /**
     * 
     * @type {number}
     * @memberof Allocation
     */
    'volume': number;
    /**
     * 
     * @type {AllocationGroup}
     * @memberof Allocation
     */
    'allocationGroup'?: AllocationGroup;
    /**
     * 
     * @type {string}
     * @memberof Allocation
     */
    'createdAt'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Allocation
     */
    'modifiedAt'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Allocation
     */
    'deletedAt'?: string | null;
}
/**
 * 
 * @export
 * @interface AllocationGroup
 */
export interface AllocationGroup {
    /**
     * 
     * @type {number}
     * @memberof AllocationGroup
     */
    'allocationGroupId'?: number;
    /**
     * 
     * @type {string}
     * @memberof AllocationGroup
     */
    'siteGuid': string;
    /**
     * 
     * @type {string}
     * @memberof AllocationGroup
     */
    'allocationName': string;
    /**
     * 
     * @type {boolean}
     * @memberof AllocationGroup
     */
    'isComplete'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof AllocationGroup
     */
    'locationId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof AllocationGroup
     */
    'comments'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof AllocationGroup
     */
    'counterpartyId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof AllocationGroup
     */
    'commodityId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof AllocationGroup
     */
    'monthlyVolume'?: string | null;
    /**
     * 
     * @type {Unit}
     * @memberof AllocationGroup
     */
    'unit': Unit;
    /**
     * 
     * @type {Location}
     * @memberof AllocationGroup
     */
    'location'?: Location;
    /**
     * 
     * @type {Counterparty}
     * @memberof AllocationGroup
     */
    'counterparty'?: Counterparty;
    /**
     * 
     * @type {Commodity}
     * @memberof AllocationGroup
     */
    'commodity'?: Commodity;
    /**
     * 
     * @type {string}
     * @memberof AllocationGroup
     */
    'createdAt'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AllocationGroup
     */
    'modifiedAt'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AllocationGroup
     */
    'deletedAt'?: string | null;
}
/**
 * 
 * @export
 * @interface AllocationModel
 */
export interface AllocationModel {
    /**
     * 
     * @type {number}
     * @memberof AllocationModel
     */
    'allocationGroupId': number;
    /**
     * 
     * @type {string}
     * @memberof AllocationModel
     */
    'siteGuid': string;
    /**
     * 
     * @type {string}
     * @memberof AllocationModel
     */
    'allocationName': string;
    /**
     * 
     * @type {boolean}
     * @memberof AllocationModel
     */
    'isComplete': boolean;
    /**
     * 
     * @type {LocationModel}
     * @memberof AllocationModel
     */
    'location': LocationModel;
    /**
     * 
     * @type {string}
     * @memberof AllocationModel
     */
    'comments'?: string | null;
    /**
     * 
     * @type {Unit}
     * @memberof AllocationModel
     */
    'unit': Unit;
    /**
     * 
     * @type {CounterpartyModel}
     * @memberof AllocationModel
     */
    'counterparty': CounterpartyModel;
    /**
     * 
     * @type {CommodityModel}
     * @memberof AllocationModel
     */
    'commodity': CommodityModel;
    /**
     * 
     * @type {string}
     * @memberof AllocationModel
     */
    'monthlyVolume': string;
    /**
     * 
     * @type {Array<Allocation>}
     * @memberof AllocationModel
     */
    'allocations': Array<Allocation>;
    /**
     * 
     * @type {Array<PositionModel>}
     * @memberof AllocationModel
     */
    'positions': Array<PositionModel>;
    /**
     * 
     * @type {Array<BudgetModel>}
     * @memberof AllocationModel
     */
    'budgets': Array<BudgetModel>;
    /**
     * 
     * @type {Array<DeliveryModel>}
     * @memberof AllocationModel
     */
    'deliveries': Array<DeliveryModel>;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const Application = {
    Demeter: 'Demeter',
    FarmAdvantage: 'FarmAdvantage',
    MyStoneXMobile: 'MyStoneXMobile',
    CommodityManagement: 'CommodityManagement'
} as const;

export type Application = typeof Application[keyof typeof Application];


/**
 * 
 * @export
 * @enum {string}
 */

export const AuditTrailAction = {
    Added: 'Added',
    Deleted: 'Deleted',
    Modified: 'Modified'
} as const;

export type AuditTrailAction = typeof AuditTrailAction[keyof typeof AuditTrailAction];


/**
 * 
 * @export
 * @interface AuditTrailModel
 */
export interface AuditTrailModel {
    /**
     * 
     * @type {string}
     * @memberof AuditTrailModel
     */
    'date': string;
    /**
     * 
     * @type {string}
     * @memberof AuditTrailModel
     */
    'user': string;
    /**
     * 
     * @type {string}
     * @memberof AuditTrailModel
     */
    'entityType': string;
    /**
     * 
     * @type {number}
     * @memberof AuditTrailModel
     */
    'entity': number;
    /**
     * 
     * @type {AuditTrailAction}
     * @memberof AuditTrailModel
     */
    'userAction': AuditTrailAction;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof AuditTrailModel
     */
    'properties': { [key: string]: any; };
}
/**
 * 
 * @export
 * @interface BudgetModel
 */
export interface BudgetModel {
    /**
     * 
     * @type {number}
     * @memberof BudgetModel
     */
    'budgetId': number;
    /**
     * 
     * @type {string}
     * @memberof BudgetModel
     */
    'quoteDate'?: string | null;
    /**
     * 
     * @type {CommodityModel}
     * @memberof BudgetModel
     */
    'commodity': CommodityModel;
    /**
     * 
     * @type {BudgetPricingStrategyModel}
     * @memberof BudgetModel
     */
    'budgetPricingStrategy': BudgetPricingStrategyModel;
    /**
     * 
     * @type {CounterpartyModel}
     * @memberof BudgetModel
     */
    'counterparty': CounterpartyModel;
    /**
     * 
     * @type {LocationModel}
     * @memberof BudgetModel
     */
    'location': LocationModel;
    /**
     * 
     * @type {Array<LocationModel>}
     * @memberof BudgetModel
     */
    'locationHierarchy': Array<LocationModel>;
    /**
     * 
     * @type {ActualModel}
     * @memberof BudgetModel
     */
    'actual': ActualModel;
    /**
     * 
     * @type {Array<PositionModel>}
     * @memberof BudgetModel
     */
    'positions': Array<PositionModel>;
    /**
     * 
     * @type {BudgetRoundModel}
     * @memberof BudgetModel
     */
    'budgetRoundModel': BudgetRoundModel;
    /**
     * 
     * @type {Array<BudgetPriceModel>}
     * @memberof BudgetModel
     */
    'budgetPrices': Array<BudgetPriceModel>;
    /**
     * 
     * @type {number}
     * @memberof BudgetModel
     */
    'price': number;
    /**
     * 
     * @type {number}
     * @memberof BudgetModel
     */
    'volume': number;
    /**
     * 
     * @type {Unit}
     * @memberof BudgetModel
     */
    'unit': Unit;
    /**
     * 
     * @type {Currency}
     * @memberof BudgetModel
     */
    'currency': Currency;
    /**
     * 
     * @type {number}
     * @memberof BudgetModel
     */
    'marketPrice'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof BudgetModel
     */
    'isExpired'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof BudgetModel
     */
    'expirationDate'?: string | null;
    /**
     * 
     * @type {ContractDate}
     * @memberof BudgetModel
     */
    'budgetDate': ContractDate;
    /**
     * 
     * @type {ContractDate}
     * @memberof BudgetModel
     */
    'contractDate': ContractDate;
    /**
     * 
     * @type {number}
     * @memberof BudgetModel
     */
    'fiscalYear': number;
    /**
     * 
     * @type {string}
     * @memberof BudgetModel
     */
    'note'?: string | null;
    /**
     * 
     * @type {Array<ComponentMarketPrice>}
     * @memberof BudgetModel
     */
    'componentMarketPrices': Array<ComponentMarketPrice>;
    /**
     * 
     * @type {ContractDate}
     * @memberof BudgetModel
     */
    'effectiveContractDate': ContractDate;
}
/**
 * 
 * @export
 * @interface BudgetPriceModel
 */
export interface BudgetPriceModel {
    /**
     * 
     * @type {number}
     * @memberof BudgetPriceModel
     */
    'budgetPriceId': number;
    /**
     * 
     * @type {number}
     * @memberof BudgetPriceModel
     */
    'budgetId': number;
    /**
     * 
     * @type {ComponentType}
     * @memberof BudgetPriceModel
     */
    'componentType': ComponentType;
    /**
     * 
     * @type {number}
     * @memberof BudgetPriceModel
     */
    'price': number;
    /**
     * 
     * @type {Unit}
     * @memberof BudgetPriceModel
     */
    'unit': Unit;
}
/**
 * 
 * @export
 * @interface BudgetPricingComponentModel
 */
export interface BudgetPricingComponentModel {
    /**
     * 
     * @type {number}
     * @memberof BudgetPricingComponentModel
     */
    'budgetPricingComponentId': number;
    /**
     * 
     * @type {number}
     * @memberof BudgetPricingComponentModel
     */
    'budgetPricingStrategyId': number;
    /**
     * 
     * @type {ComponentType}
     * @memberof BudgetPricingComponentModel
     */
    'componentType': ComponentType;
    /**
     * 
     * @type {MarketPriceProvider}
     * @memberof BudgetPricingComponentModel
     */
    'marketPriceProvider'?: MarketPriceProvider;
    /**
     * 
     * @type {number}
     * @memberof BudgetPricingComponentModel
     */
    'marketViewProductId'?: number | null;
    /**
     * 
     * @type {HedgeSource}
     * @memberof BudgetPricingComponentModel
     */
    'hedgeSource': HedgeSource;
}
/**
 * 
 * @export
 * @interface BudgetPricingStrategyModel
 */
export interface BudgetPricingStrategyModel {
    /**
     * 
     * @type {number}
     * @memberof BudgetPricingStrategyModel
     */
    'budgetPricingStrategyId': number;
    /**
     * 
     * @type {string}
     * @memberof BudgetPricingStrategyModel
     */
    'name': string;
    /**
     * 
     * @type {number}
     * @memberof BudgetPricingStrategyModel
     */
    'commodityId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof BudgetPricingStrategyModel
     */
    'locationId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof BudgetPricingStrategyModel
     */
    'counterpartyId'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof BudgetPricingStrategyModel
     */
    'isLastDay': boolean;
    /**
     * 
     * @type {Unit}
     * @memberof BudgetPricingStrategyModel
     */
    'bushelUnit'?: Unit;
    /**
     * 
     * @type {number}
     * @memberof BudgetPricingStrategyModel
     */
    'bushelVolume'?: number | null;
    /**
     * 
     * @type {Unit}
     * @memberof BudgetPricingStrategyModel
     */
    'contractUnit'?: Unit;
    /**
     * 
     * @type {number}
     * @memberof BudgetPricingStrategyModel
     */
    'contractVolume'?: number | null;
    /**
     * 
     * @type {ElectricityType}
     * @memberof BudgetPricingStrategyModel
     */
    'electricityType'?: ElectricityType;
    /**
     * 
     * @type {Array<BudgetPricingComponentModel>}
     * @memberof BudgetPricingStrategyModel
     */
    'components': Array<BudgetPricingComponentModel>;
    /**
     * 
     * @type {Array<PositionPricingStrategyModel>}
     * @memberof BudgetPricingStrategyModel
     */
    'positionStrategies': Array<PositionPricingStrategyModel>;
}
/**
 * 
 * @export
 * @interface BudgetRoundModel
 */
export interface BudgetRoundModel {
    /**
     * 
     * @type {number}
     * @memberof BudgetRoundModel
     */
    'budgetRoundId': number;
    /**
     * 
     * @type {string}
     * @memberof BudgetRoundModel
     */
    'budgetRoundName': string;
    /**
     * 
     * @type {string}
     * @memberof BudgetRoundModel
     */
    'entryDate': string;
    /**
     * 
     * @type {boolean}
     * @memberof BudgetRoundModel
     */
    'isDefault': boolean;
}
/**
 * 
 * @export
 * @interface BudgetVarianceModel
 */
export interface BudgetVarianceModel {
    /**
     * 
     * @type {Array<VarianceComponent>}
     * @memberof BudgetVarianceModel
     */
    'components': Array<VarianceComponent>;
    /**
     * 
     * @type {number}
     * @memberof BudgetVarianceModel
     */
    'allInHedgedPrice': number;
    /**
     * 
     * @type {number}
     * @memberof BudgetVarianceModel
     */
    'allInHedgedValue': number;
    /**
     * 
     * @type {number}
     * @memberof BudgetVarianceModel
     */
    'allInHedgedVolume': number;
    /**
     * 
     * @type {number}
     * @memberof BudgetVarianceModel
     */
    'allInHedgedPercent': number;
    /**
     * 
     * @type {number}
     * @memberof BudgetVarianceModel
     */
    'budgetPrice': number;
    /**
     * 
     * @type {number}
     * @memberof BudgetVarianceModel
     */
    'budgetVolume': number;
    /**
     * 
     * @type {number}
     * @memberof BudgetVarianceModel
     */
    'marketPrice': number;
    /**
     * 
     * @type {number}
     * @memberof BudgetVarianceModel
     */
    'blendedPrice': number;
    /**
     * 
     * @type {number}
     * @memberof BudgetVarianceModel
     */
    'blendedValue': number;
    /**
     * 
     * @type {number}
     * @memberof BudgetVarianceModel
     */
    'budgetValue': number;
    /**
     * 
     * @type {number}
     * @memberof BudgetVarianceModel
     */
    'effectiveBudgetVolume': number;
    /**
     * 
     * @type {number}
     * @memberof BudgetVarianceModel
     */
    'hedgedValue': number;
    /**
     * 
     * @type {number}
     * @memberof BudgetVarianceModel
     */
    'marketValue': number;
    /**
     * 
     * @type {number}
     * @memberof BudgetVarianceModel
     */
    'openValue': number;
    /**
     * 
     * @type {number}
     * @memberof BudgetVarianceModel
     */
    'profitAndLossPrice': number;
    /**
     * 
     * @type {number}
     * @memberof BudgetVarianceModel
     */
    'profitAndLossValue': number;
    /**
     * 
     * @type {number}
     * @memberof BudgetVarianceModel
     */
    'varianceToBudgetPrice': number;
    /**
     * 
     * @type {number}
     * @memberof BudgetVarianceModel
     */
    'varianceToBudgetValue': number;
    /**
     * 
     * @type {number}
     * @memberof BudgetVarianceModel
     */
    'varianceToMarketPrice': number;
    /**
     * 
     * @type {number}
     * @memberof BudgetVarianceModel
     */
    'varianceToMarketValue': number;
    /**
     * 
     * @type {number}
     * @memberof BudgetVarianceModel
     */
    'markToMarketPrice': number;
    /**
     * 
     * @type {number}
     * @memberof BudgetVarianceModel
     */
    'markToMarketValue': number;
    /**
     * 
     * @type {number}
     * @memberof BudgetVarianceModel
     */
    'budgetId': number;
    /**
     * 
     * @type {string}
     * @memberof BudgetVarianceModel
     */
    'quoteDate'?: string | null;
    /**
     * 
     * @type {CommodityModel}
     * @memberof BudgetVarianceModel
     */
    'commodity': CommodityModel;
    /**
     * 
     * @type {BudgetPricingStrategyModel}
     * @memberof BudgetVarianceModel
     */
    'budgetPricingStrategy': BudgetPricingStrategyModel;
    /**
     * 
     * @type {CounterpartyModel}
     * @memberof BudgetVarianceModel
     */
    'counterparty': CounterpartyModel;
    /**
     * 
     * @type {LocationModel}
     * @memberof BudgetVarianceModel
     */
    'location': LocationModel;
    /**
     * 
     * @type {Array<LocationModel>}
     * @memberof BudgetVarianceModel
     */
    'locationHierarchy': Array<LocationModel>;
    /**
     * 
     * @type {ActualModel}
     * @memberof BudgetVarianceModel
     */
    'actual': ActualModel;
    /**
     * 
     * @type {Array<PositionModel>}
     * @memberof BudgetVarianceModel
     */
    'positions': Array<PositionModel>;
    /**
     * 
     * @type {BudgetRoundModel}
     * @memberof BudgetVarianceModel
     */
    'budgetRoundModel': BudgetRoundModel;
    /**
     * 
     * @type {Array<BudgetPriceModel>}
     * @memberof BudgetVarianceModel
     */
    'budgetPrices': Array<BudgetPriceModel>;
    /**
     * 
     * @type {number}
     * @memberof BudgetVarianceModel
     */
    'price': number;
    /**
     * 
     * @type {number}
     * @memberof BudgetVarianceModel
     */
    'volume': number;
    /**
     * 
     * @type {Unit}
     * @memberof BudgetVarianceModel
     */
    'unit': Unit;
    /**
     * 
     * @type {Currency}
     * @memberof BudgetVarianceModel
     */
    'currency': Currency;
    /**
     * 
     * @type {boolean}
     * @memberof BudgetVarianceModel
     */
    'isExpired'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof BudgetVarianceModel
     */
    'expirationDate'?: string | null;
    /**
     * 
     * @type {ContractDate}
     * @memberof BudgetVarianceModel
     */
    'budgetDate': ContractDate;
    /**
     * 
     * @type {ContractDate}
     * @memberof BudgetVarianceModel
     */
    'contractDate': ContractDate;
    /**
     * 
     * @type {number}
     * @memberof BudgetVarianceModel
     */
    'fiscalYear': number;
    /**
     * 
     * @type {string}
     * @memberof BudgetVarianceModel
     */
    'note'?: string | null;
    /**
     * 
     * @type {Array<ComponentMarketPrice>}
     * @memberof BudgetVarianceModel
     */
    'componentMarketPrices': Array<ComponentMarketPrice>;
    /**
     * 
     * @type {ContractDate}
     * @memberof BudgetVarianceModel
     */
    'effectiveContractDate': ContractDate;
}
/**
 * 
 * @export
 * @interface CalculateMatrixRequest
 */
export interface CalculateMatrixRequest {
    /**
     * 
     * @type {number}
     * @memberof CalculateMatrixRequest
     */
    'productId': number;
    /**
     * 
     * @type {string}
     * @memberof CalculateMatrixRequest
     */
    'startDate': string;
    /**
     * 
     * @type {MatrixStripType}
     * @memberof CalculateMatrixRequest
     */
    'matrixStripType': MatrixStripType;
    /**
     * 
     * @type {MatrixContractSettlement}
     * @memberof CalculateMatrixRequest
     */
    'contractSettlement': MatrixContractSettlement;
    /**
     * 
     * @type {boolean}
     * @memberof CalculateMatrixRequest
     */
    'weighted'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof CalculateMatrixRequest
     */
    'innerRange'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CalculateMatrixRequest
     */
    'outerRange'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CalculateMatrixRequest
     */
    'innerWeight'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CalculateMatrixRequest
     */
    'outerWeight'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CalculateMatrixRequest
     */
    'yearsBack'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof CalculateMatrixRequest
     */
    'applyPpi'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CalculateMatrixRequest
     */
    'aboveMedian'?: boolean;
    /**
     * 
     * @type {Array<MatrixTerm>}
     * @memberof CalculateMatrixRequest
     */
    'terms'?: Array<MatrixTerm> | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof CalculateMatrixRequest
     */
    'months'?: Array<number> | null;
    /**
     * 
     * @type {string}
     * @memberof CalculateMatrixRequest
     */
    'calculationDate'?: string | null;
    /**
     * 
     * @type {MatrixCalculationType}
     * @memberof CalculateMatrixRequest
     */
    'calculationType'?: MatrixCalculationType;
    /**
     * 
     * @type {Array<number>}
     * @memberof CalculateMatrixRequest
     */
    'selectedYears'?: Array<number> | null;
    /**
     * 
     * @type {number}
     * @memberof CalculateMatrixRequest
     */
    'startMonth'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof CalculateMatrixRequest
     */
    'includeForwardCurve'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CalculateMatrixRequest
     */
    'refreshCache'?: boolean;
    /**
     * 
     * @type {Array<MatrixVolumeModel>}
     * @memberof CalculateMatrixRequest
     */
    'volumes'?: Array<MatrixVolumeModel> | null;
}
/**
 * 
 * @export
 * @interface CalculateMatrixResponse
 */
export interface CalculateMatrixResponse {
    /**
     * 
     * @type {number}
     * @memberof CalculateMatrixResponse
     */
    'productId'?: number;
    /**
     * 
     * @type {string}
     * @memberof CalculateMatrixResponse
     */
    'startDate'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CalculateMatrixResponse
     */
    'applyPpi'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CalculateMatrixResponse
     */
    'weighted'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CalculateMatrixResponse
     */
    'aboveMedian'?: boolean;
    /**
     * 
     * @type {Array<MatrixTermResultModel>}
     * @memberof CalculateMatrixResponse
     */
    'results'?: Array<MatrixTermResultModel> | null;
    /**
     * 
     * @type {Array<MatrixGraphPointModel>}
     * @memberof CalculateMatrixResponse
     */
    'graphPoints'?: Array<MatrixGraphPointModel> | null;
    /**
     * 
     * @type {Array<MatrixYearPriceSeriesModel>}
     * @memberof CalculateMatrixResponse
     */
    'yearPriceSeries'?: Array<MatrixYearPriceSeriesModel> | null;
    /**
     * 
     * @type {Array<MatrixForwardCurveSeriesModel>}
     * @memberof CalculateMatrixResponse
     */
    'forwardCurveSeries'?: Array<MatrixForwardCurveSeriesModel> | null;
}
/**
 * 
 * @export
 * @interface Commodity
 */
export interface Commodity {
    /**
     * 
     * @type {number}
     * @memberof Commodity
     */
    'commodityId'?: number;
    /**
     * 
     * @type {string}
     * @memberof Commodity
     */
    'siteGuid': string;
    /**
     * 
     * @type {string}
     * @memberof Commodity
     */
    'commodityName': string;
    /**
     * 
     * @type {Unit}
     * @memberof Commodity
     */
    'displayUnit'?: Unit;
    /**
     * 
     * @type {number}
     * @memberof Commodity
     */
    'displayPrecision'?: number;
    /**
     * 
     * @type {string}
     * @memberof Commodity
     */
    'createdAt'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Commodity
     */
    'modifiedAt'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Commodity
     */
    'deletedAt'?: string | null;
}
/**
 * 
 * @export
 * @interface CommodityContractMonthMappingModel
 */
export interface CommodityContractMonthMappingModel {
    /**
     * 
     * @type {number}
     * @memberof CommodityContractMonthMappingModel
     */
    'commodityContractMonthMappingId': number;
    /**
     * 
     * @type {number}
     * @memberof CommodityContractMonthMappingModel
     */
    'commodityId': number;
    /**
     * 
     * @type {number}
     * @memberof CommodityContractMonthMappingModel
     */
    'budgetMonth': number;
    /**
     * 
     * @type {number}
     * @memberof CommodityContractMonthMappingModel
     */
    'contractMonth': number;
    /**
     * 
     * @type {ContractYearOffset}
     * @memberof CommodityContractMonthMappingModel
     */
    'yearOffset': ContractYearOffset;
}
/**
 * 
 * @export
 * @interface CommodityManagementSiteAccessModel
 */
export interface CommodityManagementSiteAccessModel {
    /**
     * 
     * @type {string}
     * @memberof CommodityManagementSiteAccessModel
     */
    'siteGuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof CommodityManagementSiteAccessModel
     */
    'marketViewUserGuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof CommodityManagementSiteAccessModel
     */
    'siteName'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CommodityManagementSiteAccessModel
     */
    'isSiteManager'?: boolean;
    /**
     * 
     * @type {Array<CommodityManagementUserPermissions>}
     * @memberof CommodityManagementSiteAccessModel
     */
    'permissions'?: Array<CommodityManagementUserPermissions> | null;
}
/**
 * 
 * @export
 * @interface CommodityManagementSiteModel
 */
export interface CommodityManagementSiteModel {
    /**
     * 
     * @type {string}
     * @memberof CommodityManagementSiteModel
     */
    'siteGuid': string;
    /**
     * 
     * @type {string}
     * @memberof CommodityManagementSiteModel
     */
    'siteName': string;
    /**
     * 
     * @type {CompanyModel}
     * @memberof CommodityManagementSiteModel
     */
    'company': CompanyModel;
    /**
     * 
     * @type {Array<CommodityManagementSiteAccessModel>}
     * @memberof CommodityManagementSiteModel
     */
    'userSiteAccesses': Array<CommodityManagementSiteAccessModel>;
}
/**
 * 
 * @export
 * @interface CommodityManagementSiteUserModel
 */
export interface CommodityManagementSiteUserModel {
    /**
     * 
     * @type {string}
     * @memberof CommodityManagementSiteUserModel
     */
    'marketViewUserGuid': string;
    /**
     * 
     * @type {string}
     * @memberof CommodityManagementSiteUserModel
     */
    'stoneXUserGuid'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CommodityManagementSiteUserModel
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof CommodityManagementSiteUserModel
     */
    'firstName': string;
    /**
     * 
     * @type {string}
     * @memberof CommodityManagementSiteUserModel
     */
    'lastName': string;
    /**
     * 
     * @type {boolean}
     * @memberof CommodityManagementSiteUserModel
     */
    'isAdministrator': boolean;
    /**
     * 
     * @type {string}
     * @memberof CommodityManagementSiteUserModel
     */
    'displayName': string;
    /**
     * 
     * @type {string}
     * @memberof CommodityManagementSiteUserModel
     */
    'siteGuid': string;
    /**
     * 
     * @type {string}
     * @memberof CommodityManagementSiteUserModel
     */
    'siteName': string;
    /**
     * 
     * @type {boolean}
     * @memberof CommodityManagementSiteUserModel
     */
    'isSiteManager': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CommodityManagementSiteUserModel
     */
    'accessDisabled': boolean;
    /**
     * 
     * @type {Array<CommodityManagementUserPermissions>}
     * @memberof CommodityManagementSiteUserModel
     */
    'permissions': Array<CommodityManagementUserPermissions>;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const CommodityManagementUserPermissions = {
    ManagePosition: 'ManagePosition',
    ValidatePosition: 'ValidatePosition',
    ManageCommodity: 'ManageCommodity',
    ManageBudget: 'ManageBudget',
    ManageAccount: 'ManageAccount',
    ManagePortfolio: 'ManagePortfolio',
    ManageCounterparty: 'ManageCounterparty',
    ManageMarketPrice: 'ManageMarketPrice',
    ManageOrganization: 'ManageOrganization',
    ManageNotes: 'ManageNotes'
} as const;

export type CommodityManagementUserPermissions = typeof CommodityManagementUserPermissions[keyof typeof CommodityManagementUserPermissions];


/**
 * 
 * @export
 * @interface CommodityModel
 */
export interface CommodityModel {
    /**
     * 
     * @type {number}
     * @memberof CommodityModel
     */
    'commodityId': number;
    /**
     * 
     * @type {string}
     * @memberof CommodityModel
     */
    'commodityName': string;
    /**
     * 
     * @type {Unit}
     * @memberof CommodityModel
     */
    'displayUnit': Unit;
    /**
     * 
     * @type {number}
     * @memberof CommodityModel
     */
    'displayPrecision': number;
}
/**
 * 
 * @export
 * @interface CommodityScenarioVarianceModel
 */
export interface CommodityScenarioVarianceModel {
    /**
     * 
     * @type {CommodityModel}
     * @memberof CommodityScenarioVarianceModel
     */
    'commodity'?: CommodityModel;
    /**
     * 
     * @type {ContractDate}
     * @memberof CommodityScenarioVarianceModel
     */
    'budgetDate'?: ContractDate;
    /**
     * 
     * @type {Variance}
     * @memberof CommodityScenarioVarianceModel
     */
    'variance'?: Variance;
    /**
     * 
     * @type {Variance}
     * @memberof CommodityScenarioVarianceModel
     */
    'whatIfPositionsVariance'?: Variance;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const CommodityType = {
    NaturalGas: 'NaturalGas',
    Electricity: 'Electricity',
    Currencies: 'Currencies',
    Fuel: 'Fuel',
    Dairy: 'Dairy',
    Livestock: 'Livestock',
    Fibers: 'Fibers',
    Metals: 'Metals',
    Coffee: 'Coffee',
    Agriculture: 'Agriculture',
    Stocks: 'Stocks',
    Coal: 'Coal',
    Other: 'Other',
    CropBasis: 'CropBasis',
    CarbonAllowance: 'CarbonAllowance',
    EuNaturalGas: 'EUNaturalGas',
    EuElectricity: 'EUElectricity',
    Favorites: 'Favorites'
} as const;

export type CommodityType = typeof CommodityType[keyof typeof CommodityType];


/**
 * 
 * @export
 * @interface CompanyModel
 */
export interface CompanyModel {
    /**
     * 
     * @type {string}
     * @memberof CompanyModel
     */
    'companyGuid': string;
    /**
     * 
     * @type {string}
     * @memberof CompanyModel
     */
    'name': string;
    /**
     * 
     * @type {boolean}
     * @memberof CompanyModel
     */
    'isDisabled': boolean;
    /**
     * 
     * @type {number}
     * @memberof CompanyModel
     */
    'knowRiskEnergyCustomerId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CompanyModel
     */
    'activeUsers': number;
    /**
     * 
     * @type {number}
     * @memberof CompanyModel
     */
    'totalUsers': number;
    /**
     * 
     * @type {Array<MarketViewApplication>}
     * @memberof CompanyModel
     */
    'marketViewApplications': Array<MarketViewApplication>;
    /**
     * 
     * @type {Array<CompanyProductAccessEntryModel>}
     * @memberof CompanyModel
     */
    'productAccess': Array<CompanyProductAccessEntryModel>;
}
/**
 * 
 * @export
 * @interface CompanyProductAccessEntryModel
 */
export interface CompanyProductAccessEntryModel {
    /**
     * 
     * @type {CommodityType}
     * @memberof CompanyProductAccessEntryModel
     */
    'commodityType'?: CommodityType;
    /**
     * 
     * @type {ProductAccessOverrideType}
     * @memberof CompanyProductAccessEntryModel
     */
    'overrideType'?: ProductAccessOverrideType;
    /**
     * 
     * @type {Array<number>}
     * @memberof CompanyProductAccessEntryModel
     */
    'productIds'?: Array<number> | null;
}
/**
 * 
 * @export
 * @interface ComponentMarketPrice
 */
export interface ComponentMarketPrice {
    /**
     * 
     * @type {ComponentType}
     * @memberof ComponentMarketPrice
     */
    'componentType': ComponentType;
    /**
     * 
     * @type {number}
     * @memberof ComponentMarketPrice
     */
    'price': number;
    /**
     * 
     * @type {number}
     * @memberof ComponentMarketPrice
     */
    'volatility'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ComponentMarketPrice
     */
    'delta'?: number | null;
    /**
     * 
     * @type {Unit}
     * @memberof ComponentMarketPrice
     */
    'unit': Unit;
    /**
     * 
     * @type {Currency}
     * @memberof ComponentMarketPrice
     */
    'currency': Currency;
    /**
     * 
     * @type {MarketPriceProvider}
     * @memberof ComponentMarketPrice
     */
    'marketPriceProvider'?: MarketPriceProvider;
    /**
     * 
     * @type {number}
     * @memberof ComponentMarketPrice
     */
    'marketViewProductId'?: number | null;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const ComponentType = {
    None: 'None',
    AllIn: 'AllIn',
    Underlying: 'Underlying',
    Basis: 'Basis',
    Adder: 'Adder'
} as const;

export type ComponentType = typeof ComponentType[keyof typeof ComponentType];


/**
 * 
 * @export
 * @interface ContractDate
 */
export interface ContractDate {
    /**
     * 
     * @type {number}
     * @memberof ContractDate
     */
    'year'?: number;
    /**
     * 
     * @type {number}
     * @memberof ContractDate
     */
    'month'?: number;
    /**
     * 
     * @type {string}
     * @memberof ContractDate
     */
    'label'?: string | null;
}
/**
 * 
 * @export
 * @interface ContractDateRange
 */
export interface ContractDateRange {
    /**
     * 
     * @type {number}
     * @memberof ContractDateRange
     */
    'startYear'?: number;
    /**
     * 
     * @type {number}
     * @memberof ContractDateRange
     */
    'startMonth'?: number;
    /**
     * 
     * @type {number}
     * @memberof ContractDateRange
     */
    'endYear'?: number;
    /**
     * 
     * @type {number}
     * @memberof ContractDateRange
     */
    'endMonth'?: number;
    /**
     * 
     * @type {ContractDate}
     * @memberof ContractDateRange
     */
    'startContractDate'?: ContractDate;
    /**
     * 
     * @type {ContractDate}
     * @memberof ContractDateRange
     */
    'endContractDate'?: ContractDate;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const ContractYearOffset = {
    Current: 'Current',
    Next: 'Next',
    Previous: 'Previous'
} as const;

export type ContractYearOffset = typeof ContractYearOffset[keyof typeof ContractYearOffset];


/**
 * 
 * @export
 * @interface CopyCustomerReportsResponse
 */
export interface CopyCustomerReportsResponse {
    /**
     * 
     * @type {Array<CustomerReportModel>}
     * @memberof CopyCustomerReportsResponse
     */
    'customerReports'?: Array<CustomerReportModel> | null;
}
/**
 * 
 * @export
 * @interface Counterparty
 */
export interface Counterparty {
    /**
     * 
     * @type {number}
     * @memberof Counterparty
     */
    'counterpartyId'?: number;
    /**
     * 
     * @type {string}
     * @memberof Counterparty
     */
    'siteGuid': string;
    /**
     * 
     * @type {string}
     * @memberof Counterparty
     */
    'counterpartyName': string;
    /**
     * 
     * @type {number}
     * @memberof Counterparty
     */
    'creditLimit'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof Counterparty
     */
    'netting'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof Counterparty
     */
    'setoff'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof Counterparty
     */
    'active': boolean;
    /**
     * 
     * @type {string}
     * @memberof Counterparty
     */
    'customerCounterpartyCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Counterparty
     */
    'createdAt'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Counterparty
     */
    'modifiedAt'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Counterparty
     */
    'deletedAt'?: string | null;
}
/**
 * 
 * @export
 * @interface CounterpartyModel
 */
export interface CounterpartyModel {
    /**
     * 
     * @type {number}
     * @memberof CounterpartyModel
     */
    'counterpartyId': number;
    /**
     * 
     * @type {string}
     * @memberof CounterpartyModel
     */
    'counterpartyName': string;
    /**
     * 
     * @type {number}
     * @memberof CounterpartyModel
     */
    'creditLimit'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof CounterpartyModel
     */
    'netting'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof CounterpartyModel
     */
    'setoff'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof CounterpartyModel
     */
    'active': boolean;
    /**
     * 
     * @type {string}
     * @memberof CounterpartyModel
     */
    'customerCounterpartyCode'?: string | null;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const Currency = {
    Usd: 'USD',
    Cad: 'CAD',
    Eur: 'EUR',
    Aud: 'AUD',
    Fx: 'FX',
    Gbp: 'GBP',
    Brl: 'BRL',
    Nzd: 'NZD',
    Mxn: 'MXN'
} as const;

export type Currency = typeof Currency[keyof typeof Currency];


/**
 * 
 * @export
 * @interface CustomerReportModel
 */
export interface CustomerReportModel {
    /**
     * 
     * @type {number}
     * @memberof CustomerReportModel
     */
    'customerReportId': number;
    /**
     * 
     * @type {ReportType}
     * @memberof CustomerReportModel
     */
    'reportType': ReportType;
    /**
     * 
     * @type {string}
     * @memberof CustomerReportModel
     */
    'reportName': string;
    /**
     * 
     * @type {string}
     * @memberof CustomerReportModel
     */
    'configuration': string;
    /**
     * 
     * @type {string}
     * @memberof CustomerReportModel
     */
    'userOverrides'?: string | null;
}
/**
 * 
 * @export
 * @interface DailyMarketPriceModel
 */
export interface DailyMarketPriceModel {
    /**
     * 
     * @type {number}
     * @memberof DailyMarketPriceModel
     */
    'priceId': number;
    /**
     * 
     * @type {number}
     * @memberof DailyMarketPriceModel
     */
    'productId': number;
    /**
     * 
     * @type {number}
     * @memberof DailyMarketPriceModel
     */
    'symbolId': number;
    /**
     * 
     * @type {string}
     * @memberof DailyMarketPriceModel
     */
    'quoteDate': string;
    /**
     * 
     * @type {number}
     * @memberof DailyMarketPriceModel
     */
    'closePrice': number;
    /**
     * 
     * @type {number}
     * @memberof DailyMarketPriceModel
     */
    'highPrice': number;
    /**
     * 
     * @type {number}
     * @memberof DailyMarketPriceModel
     */
    'lowPrice': number;
    /**
     * 
     * @type {Unit}
     * @memberof DailyMarketPriceModel
     */
    'unit': Unit;
    /**
     * 
     * @type {Currency}
     * @memberof DailyMarketPriceModel
     */
    'currency': Currency;
}
/**
 * 
 * @export
 * @interface DateRangeFilter
 */
export interface DateRangeFilter {
    /**
     * 
     * @type {string}
     * @memberof DateRangeFilter
     */
    'start'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DateRangeFilter
     */
    'end'?: string | null;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const DayOfWeek = {
    Sunday: 'Sunday',
    Monday: 'Monday',
    Tuesday: 'Tuesday',
    Wednesday: 'Wednesday',
    Thursday: 'Thursday',
    Friday: 'Friday',
    Saturday: 'Saturday'
} as const;

export type DayOfWeek = typeof DayOfWeek[keyof typeof DayOfWeek];


/**
 * 
 * @export
 * @interface DealTicketModel
 */
export interface DealTicketModel {
    /**
     * 
     * @type {number}
     * @memberof DealTicketModel
     */
    'dealTicketId': number;
    /**
     * 
     * @type {string}
     * @memberof DealTicketModel
     */
    'tradeDate': string;
    /**
     * 
     * @type {string}
     * @memberof DealTicketModel
     */
    'dealTicketNumber'?: string | null;
    /**
     * 
     * @type {CommodityModel}
     * @memberof DealTicketModel
     */
    'commodity': CommodityModel;
    /**
     * 
     * @type {CounterpartyModel}
     * @memberof DealTicketModel
     */
    'counterparty': CounterpartyModel;
    /**
     * 
     * @type {PortfolioModel}
     * @memberof DealTicketModel
     */
    'portfolio': PortfolioModel;
    /**
     * 
     * @type {Array<PositionModel>}
     * @memberof DealTicketModel
     */
    'positions': Array<PositionModel>;
}
/**
 * 
 * @export
 * @interface DecisiveMarketPriceModel
 */
export interface DecisiveMarketPriceModel {
    /**
     * 
     * @type {string}
     * @memberof DecisiveMarketPriceModel
     */
    'quoteDate': string;
    /**
     * 
     * @type {string}
     * @memberof DecisiveMarketPriceModel
     */
    'productName'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DecisiveMarketPriceModel
     */
    'contractMonth': number;
    /**
     * 
     * @type {number}
     * @memberof DecisiveMarketPriceModel
     */
    'contractYear': number;
    /**
     * 
     * @type {string}
     * @memberof DecisiveMarketPriceModel
     */
    'expiration'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DecisiveMarketPriceModel
     */
    'closePrice': number;
    /**
     * 
     * @type {number}
     * @memberof DecisiveMarketPriceModel
     */
    'volatility'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof DecisiveMarketPriceModel
     */
    'priceType'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DecisiveMarketPriceModel
     */
    'optionType'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DecisiveMarketPriceModel
     */
    'strike'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof DecisiveMarketPriceModel
     */
    'delta'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof DecisiveMarketPriceModel
     */
    'country'?: string | null;
}
/**
 * 
 * @export
 * @interface DefaultBudgetRoundModel
 */
export interface DefaultBudgetRoundModel {
    /**
     * 
     * @type {number}
     * @memberof DefaultBudgetRoundModel
     */
    'defaultBudgetRoundId': number;
    /**
     * 
     * @type {string}
     * @memberof DefaultBudgetRoundModel
     */
    'siteGuid': string;
    /**
     * 
     * @type {number}
     * @memberof DefaultBudgetRoundModel
     */
    'fiscalYear': number;
    /**
     * 
     * @type {number}
     * @memberof DefaultBudgetRoundModel
     */
    'commodityId': number;
    /**
     * 
     * @type {number}
     * @memberof DefaultBudgetRoundModel
     */
    'locationId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof DefaultBudgetRoundModel
     */
    'counterpartyId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof DefaultBudgetRoundModel
     */
    'budgetRoundId': number;
}
/**
 * 
 * @export
 * @interface DeleteHedgePlanSeasonResponse
 */
export interface DeleteHedgePlanSeasonResponse {
    /**
     * 
     * @type {Array<HedgePlanSeasonModel>}
     * @memberof DeleteHedgePlanSeasonResponse
     */
    'rows'?: Array<HedgePlanSeasonModel> | null;
    /**
     * 
     * @type {HedgePlanSeasonModel}
     * @memberof DeleteHedgePlanSeasonResponse
     */
    'nextSeason'?: HedgePlanSeasonModel;
    /**
     * 
     * @type {Array<HedgePlanSeasonModel>}
     * @memberof DeleteHedgePlanSeasonResponse
     */
    'previousSeasons'?: Array<HedgePlanSeasonModel> | null;
}
/**
 * 
 * @export
 * @interface DeliveryModel
 */
export interface DeliveryModel {
    /**
     * 
     * @type {number}
     * @memberof DeliveryModel
     */
    'deliveryId': number;
    /**
     * 
     * @type {string}
     * @memberof DeliveryModel
     */
    'siteGuid': string;
    /**
     * 
     * @type {string}
     * @memberof DeliveryModel
     */
    'postingDate': string;
    /**
     * 
     * @type {string}
     * @memberof DeliveryModel
     */
    'documentDate'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DeliveryModel
     */
    'plant': string;
    /**
     * 
     * @type {number}
     * @memberof DeliveryModel
     */
    'movementType': number;
    /**
     * 
     * @type {string}
     * @memberof DeliveryModel
     */
    'movementTypeText': string;
    /**
     * 
     * @type {number}
     * @memberof DeliveryModel
     */
    'amountInLocation'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof DeliveryModel
     */
    'reasonForMovement'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DeliveryModel
     */
    'storageLocation'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DeliveryModel
     */
    'material': string;
    /**
     * 
     * @type {string}
     * @memberof DeliveryModel
     */
    'materialDescription': string;
    /**
     * 
     * @type {string}
     * @memberof DeliveryModel
     */
    'batch'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DeliveryModel
     */
    'quantity': number;
    /**
     * 
     * @type {string}
     * @memberof DeliveryModel
     */
    'baseUnitofMeasure': string;
    /**
     * 
     * @type {string}
     * @memberof DeliveryModel
     */
    'customer'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DeliveryModel
     */
    'order'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DeliveryModel
     */
    'recievingPlant'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DeliveryModel
     */
    'vendor': string;
    /**
     * 
     * @type {string}
     * @memberof DeliveryModel
     */
    'purchaseOrder': string;
}
/**
 * 
 * @export
 * @interface DocumentModel
 */
export interface DocumentModel {
    /**
     * 
     * @type {number}
     * @memberof DocumentModel
     */
    'documentId': number;
    /**
     * 
     * @type {string}
     * @memberof DocumentModel
     */
    'siteGuid': string;
    /**
     * 
     * @type {string}
     * @memberof DocumentModel
     */
    'entityName': string;
    /**
     * 
     * @type {number}
     * @memberof DocumentModel
     */
    'entityId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof DocumentModel
     */
    'documentUrl': string;
    /**
     * 
     * @type {string}
     * @memberof DocumentModel
     */
    'description'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DocumentModel
     */
    'fileName': string;
    /**
     * 
     * @type {string}
     * @memberof DocumentModel
     */
    'entryDate': string;
}
/**
 * 
 * @export
 * @interface DownloadDocumentResponse
 */
export interface DownloadDocumentResponse {
    /**
     * 
     * @type {string}
     * @memberof DownloadDocumentResponse
     */
    'fileUrl'?: string | null;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const EiaNaturalGasStorageDataSource = {
    Databricks: 'Databricks',
    Database: 'Database'
} as const;

export type EiaNaturalGasStorageDataSource = typeof EiaNaturalGasStorageDataSource[keyof typeof EiaNaturalGasStorageDataSource];


/**
 * 
 * @export
 * @interface EiaNaturalGasStorageWeekModel
 */
export interface EiaNaturalGasStorageWeekModel {
    /**
     * 
     * @type {number}
     * @memberof EiaNaturalGasStorageWeekModel
     */
    'eiaNaturalGasStorageWeekId': number;
    /**
     * 
     * @type {string}
     * @memberof EiaNaturalGasStorageWeekModel
     */
    'weekEnding': string;
    /**
     * 
     * @type {string}
     * @memberof EiaNaturalGasStorageWeekModel
     */
    'source': string;
    /**
     * 
     * @type {number}
     * @memberof EiaNaturalGasStorageWeekModel
     */
    'east'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof EiaNaturalGasStorageWeekModel
     */
    'midwest'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof EiaNaturalGasStorageWeekModel
     */
    'mountain'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof EiaNaturalGasStorageWeekModel
     */
    'pacific'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof EiaNaturalGasStorageWeekModel
     */
    'southCentral'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof EiaNaturalGasStorageWeekModel
     */
    'southCentralSalt'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof EiaNaturalGasStorageWeekModel
     */
    'southCentralNonSalt'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof EiaNaturalGasStorageWeekModel
     */
    'total': number;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const ElectricityType = {
    AroundTheClock: 'AroundTheClock',
    WrapEast: 'WrapEast',
    WrapWest: 'WrapWest',
    OnPeakEast: 'OnPeakEast',
    OnPeakWest: 'OnPeakWest'
} as const;

export type ElectricityType = typeof ElectricityType[keyof typeof ElectricityType];


/**
 * 
 * @export
 * @enum {string}
 */

export const EmailScheduleFrequency = {
    Daily: 'Daily',
    Weekdays: 'Weekdays',
    Weekly: 'Weekly',
    Monthly: 'Monthly'
} as const;

export type EmailScheduleFrequency = typeof EmailScheduleFrequency[keyof typeof EmailScheduleFrequency];


/**
 * 
 * @export
 * @interface EmailScheduleModel
 */
export interface EmailScheduleModel {
    /**
     * 
     * @type {number}
     * @memberof EmailScheduleModel
     */
    'emailScheduleId': number;
    /**
     * 
     * @type {EmailScheduleSource}
     * @memberof EmailScheduleModel
     */
    'source': EmailScheduleSource;
    /**
     * 
     * @type {number}
     * @memberof EmailScheduleModel
     */
    'sourceId': number;
    /**
     * 
     * @type {string}
     * @memberof EmailScheduleModel
     */
    'siteGuid'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EmailScheduleModel
     */
    'subject'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof EmailScheduleModel
     */
    'recipients': Array<string>;
    /**
     * 
     * @type {EmailScheduleFrequency}
     * @memberof EmailScheduleModel
     */
    'frequency': EmailScheduleFrequency;
    /**
     * 
     * @type {DayOfWeek}
     * @memberof EmailScheduleModel
     */
    'dayOfWeek'?: DayOfWeek;
    /**
     * 
     * @type {number}
     * @memberof EmailScheduleModel
     */
    'dayOfMonth'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof EmailScheduleModel
     */
    'timeOfDay': string;
    /**
     * 
     * @type {string}
     * @memberof EmailScheduleModel
     */
    'timeZoneId': string;
    /**
     * 
     * @type {boolean}
     * @memberof EmailScheduleModel
     */
    'isActive': boolean;
    /**
     * 
     * @type {string}
     * @memberof EmailScheduleModel
     */
    'nextRunAtUtc': string;
    /**
     * 
     * @type {string}
     * @memberof EmailScheduleModel
     */
    'lastRunAtUtc'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EmailScheduleModel
     */
    'lastRunError'?: string | null;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const EmailScheduleSource = {
    MarketViewSavedQuery: 'MarketViewSavedQuery',
    CommodityManagementReport: 'CommodityManagementReport'
} as const;

export type EmailScheduleSource = typeof EmailScheduleSource[keyof typeof EmailScheduleSource];


/**
 * 
 * @export
 * @enum {string}
 */

export const ExpiryStatus = {
    All: 'All',
    Expired: 'Expired',
    Open: 'Open'
} as const;

export type ExpiryStatus = typeof ExpiryStatus[keyof typeof ExpiryStatus];


/**
 * 
 * @export
 * @interface ExposureReportCommodity
 */
export interface ExposureReportCommodity {
    /**
     * 
     * @type {CommodityModel}
     * @memberof ExposureReportCommodity
     */
    'commodity'?: CommodityModel;
    /**
     * 
     * @type {number}
     * @memberof ExposureReportCommodity
     */
    'markToMarketValue'?: number | null;
    /**
     * 
     * @type {{ [key: string]: number; }}
     * @memberof ExposureReportCommodity
     */
    'stressValues'?: { [key: string]: number; } | null;
    /**
     * 
     * @type {Array<ExposureReportDealTicket>}
     * @memberof ExposureReportCommodity
     */
    'dealTickets'?: Array<ExposureReportDealTicket> | null;
}
/**
 * 
 * @export
 * @interface ExposureReportCounterparty
 */
export interface ExposureReportCounterparty {
    /**
     * 
     * @type {number}
     * @memberof ExposureReportCounterparty
     */
    'counterpartyId': number;
    /**
     * 
     * @type {string}
     * @memberof ExposureReportCounterparty
     */
    'counterpartyName': string;
    /**
     * 
     * @type {number}
     * @memberof ExposureReportCounterparty
     */
    'counterpartyCreditLimit': number;
    /**
     * 
     * @type {number}
     * @memberof ExposureReportCounterparty
     */
    'availableCredit': number;
    /**
     * 
     * @type {boolean}
     * @memberof ExposureReportCounterparty
     */
    'counterpartyNetting': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ExposureReportCounterparty
     */
    'counterpartySetOff': boolean;
    /**
     * 
     * @type {number}
     * @memberof ExposureReportCounterparty
     */
    'markToMarketValue'?: number | null;
    /**
     * 
     * @type {{ [key: string]: number; }}
     * @memberof ExposureReportCounterparty
     */
    'stressValues': { [key: string]: number; };
    /**
     * 
     * @type {{ [key: string]: number; }}
     * @memberof ExposureReportCounterparty
     */
    'availableCredits': { [key: string]: number; };
    /**
     * 
     * @type {Array<ExposureReportCommodity>}
     * @memberof ExposureReportCounterparty
     */
    'commodities': Array<ExposureReportCommodity>;
}
/**
 * 
 * @export
 * @interface ExposureReportDealTicket
 */
export interface ExposureReportDealTicket {
    /**
     * 
     * @type {number}
     * @memberof ExposureReportDealTicket
     */
    'tradeId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ExposureReportDealTicket
     */
    'dealTicket'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ExposureReportDealTicket
     */
    'volume'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ExposureReportDealTicket
     */
    'markToMarketValue'?: number | null;
    /**
     * 
     * @type {{ [key: string]: number; }}
     * @memberof ExposureReportDealTicket
     */
    'stressValues'?: { [key: string]: number; } | null;
    /**
     * 
     * @type {Array<ExposureReportPosition>}
     * @memberof ExposureReportDealTicket
     */
    'positions'?: Array<ExposureReportPosition> | null;
}
/**
 * 
 * @export
 * @interface ExposureReportPosition
 */
export interface ExposureReportPosition {
    /**
     * 
     * @type {number}
     * @memberof ExposureReportPosition
     */
    'positionId'?: number;
    /**
     * 
     * @type {number}
     * @memberof ExposureReportPosition
     */
    'portfolioId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ExposureReportPosition
     */
    'portfolioName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ExposureReportPosition
     */
    'side'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ExposureReportPosition
     */
    'contractMonth'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ExposureReportPosition
     */
    'volume'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ExposureReportPosition
     */
    'price'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ExposureReportPosition
     */
    'marketPrice'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ExposureReportPosition
     */
    'markToMarketPrice'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ExposureReportPosition
     */
    'markToMarketValue'?: number | null;
    /**
     * 
     * @type {{ [key: string]: number; }}
     * @memberof ExposureReportPosition
     */
    'stressPrices'?: { [key: string]: number; } | null;
    /**
     * 
     * @type {{ [key: string]: number; }}
     * @memberof ExposureReportPosition
     */
    'stressValues'?: { [key: string]: number; } | null;
}
/**
 * 
 * @export
 * @interface FileResponse
 */
export interface FileResponse {
    /**
     * 
     * @type {string}
     * @memberof FileResponse
     */
    'fileName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FileResponse
     */
    'fileContents'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FileResponse
     */
    'contentType'?: string | null;
}
/**
 * 
 * @export
 * @interface ForecastAveragesModel
 */
export interface ForecastAveragesModel {
    /**
     * 
     * @type {number}
     * @memberof ForecastAveragesModel
     */
    'settlementAverage'?: number;
    /**
     * 
     * @type {number}
     * @memberof ForecastAveragesModel
     */
    'recentAverage'?: number;
    /**
     * 
     * @type {number}
     * @memberof ForecastAveragesModel
     */
    'historicalMedian'?: number;
    /**
     * 
     * @type {number}
     * @memberof ForecastAveragesModel
     */
    'forecastPrice'?: number;
    /**
     * 
     * @type {number}
     * @memberof ForecastAveragesModel
     */
    'marketPrice'?: number;
}
/**
 * 
 * @export
 * @interface ForecastDecileModel
 */
export interface ForecastDecileModel {
    /**
     * 
     * @type {number}
     * @memberof ForecastDecileModel
     */
    'mean': number;
    /**
     * 
     * @type {number}
     * @memberof ForecastDecileModel
     */
    'median': number;
    /**
     * 
     * @type {number}
     * @memberof ForecastDecileModel
     */
    'min': number;
    /**
     * 
     * @type {number}
     * @memberof ForecastDecileModel
     */
    'max': number;
    /**
     * 
     * @type {Array<ForecastDecileRowModel>}
     * @memberof ForecastDecileModel
     */
    'rows': Array<ForecastDecileRowModel>;
}
/**
 * 
 * @export
 * @interface ForecastDecileRowModel
 */
export interface ForecastDecileRowModel {
    /**
     * 
     * @type {string}
     * @memberof ForecastDecileRowModel
     */
    'label': string;
    /**
     * 
     * @type {number}
     * @memberof ForecastDecileRowModel
     */
    'lowValue': number;
    /**
     * 
     * @type {number}
     * @memberof ForecastDecileRowModel
     */
    'highValue': number;
}
/**
 * 
 * @export
 * @interface ForecastModel
 */
export interface ForecastModel {
    /**
     * 
     * @type {ContractDate}
     * @memberof ForecastModel
     */
    'contractDate': ContractDate;
    /**
     * 
     * @type {number}
     * @memberof ForecastModel
     */
    'marketPrice': number;
    /**
     * 
     * @type {number}
     * @memberof ForecastModel
     */
    'settlementAverage': number;
    /**
     * 
     * @type {number}
     * @memberof ForecastModel
     */
    'settlementAverageWeight': number;
    /**
     * 
     * @type {number}
     * @memberof ForecastModel
     */
    'recentAverage': number;
    /**
     * 
     * @type {number}
     * @memberof ForecastModel
     */
    'recentAverageWeight': number;
    /**
     * 
     * @type {number}
     * @memberof ForecastModel
     */
    'historicalMedian': number;
    /**
     * 
     * @type {number}
     * @memberof ForecastModel
     */
    'historicalMedianWeight': number;
    /**
     * 
     * @type {number}
     * @memberof ForecastModel
     */
    'forecastPrice': number;
}
/**
 * 
 * @export
 * @interface GetAuditTrailResponse
 */
export interface GetAuditTrailResponse {
    /**
     * 
     * @type {Array<AuditTrailModel>}
     * @memberof GetAuditTrailResponse
     */
    'rows'?: Array<AuditTrailModel> | null;
    /**
     * 
     * @type {number}
     * @memberof GetAuditTrailResponse
     */
    'totalCount'?: number;
    /**
     * 
     * @type {string}
     * @memberof GetAuditTrailResponse
     */
    'sortColumn'?: string | null;
    /**
     * 
     * @type {SortDirection}
     * @memberof GetAuditTrailResponse
     */
    'sortDirection'?: SortDirection;
    /**
     * 
     * @type {number}
     * @memberof GetAuditTrailResponse
     */
    'take'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof GetAuditTrailResponse
     */
    'skip'?: number;
}
/**
 * 
 * @export
 * @interface GetCompanyResponse
 */
export interface GetCompanyResponse {
    /**
     * 
     * @type {CompanyModel}
     * @memberof GetCompanyResponse
     */
    'company'?: CompanyModel;
}
/**
 * 
 * @export
 * @interface GetCustomerDataResponse
 */
export interface GetCustomerDataResponse {
    /**
     * 
     * @type {Array<CommodityModel>}
     * @memberof GetCustomerDataResponse
     */
    'commodities'?: Array<CommodityModel> | null;
    /**
     * 
     * @type {Array<TierModel>}
     * @memberof GetCustomerDataResponse
     */
    'tiers'?: Array<TierModel> | null;
    /**
     * 
     * @type {Array<LocationModel>}
     * @memberof GetCustomerDataResponse
     */
    'locations'?: Array<LocationModel> | null;
    /**
     * 
     * @type {Array<LocationModel>}
     * @memberof GetCustomerDataResponse
     */
    'budgetingLocations'?: Array<LocationModel> | null;
    /**
     * 
     * @type {Array<CounterpartyModel>}
     * @memberof GetCustomerDataResponse
     */
    'counterparties'?: Array<CounterpartyModel> | null;
    /**
     * 
     * @type {Array<PortfolioModel>}
     * @memberof GetCustomerDataResponse
     */
    'portfolios'?: Array<PortfolioModel> | null;
    /**
     * 
     * @type {Array<BudgetRoundModel>}
     * @memberof GetCustomerDataResponse
     */
    'budgetRounds'?: Array<BudgetRoundModel> | null;
    /**
     * 
     * @type {Array<Unit>}
     * @memberof GetCustomerDataResponse
     */
    'units'?: Array<Unit> | null;
    /**
     * 
     * @type {Array<Currency>}
     * @memberof GetCustomerDataResponse
     */
    'currencies'?: Array<Currency> | null;
    /**
     * 
     * @type {Array<PositionType>}
     * @memberof GetCustomerDataResponse
     */
    'positionTypes'?: Array<PositionType> | null;
    /**
     * 
     * @type {Array<OptionType>}
     * @memberof GetCustomerDataResponse
     */
    'optionTypes'?: Array<OptionType> | null;
    /**
     * 
     * @type {Array<OptionStyle>}
     * @memberof GetCustomerDataResponse
     */
    'optionStyles'?: Array<OptionStyle> | null;
}
/**
 * 
 * @export
 * @interface GetCustomerReportsResponse
 */
export interface GetCustomerReportsResponse {
    /**
     * 
     * @type {Array<CustomerReportModel>}
     * @memberof GetCustomerReportsResponse
     */
    'rows'?: Array<CustomerReportModel> | null;
    /**
     * 
     * @type {number}
     * @memberof GetCustomerReportsResponse
     */
    'totalCount'?: number;
    /**
     * 
     * @type {string}
     * @memberof GetCustomerReportsResponse
     */
    'sortColumn'?: string | null;
    /**
     * 
     * @type {SortDirection}
     * @memberof GetCustomerReportsResponse
     */
    'sortDirection'?: SortDirection;
    /**
     * 
     * @type {number}
     * @memberof GetCustomerReportsResponse
     */
    'take'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof GetCustomerReportsResponse
     */
    'skip'?: number;
}
/**
 * 
 * @export
 * @interface GetCustomerSettingsResponse
 */
export interface GetCustomerSettingsResponse {
    /**
     * 
     * @type {number}
     * @memberof GetCustomerSettingsResponse
     */
    'fiscalMonthOffset'?: number;
    /**
     * 
     * @type {number}
     * @memberof GetCustomerSettingsResponse
     */
    'defaultActiveYear'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof GetCustomerSettingsResponse
     */
    'budgetsByLocation'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetCustomerSettingsResponse
     */
    'budgetsByCounterparty'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetCustomerSettingsResponse
     */
    'budgetsByPortfolio'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetCustomerSettingsResponse
     */
    'positionsByLocation'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetCustomerSettingsResponse
     */
    'positionsByPortfolio'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetCustomerSettingsResponse
     */
    'positionsByCounterparty'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetCustomerSettingsResponse
     */
    'usesBudgetRounds'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetCustomerSettingsResponse
     */
    'separatePricingStrategiesForPositions'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetCustomerSettingsResponse
     */
    'positionContractDates'?: boolean;
    /**
     * 
     * @type {ContractDate}
     * @memberof GetCustomerSettingsResponse
     */
    'defaultActiveMonthStart'?: ContractDate;
    /**
     * 
     * @type {ContractDate}
     * @memberof GetCustomerSettingsResponse
     */
    'defaultActiveMonthEnd'?: ContractDate;
}
/**
 * 
 * @export
 * @interface GetDailyPositionsReportRequest
 */
export interface GetDailyPositionsReportRequest {
    /**
     * 
     * @type {number}
     * @memberof GetDailyPositionsReportRequest
     */
    'customerReportId': number;
    /**
     * 
     * @type {string}
     * @memberof GetDailyPositionsReportRequest
     */
    'pricingStartDate': string;
    /**
     * 
     * @type {string}
     * @memberof GetDailyPositionsReportRequest
     */
    'pricingEndDate': string;
}
/**
 * 
 * @export
 * @interface GetDailyPositionsReportResponse
 */
export interface GetDailyPositionsReportResponse {
    /**
     * 
     * @type {Array<PositionModel>}
     * @memberof GetDailyPositionsReportResponse
     */
    'rows'?: Array<PositionModel> | null;
    /**
     * 
     * @type {number}
     * @memberof GetDailyPositionsReportResponse
     */
    'totalCount'?: number;
    /**
     * 
     * @type {string}
     * @memberof GetDailyPositionsReportResponse
     */
    'sortColumn'?: string | null;
    /**
     * 
     * @type {SortDirection}
     * @memberof GetDailyPositionsReportResponse
     */
    'sortDirection'?: SortDirection;
    /**
     * 
     * @type {number}
     * @memberof GetDailyPositionsReportResponse
     */
    'take'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof GetDailyPositionsReportResponse
     */
    'skip'?: number;
}
/**
 * 
 * @export
 * @interface GetDealTicketResponse
 */
export interface GetDealTicketResponse {
    /**
     * 
     * @type {DealTicketModel}
     * @memberof GetDealTicketResponse
     */
    'dealTicket'?: DealTicketModel;
}
/**
 * 
 * @export
 * @interface GetExposureReportResponse
 */
export interface GetExposureReportResponse {
    /**
     * 
     * @type {Array<ExposureReportCounterparty>}
     * @memberof GetExposureReportResponse
     */
    'rows'?: Array<ExposureReportCounterparty> | null;
    /**
     * 
     * @type {number}
     * @memberof GetExposureReportResponse
     */
    'totalCount'?: number;
    /**
     * 
     * @type {string}
     * @memberof GetExposureReportResponse
     */
    'sortColumn'?: string | null;
    /**
     * 
     * @type {SortDirection}
     * @memberof GetExposureReportResponse
     */
    'sortDirection'?: SortDirection;
    /**
     * 
     * @type {number}
     * @memberof GetExposureReportResponse
     */
    'take'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof GetExposureReportResponse
     */
    'skip'?: number;
}
/**
 * 
 * @export
 * @interface GetForecastResponse
 */
export interface GetForecastResponse {
    /**
     * 
     * @type {string}
     * @memberof GetForecastResponse
     */
    'quoteDate'?: string;
    /**
     * 
     * @type {ForecastDecileModel}
     * @memberof GetForecastResponse
     */
    'decileTable'?: ForecastDecileModel;
    /**
     * 
     * @type {ForecastAveragesModel}
     * @memberof GetForecastResponse
     */
    'averages'?: ForecastAveragesModel;
    /**
     * 
     * @type {Array<ForecastModel>}
     * @memberof GetForecastResponse
     */
    'rows'?: Array<ForecastModel> | null;
    /**
     * 
     * @type {number}
     * @memberof GetForecastResponse
     */
    'totalCount'?: number;
    /**
     * 
     * @type {string}
     * @memberof GetForecastResponse
     */
    'sortColumn'?: string | null;
    /**
     * 
     * @type {SortDirection}
     * @memberof GetForecastResponse
     */
    'sortDirection'?: SortDirection;
    /**
     * 
     * @type {number}
     * @memberof GetForecastResponse
     */
    'take'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof GetForecastResponse
     */
    'skip'?: number;
}
/**
 * 
 * @export
 * @interface GetForecastWithHistoryResponse
 */
export interface GetForecastWithHistoryResponse {
    /**
     * 
     * @type {ForecastDecileModel}
     * @memberof GetForecastWithHistoryResponse
     */
    'decileTable'?: ForecastDecileModel;
    /**
     * 
     * @type {ForecastAveragesModel}
     * @memberof GetForecastWithHistoryResponse
     */
    'averages'?: ForecastAveragesModel;
    /**
     * 
     * @type {Array<QuoteDateForecast>}
     * @memberof GetForecastWithHistoryResponse
     */
    'rows'?: Array<QuoteDateForecast> | null;
    /**
     * 
     * @type {number}
     * @memberof GetForecastWithHistoryResponse
     */
    'totalCount'?: number;
    /**
     * 
     * @type {string}
     * @memberof GetForecastWithHistoryResponse
     */
    'sortColumn'?: string | null;
    /**
     * 
     * @type {SortDirection}
     * @memberof GetForecastWithHistoryResponse
     */
    'sortDirection'?: SortDirection;
    /**
     * 
     * @type {number}
     * @memberof GetForecastWithHistoryResponse
     */
    'take'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof GetForecastWithHistoryResponse
     */
    'skip'?: number;
}
/**
 * 
 * @export
 * @interface GetHedgePlanReportResponse
 */
export interface GetHedgePlanReportResponse {
    /**
     * 
     * @type {HedgePlanTermReportModel}
     * @memberof GetHedgePlanReportResponse
     */
    'report'?: HedgePlanTermReportModel;
}
/**
 * 
 * @export
 * @interface GetKnowRiskEnergyLocationsForCompanyResponse
 */
export interface GetKnowRiskEnergyLocationsForCompanyResponse {
    /**
     * 
     * @type {Array<KnowRiskEnergyLocationModel>}
     * @memberof GetKnowRiskEnergyLocationsForCompanyResponse
     */
    'rows'?: Array<KnowRiskEnergyLocationModel> | null;
}
/**
 * 
 * @export
 * @interface GetMarkToMarketReportRequest
 */
export interface GetMarkToMarketReportRequest {
    /**
     * 
     * @type {string}
     * @memberof GetMarkToMarketReportRequest
     */
    'quoteDate': string;
    /**
     * 
     * @type {number}
     * @memberof GetMarkToMarketReportRequest
     */
    'customerReportId': number;
    /**
     * 
     * @type {ExpiryStatus}
     * @memberof GetMarkToMarketReportRequest
     */
    'expiryStatus'?: ExpiryStatus;
    /**
     * 
     * @type {ContractDate}
     * @memberof GetMarkToMarketReportRequest
     */
    'budgetStartMonth'?: ContractDate;
    /**
     * 
     * @type {ContractDate}
     * @memberof GetMarkToMarketReportRequest
     */
    'budgetEndMonth'?: ContractDate;
    /**
     * 
     * @type {Array<ScenarioMarketPriceModel>}
     * @memberof GetMarkToMarketReportRequest
     */
    'scenarioMarketPrices'?: Array<ScenarioMarketPriceModel> | null;
}
/**
 * 
 * @export
 * @interface GetMarkToMarketReportResponse
 */
export interface GetMarkToMarketReportResponse {
    /**
     * 
     * @type {Array<PositionModel>}
     * @memberof GetMarkToMarketReportResponse
     */
    'rows'?: Array<PositionModel> | null;
    /**
     * 
     * @type {number}
     * @memberof GetMarkToMarketReportResponse
     */
    'totalCount'?: number;
    /**
     * 
     * @type {string}
     * @memberof GetMarkToMarketReportResponse
     */
    'sortColumn'?: string | null;
    /**
     * 
     * @type {SortDirection}
     * @memberof GetMarkToMarketReportResponse
     */
    'sortDirection'?: SortDirection;
    /**
     * 
     * @type {number}
     * @memberof GetMarkToMarketReportResponse
     */
    'take'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof GetMarkToMarketReportResponse
     */
    'skip'?: number;
}
/**
 * 
 * @export
 * @interface GetMarketViewLastQuoteDateResponse
 */
export interface GetMarketViewLastQuoteDateResponse {
    /**
     * 
     * @type {number}
     * @memberof GetMarketViewLastQuoteDateResponse
     */
    'symbolId'?: number;
    /**
     * 
     * @type {string}
     * @memberof GetMarketViewLastQuoteDateResponse
     */
    'quoteDate'?: string;
}
/**
 * 
 * @export
 * @interface GetMarketViewUserAuthorizationResponse
 */
export interface GetMarketViewUserAuthorizationResponse {
    /**
     * 
     * @type {MarketViewUserModel}
     * @memberof GetMarketViewUserAuthorizationResponse
     */
    'user'?: MarketViewUserModel;
}
/**
 * 
 * @export
 * @interface GetMarketViewUserResponse
 */
export interface GetMarketViewUserResponse {
    /**
     * 
     * @type {MarketViewUserModel}
     * @memberof GetMarketViewUserResponse
     */
    'user'?: MarketViewUserModel;
}
/**
 * 
 * @export
 * @interface GetPiedmontHedgingReportResponse
 */
export interface GetPiedmontHedgingReportResponse {
    /**
     * 
     * @type {string}
     * @memberof GetPiedmontHedgingReportResponse
     */
    'customerName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetPiedmontHedgingReportResponse
     */
    'quoteDate'?: string;
    /**
     * 
     * @type {ContractDate}
     * @memberof GetPiedmontHedgingReportResponse
     */
    'budgetStartMonth'?: ContractDate;
    /**
     * 
     * @type {ContractDate}
     * @memberof GetPiedmontHedgingReportResponse
     */
    'budgetEndMonth'?: ContractDate;
    /**
     * 
     * @type {Array<PiedmontHedgingLocationModel>}
     * @memberof GetPiedmontHedgingReportResponse
     */
    'locations'?: Array<PiedmontHedgingLocationModel> | null;
    /**
     * 
     * @type {Array<PiedmontOpenContractsRowModel>}
     * @memberof GetPiedmontHedgingReportResponse
     */
    'openContracts'?: Array<PiedmontOpenContractsRowModel> | null;
    /**
     * 
     * @type {number}
     * @memberof GetPiedmontHedgingReportResponse
     */
    'totalOpenContracts'?: number;
}
/**
 * 
 * @export
 * @interface GetScenarioReportResponse
 */
export interface GetScenarioReportResponse {
    /**
     * 
     * @type {Array<ScenarioVarianceModel>}
     * @memberof GetScenarioReportResponse
     */
    'rows'?: Array<ScenarioVarianceModel> | null;
    /**
     * 
     * @type {number}
     * @memberof GetScenarioReportResponse
     */
    'totalCount'?: number;
    /**
     * 
     * @type {string}
     * @memberof GetScenarioReportResponse
     */
    'sortColumn'?: string | null;
    /**
     * 
     * @type {SortDirection}
     * @memberof GetScenarioReportResponse
     */
    'sortDirection'?: SortDirection;
    /**
     * 
     * @type {number}
     * @memberof GetScenarioReportResponse
     */
    'take'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof GetScenarioReportResponse
     */
    'skip'?: number;
}
/**
 * 
 * @export
 * @interface GetTermsAndConditionsResponse
 */
export interface GetTermsAndConditionsResponse {
    /**
     * 
     * @type {boolean}
     * @memberof GetTermsAndConditionsResponse
     */
    'agreed'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof GetTermsAndConditionsResponse
     */
    'asOfDate'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof GetTermsAndConditionsResponse
     */
    'version'?: number | null;
}
/**
 * 
 * @export
 * @interface GetTimeTriggerReportResponse
 */
export interface GetTimeTriggerReportResponse {
    /**
     * 
     * @type {Array<TimeTriggerReportModel>}
     * @memberof GetTimeTriggerReportResponse
     */
    'rows'?: Array<TimeTriggerReportModel> | null;
    /**
     * 
     * @type {number}
     * @memberof GetTimeTriggerReportResponse
     */
    'totalCount'?: number;
    /**
     * 
     * @type {string}
     * @memberof GetTimeTriggerReportResponse
     */
    'sortColumn'?: string | null;
    /**
     * 
     * @type {SortDirection}
     * @memberof GetTimeTriggerReportResponse
     */
    'sortDirection'?: SortDirection;
    /**
     * 
     * @type {number}
     * @memberof GetTimeTriggerReportResponse
     */
    'take'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof GetTimeTriggerReportResponse
     */
    'skip'?: number;
}
/**
 * 
 * @export
 * @interface GetVarianceReportResponse
 */
export interface GetVarianceReportResponse {
    /**
     * 
     * @type {Array<BudgetVarianceModel>}
     * @memberof GetVarianceReportResponse
     */
    'rows'?: Array<BudgetVarianceModel> | null;
    /**
     * 
     * @type {number}
     * @memberof GetVarianceReportResponse
     */
    'totalCount'?: number;
    /**
     * 
     * @type {string}
     * @memberof GetVarianceReportResponse
     */
    'sortColumn'?: string | null;
    /**
     * 
     * @type {SortDirection}
     * @memberof GetVarianceReportResponse
     */
    'sortDirection'?: SortDirection;
    /**
     * 
     * @type {number}
     * @memberof GetVarianceReportResponse
     */
    'take'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof GetVarianceReportResponse
     */
    'skip'?: number;
}
/**
 * 
 * @export
 * @interface HedgePlanBudgetTriggerModel
 */
export interface HedgePlanBudgetTriggerModel {
    /**
     * 
     * @type {number}
     * @memberof HedgePlanBudgetTriggerModel
     */
    'hedgePlanBudgetTriggerId': number;
    /**
     * 
     * @type {number}
     * @memberof HedgePlanBudgetTriggerModel
     */
    'hedgePlanId': number;
    /**
     * 
     * @type {number}
     * @memberof HedgePlanBudgetTriggerModel
     */
    'year': number;
    /**
     * 
     * @type {MatrixTerm}
     * @memberof HedgePlanBudgetTriggerModel
     */
    'term': MatrixTerm;
    /**
     * 
     * @type {number}
     * @memberof HedgePlanBudgetTriggerModel
     */
    'seasonPosition'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof HedgePlanBudgetTriggerModel
     */
    'price': number;
    /**
     * 
     * @type {number}
     * @memberof HedgePlanBudgetTriggerModel
     */
    'targetHedgePercent': number;
    /**
     * 
     * @type {boolean}
     * @memberof HedgePlanBudgetTriggerModel
     */
    'disabled': boolean;
    /**
     * 
     * @type {string}
     * @memberof HedgePlanBudgetTriggerModel
     */
    'note'?: string | null;
}
/**
 * 
 * @export
 * @interface HedgePlanDecileBandModel
 */
export interface HedgePlanDecileBandModel {
    /**
     * 
     * @type {number}
     * @memberof HedgePlanDecileBandModel
     */
    'percentile'?: number;
    /**
     * 
     * @type {string}
     * @memberof HedgePlanDecileBandModel
     */
    'label'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof HedgePlanDecileBandModel
     */
    'lowValue'?: number;
    /**
     * 
     * @type {number}
     * @memberof HedgePlanDecileBandModel
     */
    'highValue'?: number;
}
/**
 * 
 * @export
 * @interface HedgePlanDecilePointModel
 */
export interface HedgePlanDecilePointModel {
    /**
     * 
     * @type {string}
     * @memberof HedgePlanDecilePointModel
     */
    'calculationDate'?: string;
    /**
     * 
     * @type {number}
     * @memberof HedgePlanDecilePointModel
     */
    'percentile'?: number;
    /**
     * 
     * @type {number}
     * @memberof HedgePlanDecilePointModel
     */
    'value'?: number;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const HedgePlanExecutionType = {
    Value: 'Value',
    Budget: 'Budget',
    Time: 'Time'
} as const;

export type HedgePlanExecutionType = typeof HedgePlanExecutionType[keyof typeof HedgePlanExecutionType];


/**
 * 
 * @export
 * @interface HedgePlanModel
 */
export interface HedgePlanModel {
    /**
     * 
     * @type {number}
     * @memberof HedgePlanModel
     */
    'hedgePlanId': number;
    /**
     * 
     * @type {string}
     * @memberof HedgePlanModel
     */
    'companyGuid'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof HedgePlanModel
     */
    'name': string;
    /**
     * 
     * @type {number}
     * @memberof HedgePlanModel
     */
    'marketViewProductId': number;
    /**
     * 
     * @type {HedgePlanType}
     * @memberof HedgePlanModel
     */
    'planType': HedgePlanType;
    /**
     * 
     * @type {MatrixSeasonType}
     * @memberof HedgePlanModel
     */
    'seasonType': MatrixSeasonType;
    /**
     * 
     * @type {number}
     * @memberof HedgePlanModel
     */
    'fiscalStartMonth': number;
    /**
     * 
     * @type {MatrixCalculationType}
     * @memberof HedgePlanModel
     */
    'calculationType': MatrixCalculationType;
    /**
     * 
     * @type {MatrixContractSettlement}
     * @memberof HedgePlanModel
     */
    'contractSettlement': MatrixContractSettlement;
    /**
     * 
     * @type {MatrixStripType}
     * @memberof HedgePlanModel
     */
    'stripType': MatrixStripType;
    /**
     * 
     * @type {string}
     * @memberof HedgePlanModel
     */
    'siteGuid'?: string | null;
    /**
     * 
     * @type {VolumeSource}
     * @memberof HedgePlanModel
     */
    'volumeSource'?: VolumeSource;
    /**
     * 
     * @type {Array<number>}
     * @memberof HedgePlanModel
     */
    'volumeSourceIds': Array<number>;
    /**
     * 
     * @type {HedgePlanOverHedgeLimit}
     * @memberof HedgePlanModel
     */
    'overHedgeLimit': HedgePlanOverHedgeLimit;
    /**
     * 
     * @type {boolean}
     * @memberof HedgePlanModel
     */
    'applyPpi': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof HedgePlanModel
     */
    'weightPriceCurveByVolume': boolean;
    /**
     * 
     * @type {string}
     * @memberof HedgePlanModel
     */
    'configuration': string;
    /**
     * 
     * @type {number}
     * @memberof HedgePlanModel
     */
    'seasonsAhead': number;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const HedgePlanOverHedgeLimit = {
    Hundred: 'Hundred',
    MaxTarget: 'MaxTarget'
} as const;

export type HedgePlanOverHedgeLimit = typeof HedgePlanOverHedgeLimit[keyof typeof HedgePlanOverHedgeLimit];


/**
 * 
 * @export
 * @interface HedgePlanPricePointModel
 */
export interface HedgePlanPricePointModel {
    /**
     * 
     * @type {string}
     * @memberof HedgePlanPricePointModel
     */
    'date'?: string;
    /**
     * 
     * @type {number}
     * @memberof HedgePlanPricePointModel
     */
    'price'?: number | null;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const HedgePlanRecommendationReason = {
    OverHedged: 'OverHedged',
    OverTarget: 'OverTarget',
    MissedTimeTrigger: 'MissedTimeTrigger',
    ApproachingTimeTrigger: 'ApproachingTimeTrigger',
    HitValueTrigger: 'HitValueTrigger'
} as const;

export type HedgePlanRecommendationReason = typeof HedgePlanRecommendationReason[keyof typeof HedgePlanRecommendationReason];


/**
 * 
 * @export
 * @interface HedgePlanSeasonModel
 */
export interface HedgePlanSeasonModel {
    /**
     * 
     * @type {number}
     * @memberof HedgePlanSeasonModel
     */
    'year': number;
    /**
     * 
     * @type {MatrixTerm}
     * @memberof HedgePlanSeasonModel
     */
    'term': MatrixTerm;
    /**
     * 
     * @type {string}
     * @memberof HedgePlanSeasonModel
     */
    'label': string;
    /**
     * 
     * @type {string}
     * @memberof HedgePlanSeasonModel
     */
    'startDate': string;
    /**
     * 
     * @type {string}
     * @memberof HedgePlanSeasonModel
     */
    'endDate': string;
    /**
     * 
     * @type {boolean}
     * @memberof HedgePlanSeasonModel
     */
    'isCurrent': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof HedgePlanSeasonModel
     */
    'isHidden': boolean;
    /**
     * 
     * @type {number}
     * @memberof HedgePlanSeasonModel
     */
    'budgetAdjustment'?: number | null;
}
/**
 * 
 * @export
 * @interface HedgePlanSeasonSummaryModel
 */
export interface HedgePlanSeasonSummaryModel {
    /**
     * 
     * @type {string}
     * @memberof HedgePlanSeasonSummaryModel
     */
    'quoteDate': string;
    /**
     * 
     * @type {number}
     * @memberof HedgePlanSeasonSummaryModel
     */
    'currentMarketPrice'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof HedgePlanSeasonSummaryModel
     */
    'budgetPrice'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof HedgePlanSeasonSummaryModel
     */
    'averageHedgePrice'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof HedgePlanSeasonSummaryModel
     */
    'hedgedPercent'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof HedgePlanSeasonSummaryModel
     */
    'hedgedVolume'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof HedgePlanSeasonSummaryModel
     */
    'minimumHedgePercent': number;
    /**
     * 
     * @type {number}
     * @memberof HedgePlanSeasonSummaryModel
     */
    'minimumHedgeVolume'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof HedgePlanSeasonSummaryModel
     */
    'maximumHedgePercent': number;
    /**
     * 
     * @type {number}
     * @memberof HedgePlanSeasonSummaryModel
     */
    'maximumHedgeVolume'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof HedgePlanSeasonSummaryModel
     */
    'recommendationPercent'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof HedgePlanSeasonSummaryModel
     */
    'recommendationVolume'?: number | null;
    /**
     * 
     * @type {Array<HedgePlanRecommendationReason>}
     * @memberof HedgePlanSeasonSummaryModel
     */
    'recommendationReasons': Array<HedgePlanRecommendationReason>;
    /**
     * 
     * @type {Array<HedgePlanDecileBandModel>}
     * @memberof HedgePlanSeasonSummaryModel
     */
    'decileBands': Array<HedgePlanDecileBandModel>;
    /**
     * 
     * @type {Array<HedgePlanTriggerProgressModel>}
     * @memberof HedgePlanSeasonSummaryModel
     */
    'triggers': Array<HedgePlanTriggerProgressModel>;
    /**
     * 
     * @type {Array<HedgePlanTradeModel>}
     * @memberof HedgePlanSeasonSummaryModel
     */
    'trades': Array<HedgePlanTradeModel>;
}
/**
 * 
 * @export
 * @interface HedgePlanTermReportModel
 */
export interface HedgePlanTermReportModel {
    /**
     * 
     * @type {MatrixTerm}
     * @memberof HedgePlanTermReportModel
     */
    'term': MatrixTerm;
    /**
     * 
     * @type {string}
     * @memberof HedgePlanTermReportModel
     */
    'termLabel': string;
    /**
     * 
     * @type {number}
     * @memberof HedgePlanTermReportModel
     */
    'year': number;
    /**
     * 
     * @type {Array<HedgePlanPricePointModel>}
     * @memberof HedgePlanTermReportModel
     */
    'priceSeries': Array<HedgePlanPricePointModel>;
    /**
     * 
     * @type {Array<HedgePlanDecilePointModel>}
     * @memberof HedgePlanTermReportModel
     */
    'decileSeries': Array<HedgePlanDecilePointModel>;
    /**
     * 
     * @type {Array<HedgePlanVolumePointModel>}
     * @memberof HedgePlanTermReportModel
     */
    'volumeSeries': Array<HedgePlanVolumePointModel>;
    /**
     * 
     * @type {number}
     * @memberof HedgePlanTermReportModel
     */
    'budgetedVolume'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof HedgePlanTermReportModel
     */
    'budgetAdjustment'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof HedgePlanTermReportModel
     */
    'totalVolume'?: number | null;
    /**
     * 
     * @type {Unit}
     * @memberof HedgePlanTermReportModel
     */
    'volumeUnit'?: Unit;
    /**
     * 
     * @type {boolean}
     * @memberof HedgePlanTermReportModel
     */
    'isWeightedByVolume': boolean;
    /**
     * 
     * @type {HedgePlanSeasonSummaryModel}
     * @memberof HedgePlanTermReportModel
     */
    'summary': HedgePlanSeasonSummaryModel;
}
/**
 * 
 * @export
 * @interface HedgePlanTimeTriggerModel
 */
export interface HedgePlanTimeTriggerModel {
    /**
     * 
     * @type {number}
     * @memberof HedgePlanTimeTriggerModel
     */
    'hedgePlanTimeTriggerId': number;
    /**
     * 
     * @type {number}
     * @memberof HedgePlanTimeTriggerModel
     */
    'hedgePlanId': number;
    /**
     * 
     * @type {number}
     * @memberof HedgePlanTimeTriggerModel
     */
    'year': number;
    /**
     * 
     * @type {MatrixTerm}
     * @memberof HedgePlanTimeTriggerModel
     */
    'term': MatrixTerm;
    /**
     * 
     * @type {number}
     * @memberof HedgePlanTimeTriggerModel
     */
    'seasonPosition'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof HedgePlanTimeTriggerModel
     */
    'triggerDate': string;
    /**
     * 
     * @type {number}
     * @memberof HedgePlanTimeTriggerModel
     */
    'targetHedgePercent': number;
    /**
     * 
     * @type {boolean}
     * @memberof HedgePlanTimeTriggerModel
     */
    'disabled': boolean;
    /**
     * 
     * @type {string}
     * @memberof HedgePlanTimeTriggerModel
     */
    'note'?: string | null;
}
/**
 * 
 * @export
 * @interface HedgePlanTradeModel
 */
export interface HedgePlanTradeModel {
    /**
     * 
     * @type {number}
     * @memberof HedgePlanTradeModel
     */
    'hedgePlanTradeId': number;
    /**
     * 
     * @type {number}
     * @memberof HedgePlanTradeModel
     */
    'hedgePlanId': number;
    /**
     * 
     * @type {number}
     * @memberof HedgePlanTradeModel
     */
    'year': number;
    /**
     * 
     * @type {MatrixTerm}
     * @memberof HedgePlanTradeModel
     */
    'term': MatrixTerm;
    /**
     * 
     * @type {HedgePlanExecutionType}
     * @memberof HedgePlanTradeModel
     */
    'executionType': HedgePlanExecutionType;
    /**
     * 
     * @type {string}
     * @memberof HedgePlanTradeModel
     */
    'tradeDate': string;
    /**
     * 
     * @type {number}
     * @memberof HedgePlanTradeModel
     */
    'volumePercent'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof HedgePlanTradeModel
     */
    'volume'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof HedgePlanTradeModel
     */
    'price'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof HedgePlanTradeModel
     */
    'triggerDecilePercentile'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof HedgePlanTradeModel
     */
    'triggerPrice'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof HedgePlanTradeModel
     */
    'triggerDate'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof HedgePlanTradeModel
     */
    'isTriggerMissing': boolean;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const HedgePlanTriggerFulfillmentStatus = {
    None: 'None',
    Partial: 'Partial',
    Full: 'Full'
} as const;

export type HedgePlanTriggerFulfillmentStatus = typeof HedgePlanTriggerFulfillmentStatus[keyof typeof HedgePlanTriggerFulfillmentStatus];


/**
 * 
 * @export
 * @interface HedgePlanTriggerProgressModel
 */
export interface HedgePlanTriggerProgressModel {
    /**
     * 
     * @type {HedgePlanExecutionType}
     * @memberof HedgePlanTriggerProgressModel
     */
    'triggerType'?: HedgePlanExecutionType;
    /**
     * 
     * @type {number}
     * @memberof HedgePlanTriggerProgressModel
     */
    'triggerId'?: number;
    /**
     * 
     * @type {number}
     * @memberof HedgePlanTriggerProgressModel
     */
    'targetHedgePercent'?: number;
    /**
     * 
     * @type {number}
     * @memberof HedgePlanTriggerProgressModel
     */
    'targetHedgeVolume'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof HedgePlanTriggerProgressModel
     */
    'fulfilledPercent'?: number;
    /**
     * 
     * @type {number}
     * @memberof HedgePlanTriggerProgressModel
     */
    'fulfilledVolume'?: number | null;
    /**
     * 
     * @type {HedgePlanTriggerFulfillmentStatus}
     * @memberof HedgePlanTriggerProgressModel
     */
    'status'?: HedgePlanTriggerFulfillmentStatus;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const HedgePlanType = {
    Static: 'Static',
    Rolling: 'Rolling'
} as const;

export type HedgePlanType = typeof HedgePlanType[keyof typeof HedgePlanType];


/**
 * 
 * @export
 * @interface HedgePlanValueTriggerModel
 */
export interface HedgePlanValueTriggerModel {
    /**
     * 
     * @type {number}
     * @memberof HedgePlanValueTriggerModel
     */
    'hedgePlanValueTriggerId': number;
    /**
     * 
     * @type {number}
     * @memberof HedgePlanValueTriggerModel
     */
    'hedgePlanId': number;
    /**
     * 
     * @type {number}
     * @memberof HedgePlanValueTriggerModel
     */
    'year': number;
    /**
     * 
     * @type {MatrixTerm}
     * @memberof HedgePlanValueTriggerModel
     */
    'term': MatrixTerm;
    /**
     * 
     * @type {number}
     * @memberof HedgePlanValueTriggerModel
     */
    'seasonPosition'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof HedgePlanValueTriggerModel
     */
    'decilePercentile': number;
    /**
     * 
     * @type {number}
     * @memberof HedgePlanValueTriggerModel
     */
    'targetHedgePercent': number;
    /**
     * 
     * @type {boolean}
     * @memberof HedgePlanValueTriggerModel
     */
    'disabled': boolean;
    /**
     * 
     * @type {string}
     * @memberof HedgePlanValueTriggerModel
     */
    'note'?: string | null;
}
/**
 * 
 * @export
 * @interface HedgePlanVolumePointModel
 */
export interface HedgePlanVolumePointModel {
    /**
     * 
     * @type {number}
     * @memberof HedgePlanVolumePointModel
     */
    'contractYear'?: number;
    /**
     * 
     * @type {number}
     * @memberof HedgePlanVolumePointModel
     */
    'contractMonth'?: number;
    /**
     * 
     * @type {number}
     * @memberof HedgePlanVolumePointModel
     */
    'volume'?: number;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const HedgeSource = {
    Positions: 'Positions',
    AlwaysFullyHedged: 'AlwaysFullyHedged',
    MatchAllInHedge: 'MatchAllInHedge'
} as const;

export type HedgeSource = typeof HedgeSource[keyof typeof HedgeSource];


/**
 * 
 * @export
 * @interface KnowRiskEnergyCustomerModel
 */
export interface KnowRiskEnergyCustomerModel {
    /**
     * 
     * @type {number}
     * @memberof KnowRiskEnergyCustomerModel
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof KnowRiskEnergyCustomerModel
     */
    'name'?: string | null;
}
/**
 * 
 * @export
 * @interface KnowRiskEnergyLocationModel
 */
export interface KnowRiskEnergyLocationModel {
    /**
     * 
     * @type {number}
     * @memberof KnowRiskEnergyLocationModel
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof KnowRiskEnergyLocationModel
     */
    'name'?: string | null;
}
/**
 * 
 * @export
 * @interface ListAllocationsResponse
 */
export interface ListAllocationsResponse {
    /**
     * 
     * @type {Array<AllocationModel>}
     * @memberof ListAllocationsResponse
     */
    'rows'?: Array<AllocationModel> | null;
    /**
     * 
     * @type {number}
     * @memberof ListAllocationsResponse
     */
    'totalCount'?: number;
    /**
     * 
     * @type {string}
     * @memberof ListAllocationsResponse
     */
    'sortColumn'?: string | null;
    /**
     * 
     * @type {SortDirection}
     * @memberof ListAllocationsResponse
     */
    'sortDirection'?: SortDirection;
    /**
     * 
     * @type {number}
     * @memberof ListAllocationsResponse
     */
    'take'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ListAllocationsResponse
     */
    'skip'?: number;
}
/**
 * 
 * @export
 * @interface ListBudgetYearAllotmentPropertiesResponse
 */
export interface ListBudgetYearAllotmentPropertiesResponse {
    /**
     * 
     * @type {Array<YearAllotmentDataModel>}
     * @memberof ListBudgetYearAllotmentPropertiesResponse
     */
    'rows'?: Array<YearAllotmentDataModel> | null;
    /**
     * 
     * @type {number}
     * @memberof ListBudgetYearAllotmentPropertiesResponse
     */
    'totalCount'?: number;
    /**
     * 
     * @type {string}
     * @memberof ListBudgetYearAllotmentPropertiesResponse
     */
    'sortColumn'?: string | null;
    /**
     * 
     * @type {SortDirection}
     * @memberof ListBudgetYearAllotmentPropertiesResponse
     */
    'sortDirection'?: SortDirection;
    /**
     * 
     * @type {number}
     * @memberof ListBudgetYearAllotmentPropertiesResponse
     */
    'take'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ListBudgetYearAllotmentPropertiesResponse
     */
    'skip'?: number;
}
/**
 * 
 * @export
 * @interface ListBudgetYearsResponse
 */
export interface ListBudgetYearsResponse {
    /**
     * 
     * @type {Array<YearDataModel>}
     * @memberof ListBudgetYearsResponse
     */
    'rows'?: Array<YearDataModel> | null;
    /**
     * 
     * @type {number}
     * @memberof ListBudgetYearsResponse
     */
    'totalCount'?: number;
    /**
     * 
     * @type {string}
     * @memberof ListBudgetYearsResponse
     */
    'sortColumn'?: string | null;
    /**
     * 
     * @type {SortDirection}
     * @memberof ListBudgetYearsResponse
     */
    'sortDirection'?: SortDirection;
    /**
     * 
     * @type {number}
     * @memberof ListBudgetYearsResponse
     */
    'take'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ListBudgetYearsResponse
     */
    'skip'?: number;
}
/**
 * 
 * @export
 * @interface ListBudgetsResponse
 */
export interface ListBudgetsResponse {
    /**
     * 
     * @type {Array<BudgetModel>}
     * @memberof ListBudgetsResponse
     */
    'rows'?: Array<BudgetModel> | null;
    /**
     * 
     * @type {number}
     * @memberof ListBudgetsResponse
     */
    'totalCount'?: number;
    /**
     * 
     * @type {string}
     * @memberof ListBudgetsResponse
     */
    'sortColumn'?: string | null;
    /**
     * 
     * @type {SortDirection}
     * @memberof ListBudgetsResponse
     */
    'sortDirection'?: SortDirection;
    /**
     * 
     * @type {number}
     * @memberof ListBudgetsResponse
     */
    'take'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ListBudgetsResponse
     */
    'skip'?: number;
}
/**
 * 
 * @export
 * @interface ListCommodityContractMonthMappingsResponse
 */
export interface ListCommodityContractMonthMappingsResponse {
    /**
     * 
     * @type {Array<CommodityContractMonthMappingModel>}
     * @memberof ListCommodityContractMonthMappingsResponse
     */
    'rows'?: Array<CommodityContractMonthMappingModel> | null;
    /**
     * 
     * @type {number}
     * @memberof ListCommodityContractMonthMappingsResponse
     */
    'totalCount'?: number;
    /**
     * 
     * @type {string}
     * @memberof ListCommodityContractMonthMappingsResponse
     */
    'sortColumn'?: string | null;
    /**
     * 
     * @type {SortDirection}
     * @memberof ListCommodityContractMonthMappingsResponse
     */
    'sortDirection'?: SortDirection;
    /**
     * 
     * @type {number}
     * @memberof ListCommodityContractMonthMappingsResponse
     */
    'take'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ListCommodityContractMonthMappingsResponse
     */
    'skip'?: number;
}
/**
 * 
 * @export
 * @interface ListCommodityManagementSiteUsersResponse
 */
export interface ListCommodityManagementSiteUsersResponse {
    /**
     * 
     * @type {Array<CommodityManagementSiteUserModel>}
     * @memberof ListCommodityManagementSiteUsersResponse
     */
    'rows'?: Array<CommodityManagementSiteUserModel> | null;
    /**
     * 
     * @type {number}
     * @memberof ListCommodityManagementSiteUsersResponse
     */
    'totalCount'?: number;
    /**
     * 
     * @type {string}
     * @memberof ListCommodityManagementSiteUsersResponse
     */
    'sortColumn'?: string | null;
    /**
     * 
     * @type {SortDirection}
     * @memberof ListCommodityManagementSiteUsersResponse
     */
    'sortDirection'?: SortDirection;
    /**
     * 
     * @type {number}
     * @memberof ListCommodityManagementSiteUsersResponse
     */
    'take'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ListCommodityManagementSiteUsersResponse
     */
    'skip'?: number;
}
/**
 * 
 * @export
 * @interface ListCommodityManagementSitesResponse
 */
export interface ListCommodityManagementSitesResponse {
    /**
     * 
     * @type {Array<CommodityManagementSiteModel>}
     * @memberof ListCommodityManagementSitesResponse
     */
    'rows'?: Array<CommodityManagementSiteModel> | null;
    /**
     * 
     * @type {number}
     * @memberof ListCommodityManagementSitesResponse
     */
    'totalCount'?: number;
    /**
     * 
     * @type {string}
     * @memberof ListCommodityManagementSitesResponse
     */
    'sortColumn'?: string | null;
    /**
     * 
     * @type {SortDirection}
     * @memberof ListCommodityManagementSitesResponse
     */
    'sortDirection'?: SortDirection;
    /**
     * 
     * @type {number}
     * @memberof ListCommodityManagementSitesResponse
     */
    'take'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ListCommodityManagementSitesResponse
     */
    'skip'?: number;
}
/**
 * 
 * @export
 * @interface ListCompaniesResponse
 */
export interface ListCompaniesResponse {
    /**
     * 
     * @type {Array<CompanyModel>}
     * @memberof ListCompaniesResponse
     */
    'rows'?: Array<CompanyModel> | null;
    /**
     * 
     * @type {number}
     * @memberof ListCompaniesResponse
     */
    'totalCount'?: number;
    /**
     * 
     * @type {string}
     * @memberof ListCompaniesResponse
     */
    'sortColumn'?: string | null;
    /**
     * 
     * @type {SortDirection}
     * @memberof ListCompaniesResponse
     */
    'sortDirection'?: SortDirection;
    /**
     * 
     * @type {number}
     * @memberof ListCompaniesResponse
     */
    'take'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ListCompaniesResponse
     */
    'skip'?: number;
}
/**
 * 
 * @export
 * @interface ListDefaultBudgetRoundsResponse
 */
export interface ListDefaultBudgetRoundsResponse {
    /**
     * 
     * @type {Array<DefaultBudgetRoundModel>}
     * @memberof ListDefaultBudgetRoundsResponse
     */
    'rows'?: Array<DefaultBudgetRoundModel> | null;
    /**
     * 
     * @type {number}
     * @memberof ListDefaultBudgetRoundsResponse
     */
    'totalCount'?: number;
    /**
     * 
     * @type {string}
     * @memberof ListDefaultBudgetRoundsResponse
     */
    'sortColumn'?: string | null;
    /**
     * 
     * @type {SortDirection}
     * @memberof ListDefaultBudgetRoundsResponse
     */
    'sortDirection'?: SortDirection;
    /**
     * 
     * @type {number}
     * @memberof ListDefaultBudgetRoundsResponse
     */
    'take'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ListDefaultBudgetRoundsResponse
     */
    'skip'?: number;
}
/**
 * 
 * @export
 * @interface ListDeliveriesResponse
 */
export interface ListDeliveriesResponse {
    /**
     * 
     * @type {Array<DeliveryModel>}
     * @memberof ListDeliveriesResponse
     */
    'rows'?: Array<DeliveryModel> | null;
    /**
     * 
     * @type {number}
     * @memberof ListDeliveriesResponse
     */
    'totalCount'?: number;
    /**
     * 
     * @type {string}
     * @memberof ListDeliveriesResponse
     */
    'sortColumn'?: string | null;
    /**
     * 
     * @type {SortDirection}
     * @memberof ListDeliveriesResponse
     */
    'sortDirection'?: SortDirection;
    /**
     * 
     * @type {number}
     * @memberof ListDeliveriesResponse
     */
    'take'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ListDeliveriesResponse
     */
    'skip'?: number;
}
/**
 * 
 * @export
 * @interface ListDocumentsResponse
 */
export interface ListDocumentsResponse {
    /**
     * 
     * @type {Array<DocumentModel>}
     * @memberof ListDocumentsResponse
     */
    'rows'?: Array<DocumentModel> | null;
    /**
     * 
     * @type {number}
     * @memberof ListDocumentsResponse
     */
    'totalCount'?: number;
    /**
     * 
     * @type {string}
     * @memberof ListDocumentsResponse
     */
    'sortColumn'?: string | null;
    /**
     * 
     * @type {SortDirection}
     * @memberof ListDocumentsResponse
     */
    'sortDirection'?: SortDirection;
    /**
     * 
     * @type {number}
     * @memberof ListDocumentsResponse
     */
    'take'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ListDocumentsResponse
     */
    'skip'?: number;
}
/**
 * 
 * @export
 * @interface ListEiaNaturalGasStorageWeeksResponse
 */
export interface ListEiaNaturalGasStorageWeeksResponse {
    /**
     * 
     * @type {EiaNaturalGasStorageDataSource}
     * @memberof ListEiaNaturalGasStorageWeeksResponse
     */
    'dataSource'?: EiaNaturalGasStorageDataSource;
    /**
     * 
     * @type {Array<EiaNaturalGasStorageWeekModel>}
     * @memberof ListEiaNaturalGasStorageWeeksResponse
     */
    'rows'?: Array<EiaNaturalGasStorageWeekModel> | null;
    /**
     * 
     * @type {number}
     * @memberof ListEiaNaturalGasStorageWeeksResponse
     */
    'totalCount'?: number;
    /**
     * 
     * @type {string}
     * @memberof ListEiaNaturalGasStorageWeeksResponse
     */
    'sortColumn'?: string | null;
    /**
     * 
     * @type {SortDirection}
     * @memberof ListEiaNaturalGasStorageWeeksResponse
     */
    'sortDirection'?: SortDirection;
    /**
     * 
     * @type {number}
     * @memberof ListEiaNaturalGasStorageWeeksResponse
     */
    'take'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ListEiaNaturalGasStorageWeeksResponse
     */
    'skip'?: number;
}
/**
 * 
 * @export
 * @interface ListEmailSchedulesResponse
 */
export interface ListEmailSchedulesResponse {
    /**
     * 
     * @type {Array<EmailScheduleModel>}
     * @memberof ListEmailSchedulesResponse
     */
    'rows'?: Array<EmailScheduleModel> | null;
    /**
     * 
     * @type {number}
     * @memberof ListEmailSchedulesResponse
     */
    'totalCount'?: number;
    /**
     * 
     * @type {string}
     * @memberof ListEmailSchedulesResponse
     */
    'sortColumn'?: string | null;
    /**
     * 
     * @type {SortDirection}
     * @memberof ListEmailSchedulesResponse
     */
    'sortDirection'?: SortDirection;
    /**
     * 
     * @type {number}
     * @memberof ListEmailSchedulesResponse
     */
    'take'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ListEmailSchedulesResponse
     */
    'skip'?: number;
}
/**
 * 
 * @export
 * @interface ListHedgePlanDataResponse
 */
export interface ListHedgePlanDataResponse {
    /**
     * 
     * @type {HedgePlanModel}
     * @memberof ListHedgePlanDataResponse
     */
    'hedgePlan'?: HedgePlanModel;
    /**
     * 
     * @type {Array<HedgePlanValueTriggerModel>}
     * @memberof ListHedgePlanDataResponse
     */
    'valueTriggers'?: Array<HedgePlanValueTriggerModel> | null;
    /**
     * 
     * @type {Array<HedgePlanBudgetTriggerModel>}
     * @memberof ListHedgePlanDataResponse
     */
    'budgetTriggers'?: Array<HedgePlanBudgetTriggerModel> | null;
    /**
     * 
     * @type {Array<HedgePlanTimeTriggerModel>}
     * @memberof ListHedgePlanDataResponse
     */
    'timeTriggers'?: Array<HedgePlanTimeTriggerModel> | null;
    /**
     * 
     * @type {Array<HedgePlanTradeModel>}
     * @memberof ListHedgePlanDataResponse
     */
    'trades'?: Array<HedgePlanTradeModel> | null;
}
/**
 * 
 * @export
 * @interface ListHedgePlanSeasonsResponse
 */
export interface ListHedgePlanSeasonsResponse {
    /**
     * 
     * @type {Array<HedgePlanSeasonModel>}
     * @memberof ListHedgePlanSeasonsResponse
     */
    'rows'?: Array<HedgePlanSeasonModel> | null;
    /**
     * 
     * @type {HedgePlanSeasonModel}
     * @memberof ListHedgePlanSeasonsResponse
     */
    'nextSeason'?: HedgePlanSeasonModel;
    /**
     * 
     * @type {Array<HedgePlanSeasonModel>}
     * @memberof ListHedgePlanSeasonsResponse
     */
    'previousSeasons'?: Array<HedgePlanSeasonModel> | null;
}
/**
 * 
 * @export
 * @interface ListHedgePlansResponse
 */
export interface ListHedgePlansResponse {
    /**
     * 
     * @type {Array<HedgePlanModel>}
     * @memberof ListHedgePlansResponse
     */
    'rows'?: Array<HedgePlanModel> | null;
    /**
     * 
     * @type {number}
     * @memberof ListHedgePlansResponse
     */
    'totalCount'?: number;
    /**
     * 
     * @type {string}
     * @memberof ListHedgePlansResponse
     */
    'sortColumn'?: string | null;
    /**
     * 
     * @type {SortDirection}
     * @memberof ListHedgePlansResponse
     */
    'sortDirection'?: SortDirection;
    /**
     * 
     * @type {number}
     * @memberof ListHedgePlansResponse
     */
    'take'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ListHedgePlansResponse
     */
    'skip'?: number;
}
/**
 * 
 * @export
 * @interface ListKnowRiskEnergyCustomersResponse
 */
export interface ListKnowRiskEnergyCustomersResponse {
    /**
     * 
     * @type {Array<KnowRiskEnergyCustomerModel>}
     * @memberof ListKnowRiskEnergyCustomersResponse
     */
    'rows'?: Array<KnowRiskEnergyCustomerModel> | null;
}
/**
 * 
 * @export
 * @interface ListKnowRiskEnergyLocationsResponse
 */
export interface ListKnowRiskEnergyLocationsResponse {
    /**
     * 
     * @type {Array<KnowRiskEnergyLocationModel>}
     * @memberof ListKnowRiskEnergyLocationsResponse
     */
    'rows'?: Array<KnowRiskEnergyLocationModel> | null;
}
/**
 * 
 * @export
 * @interface ListMarketViewContractPricesRequest
 */
export interface ListMarketViewContractPricesRequest {
    /**
     * 
     * @type {Array<MarketViewPriceQuery>}
     * @memberof ListMarketViewContractPricesRequest
     */
    'marketViewPriceQuery'?: Array<MarketViewPriceQuery> | null;
    /**
     * 
     * @type {string}
     * @memberof ListMarketViewContractPricesRequest
     */
    'quoteDate'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ListMarketViewContractPricesRequest
     */
    'includeSettled'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ListMarketViewContractPricesRequest
     */
    'calculateGreeks'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ListMarketViewContractPricesRequest
     */
    'resolveToOptionProducts'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ListMarketViewContractPricesRequest
     */
    'implyOptionsIfNotFound'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ListMarketViewContractPricesRequest
     */
    'sortColumn'?: string | null;
    /**
     * 
     * @type {SortDirection}
     * @memberof ListMarketViewContractPricesRequest
     */
    'sortDirection'?: SortDirection;
    /**
     * 
     * @type {number}
     * @memberof ListMarketViewContractPricesRequest
     */
    'take'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ListMarketViewContractPricesRequest
     */
    'skip'?: number | null;
}
/**
 * 
 * @export
 * @interface ListMarketViewContractPricesResponse
 */
export interface ListMarketViewContractPricesResponse {
    /**
     * 
     * @type {Array<MarketViewPriceModel>}
     * @memberof ListMarketViewContractPricesResponse
     */
    'rows'?: Array<MarketViewPriceModel> | null;
    /**
     * 
     * @type {number}
     * @memberof ListMarketViewContractPricesResponse
     */
    'totalCount'?: number;
    /**
     * 
     * @type {string}
     * @memberof ListMarketViewContractPricesResponse
     */
    'sortColumn'?: string | null;
    /**
     * 
     * @type {SortDirection}
     * @memberof ListMarketViewContractPricesResponse
     */
    'sortDirection'?: SortDirection;
    /**
     * 
     * @type {number}
     * @memberof ListMarketViewContractPricesResponse
     */
    'take'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ListMarketViewContractPricesResponse
     */
    'skip'?: number;
}
/**
 * 
 * @export
 * @interface ListMarketViewCurrencySpotRatesResponse
 */
export interface ListMarketViewCurrencySpotRatesResponse {
    /**
     * 
     * @type {{ [key: string]: { [key: string]: MarketViewSpotPriceModel; }; }}
     * @memberof ListMarketViewCurrencySpotRatesResponse
     */
    'currencyPairToSpotRates'?: { [key: string]: { [key: string]: MarketViewSpotPriceModel; }; } | null;
}
/**
 * 
 * @export
 * @interface ListMarketViewExpirationDatesResponse
 */
export interface ListMarketViewExpirationDatesResponse {
    /**
     * 
     * @type {{ [key: string]: { [key: string]: string; }; }}
     * @memberof ListMarketViewExpirationDatesResponse
     */
    'productIdToContractDateToExpiration'?: { [key: string]: { [key: string]: string; }; } | null;
    /**
     * 
     * @type {{ [key: string]: { [key: string]: MarketViewExpirationDateModel; }; }}
     * @memberof ListMarketViewExpirationDatesResponse
     */
    'productIdToContractDateToExpirationModel'?: { [key: string]: { [key: string]: MarketViewExpirationDateModel; }; } | null;
}
/**
 * 
 * @export
 * @interface ListMarketViewInternalProductsResponse
 */
export interface ListMarketViewInternalProductsResponse {
    /**
     * 
     * @type {Array<MarketViewProductModel>}
     * @memberof ListMarketViewInternalProductsResponse
     */
    'rows'?: Array<MarketViewProductModel> | null;
    /**
     * 
     * @type {number}
     * @memberof ListMarketViewInternalProductsResponse
     */
    'totalCount'?: number;
    /**
     * 
     * @type {string}
     * @memberof ListMarketViewInternalProductsResponse
     */
    'sortColumn'?: string | null;
    /**
     * 
     * @type {SortDirection}
     * @memberof ListMarketViewInternalProductsResponse
     */
    'sortDirection'?: SortDirection;
    /**
     * 
     * @type {number}
     * @memberof ListMarketViewInternalProductsResponse
     */
    'take'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ListMarketViewInternalProductsResponse
     */
    'skip'?: number;
}
/**
 * 
 * @export
 * @interface ListMarketViewLastQuoteDateResponse
 */
export interface ListMarketViewLastQuoteDateResponse {
    /**
     * 
     * @type {Array<MarketViewLastQuoteDateModel>}
     * @memberof ListMarketViewLastQuoteDateResponse
     */
    'rows'?: Array<MarketViewLastQuoteDateModel> | null;
    /**
     * 
     * @type {number}
     * @memberof ListMarketViewLastQuoteDateResponse
     */
    'totalCount'?: number;
    /**
     * 
     * @type {string}
     * @memberof ListMarketViewLastQuoteDateResponse
     */
    'sortColumn'?: string | null;
    /**
     * 
     * @type {SortDirection}
     * @memberof ListMarketViewLastQuoteDateResponse
     */
    'sortDirection'?: SortDirection;
    /**
     * 
     * @type {number}
     * @memberof ListMarketViewLastQuoteDateResponse
     */
    'take'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ListMarketViewLastQuoteDateResponse
     */
    'skip'?: number;
}
/**
 * 
 * @export
 * @interface ListMarketViewPricesResponse
 */
export interface ListMarketViewPricesResponse {
    /**
     * 
     * @type {Array<MarketViewPriceModel>}
     * @memberof ListMarketViewPricesResponse
     */
    'rows'?: Array<MarketViewPriceModel> | null;
    /**
     * 
     * @type {number}
     * @memberof ListMarketViewPricesResponse
     */
    'totalCount'?: number;
    /**
     * 
     * @type {string}
     * @memberof ListMarketViewPricesResponse
     */
    'sortColumn'?: string | null;
    /**
     * 
     * @type {SortDirection}
     * @memberof ListMarketViewPricesResponse
     */
    'sortDirection'?: SortDirection;
    /**
     * 
     * @type {number}
     * @memberof ListMarketViewPricesResponse
     */
    'take'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ListMarketViewPricesResponse
     */
    'skip'?: number;
}
/**
 * 
 * @export
 * @interface ListMarketViewProductTypesResponse
 */
export interface ListMarketViewProductTypesResponse {
    /**
     * 
     * @type {Array<MarketViewProductTypeModel>}
     * @memberof ListMarketViewProductTypesResponse
     */
    'rows'?: Array<MarketViewProductTypeModel> | null;
    /**
     * 
     * @type {number}
     * @memberof ListMarketViewProductTypesResponse
     */
    'totalCount'?: number;
    /**
     * 
     * @type {string}
     * @memberof ListMarketViewProductTypesResponse
     */
    'sortColumn'?: string | null;
    /**
     * 
     * @type {SortDirection}
     * @memberof ListMarketViewProductTypesResponse
     */
    'sortDirection'?: SortDirection;
    /**
     * 
     * @type {number}
     * @memberof ListMarketViewProductTypesResponse
     */
    'take'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ListMarketViewProductTypesResponse
     */
    'skip'?: number;
}
/**
 * 
 * @export
 * @interface ListMarketViewProductsResponse
 */
export interface ListMarketViewProductsResponse {
    /**
     * 
     * @type {Array<MarketViewProductModel>}
     * @memberof ListMarketViewProductsResponse
     */
    'rows'?: Array<MarketViewProductModel> | null;
    /**
     * 
     * @type {number}
     * @memberof ListMarketViewProductsResponse
     */
    'totalCount'?: number;
    /**
     * 
     * @type {string}
     * @memberof ListMarketViewProductsResponse
     */
    'sortColumn'?: string | null;
    /**
     * 
     * @type {SortDirection}
     * @memberof ListMarketViewProductsResponse
     */
    'sortDirection'?: SortDirection;
    /**
     * 
     * @type {number}
     * @memberof ListMarketViewProductsResponse
     */
    'take'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ListMarketViewProductsResponse
     */
    'skip'?: number;
}
/**
 * 
 * @export
 * @interface ListMarketViewSavedQueryResponse
 */
export interface ListMarketViewSavedQueryResponse {
    /**
     * 
     * @type {Array<MarkItViewSavedQueryModel>}
     * @memberof ListMarketViewSavedQueryResponse
     */
    'rows'?: Array<MarkItViewSavedQueryModel> | null;
    /**
     * 
     * @type {number}
     * @memberof ListMarketViewSavedQueryResponse
     */
    'totalCount'?: number;
    /**
     * 
     * @type {string}
     * @memberof ListMarketViewSavedQueryResponse
     */
    'sortColumn'?: string | null;
    /**
     * 
     * @type {SortDirection}
     * @memberof ListMarketViewSavedQueryResponse
     */
    'sortDirection'?: SortDirection;
    /**
     * 
     * @type {number}
     * @memberof ListMarketViewSavedQueryResponse
     */
    'take'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ListMarketViewSavedQueryResponse
     */
    'skip'?: number;
}
/**
 * 
 * @export
 * @interface ListMarketViewUsersResponse
 */
export interface ListMarketViewUsersResponse {
    /**
     * 
     * @type {Array<MarketViewUserModel>}
     * @memberof ListMarketViewUsersResponse
     */
    'rows'?: Array<MarketViewUserModel> | null;
    /**
     * 
     * @type {number}
     * @memberof ListMarketViewUsersResponse
     */
    'totalCount'?: number;
    /**
     * 
     * @type {string}
     * @memberof ListMarketViewUsersResponse
     */
    'sortColumn'?: string | null;
    /**
     * 
     * @type {SortDirection}
     * @memberof ListMarketViewUsersResponse
     */
    'sortDirection'?: SortDirection;
    /**
     * 
     * @type {number}
     * @memberof ListMarketViewUsersResponse
     */
    'take'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ListMarketViewUsersResponse
     */
    'skip'?: number;
}
/**
 * 
 * @export
 * @interface ListNotesResponse
 */
export interface ListNotesResponse {
    /**
     * 
     * @type {Array<NoteModel>}
     * @memberof ListNotesResponse
     */
    'rows'?: Array<NoteModel> | null;
    /**
     * 
     * @type {number}
     * @memberof ListNotesResponse
     */
    'totalCount'?: number;
    /**
     * 
     * @type {string}
     * @memberof ListNotesResponse
     */
    'sortColumn'?: string | null;
    /**
     * 
     * @type {SortDirection}
     * @memberof ListNotesResponse
     */
    'sortDirection'?: SortDirection;
    /**
     * 
     * @type {number}
     * @memberof ListNotesResponse
     */
    'take'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ListNotesResponse
     */
    'skip'?: number;
}
/**
 * 
 * @export
 * @interface ListPositionYearsResponse
 */
export interface ListPositionYearsResponse {
    /**
     * 
     * @type {Array<YearDataModel>}
     * @memberof ListPositionYearsResponse
     */
    'rows'?: Array<YearDataModel> | null;
    /**
     * 
     * @type {number}
     * @memberof ListPositionYearsResponse
     */
    'totalCount'?: number;
    /**
     * 
     * @type {string}
     * @memberof ListPositionYearsResponse
     */
    'sortColumn'?: string | null;
    /**
     * 
     * @type {SortDirection}
     * @memberof ListPositionYearsResponse
     */
    'sortDirection'?: SortDirection;
    /**
     * 
     * @type {number}
     * @memberof ListPositionYearsResponse
     */
    'take'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ListPositionYearsResponse
     */
    'skip'?: number;
}
/**
 * 
 * @export
 * @interface ListPositionsResponse
 */
export interface ListPositionsResponse {
    /**
     * 
     * @type {Array<PositionModel>}
     * @memberof ListPositionsResponse
     */
    'rows'?: Array<PositionModel> | null;
    /**
     * 
     * @type {number}
     * @memberof ListPositionsResponse
     */
    'totalCount'?: number;
    /**
     * 
     * @type {string}
     * @memberof ListPositionsResponse
     */
    'sortColumn'?: string | null;
    /**
     * 
     * @type {SortDirection}
     * @memberof ListPositionsResponse
     */
    'sortDirection'?: SortDirection;
    /**
     * 
     * @type {number}
     * @memberof ListPositionsResponse
     */
    'take'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ListPositionsResponse
     */
    'skip'?: number;
}
/**
 * 
 * @export
 * @interface ListPricingStrategiesResponse
 */
export interface ListPricingStrategiesResponse {
    /**
     * 
     * @type {Array<BudgetPricingStrategyModel>}
     * @memberof ListPricingStrategiesResponse
     */
    'rows'?: Array<BudgetPricingStrategyModel> | null;
    /**
     * 
     * @type {number}
     * @memberof ListPricingStrategiesResponse
     */
    'totalCount'?: number;
    /**
     * 
     * @type {string}
     * @memberof ListPricingStrategiesResponse
     */
    'sortColumn'?: string | null;
    /**
     * 
     * @type {SortDirection}
     * @memberof ListPricingStrategiesResponse
     */
    'sortDirection'?: SortDirection;
    /**
     * 
     * @type {number}
     * @memberof ListPricingStrategiesResponse
     */
    'take'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ListPricingStrategiesResponse
     */
    'skip'?: number;
}
/**
 * 
 * @export
 * @interface ListScenarioMarketPricesFromUploadResponse
 */
export interface ListScenarioMarketPricesFromUploadResponse {
    /**
     * 
     * @type {string}
     * @memberof ListScenarioMarketPricesFromUploadResponse
     */
    'readException'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof ListScenarioMarketPricesFromUploadResponse
     */
    'warnings'?: Array<string> | null;
    /**
     * 
     * @type {Array<ScenarioMarketPriceExcelTemplateRow>}
     * @memberof ListScenarioMarketPricesFromUploadResponse
     */
    'rows'?: Array<ScenarioMarketPriceExcelTemplateRow> | null;
    /**
     * 
     * @type {number}
     * @memberof ListScenarioMarketPricesFromUploadResponse
     */
    'totalCount'?: number;
    /**
     * 
     * @type {string}
     * @memberof ListScenarioMarketPricesFromUploadResponse
     */
    'sortColumn'?: string | null;
    /**
     * 
     * @type {SortDirection}
     * @memberof ListScenarioMarketPricesFromUploadResponse
     */
    'sortDirection'?: SortDirection;
    /**
     * 
     * @type {number}
     * @memberof ListScenarioMarketPricesFromUploadResponse
     */
    'take'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ListScenarioMarketPricesFromUploadResponse
     */
    'skip'?: number;
}
/**
 * 
 * @export
 * @interface ListWhatIfStrategyResponse
 */
export interface ListWhatIfStrategyResponse {
    /**
     * 
     * @type {Array<WhatIfStrategyModel>}
     * @memberof ListWhatIfStrategyResponse
     */
    'rows'?: Array<WhatIfStrategyModel> | null;
    /**
     * 
     * @type {number}
     * @memberof ListWhatIfStrategyResponse
     */
    'totalCount'?: number;
    /**
     * 
     * @type {string}
     * @memberof ListWhatIfStrategyResponse
     */
    'sortColumn'?: string | null;
    /**
     * 
     * @type {SortDirection}
     * @memberof ListWhatIfStrategyResponse
     */
    'sortDirection'?: SortDirection;
    /**
     * 
     * @type {number}
     * @memberof ListWhatIfStrategyResponse
     */
    'take'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ListWhatIfStrategyResponse
     */
    'skip'?: number;
}
/**
 * 
 * @export
 * @interface Location
 */
export interface Location {
    /**
     * 
     * @type {number}
     * @memberof Location
     */
    'locationId'?: number;
    /**
     * 
     * @type {string}
     * @memberof Location
     */
    'siteGuid': string;
    /**
     * 
     * @type {string}
     * @memberof Location
     */
    'locationName': string;
    /**
     * 
     * @type {number}
     * @memberof Location
     */
    'tierId': number;
    /**
     * 
     * @type {number}
     * @memberof Location
     */
    'parentLocationId'?: number | null;
    /**
     * 
     * @type {Tier}
     * @memberof Location
     */
    'tier'?: Tier;
    /**
     * 
     * @type {string}
     * @memberof Location
     */
    'customerLocationCode'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof Location
     */
    'active'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof Location
     */
    'createdAt'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Location
     */
    'modifiedAt'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Location
     */
    'deletedAt'?: string | null;
}
/**
 * 
 * @export
 * @interface LocationModel
 */
export interface LocationModel {
    /**
     * 
     * @type {number}
     * @memberof LocationModel
     */
    'locationId': number;
    /**
     * 
     * @type {string}
     * @memberof LocationModel
     */
    'locationName': string;
    /**
     * 
     * @type {number}
     * @memberof LocationModel
     */
    'tierId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof LocationModel
     */
    'tierName'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof LocationModel
     */
    'tierRank'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof LocationModel
     */
    'parentLocationId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof LocationModel
     */
    'customerLocationCode'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof LocationModel
     */
    'active': boolean;
}
/**
 * 
 * @export
 * @interface MarkItViewQuerySavedParameters
 */
export interface MarkItViewQuerySavedParameters {
    /**
     * 
     * @type {number}
     * @memberof MarkItViewQuerySavedParameters
     */
    'id': number;
    /**
     * 
     * @type {number}
     * @memberof MarkItViewQuerySavedParameters
     */
    'daysToLookback'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof MarkItViewQuerySavedParameters
     */
    'priceQueryType'?: string | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof MarkItViewQuerySavedParameters
     */
    'years': Array<number>;
    /**
     * 
     * @type {Array<number>}
     * @memberof MarkItViewQuerySavedParameters
     */
    'months': Array<number>;
    /**
     * 
     * @type {CommodityType}
     * @memberof MarkItViewQuerySavedParameters
     */
    'commodityType'?: CommodityType;
    /**
     * 
     * @type {number}
     * @memberof MarkItViewQuerySavedParameters
     */
    'productId'?: number | null;
    /**
     * 
     * @type {ContractDate}
     * @memberof MarkItViewQuerySavedParameters
     */
    'startContractDate': ContractDate;
    /**
     * 
     * @type {ContractDate}
     * @memberof MarkItViewQuerySavedParameters
     */
    'endContractDate': ContractDate;
    /**
     * 
     * @type {number}
     * @memberof MarkItViewQuerySavedParameters
     */
    'monthsAhead'?: number | null;
    /**
     * 
     * @type {MatrixSavedParameters}
     * @memberof MarkItViewQuerySavedParameters
     */
    'matrixParameters': MatrixSavedParameters;
}
/**
 * 
 * @export
 * @interface MarkItViewSavedQueryModel
 */
export interface MarkItViewSavedQueryModel {
    /**
     * 
     * @type {number}
     * @memberof MarkItViewSavedQueryModel
     */
    'savedQueryId': number;
    /**
     * 
     * @type {string}
     * @memberof MarkItViewSavedQueryModel
     */
    'name': string;
    /**
     * 
     * @type {Array<MarkItViewQuerySavedParameters>}
     * @memberof MarkItViewSavedQueryModel
     */
    'queriesParameters': Array<MarkItViewQuerySavedParameters>;
    /**
     * 
     * @type {EmailScheduleModel}
     * @memberof MarkItViewSavedQueryModel
     */
    'emailSchedule': EmailScheduleModel;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const MarketPriceProvider = {
    None: 'None',
    MarketView: 'MarketView',
    CustomFlat: 'CustomFlat',
    CustomForward: 'CustomForward',
    Budget: 'Budget'
} as const;

export type MarketPriceProvider = typeof MarketPriceProvider[keyof typeof MarketPriceProvider];


/**
 * 
 * @export
 * @enum {string}
 */

export const MarketViewApplication = {
    MarketView: 'MarketView',
    Benchmark: 'Benchmark',
    Deciles: 'Deciles',
    Forecast: 'Forecast',
    HedgePlan: 'HedgePlan',
    TradersDesk: 'TradersDesk',
    EiaNaturalGasStorage: 'EiaNaturalGasStorage'
} as const;

export type MarketViewApplication = typeof MarketViewApplication[keyof typeof MarketViewApplication];


/**
 * 
 * @export
 * @interface MarketViewContractPriceModel
 */
export interface MarketViewContractPriceModel {
    /**
     * 
     * @type {ContractDate}
     * @memberof MarketViewContractPriceModel
     */
    'contractDate': ContractDate;
    /**
     * 
     * @type {number}
     * @memberof MarketViewContractPriceModel
     */
    'price'?: number | null;
}
/**
 * 
 * @export
 * @interface MarketViewExpirationDateModel
 */
export interface MarketViewExpirationDateModel {
    /**
     * 
     * @type {number}
     * @memberof MarketViewExpirationDateModel
     */
    'productId': number;
    /**
     * 
     * @type {number}
     * @memberof MarketViewExpirationDateModel
     */
    'contractMonth': number;
    /**
     * 
     * @type {number}
     * @memberof MarketViewExpirationDateModel
     */
    'contractYear': number;
    /**
     * 
     * @type {string}
     * @memberof MarketViewExpirationDateModel
     */
    'expiration': string;
    /**
     * 
     * @type {string}
     * @memberof MarketViewExpirationDateModel
     */
    'optionExpiration'?: string | null;
    /**
     * 
     * @type {ContractDate}
     * @memberof MarketViewExpirationDateModel
     */
    'contractDate': ContractDate;
}
/**
 * 
 * @export
 * @interface MarketViewLastQuoteDateModel
 */
export interface MarketViewLastQuoteDateModel {
    /**
     * 
     * @type {number}
     * @memberof MarketViewLastQuoteDateModel
     */
    'symbolId': number;
    /**
     * 
     * @type {string}
     * @memberof MarketViewLastQuoteDateModel
     */
    'quoteDate': string;
}
/**
 * 
 * @export
 * @interface MarketViewPriceModel
 */
export interface MarketViewPriceModel {
    /**
     * 
     * @type {number}
     * @memberof MarketViewPriceModel
     */
    'priceId': number;
    /**
     * 
     * @type {number}
     * @memberof MarketViewPriceModel
     */
    'productId': number;
    /**
     * 
     * @type {number}
     * @memberof MarketViewPriceModel
     */
    'parentProductId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MarketViewPriceModel
     */
    'symbolId': number;
    /**
     * 
     * @type {number}
     * @memberof MarketViewPriceModel
     */
    'contractMonth': number;
    /**
     * 
     * @type {number}
     * @memberof MarketViewPriceModel
     */
    'contractYear': number;
    /**
     * 
     * @type {string}
     * @memberof MarketViewPriceModel
     */
    'quoteDate': string;
    /**
     * 
     * @type {string}
     * @memberof MarketViewPriceModel
     */
    'expirationDate'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof MarketViewPriceModel
     */
    'closePrice': number;
    /**
     * 
     * @type {number}
     * @memberof MarketViewPriceModel
     */
    'highPrice': number;
    /**
     * 
     * @type {number}
     * @memberof MarketViewPriceModel
     */
    'lowPrice': number;
    /**
     * 
     * @type {OptionStyle}
     * @memberof MarketViewPriceModel
     */
    'optionStyle'?: OptionStyle;
    /**
     * 
     * @type {OptionType}
     * @memberof MarketViewPriceModel
     */
    'optionType'?: OptionType;
    /**
     * 
     * @type {number}
     * @memberof MarketViewPriceModel
     */
    'strike'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MarketViewPriceModel
     */
    'volatility'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MarketViewPriceModel
     */
    'delta'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MarketViewPriceModel
     */
    'gamma'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MarketViewPriceModel
     */
    'theta'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MarketViewPriceModel
     */
    'vega'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MarketViewPriceModel
     */
    'rho'?: number | null;
    /**
     * 
     * @type {Unit}
     * @memberof MarketViewPriceModel
     */
    'unit': Unit;
    /**
     * 
     * @type {Currency}
     * @memberof MarketViewPriceModel
     */
    'currency': Currency;
    /**
     * 
     * @type {boolean}
     * @memberof MarketViewPriceModel
     */
    'isImpliedOption': boolean;
    /**
     * 
     * @type {ContractDate}
     * @memberof MarketViewPriceModel
     */
    'contractDate': ContractDate;
}
/**
 * 
 * @export
 * @interface MarketViewPriceQuery
 */
export interface MarketViewPriceQuery {
    /**
     * 
     * @type {number}
     * @memberof MarketViewPriceQuery
     */
    'productId'?: number;
    /**
     * 
     * @type {number}
     * @memberof MarketViewPriceQuery
     */
    'contractYear'?: number;
    /**
     * 
     * @type {number}
     * @memberof MarketViewPriceQuery
     */
    'contractMonth'?: number;
    /**
     * 
     * @type {OptionType}
     * @memberof MarketViewPriceQuery
     */
    'optionType'?: OptionType;
    /**
     * 
     * @type {OptionStyle}
     * @memberof MarketViewPriceQuery
     */
    'optionStyle'?: OptionStyle;
    /**
     * 
     * @type {number}
     * @memberof MarketViewPriceQuery
     */
    'strike'?: number | null;
    /**
     * 
     * @type {ContractDate}
     * @memberof MarketViewPriceQuery
     */
    'contractDate'?: ContractDate;
}
/**
 * 
 * @export
 * @interface MarketViewProductModel
 */
export interface MarketViewProductModel {
    /**
     * 
     * @type {number}
     * @memberof MarketViewProductModel
     */
    'productId': number;
    /**
     * 
     * @type {number}
     * @memberof MarketViewProductModel
     */
    'parentProductId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MarketViewProductModel
     */
    'symbolId': number;
    /**
     * 
     * @type {string}
     * @memberof MarketViewProductModel
     */
    'name': string;
    /**
     * 
     * @type {CommodityType}
     * @memberof MarketViewProductModel
     */
    'commodityType': CommodityType;
    /**
     * 
     * @type {PriceType}
     * @memberof MarketViewProductModel
     */
    'priceType': PriceType;
    /**
     * 
     * @type {OptionStyle}
     * @memberof MarketViewProductModel
     */
    'optionStyle'?: OptionStyle;
    /**
     * 
     * @type {Unit}
     * @memberof MarketViewProductModel
     */
    'unit': Unit;
    /**
     * 
     * @type {Currency}
     * @memberof MarketViewProductModel
     */
    'currency': Currency;
    /**
     * 
     * @type {boolean}
     * @memberof MarketViewProductModel
     */
    'isFavorite': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MarketViewProductModel
     */
    'hasDailyPrices': boolean;
}
/**
 * 
 * @export
 * @interface MarketViewProductTradingMonthsResponse
 */
export interface MarketViewProductTradingMonthsResponse {
    /**
     * 
     * @type {Array<number>}
     * @memberof MarketViewProductTradingMonthsResponse
     */
    'years'?: Array<number> | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof MarketViewProductTradingMonthsResponse
     */
    'months'?: Array<number> | null;
}
/**
 * 
 * @export
 * @interface MarketViewProductTypeModel
 */
export interface MarketViewProductTypeModel {
    /**
     * 
     * @type {CommodityType}
     * @memberof MarketViewProductTypeModel
     */
    'commodityType': CommodityType;
}
/**
 * 
 * @export
 * @interface MarketViewQueryCalendarStripAverageResponse
 */
export interface MarketViewQueryCalendarStripAverageResponse {
    /**
     * 
     * @type {Array<MarketViewQuoteDateYearsModel>}
     * @memberof MarketViewQueryCalendarStripAverageResponse
     */
    'rows'?: Array<MarketViewQuoteDateYearsModel> | null;
    /**
     * 
     * @type {number}
     * @memberof MarketViewQueryCalendarStripAverageResponse
     */
    'totalCount'?: number;
    /**
     * 
     * @type {string}
     * @memberof MarketViewQueryCalendarStripAverageResponse
     */
    'sortColumn'?: string | null;
    /**
     * 
     * @type {SortDirection}
     * @memberof MarketViewQueryCalendarStripAverageResponse
     */
    'sortDirection'?: SortDirection;
    /**
     * 
     * @type {number}
     * @memberof MarketViewQueryCalendarStripAverageResponse
     */
    'take'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MarketViewQueryCalendarStripAverageResponse
     */
    'skip'?: number;
}
/**
 * 
 * @export
 * @interface MarketViewQueryDailyPricesResponse
 */
export interface MarketViewQueryDailyPricesResponse {
    /**
     * 
     * @type {Array<DailyMarketPriceModel>}
     * @memberof MarketViewQueryDailyPricesResponse
     */
    'rows'?: Array<DailyMarketPriceModel> | null;
    /**
     * 
     * @type {number}
     * @memberof MarketViewQueryDailyPricesResponse
     */
    'totalCount'?: number;
    /**
     * 
     * @type {string}
     * @memberof MarketViewQueryDailyPricesResponse
     */
    'sortColumn'?: string | null;
    /**
     * 
     * @type {SortDirection}
     * @memberof MarketViewQueryDailyPricesResponse
     */
    'sortDirection'?: SortDirection;
    /**
     * 
     * @type {number}
     * @memberof MarketViewQueryDailyPricesResponse
     */
    'take'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MarketViewQueryDailyPricesResponse
     */
    'skip'?: number;
}
/**
 * 
 * @export
 * @interface MarketViewQueryForwardCurveResponse
 */
export interface MarketViewQueryForwardCurveResponse {
    /**
     * 
     * @type {string}
     * @memberof MarketViewQueryForwardCurveResponse
     */
    'quoteDate'?: string;
    /**
     * 
     * @type {Array<MarketViewContractPriceModel>}
     * @memberof MarketViewQueryForwardCurveResponse
     */
    'rows'?: Array<MarketViewContractPriceModel> | null;
    /**
     * 
     * @type {number}
     * @memberof MarketViewQueryForwardCurveResponse
     */
    'totalCount'?: number;
    /**
     * 
     * @type {string}
     * @memberof MarketViewQueryForwardCurveResponse
     */
    'sortColumn'?: string | null;
    /**
     * 
     * @type {SortDirection}
     * @memberof MarketViewQueryForwardCurveResponse
     */
    'sortDirection'?: SortDirection;
    /**
     * 
     * @type {number}
     * @memberof MarketViewQueryForwardCurveResponse
     */
    'take'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MarketViewQueryForwardCurveResponse
     */
    'skip'?: number;
}
/**
 * 
 * @export
 * @interface MarketViewQueryPriceResponse
 */
export interface MarketViewQueryPriceResponse {
    /**
     * 
     * @type {Array<MarketViewQuoteDateContractsModel>}
     * @memberof MarketViewQueryPriceResponse
     */
    'rows'?: Array<MarketViewQuoteDateContractsModel> | null;
    /**
     * 
     * @type {number}
     * @memberof MarketViewQueryPriceResponse
     */
    'totalCount'?: number;
    /**
     * 
     * @type {string}
     * @memberof MarketViewQueryPriceResponse
     */
    'sortColumn'?: string | null;
    /**
     * 
     * @type {SortDirection}
     * @memberof MarketViewQueryPriceResponse
     */
    'sortDirection'?: SortDirection;
    /**
     * 
     * @type {number}
     * @memberof MarketViewQueryPriceResponse
     */
    'take'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MarketViewQueryPriceResponse
     */
    'skip'?: number;
}
/**
 * 
 * @export
 * @interface MarketViewQueryRollingMonthAheadResponse
 */
export interface MarketViewQueryRollingMonthAheadResponse {
    /**
     * 
     * @type {number}
     * @memberof MarketViewQueryRollingMonthAheadResponse
     */
    'monthsAhead'?: number;
    /**
     * 
     * @type {Array<MarketViewQuoteDatePriceModel>}
     * @memberof MarketViewQueryRollingMonthAheadResponse
     */
    'rows'?: Array<MarketViewQuoteDatePriceModel> | null;
    /**
     * 
     * @type {number}
     * @memberof MarketViewQueryRollingMonthAheadResponse
     */
    'totalCount'?: number;
    /**
     * 
     * @type {string}
     * @memberof MarketViewQueryRollingMonthAheadResponse
     */
    'sortColumn'?: string | null;
    /**
     * 
     * @type {SortDirection}
     * @memberof MarketViewQueryRollingMonthAheadResponse
     */
    'sortDirection'?: SortDirection;
    /**
     * 
     * @type {number}
     * @memberof MarketViewQueryRollingMonthAheadResponse
     */
    'take'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MarketViewQueryRollingMonthAheadResponse
     */
    'skip'?: number;
}
/**
 * 
 * @export
 * @interface MarketViewQuerySettlementsResponse
 */
export interface MarketViewQuerySettlementsResponse {
    /**
     * 
     * @type {Array<MarketViewSettlementPriceModel>}
     * @memberof MarketViewQuerySettlementsResponse
     */
    'rows'?: Array<MarketViewSettlementPriceModel> | null;
    /**
     * 
     * @type {number}
     * @memberof MarketViewQuerySettlementsResponse
     */
    'totalCount'?: number;
    /**
     * 
     * @type {string}
     * @memberof MarketViewQuerySettlementsResponse
     */
    'sortColumn'?: string | null;
    /**
     * 
     * @type {SortDirection}
     * @memberof MarketViewQuerySettlementsResponse
     */
    'sortDirection'?: SortDirection;
    /**
     * 
     * @type {number}
     * @memberof MarketViewQuerySettlementsResponse
     */
    'take'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MarketViewQuerySettlementsResponse
     */
    'skip'?: number;
}
/**
 * 
 * @export
 * @interface MarketViewQueryStripAverageResponse
 */
export interface MarketViewQueryStripAverageResponse {
    /**
     * 
     * @type {DateRangeFilter}
     * @memberof MarketViewQueryStripAverageResponse
     */
    'quoteDateRange'?: DateRangeFilter;
    /**
     * 
     * @type {ContractDateRange}
     * @memberof MarketViewQueryStripAverageResponse
     */
    'contractDateRange'?: ContractDateRange;
    /**
     * 
     * @type {Array<MarketViewQuoteDatePriceModel>}
     * @memberof MarketViewQueryStripAverageResponse
     */
    'rows'?: Array<MarketViewQuoteDatePriceModel> | null;
    /**
     * 
     * @type {number}
     * @memberof MarketViewQueryStripAverageResponse
     */
    'totalCount'?: number;
    /**
     * 
     * @type {string}
     * @memberof MarketViewQueryStripAverageResponse
     */
    'sortColumn'?: string | null;
    /**
     * 
     * @type {SortDirection}
     * @memberof MarketViewQueryStripAverageResponse
     */
    'sortDirection'?: SortDirection;
    /**
     * 
     * @type {number}
     * @memberof MarketViewQueryStripAverageResponse
     */
    'take'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MarketViewQueryStripAverageResponse
     */
    'skip'?: number;
}
/**
 * 
 * @export
 * @interface MarketViewQuoteDateContractsModel
 */
export interface MarketViewQuoteDateContractsModel {
    /**
     * 
     * @type {string}
     * @memberof MarketViewQuoteDateContractsModel
     */
    'quoteDate': string;
    /**
     * 
     * @type {Array<MarketViewContractPriceModel>}
     * @memberof MarketViewQuoteDateContractsModel
     */
    'contractPrices': Array<MarketViewContractPriceModel>;
}
/**
 * 
 * @export
 * @interface MarketViewQuoteDatePriceModel
 */
export interface MarketViewQuoteDatePriceModel {
    /**
     * 
     * @type {string}
     * @memberof MarketViewQuoteDatePriceModel
     */
    'quoteDate': string;
    /**
     * 
     * @type {number}
     * @memberof MarketViewQuoteDatePriceModel
     */
    'price': number;
}
/**
 * 
 * @export
 * @interface MarketViewQuoteDateYearsModel
 */
export interface MarketViewQuoteDateYearsModel {
    /**
     * 
     * @type {string}
     * @memberof MarketViewQuoteDateYearsModel
     */
    'quoteDate': string;
    /**
     * 
     * @type {Array<MarketViewYearPriceModel>}
     * @memberof MarketViewQuoteDateYearsModel
     */
    'yearPrices': Array<MarketViewYearPriceModel>;
}
/**
 * 
 * @export
 * @interface MarketViewSettlementPriceModel
 */
export interface MarketViewSettlementPriceModel {
    /**
     * 
     * @type {string}
     * @memberof MarketViewSettlementPriceModel
     */
    'quoteDate': string;
    /**
     * 
     * @type {ContractDate}
     * @memberof MarketViewSettlementPriceModel
     */
    'contractDate': ContractDate;
    /**
     * 
     * @type {number}
     * @memberof MarketViewSettlementPriceModel
     */
    'price'?: number | null;
}
/**
 * 
 * @export
 * @interface MarketViewSpotPriceModel
 */
export interface MarketViewSpotPriceModel {
    /**
     * 
     * @type {Currency}
     * @memberof MarketViewSpotPriceModel
     */
    'currencyFrom': Currency;
    /**
     * 
     * @type {Currency}
     * @memberof MarketViewSpotPriceModel
     */
    'currencyTo': Currency;
    /**
     * 
     * @type {ContractDate}
     * @memberof MarketViewSpotPriceModel
     */
    'contractDate': ContractDate;
    /**
     * 
     * @type {number}
     * @memberof MarketViewSpotPriceModel
     */
    'conversionRate': number;
}
/**
 * 
 * @export
 * @interface MarketViewUserModel
 */
export interface MarketViewUserModel {
    /**
     * 
     * @type {Array<CommodityManagementSiteAccessModel>}
     * @memberof MarketViewUserModel
     */
    'commodityManagementUserSiteAccesses'?: Array<CommodityManagementSiteAccessModel> | null;
    /**
     * 
     * @type {string}
     * @memberof MarketViewUserModel
     */
    'marketViewUserGuid': string;
    /**
     * 
     * @type {string}
     * @memberof MarketViewUserModel
     */
    'stoneXUserGuid'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MarketViewUserModel
     */
    'email'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MarketViewUserModel
     */
    'firstName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MarketViewUserModel
     */
    'lastName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MarketViewUserModel
     */
    'companyGuid'?: string | null;
    /**
     * 
     * @type {CompanyModel}
     * @memberof MarketViewUserModel
     */
    'company': CompanyModel;
    /**
     * 
     * @type {Array<MarketViewApplication>}
     * @memberof MarketViewUserModel
     */
    'marketViewApplications': Array<MarketViewApplication>;
    /**
     * 
     * @type {boolean}
     * @memberof MarketViewUserModel
     */
    'isAdministrator': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MarketViewUserModel
     */
    'isDisabled': boolean;
    /**
     * 
     * @type {string}
     * @memberof MarketViewUserModel
     */
    'userAddedDate': string;
    /**
     * 
     * @type {string}
     * @memberof MarketViewUserModel
     */
    'addedByUserGuid'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MarketViewUserModel
     */
    'addedByUserName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MarketViewUserModel
     */
    'lastAuthorizationTime'?: string | null;
    /**
     * 
     * @type {GetTermsAndConditionsResponse}
     * @memberof MarketViewUserModel
     */
    'getTermsAndConditionsResponse': GetTermsAndConditionsResponse;
    /**
     * 
     * @type {string}
     * @memberof MarketViewUserModel
     */
    'displayName': string;
}
/**
 * 
 * @export
 * @interface MarketViewVolumeModel
 */
export interface MarketViewVolumeModel {
    /**
     * 
     * @type {number}
     * @memberof MarketViewVolumeModel
     */
    'userVolumeId': number;
    /**
     * 
     * @type {string}
     * @memberof MarketViewVolumeModel
     */
    'name': string;
    /**
     * 
     * @type {{ [key: string]: number; }}
     * @memberof MarketViewVolumeModel
     */
    'volumes': { [key: string]: number; };
}
/**
 * 
 * @export
 * @interface MarketViewVolumesResponse
 */
export interface MarketViewVolumesResponse {
    /**
     * 
     * @type {Array<MarketViewVolumeModel>}
     * @memberof MarketViewVolumesResponse
     */
    'rows'?: Array<MarketViewVolumeModel> | null;
    /**
     * 
     * @type {number}
     * @memberof MarketViewVolumesResponse
     */
    'totalCount'?: number;
    /**
     * 
     * @type {string}
     * @memberof MarketViewVolumesResponse
     */
    'sortColumn'?: string | null;
    /**
     * 
     * @type {SortDirection}
     * @memberof MarketViewVolumesResponse
     */
    'sortDirection'?: SortDirection;
    /**
     * 
     * @type {number}
     * @memberof MarketViewVolumesResponse
     */
    'take'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MarketViewVolumesResponse
     */
    'skip'?: number;
}
/**
 * 
 * @export
 * @interface MarketViewYearPriceModel
 */
export interface MarketViewYearPriceModel {
    /**
     * 
     * @type {number}
     * @memberof MarketViewYearPriceModel
     */
    'year'?: number;
    /**
     * 
     * @type {number}
     * @memberof MarketViewYearPriceModel
     */
    'price'?: number | null;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const MatrixCalculationType = {
    Monthly: 'Monthly',
    Expiration: 'Expiration'
} as const;

export type MatrixCalculationType = typeof MatrixCalculationType[keyof typeof MatrixCalculationType];


/**
 * 
 * @export
 * @enum {string}
 */

export const MatrixContractSettlement = {
    ExpirationDate: 'ExpirationDate',
    LastDayOfTheMonth: 'LastDayOfTheMonth'
} as const;

export type MatrixContractSettlement = typeof MatrixContractSettlement[keyof typeof MatrixContractSettlement];


/**
 * 
 * @export
 * @interface MatrixForwardCurvePointModel
 */
export interface MatrixForwardCurvePointModel {
    /**
     * 
     * @type {number}
     * @memberof MatrixForwardCurvePointModel
     */
    'contractMonth'?: number;
    /**
     * 
     * @type {number}
     * @memberof MatrixForwardCurvePointModel
     */
    'contractYear'?: number;
    /**
     * 
     * @type {number}
     * @memberof MatrixForwardCurvePointModel
     */
    'price'?: number;
}
/**
 * 
 * @export
 * @interface MatrixForwardCurveSeriesModel
 */
export interface MatrixForwardCurveSeriesModel {
    /**
     * 
     * @type {string}
     * @memberof MatrixForwardCurveSeriesModel
     */
    'term'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MatrixForwardCurveSeriesModel
     */
    'quoteDate'?: string;
    /**
     * 
     * @type {Array<MatrixForwardCurvePointModel>}
     * @memberof MatrixForwardCurveSeriesModel
     */
    'prices'?: Array<MatrixForwardCurvePointModel> | null;
}
/**
 * 
 * @export
 * @interface MatrixGraphPointModel
 */
export interface MatrixGraphPointModel {
    /**
     * 
     * @type {string}
     * @memberof MatrixGraphPointModel
     */
    'calculationDate'?: string;
    /**
     * 
     * @type {Array<MatrixTermResultModel>}
     * @memberof MatrixGraphPointModel
     */
    'terms'?: Array<MatrixTermResultModel> | null;
}
/**
 * 
 * @export
 * @interface MatrixModel
 */
export interface MatrixModel {
    /**
     * 
     * @type {number}
     * @memberof MatrixModel
     */
    'rank'?: number;
    /**
     * 
     * @type {number}
     * @memberof MatrixModel
     */
    'value'?: number;
}
/**
 * 
 * @export
 * @interface MatrixPriceModel
 */
export interface MatrixPriceModel {
    /**
     * 
     * @type {string}
     * @memberof MatrixPriceModel
     */
    'quoteDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof MatrixPriceModel
     */
    'contractDate'?: string;
    /**
     * 
     * @type {number}
     * @memberof MatrixPriceModel
     */
    'price'?: number;
}
/**
 * 
 * @export
 * @interface MatrixSavedParameters
 */
export interface MatrixSavedParameters {
    /**
     * 
     * @type {number}
     * @memberof MatrixSavedParameters
     */
    'productId'?: number;
    /**
     * 
     * @type {string}
     * @memberof MatrixSavedParameters
     */
    'startDate'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MatrixSavedParameters
     */
    'endDate'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MatrixSavedParameters
     */
    'matrixStripType'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MatrixSavedParameters
     */
    'contractSettlement'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof MatrixSavedParameters
     */
    'terms'?: Array<string> | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof MatrixSavedParameters
     */
    'months'?: Array<number> | null;
    /**
     * 
     * @type {number}
     * @memberof MatrixSavedParameters
     */
    'startMonth'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof MatrixSavedParameters
     */
    'weighted'?: boolean | null;
    /**
     * 
     * @type {number}
     * @memberof MatrixSavedParameters
     */
    'innerRange'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MatrixSavedParameters
     */
    'outerRange'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MatrixSavedParameters
     */
    'innerWeight'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MatrixSavedParameters
     */
    'outerWeight'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MatrixSavedParameters
     */
    'yearsBack'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof MatrixSavedParameters
     */
    'applyPpi'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof MatrixSavedParameters
     */
    'aboveMedian'?: boolean | null;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const MatrixSeasonType = {
    Annual: 'Annual',
    WinterSummer: 'WinterSummer',
    Quarterly: 'Quarterly'
} as const;

export type MatrixSeasonType = typeof MatrixSeasonType[keyof typeof MatrixSeasonType];


/**
 * 
 * @export
 * @enum {string}
 */

export const MatrixStripType = {
    FirstContractMonth: 'FirstContractMonth',
    SecondContractMonth: 'SecondContractMonth',
    Strip: 'Strip',
    ContractPeriod: 'ContractPeriod',
    RollingMonth: 'RollingMonth'
} as const;

export type MatrixStripType = typeof MatrixStripType[keyof typeof MatrixStripType];


/**
 * 
 * @export
 * @enum {string}
 */

export const MatrixTerm = {
    Annual: 'Annual',
    Summer: 'Summer',
    Winter: 'Winter',
    FirstQuarter: 'FirstQuarter',
    SecondQuarter: 'SecondQuarter',
    ThirdQuarter: 'ThirdQuarter',
    FourthQuarter: 'FourthQuarter',
    JanuaryFebruary: 'JanuaryFebruary',
    MarchApril: 'MarchApril',
    JulyAugust: 'JulyAugust',
    OctoberDecember: 'OctoberDecember',
    Custom: 'Custom'
} as const;

export type MatrixTerm = typeof MatrixTerm[keyof typeof MatrixTerm];


/**
 * 
 * @export
 * @interface MatrixTermResultModel
 */
export interface MatrixTermResultModel {
    /**
     * 
     * @type {string}
     * @memberof MatrixTermResultModel
     */
    'season'?: string | null;
    /**
     * 
     * @type {Array<MatrixModel>}
     * @memberof MatrixTermResultModel
     */
    'weightedDeciles'?: Array<MatrixModel> | null;
    /**
     * 
     * @type {Array<MatrixModel>}
     * @memberof MatrixTermResultModel
     */
    'innerDeciles'?: Array<MatrixModel> | null;
    /**
     * 
     * @type {Array<MatrixModel>}
     * @memberof MatrixTermResultModel
     */
    'outerDeciles'?: Array<MatrixModel> | null;
    /**
     * 
     * @type {number}
     * @memberof MatrixTermResultModel
     */
    'innerMean'?: number;
    /**
     * 
     * @type {number}
     * @memberof MatrixTermResultModel
     */
    'outerMean'?: number;
    /**
     * 
     * @type {number}
     * @memberof MatrixTermResultModel
     */
    'weightedMean'?: number;
    /**
     * 
     * @type {Array<MatrixPriceModel>}
     * @memberof MatrixTermResultModel
     */
    'innerPrices'?: Array<MatrixPriceModel> | null;
    /**
     * 
     * @type {Array<MatrixPriceModel>}
     * @memberof MatrixTermResultModel
     */
    'outerPrices'?: Array<MatrixPriceModel> | null;
    /**
     * 
     * @type {number}
     * @memberof MatrixTermResultModel
     */
    'innerPriceCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof MatrixTermResultModel
     */
    'outerPriceCount'?: number;
}
/**
 * 
 * @export
 * @interface MatrixVolumeModel
 */
export interface MatrixVolumeModel {
    /**
     * 
     * @type {number}
     * @memberof MatrixVolumeModel
     */
    'contractYear'?: number;
    /**
     * 
     * @type {number}
     * @memberof MatrixVolumeModel
     */
    'contractMonth'?: number;
    /**
     * 
     * @type {number}
     * @memberof MatrixVolumeModel
     */
    'volume'?: number;
}
/**
 * 
 * @export
 * @interface MatrixYearPriceDailyModel
 */
export interface MatrixYearPriceDailyModel {
    /**
     * 
     * @type {string}
     * @memberof MatrixYearPriceDailyModel
     */
    'date'?: string;
    /**
     * 
     * @type {number}
     * @memberof MatrixYearPriceDailyModel
     */
    'price'?: number | null;
}
/**
 * 
 * @export
 * @interface MatrixYearPriceSeriesModel
 */
export interface MatrixYearPriceSeriesModel {
    /**
     * 
     * @type {number}
     * @memberof MatrixYearPriceSeriesModel
     */
    'year'?: number;
    /**
     * 
     * @type {string}
     * @memberof MatrixYearPriceSeriesModel
     */
    'term'?: string | null;
    /**
     * 
     * @type {Array<MatrixYearPriceDailyModel>}
     * @memberof MatrixYearPriceSeriesModel
     */
    'dailyPrices'?: Array<MatrixYearPriceDailyModel> | null;
    /**
     * 
     * @type {Array<MatrixVolumeModel>}
     * @memberof MatrixYearPriceSeriesModel
     */
    'volumes'?: Array<MatrixVolumeModel> | null;
}
/**
 * 
 * @export
 * @interface NoteModel
 */
export interface NoteModel {
    /**
     * 
     * @type {number}
     * @memberof NoteModel
     */
    'noteId': number;
    /**
     * 
     * @type {string}
     * @memberof NoteModel
     */
    'marketViewUsername': string;
    /**
     * 
     * @type {string}
     * @memberof NoteModel
     */
    'subject': string;
    /**
     * 
     * @type {string}
     * @memberof NoteModel
     */
    'content': string;
    /**
     * 
     * @type {string}
     * @memberof NoteModel
     */
    'createdAt'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof NoteModel
     */
    'modifiedAt'?: string | null;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const OptionStyle = {
    American: 'American',
    European: 'European',
    Asian: 'Asian'
} as const;

export type OptionStyle = typeof OptionStyle[keyof typeof OptionStyle];


/**
 * 
 * @export
 * @enum {string}
 */

export const OptionType = {
    Call: 'Call',
    Put: 'Put'
} as const;

export type OptionType = typeof OptionType[keyof typeof OptionType];


/**
 * 
 * @export
 * @interface PiedmontHedgingLocationModel
 */
export interface PiedmontHedgingLocationModel {
    /**
     * 
     * @type {number}
     * @memberof PiedmontHedgingLocationModel
     */
    'locationId': number;
    /**
     * 
     * @type {string}
     * @memberof PiedmontHedgingLocationModel
     */
    'locationName': string;
    /**
     * 
     * @type {string}
     * @memberof PiedmontHedgingLocationModel
     */
    'sheetCode': string;
    /**
     * 
     * @type {boolean}
     * @memberof PiedmontHedgingLocationModel
     */
    'includeHedgingDollars': boolean;
    /**
     * 
     * @type {Array<PiedmontHedgingMarkToMarketRowModel>}
     * @memberof PiedmontHedgingLocationModel
     */
    'markToMarketRows': Array<PiedmontHedgingMarkToMarketRowModel>;
    /**
     * 
     * @type {PiedmontHedgingMarkToMarketSummaryModel}
     * @memberof PiedmontHedgingLocationModel
     */
    'markToMarketSummary': PiedmontHedgingMarkToMarketSummaryModel;
    /**
     * 
     * @type {Array<PiedmontHedgingPositionRowModel>}
     * @memberof PiedmontHedgingLocationModel
     */
    'positionRows': Array<PiedmontHedgingPositionRowModel>;
}
/**
 * 
 * @export
 * @interface PiedmontHedgingMarkToMarketRowModel
 */
export interface PiedmontHedgingMarkToMarketRowModel {
    /**
     * 
     * @type {string}
     * @memberof PiedmontHedgingMarkToMarketRowModel
     */
    'budgetMonth': string;
    /**
     * 
     * @type {string}
     * @memberof PiedmontHedgingMarkToMarketRowModel
     */
    'tool': string;
    /**
     * 
     * @type {string}
     * @memberof PiedmontHedgingMarkToMarketRowModel
     */
    'counterpartyName': string;
    /**
     * 
     * @type {string}
     * @memberof PiedmontHedgingMarkToMarketRowModel
     */
    'tradeDate'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof PiedmontHedgingMarkToMarketRowModel
     */
    'volume': number;
    /**
     * 
     * @type {number}
     * @memberof PiedmontHedgingMarkToMarketRowModel
     */
    'strikeOrFixedPrice': number;
    /**
     * 
     * @type {number}
     * @memberof PiedmontHedgingMarkToMarketRowModel
     */
    'purchasePrice': number;
    /**
     * 
     * @type {number}
     * @memberof PiedmontHedgingMarkToMarketRowModel
     */
    'purchaseCost': number;
    /**
     * 
     * @type {string}
     * @memberof PiedmontHedgingMarkToMarketRowModel
     */
    'expirationDate'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof PiedmontHedgingMarkToMarketRowModel
     */
    'marketPrice': number;
    /**
     * 
     * @type {number}
     * @memberof PiedmontHedgingMarkToMarketRowModel
     */
    'marketValue': number;
    /**
     * 
     * @type {number}
     * @memberof PiedmontHedgingMarkToMarketRowModel
     */
    'netValue': number;
    /**
     * 
     * @type {number}
     * @memberof PiedmontHedgingMarkToMarketRowModel
     */
    'level'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PiedmontHedgingMarkToMarketRowModel
     */
    'hedgingDollars'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PiedmontHedgingMarkToMarketRowModel
     */
    'availableHedgingDollars'?: number | null;
}
/**
 * 
 * @export
 * @interface PiedmontHedgingMarkToMarketSummaryModel
 */
export interface PiedmontHedgingMarkToMarketSummaryModel {
    /**
     * 
     * @type {number}
     * @memberof PiedmontHedgingMarkToMarketSummaryModel
     */
    'totalVolume': number;
    /**
     * 
     * @type {number}
     * @memberof PiedmontHedgingMarkToMarketSummaryModel
     */
    'totalPurchaseCost': number;
    /**
     * 
     * @type {number}
     * @memberof PiedmontHedgingMarkToMarketSummaryModel
     */
    'totalMarketValue': number;
    /**
     * 
     * @type {number}
     * @memberof PiedmontHedgingMarkToMarketSummaryModel
     */
    'totalNetValue': number;
}
/**
 * 
 * @export
 * @interface PiedmontHedgingPositionRowModel
 */
export interface PiedmontHedgingPositionRowModel {
    /**
     * 
     * @type {string}
     * @memberof PiedmontHedgingPositionRowModel
     */
    'budgetMonth': string;
    /**
     * 
     * @type {number}
     * @memberof PiedmontHedgingPositionRowModel
     */
    'contracts': number;
    /**
     * 
     * @type {string}
     * @memberof PiedmontHedgingPositionRowModel
     */
    'counterpartyName': string;
    /**
     * 
     * @type {string}
     * @memberof PiedmontHedgingPositionRowModel
     */
    'settlementIndicator': string;
    /**
     * 
     * @type {string}
     * @memberof PiedmontHedgingPositionRowModel
     */
    'tool': string;
    /**
     * 
     * @type {string}
     * @memberof PiedmontHedgingPositionRowModel
     */
    'toolDescription': string;
    /**
     * 
     * @type {number}
     * @memberof PiedmontHedgingPositionRowModel
     */
    'purchasePrice': number;
    /**
     * 
     * @type {number}
     * @memberof PiedmontHedgingPositionRowModel
     */
    'underlyingMarketPrice'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof PiedmontHedgingPositionRowModel
     */
    'decile': string;
    /**
     * 
     * @type {number}
     * @memberof PiedmontHedgingPositionRowModel
     */
    'strikePrice': number;
    /**
     * 
     * @type {string}
     * @memberof PiedmontHedgingPositionRowModel
     */
    'priceOrTimeTrigger': string;
    /**
     * 
     * @type {number}
     * @memberof PiedmontHedgingPositionRowModel
     */
    'coverage': number;
    /**
     * 
     * @type {number}
     * @memberof PiedmontHedgingPositionRowModel
     */
    'cumulativeCoverage': number;
    /**
     * 
     * @type {string}
     * @memberof PiedmontHedgingPositionRowModel
     */
    'tradeDate'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof PiedmontHedgingPositionRowModel
     */
    'maximumContracts': number;
}
/**
 * 
 * @export
 * @interface PiedmontOpenContractsRowModel
 */
export interface PiedmontOpenContractsRowModel {
    /**
     * 
     * @type {string}
     * @memberof PiedmontOpenContractsRowModel
     */
    'budgetMonth': string;
    /**
     * 
     * @type {number}
     * @memberof PiedmontOpenContractsRowModel
     */
    'contracts': number;
}
/**
 * 
 * @export
 * @interface PortfolioModel
 */
export interface PortfolioModel {
    /**
     * 
     * @type {number}
     * @memberof PortfolioModel
     */
    'portfolioId': number;
    /**
     * 
     * @type {string}
     * @memberof PortfolioModel
     */
    'portfolioName': string;
    /**
     * 
     * @type {boolean}
     * @memberof PortfolioModel
     */
    'active': boolean;
}
/**
 * 
 * @export
 * @interface PositionModel
 */
export interface PositionModel {
    /**
     * 
     * @type {number}
     * @memberof PositionModel
     */
    'positionId': number;
    /**
     * 
     * @type {number}
     * @memberof PositionModel
     */
    'dealTicketId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof PositionModel
     */
    'tradeDate'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PositionModel
     */
    'dealTicketNumber'?: string | null;
    /**
     * 
     * @type {PositionType}
     * @memberof PositionModel
     */
    'positionType': PositionType;
    /**
     * 
     * @type {number}
     * @memberof PositionModel
     */
    'price': number;
    /**
     * 
     * @type {number}
     * @memberof PositionModel
     */
    'volume': number;
    /**
     * 
     * @type {Side}
     * @memberof PositionModel
     */
    'side': Side;
    /**
     * 
     * @type {Unit}
     * @memberof PositionModel
     */
    'unit': Unit;
    /**
     * 
     * @type {Currency}
     * @memberof PositionModel
     */
    'currency': Currency;
    /**
     * 
     * @type {boolean}
     * @memberof PositionModel
     */
    'isValidated': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PositionModel
     */
    'isLastDay': boolean;
    /**
     * 
     * @type {number}
     * @memberof PositionModel
     */
    'optionStrike'?: number | null;
    /**
     * 
     * @type {OptionType}
     * @memberof PositionModel
     */
    'optionType'?: OptionType;
    /**
     * 
     * @type {OptionStyle}
     * @memberof PositionModel
     */
    'optionStyle'?: OptionStyle;
    /**
     * 
     * @type {string}
     * @memberof PositionModel
     */
    'quoteDate'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PositionModel
     */
    'expirationDate'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof PositionModel
     */
    'marketPrice'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PositionModel
     */
    'markToMarketPrice'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PositionModel
     */
    'markToMarketValue'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PositionModel
     */
    'scenarioMarketPrice'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PositionModel
     */
    'scenarioMarkToMarketPrice'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PositionModel
     */
    'scenarioMarkToMarketValue'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PositionModel
     */
    'delta'?: number | null;
    /**
     * 
     * @type {CommodityModel}
     * @memberof PositionModel
     */
    'commodity': CommodityModel;
    /**
     * 
     * @type {LocationModel}
     * @memberof PositionModel
     */
    'location': LocationModel;
    /**
     * 
     * @type {Array<LocationModel>}
     * @memberof PositionModel
     */
    'locationHierarchy': Array<LocationModel>;
    /**
     * 
     * @type {CounterpartyModel}
     * @memberof PositionModel
     */
    'counterparty': CounterpartyModel;
    /**
     * 
     * @type {PortfolioModel}
     * @memberof PositionModel
     */
    'portfolio': PortfolioModel;
    /**
     * 
     * @type {boolean}
     * @memberof PositionModel
     */
    'isExpired'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof PositionModel
     */
    'settlementSymbol'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PositionModel
     */
    'customData'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PositionModel
     */
    'pricingStartDate'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PositionModel
     */
    'pricingEndDate'?: string | null;
    /**
     * 
     * @type {Array<ComponentMarketPrice>}
     * @memberof PositionModel
     */
    'componentMarketPrices': Array<ComponentMarketPrice>;
    /**
     * 
     * @type {PositionPricingStrategyModel}
     * @memberof PositionModel
     */
    'positionPricingStrategy': PositionPricingStrategyModel;
    /**
     * 
     * @type {Array<ComponentType>}
     * @memberof PositionModel
     */
    'missingPricingComponents': Array<ComponentType>;
    /**
     * 
     * @type {string}
     * @memberof PositionModel
     */
    'positionTypeOrOption': string;
    /**
     * 
     * @type {string}
     * @memberof PositionModel
     */
    'positionTypeOrOptionAndStrike': string;
    /**
     * 
     * @type {ContractDate}
     * @memberof PositionModel
     */
    'budgetDate': ContractDate;
    /**
     * 
     * @type {ContractDate}
     * @memberof PositionModel
     */
    'contractDate': ContractDate;
    /**
     * 
     * @type {ContractDate}
     * @memberof PositionModel
     */
    'effectiveContractDate': ContractDate;
    /**
     * 
     * @type {number}
     * @memberof PositionModel
     */
    'effectiveVolume': number;
}
/**
 * 
 * @export
 * @interface PositionPricingComponentModel
 */
export interface PositionPricingComponentModel {
    /**
     * 
     * @type {number}
     * @memberof PositionPricingComponentModel
     */
    'positionPricingComponentId': number;
    /**
     * 
     * @type {number}
     * @memberof PositionPricingComponentModel
     */
    'positionPricingStrategyId': number;
    /**
     * 
     * @type {ComponentType}
     * @memberof PositionPricingComponentModel
     */
    'componentType': ComponentType;
    /**
     * 
     * @type {MarketPriceProvider}
     * @memberof PositionPricingComponentModel
     */
    'marketPriceProvider'?: MarketPriceProvider;
    /**
     * 
     * @type {number}
     * @memberof PositionPricingComponentModel
     */
    'marketViewProductId'?: number | null;
    /**
     * 
     * @type {Unit}
     * @memberof PositionPricingComponentModel
     */
    'bushelUnit'?: Unit;
    /**
     * 
     * @type {number}
     * @memberof PositionPricingComponentModel
     */
    'bushelVolume'?: number | null;
    /**
     * 
     * @type {Unit}
     * @memberof PositionPricingComponentModel
     */
    'contractUnit'?: Unit;
    /**
     * 
     * @type {number}
     * @memberof PositionPricingComponentModel
     */
    'contractVolume'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof PositionPricingComponentModel
     */
    'settlementSymbol'?: string | null;
}
/**
 * 
 * @export
 * @interface PositionPricingStrategyModel
 */
export interface PositionPricingStrategyModel {
    /**
     * 
     * @type {number}
     * @memberof PositionPricingStrategyModel
     */
    'positionPricingStrategyId': number;
    /**
     * 
     * @type {number}
     * @memberof PositionPricingStrategyModel
     */
    'budgetPricingStrategyId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof PositionPricingStrategyModel
     */
    'name': string;
    /**
     * 
     * @type {number}
     * @memberof PositionPricingStrategyModel
     */
    'commodityId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PositionPricingStrategyModel
     */
    'locationId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PositionPricingStrategyModel
     */
    'counterpartyId'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof PositionPricingStrategyModel
     */
    'isLastDay': boolean;
    /**
     * 
     * @type {Array<PositionPricingComponentModel>}
     * @memberof PositionPricingStrategyModel
     */
    'components': Array<PositionPricingComponentModel>;
    /**
     * 
     * @type {string}
     * @memberof PositionPricingStrategyModel
     */
    'settlementSymbol'?: string | null;
    /**
     * 
     * @type {Unit}
     * @memberof PositionPricingStrategyModel
     */
    'bushelUnit'?: Unit;
    /**
     * 
     * @type {number}
     * @memberof PositionPricingStrategyModel
     */
    'bushelVolume'?: number | null;
    /**
     * 
     * @type {Unit}
     * @memberof PositionPricingStrategyModel
     */
    'contractUnit'?: Unit;
    /**
     * 
     * @type {number}
     * @memberof PositionPricingStrategyModel
     */
    'contractVolume'?: number | null;
    /**
     * 
     * @type {ElectricityType}
     * @memberof PositionPricingStrategyModel
     */
    'electricityType'?: ElectricityType;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const PositionType = {
    AllIn: 'AllIn',
    Future: 'Future',
    Option: 'Option',
    Physical: 'Physical',
    Underlying: 'Underlying',
    Basis: 'Basis',
    Swap: 'Swap',
    Index: 'Index',
    Daily: 'Daily',
    Credit: 'Credit'
} as const;

export type PositionType = typeof PositionType[keyof typeof PositionType];


/**
 * 
 * @export
 * @enum {string}
 */

export const PriceType = {
    None: 'None',
    Future: 'Future',
    Option: 'Option',
    Physical: 'Physical',
    Basis: 'Basis',
    OnPeakEast: 'OnPeakEast',
    WrapEast: 'WrapEast',
    OnPeakWest: 'OnPeakWest',
    WrapWest: 'WrapWest',
    AroundTheClock: 'AroundTheClock',
    StaticPrice: 'StaticPrice',
    Daily: 'Daily',
    Cm: 'CM',
    Cm1: 'CM1'
} as const;

export type PriceType = typeof PriceType[keyof typeof PriceType];


/**
 * 
 * @export
 * @enum {string}
 */

export const ProductAccessOverrideType = {
    Allow: 'Allow',
    Block: 'Block'
} as const;

export type ProductAccessOverrideType = typeof ProductAccessOverrideType[keyof typeof ProductAccessOverrideType];


/**
 * 
 * @export
 * @interface QuoteDateForecast
 */
export interface QuoteDateForecast {
    /**
     * 
     * @type {string}
     * @memberof QuoteDateForecast
     */
    'quoteDate': string;
    /**
     * 
     * @type {number}
     * @memberof QuoteDateForecast
     */
    'forecastAverage': number;
    /**
     * 
     * @type {number}
     * @memberof QuoteDateForecast
     */
    'forwardAverage': number;
    /**
     * 
     * @type {Array<ForecastModel>}
     * @memberof QuoteDateForecast
     */
    'forecasts': Array<ForecastModel>;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const ReportType = {
    MarkToMarket: 'MarkToMarket',
    VarianceToBudget: 'VarianceToBudget',
    Scenario: 'Scenario',
    TimeTrigger: 'TimeTrigger',
    ProfitAndLoss: 'ProfitAndLoss',
    Summary: 'Summary',
    Position: 'Position',
    Exposure: 'Exposure',
    DailyPositions: 'DailyPositions',
    HedgePlan: 'HedgePlan',
    MarkToMarketClosed: 'MarkToMarketClosed',
    GrossHedging: 'GrossHedging',
    WeightedCostAverage: 'WeightedCostAverage',
    Combined: 'Combined',
    OpenContracts: 'OpenContracts',
    HedgingPosition: 'HedgingPosition',
    HedgingMtm: 'HedgingMTM',
    PiedmontHedging: 'PiedmontHedging'
} as const;

export type ReportType = typeof ReportType[keyof typeof ReportType];


/**
 * 
 * @export
 * @interface ScenarioMarketPriceExcelTemplateRow
 */
export interface ScenarioMarketPriceExcelTemplateRow {
    /**
     * 
     * @type {number}
     * @memberof ScenarioMarketPriceExcelTemplateRow
     */
    'marketPrice': number;
    /**
     * 
     * @type {number}
     * @memberof ScenarioMarketPriceExcelTemplateRow
     */
    'budgetYear'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ScenarioMarketPriceExcelTemplateRow
     */
    'budgetMonth'?: number | null;
    /**
     * 
     * @type {ComponentType}
     * @memberof ScenarioMarketPriceExcelTemplateRow
     */
    'componentType'?: ComponentType;
    /**
     * 
     * @type {ScenarioMarketPriceModel}
     * @memberof ScenarioMarketPriceExcelTemplateRow
     */
    'model': ScenarioMarketPriceModel;
    /**
     * 
     * @type {number}
     * @memberof ScenarioMarketPriceExcelTemplateRow
     */
    'row': number;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof ScenarioMarketPriceExcelTemplateRow
     */
    'cellValues': { [key: string]: any; };
    /**
     * 
     * @type {{ [key: string]: Array<string>; }}
     * @memberof ScenarioMarketPriceExcelTemplateRow
     */
    'fieldErrors': { [key: string]: Array<string>; };
    /**
     * 
     * @type {boolean}
     * @memberof ScenarioMarketPriceExcelTemplateRow
     */
    'isSuccessful': boolean;
}
/**
 * 
 * @export
 * @interface ScenarioMarketPriceModel
 */
export interface ScenarioMarketPriceModel {
    /**
     * 
     * @type {number}
     * @memberof ScenarioMarketPriceModel
     */
    'marketPrice': number;
    /**
     * 
     * @type {number}
     * @memberof ScenarioMarketPriceModel
     */
    'budgetYear'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ScenarioMarketPriceModel
     */
    'budgetMonth'?: number | null;
    /**
     * 
     * @type {ComponentType}
     * @memberof ScenarioMarketPriceModel
     */
    'componentType'?: ComponentType;
}
/**
 * 
 * @export
 * @interface ScenarioVarianceModel
 */
export interface ScenarioVarianceModel {
    /**
     * 
     * @type {number}
     * @memberof ScenarioVarianceModel
     */
    'stressIncrement': number;
    /**
     * 
     * @type {StressIncrementType}
     * @memberof ScenarioVarianceModel
     */
    'stresIncrementType': StressIncrementType;
    /**
     * 
     * @type {Array<CommodityScenarioVarianceModel>}
     * @memberof ScenarioVarianceModel
     */
    'commodityScenarios': Array<CommodityScenarioVarianceModel>;
}
/**
 * 
 * @export
 * @interface SendCommodityManagementReportEmailRequest
 */
export interface SendCommodityManagementReportEmailRequest {
    /**
     * 
     * @type {number}
     * @memberof SendCommodityManagementReportEmailRequest
     */
    'customerReportId': number;
    /**
     * 
     * @type {Array<string>}
     * @memberof SendCommodityManagementReportEmailRequest
     */
    'recipients': Array<string>;
    /**
     * 
     * @type {string}
     * @memberof SendCommodityManagementReportEmailRequest
     */
    'subject'?: string | null;
}
/**
 * 
 * @export
 * @interface SendCommodityManagementReportEmailResponse
 */
export interface SendCommodityManagementReportEmailResponse {
    /**
     * 
     * @type {string}
     * @memberof SendCommodityManagementReportEmailResponse
     */
    'subject'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SendCommodityManagementReportEmailResponse
     */
    'quoteDate'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof SendCommodityManagementReportEmailResponse
     */
    'recipients'?: Array<string> | null;
}
/**
 * 
 * @export
 * @interface SendEmailScheduleResponse
 */
export interface SendEmailScheduleResponse {
    /**
     * 
     * @type {boolean}
     * @memberof SendEmailScheduleResponse
     */
    'sent'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof SendEmailScheduleResponse
     */
    'error'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SendEmailScheduleResponse
     */
    'nextRunAtUtc'?: string;
}
/**
 * 
 * @export
 * @interface SendMarketViewSavedQueryEmailRequest
 */
export interface SendMarketViewSavedQueryEmailRequest {
    /**
     * 
     * @type {number}
     * @memberof SendMarketViewSavedQueryEmailRequest
     */
    'savedQueryId': number;
    /**
     * 
     * @type {Array<string>}
     * @memberof SendMarketViewSavedQueryEmailRequest
     */
    'recipients': Array<string>;
    /**
     * 
     * @type {string}
     * @memberof SendMarketViewSavedQueryEmailRequest
     */
    'subject'?: string | null;
}
/**
 * 
 * @export
 * @interface SendMarketViewSavedQueryEmailResponse
 */
export interface SendMarketViewSavedQueryEmailResponse {
    /**
     * 
     * @type {string}
     * @memberof SendMarketViewSavedQueryEmailResponse
     */
    'subject'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SendMarketViewSavedQueryEmailResponse
     */
    'quoteDate'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof SendMarketViewSavedQueryEmailResponse
     */
    'recipients'?: Array<string> | null;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const Side = {
    Buy: 'Buy',
    Sell: 'Sell'
} as const;

export type Side = typeof Side[keyof typeof Side];


/**
 * 
 * @export
 * @enum {string}
 */

export const SortDirection = {
    Asc: 'Asc',
    Desc: 'Desc',
    None: 'None'
} as const;

export type SortDirection = typeof SortDirection[keyof typeof SortDirection];


/**
 * 
 * @export
 * @enum {string}
 */

export const StressIncrementType = {
    Percent: 'Percent',
    Price: 'Price'
} as const;

export type StressIncrementType = typeof StressIncrementType[keyof typeof StressIncrementType];


/**
 * 
 * @export
 * @interface Tier
 */
export interface Tier {
    /**
     * 
     * @type {number}
     * @memberof Tier
     */
    'tierId'?: number;
    /**
     * 
     * @type {string}
     * @memberof Tier
     */
    'siteGuid': string;
    /**
     * 
     * @type {string}
     * @memberof Tier
     */
    'tierName': string;
    /**
     * 
     * @type {number}
     * @memberof Tier
     */
    'tierRank': number;
    /**
     * 
     * @type {string}
     * @memberof Tier
     */
    'createdAt'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Tier
     */
    'modifiedAt'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Tier
     */
    'deletedAt'?: string | null;
}
/**
 * 
 * @export
 * @interface TierModel
 */
export interface TierModel {
    /**
     * 
     * @type {number}
     * @memberof TierModel
     */
    'tierId': number;
    /**
     * 
     * @type {string}
     * @memberof TierModel
     */
    'tierName': string;
    /**
     * 
     * @type {number}
     * @memberof TierModel
     */
    'tierRank': number;
}
/**
 * 
 * @export
 * @interface TimeTriggerModel
 */
export interface TimeTriggerModel {
    /**
     * 
     * @type {ContractDate}
     * @memberof TimeTriggerModel
     */
    'contractMonth'?: ContractDate;
    /**
     * 
     * @type {number}
     * @memberof TimeTriggerModel
     */
    'minimumHedge'?: number;
    /**
     * 
     * @type {number}
     * @memberof TimeTriggerModel
     */
    'maximumHedge'?: number;
}
/**
 * 
 * @export
 * @interface TimeTriggerReportModel
 */
export interface TimeTriggerReportModel {
    /**
     * 
     * @type {Array<TimeTriggerModel>}
     * @memberof TimeTriggerReportModel
     */
    'timeTriggers': Array<TimeTriggerModel>;
    /**
     * 
     * @type {ContractDate}
     * @memberof TimeTriggerReportModel
     */
    'budgetMonth': ContractDate;
    /**
     * 
     * @type {number}
     * @memberof TimeTriggerReportModel
     */
    'budgetVolume': number;
    /**
     * 
     * @type {number}
     * @memberof TimeTriggerReportModel
     */
    'hedgedVolume': number;
    /**
     * 
     * @type {number}
     * @memberof TimeTriggerReportModel
     */
    'totalMinimumHedge': number;
    /**
     * 
     * @type {number}
     * @memberof TimeTriggerReportModel
     */
    'totalMaximumHedge': number;
    /**
     * 
     * @type {number}
     * @memberof TimeTriggerReportModel
     */
    'totalHedgePerentage': number;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const Unit = {
    None: 'None',
    Mmbtu: 'MMBTu',
    Mw: 'MW',
    Ton: 'Ton',
    Tonne: 'Tonne',
    Bbl: 'Bbl',
    Bu: 'Bu',
    Gal: 'Gal',
    Lb: 'Lb',
    Cwt: 'Cwt',
    Sc: 'Sc',
    Contract: 'Contract',
    Kg: 'Kg',
    Lt: 'Lt',
    Mwh: 'MWh',
    Toz: 'Toz',
    Gj: 'Gj',
    KgMs: 'KgMs',
    Allowance: 'Allowance'
} as const;

export type Unit = typeof Unit[keyof typeof Unit];


/**
 * 
 * @export
 * @interface UodateBudgetRoundResponse
 */
export interface UodateBudgetRoundResponse {
    /**
     * 
     * @type {BudgetRoundModel}
     * @memberof UodateBudgetRoundResponse
     */
    'budgetRound'?: BudgetRoundModel;
}
/**
 * 
 * @export
 * @interface UpdateAllocationGroupRequest
 */
export interface UpdateAllocationGroupRequest {
    /**
     * 
     * @type {number}
     * @memberof UpdateAllocationGroupRequest
     */
    'allocationGroupId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateAllocationGroupRequest
     */
    'locationId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateAllocationGroupRequest
     */
    'commodityId': number;
    /**
     * 
     * @type {number}
     * @memberof UpdateAllocationGroupRequest
     */
    'counterpartyId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateAllocationGroupRequest
     */
    'portfolioId'?: number | null;
    /**
     * 
     * @type {Unit}
     * @memberof UpdateAllocationGroupRequest
     */
    'unit'?: Unit;
    /**
     * 
     * @type {string}
     * @memberof UpdateAllocationGroupRequest
     */
    'allocationName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateAllocationGroupRequest
     */
    'comments'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateAllocationGroupRequest
     */
    'monthlyVolume'?: string | null;
}
/**
 * 
 * @export
 * @interface UpdateAllocationGroupResponse
 */
export interface UpdateAllocationGroupResponse {
    /**
     * 
     * @type {number}
     * @memberof UpdateAllocationGroupResponse
     */
    'allocationGroupId'?: number;
}
/**
 * 
 * @export
 * @interface UpdateAllocationRequest
 */
export interface UpdateAllocationRequest {
    /**
     * 
     * @type {number}
     * @memberof UpdateAllocationRequest
     */
    'allocationId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateAllocationRequest
     */
    'allocationGroupId': number;
    /**
     * 
     * @type {number}
     * @memberof UpdateAllocationRequest
     */
    'positionId': number;
    /**
     * 
     * @type {number}
     * @memberof UpdateAllocationRequest
     */
    'volume': number;
}
/**
 * 
 * @export
 * @interface UpdateAllocationResponse
 */
export interface UpdateAllocationResponse {
    /**
     * 
     * @type {number}
     * @memberof UpdateAllocationResponse
     */
    'allocationId'?: number;
}
/**
 * 
 * @export
 * @interface UpdateBudgetModel
 */
export interface UpdateBudgetModel {
    /**
     * 
     * @type {number}
     * @memberof UpdateBudgetModel
     */
    'budgetId': number;
    /**
     * 
     * @type {number}
     * @memberof UpdateBudgetModel
     */
    'commodityId': number;
    /**
     * 
     * @type {number}
     * @memberof UpdateBudgetModel
     */
    'pricingStrategyId': number;
    /**
     * 
     * @type {number}
     * @memberof UpdateBudgetModel
     */
    'volume': number;
    /**
     * 
     * @type {Unit}
     * @memberof UpdateBudgetModel
     */
    'unit': Unit;
    /**
     * 
     * @type {Currency}
     * @memberof UpdateBudgetModel
     */
    'currency': Currency;
    /**
     * 
     * @type {ContractDate}
     * @memberof UpdateBudgetModel
     */
    'budgetDate': ContractDate;
    /**
     * 
     * @type {ContractDate}
     * @memberof UpdateBudgetModel
     */
    'contractDate'?: ContractDate;
    /**
     * 
     * @type {number}
     * @memberof UpdateBudgetModel
     */
    'locationId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateBudgetModel
     */
    'counterpartyId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateBudgetModel
     */
    'budgetRoundId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateBudgetModel
     */
    'note'?: string | null;
    /**
     * 
     * @type {Array<UpdateBudgetPriceModel>}
     * @memberof UpdateBudgetModel
     */
    'budgetPrices': Array<UpdateBudgetPriceModel>;
}
/**
 * 
 * @export
 * @interface UpdateBudgetPriceModel
 */
export interface UpdateBudgetPriceModel {
    /**
     * 
     * @type {number}
     * @memberof UpdateBudgetPriceModel
     */
    'budgetPriceId': number;
    /**
     * 
     * @type {ComponentType}
     * @memberof UpdateBudgetPriceModel
     */
    'componentType': ComponentType;
    /**
     * 
     * @type {number}
     * @memberof UpdateBudgetPriceModel
     */
    'price': number;
    /**
     * 
     * @type {Unit}
     * @memberof UpdateBudgetPriceModel
     */
    'unit': Unit;
}
/**
 * 
 * @export
 * @interface UpdateBudgetPricingComponentModel
 */
export interface UpdateBudgetPricingComponentModel {
    /**
     * 
     * @type {number}
     * @memberof UpdateBudgetPricingComponentModel
     */
    'budgetPricingComponentId': number;
    /**
     * 
     * @type {ComponentType}
     * @memberof UpdateBudgetPricingComponentModel
     */
    'componentType': ComponentType;
    /**
     * 
     * @type {MarketPriceProvider}
     * @memberof UpdateBudgetPricingComponentModel
     */
    'marketPriceProvider'?: MarketPriceProvider;
    /**
     * 
     * @type {number}
     * @memberof UpdateBudgetPricingComponentModel
     */
    'marketViewProductId'?: number | null;
    /**
     * 
     * @type {HedgeSource}
     * @memberof UpdateBudgetPricingComponentModel
     */
    'hedgeSource': HedgeSource;
}
/**
 * 
 * @export
 * @interface UpdateBudgetPricingStrategyModel
 */
export interface UpdateBudgetPricingStrategyModel {
    /**
     * 
     * @type {number}
     * @memberof UpdateBudgetPricingStrategyModel
     */
    'budgetPricingStrategyId': number;
    /**
     * 
     * @type {string}
     * @memberof UpdateBudgetPricingStrategyModel
     */
    'name': string;
    /**
     * 
     * @type {number}
     * @memberof UpdateBudgetPricingStrategyModel
     */
    'commodityId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateBudgetPricingStrategyModel
     */
    'locationId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateBudgetPricingStrategyModel
     */
    'counterpartyId'?: number | null;
    /**
     * 
     * @type {Unit}
     * @memberof UpdateBudgetPricingStrategyModel
     */
    'bushelUnit'?: Unit;
    /**
     * 
     * @type {number}
     * @memberof UpdateBudgetPricingStrategyModel
     */
    'bushelVolume'?: number | null;
    /**
     * 
     * @type {Unit}
     * @memberof UpdateBudgetPricingStrategyModel
     */
    'contractUnit'?: Unit;
    /**
     * 
     * @type {number}
     * @memberof UpdateBudgetPricingStrategyModel
     */
    'contractVolume'?: number | null;
    /**
     * 
     * @type {ElectricityType}
     * @memberof UpdateBudgetPricingStrategyModel
     */
    'electricityType'?: ElectricityType;
    /**
     * 
     * @type {Array<UpdateBudgetPricingComponentModel>}
     * @memberof UpdateBudgetPricingStrategyModel
     */
    'components': Array<UpdateBudgetPricingComponentModel>;
    /**
     * 
     * @type {Array<UpdatePositionPricingStrategyModel>}
     * @memberof UpdateBudgetPricingStrategyModel
     */
    'positionStrategies': Array<UpdatePositionPricingStrategyModel>;
}
/**
 * 
 * @export
 * @interface UpdateBudgetRoundRequest
 */
export interface UpdateBudgetRoundRequest {
    /**
     * 
     * @type {number}
     * @memberof UpdateBudgetRoundRequest
     */
    'budgetRoundId': number;
    /**
     * 
     * @type {string}
     * @memberof UpdateBudgetRoundRequest
     */
    'budgetRoundName': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateBudgetRoundRequest
     */
    'entryDate': string;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateBudgetRoundRequest
     */
    'isDefault': boolean;
}
/**
 * 
 * @export
 * @interface UpdateBudgetsRequest
 */
export interface UpdateBudgetsRequest {
    /**
     * 
     * @type {Array<UpdateBudgetModel>}
     * @memberof UpdateBudgetsRequest
     */
    'budgets'?: Array<UpdateBudgetModel> | null;
}
/**
 * 
 * @export
 * @interface UpdateCommodityContractMonthMappingModel
 */
export interface UpdateCommodityContractMonthMappingModel {
    /**
     * 
     * @type {number}
     * @memberof UpdateCommodityContractMonthMappingModel
     */
    'budgetMonth': number;
    /**
     * 
     * @type {number}
     * @memberof UpdateCommodityContractMonthMappingModel
     */
    'contractMonth': number;
    /**
     * 
     * @type {ContractYearOffset}
     * @memberof UpdateCommodityContractMonthMappingModel
     */
    'yearOffset': ContractYearOffset;
}
/**
 * 
 * @export
 * @interface UpdateCommodityContractMonthMappingsRequest
 */
export interface UpdateCommodityContractMonthMappingsRequest {
    /**
     * 
     * @type {number}
     * @memberof UpdateCommodityContractMonthMappingsRequest
     */
    'commodityId': number;
    /**
     * 
     * @type {Array<UpdateCommodityContractMonthMappingModel>}
     * @memberof UpdateCommodityContractMonthMappingsRequest
     */
    'mappings': Array<UpdateCommodityContractMonthMappingModel>;
}
/**
 * 
 * @export
 * @interface UpdateCommodityContractMonthMappingsResponse
 */
export interface UpdateCommodityContractMonthMappingsResponse {
    /**
     * 
     * @type {Array<CommodityContractMonthMappingModel>}
     * @memberof UpdateCommodityContractMonthMappingsResponse
     */
    'mappings'?: Array<CommodityContractMonthMappingModel> | null;
}
/**
 * 
 * @export
 * @interface UpdateCommodityManagementSiteResponse
 */
export interface UpdateCommodityManagementSiteResponse {
    /**
     * 
     * @type {CommodityManagementSiteModel}
     * @memberof UpdateCommodityManagementSiteResponse
     */
    'site'?: CommodityManagementSiteModel;
}
/**
 * 
 * @export
 * @interface UpdateCommodityResponse
 */
export interface UpdateCommodityResponse {
    /**
     * 
     * @type {CommodityModel}
     * @memberof UpdateCommodityResponse
     */
    'commodity'?: CommodityModel;
}
/**
 * 
 * @export
 * @interface UpdateCompanyRequest
 */
export interface UpdateCompanyRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateCompanyRequest
     */
    'companyGuid': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateCompanyRequest
     */
    'name': string;
    /**
     * 
     * @type {Array<MarketViewApplication>}
     * @memberof UpdateCompanyRequest
     */
    'marketViewApplications'?: Array<MarketViewApplication> | null;
    /**
     * 
     * @type {Array<CompanyProductAccessEntryModel>}
     * @memberof UpdateCompanyRequest
     */
    'productAccess'?: Array<CompanyProductAccessEntryModel> | null;
}
/**
 * 
 * @export
 * @interface UpdateCompanyResponse
 */
export interface UpdateCompanyResponse {
    /**
     * 
     * @type {CompanyModel}
     * @memberof UpdateCompanyResponse
     */
    'company'?: CompanyModel;
}
/**
 * 
 * @export
 * @interface UpdateCounterpartyResponse
 */
export interface UpdateCounterpartyResponse {
    /**
     * 
     * @type {CounterpartyModel}
     * @memberof UpdateCounterpartyResponse
     */
    'counterparty'?: CounterpartyModel;
}
/**
 * 
 * @export
 * @interface UpdateCustomerReportRequest
 */
export interface UpdateCustomerReportRequest {
    /**
     * 
     * @type {number}
     * @memberof UpdateCustomerReportRequest
     */
    'customerReportId': number;
    /**
     * 
     * @type {ReportType}
     * @memberof UpdateCustomerReportRequest
     */
    'reportType': ReportType;
    /**
     * 
     * @type {string}
     * @memberof UpdateCustomerReportRequest
     */
    'reportName': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateCustomerReportRequest
     */
    'configuration': string;
}
/**
 * 
 * @export
 * @interface UpdateCustomerReportResponse
 */
export interface UpdateCustomerReportResponse {
    /**
     * 
     * @type {CustomerReportModel}
     * @memberof UpdateCustomerReportResponse
     */
    'customerReport'?: CustomerReportModel;
}
/**
 * 
 * @export
 * @interface UpdateCustomerSettingsRequest
 */
export interface UpdateCustomerSettingsRequest {
    /**
     * 
     * @type {number}
     * @memberof UpdateCustomerSettingsRequest
     */
    'fiscalMonthOffset': number;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateCustomerSettingsRequest
     */
    'budgetsByLocation': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateCustomerSettingsRequest
     */
    'budgetsByPortfolio'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateCustomerSettingsRequest
     */
    'budgetsByCounterparty': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateCustomerSettingsRequest
     */
    'positionsByLocation': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateCustomerSettingsRequest
     */
    'positionsByPortfolio': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateCustomerSettingsRequest
     */
    'positionsByCounterparty'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateCustomerSettingsRequest
     */
    'usesBudgetRounds': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateCustomerSettingsRequest
     */
    'enableLastDayProductTypes': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateCustomerSettingsRequest
     */
    'separatePricingStrategiesForPositions': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateCustomerSettingsRequest
     */
    'positionContractDates': boolean;
}
/**
 * 
 * @export
 * @interface UpdateCustomerSettingsResponse
 */
export interface UpdateCustomerSettingsResponse {
    /**
     * 
     * @type {number}
     * @memberof UpdateCustomerSettingsResponse
     */
    'fiscalMonthOffset'?: number;
    /**
     * 
     * @type {number}
     * @memberof UpdateCustomerSettingsResponse
     */
    'defaultActiveYear'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateCustomerSettingsResponse
     */
    'budgetsByLocation'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateCustomerSettingsResponse
     */
    'budgetsByPortfolio'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateCustomerSettingsResponse
     */
    'budgetsByCounterparty'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateCustomerSettingsResponse
     */
    'positionsByLocation'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateCustomerSettingsResponse
     */
    'positionsByPortfolio'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateCustomerSettingsResponse
     */
    'positionsByCounterparty'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateCustomerSettingsResponse
     */
    'usesBudgetRounds'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateCustomerSettingsResponse
     */
    'enableLastDayProductTypes'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateCustomerSettingsResponse
     */
    'separatePricingStrategiesForPositions'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateCustomerSettingsResponse
     */
    'positionContractDates'?: boolean;
    /**
     * 
     * @type {ContractDate}
     * @memberof UpdateCustomerSettingsResponse
     */
    'defaultActiveMonthStart'?: ContractDate;
    /**
     * 
     * @type {ContractDate}
     * @memberof UpdateCustomerSettingsResponse
     */
    'defaultActiveMonthEnd'?: ContractDate;
}
/**
 * 
 * @export
 * @interface UpdateDealTicketRequest
 */
export interface UpdateDealTicketRequest {
    /**
     * 
     * @type {number}
     * @memberof UpdateDealTicketRequest
     */
    'dealTicketId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateDealTicketRequest
     */
    'tradeDate': string;
    /**
     * 
     * @type {number}
     * @memberof UpdateDealTicketRequest
     */
    'commodityId': number;
    /**
     * 
     * @type {number}
     * @memberof UpdateDealTicketRequest
     */
    'counterpartyId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateDealTicketRequest
     */
    'portfolioId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateDealTicketRequest
     */
    'dealTicketNumber'?: string | null;
    /**
     * 
     * @type {Array<UpdatePositionModel>}
     * @memberof UpdateDealTicketRequest
     */
    'positions'?: Array<UpdatePositionModel> | null;
}
/**
 * 
 * @export
 * @interface UpdateDealTicketResponse
 */
export interface UpdateDealTicketResponse {
    /**
     * 
     * @type {number}
     * @memberof UpdateDealTicketResponse
     */
    'dealTicketId'?: number;
}
/**
 * 
 * @export
 * @interface UpdateDefaultBudgetRoundsRequest
 */
export interface UpdateDefaultBudgetRoundsRequest {
    /**
     * 
     * @type {Array<YearDefaultBudgetRoundModel>}
     * @memberof UpdateDefaultBudgetRoundsRequest
     */
    'yearDefaultBudgetRounds'?: Array<YearDefaultBudgetRoundModel> | null;
}
/**
 * 
 * @export
 * @interface UpdateDeliveriesRequest
 */
export interface UpdateDeliveriesRequest {
    /**
     * 
     * @type {Array<DeliveryModel>}
     * @memberof UpdateDeliveriesRequest
     */
    'deliveries'?: Array<DeliveryModel> | null;
}
/**
 * 
 * @export
 * @interface UpdateDocumentsResponse
 */
export interface UpdateDocumentsResponse {
    /**
     * 
     * @type {number}
     * @memberof UpdateDocumentsResponse
     */
    'documentId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateDocumentsResponse
     */
    'result'?: string | null;
}
/**
 * 
 * @export
 * @interface UpdateHedgePlanBudgetTriggerModel
 */
export interface UpdateHedgePlanBudgetTriggerModel {
    /**
     * 
     * @type {number}
     * @memberof UpdateHedgePlanBudgetTriggerModel
     */
    'hedgePlanBudgetTriggerId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateHedgePlanBudgetTriggerModel
     */
    'price': number;
    /**
     * 
     * @type {number}
     * @memberof UpdateHedgePlanBudgetTriggerModel
     */
    'targetHedgePercent'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateHedgePlanBudgetTriggerModel
     */
    'disabled'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UpdateHedgePlanBudgetTriggerModel
     */
    'note'?: string | null;
}
/**
 * 
 * @export
 * @interface UpdateHedgePlanBudgetTriggersRequest
 */
export interface UpdateHedgePlanBudgetTriggersRequest {
    /**
     * 
     * @type {number}
     * @memberof UpdateHedgePlanBudgetTriggersRequest
     */
    'hedgePlanId': number;
    /**
     * 
     * @type {number}
     * @memberof UpdateHedgePlanBudgetTriggersRequest
     */
    'year': number;
    /**
     * 
     * @type {MatrixTerm}
     * @memberof UpdateHedgePlanBudgetTriggersRequest
     */
    'term'?: MatrixTerm;
    /**
     * 
     * @type {Array<UpdateHedgePlanBudgetTriggerModel>}
     * @memberof UpdateHedgePlanBudgetTriggersRequest
     */
    'triggers': Array<UpdateHedgePlanBudgetTriggerModel>;
}
/**
 * 
 * @export
 * @interface UpdateHedgePlanBudgetTriggersResponse
 */
export interface UpdateHedgePlanBudgetTriggersResponse {
    /**
     * 
     * @type {Array<HedgePlanBudgetTriggerModel>}
     * @memberof UpdateHedgePlanBudgetTriggersResponse
     */
    'budgetTriggers'?: Array<HedgePlanBudgetTriggerModel> | null;
}
/**
 * 
 * @export
 * @interface UpdateHedgePlanRequest
 */
export interface UpdateHedgePlanRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateHedgePlanRequest
     */
    'companyGuid': string;
    /**
     * 
     * @type {number}
     * @memberof UpdateHedgePlanRequest
     */
    'hedgePlanId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateHedgePlanRequest
     */
    'name': string;
    /**
     * 
     * @type {number}
     * @memberof UpdateHedgePlanRequest
     */
    'marketViewProductId': number;
    /**
     * 
     * @type {HedgePlanType}
     * @memberof UpdateHedgePlanRequest
     */
    'planType'?: HedgePlanType;
    /**
     * 
     * @type {MatrixSeasonType}
     * @memberof UpdateHedgePlanRequest
     */
    'seasonType'?: MatrixSeasonType;
    /**
     * 
     * @type {number}
     * @memberof UpdateHedgePlanRequest
     */
    'fiscalStartMonth'?: number;
    /**
     * 
     * @type {MatrixCalculationType}
     * @memberof UpdateHedgePlanRequest
     */
    'calculationType'?: MatrixCalculationType;
    /**
     * 
     * @type {MatrixContractSettlement}
     * @memberof UpdateHedgePlanRequest
     */
    'contractSettlement'?: MatrixContractSettlement;
    /**
     * 
     * @type {MatrixStripType}
     * @memberof UpdateHedgePlanRequest
     */
    'stripType'?: MatrixStripType;
    /**
     * 
     * @type {string}
     * @memberof UpdateHedgePlanRequest
     */
    'siteGuid'?: string | null;
    /**
     * 
     * @type {VolumeSource}
     * @memberof UpdateHedgePlanRequest
     */
    'volumeSource'?: VolumeSource;
    /**
     * 
     * @type {Array<number>}
     * @memberof UpdateHedgePlanRequest
     */
    'volumeSourceIds'?: Array<number> | null;
    /**
     * 
     * @type {HedgePlanOverHedgeLimit}
     * @memberof UpdateHedgePlanRequest
     */
    'overHedgeLimit'?: HedgePlanOverHedgeLimit;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateHedgePlanRequest
     */
    'applyPpi'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateHedgePlanRequest
     */
    'weightPriceCurveByVolume'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UpdateHedgePlanRequest
     */
    'configuration': string;
}
/**
 * 
 * @export
 * @interface UpdateHedgePlanResponse
 */
export interface UpdateHedgePlanResponse {
    /**
     * 
     * @type {HedgePlanModel}
     * @memberof UpdateHedgePlanResponse
     */
    'hedgePlan'?: HedgePlanModel;
}
/**
 * 
 * @export
 * @interface UpdateHedgePlanSeasonSettingsRequest
 */
export interface UpdateHedgePlanSeasonSettingsRequest {
    /**
     * 
     * @type {number}
     * @memberof UpdateHedgePlanSeasonSettingsRequest
     */
    'hedgePlanId': number;
    /**
     * 
     * @type {number}
     * @memberof UpdateHedgePlanSeasonSettingsRequest
     */
    'year': number;
    /**
     * 
     * @type {MatrixTerm}
     * @memberof UpdateHedgePlanSeasonSettingsRequest
     */
    'term'?: MatrixTerm;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateHedgePlanSeasonSettingsRequest
     */
    'isHidden'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof UpdateHedgePlanSeasonSettingsRequest
     */
    'budgetAdjustment'?: number | null;
}
/**
 * 
 * @export
 * @interface UpdateHedgePlanSeasonSettingsResponse
 */
export interface UpdateHedgePlanSeasonSettingsResponse {
    /**
     * 
     * @type {Array<HedgePlanSeasonModel>}
     * @memberof UpdateHedgePlanSeasonSettingsResponse
     */
    'rows'?: Array<HedgePlanSeasonModel> | null;
    /**
     * 
     * @type {HedgePlanSeasonModel}
     * @memberof UpdateHedgePlanSeasonSettingsResponse
     */
    'nextSeason'?: HedgePlanSeasonModel;
    /**
     * 
     * @type {Array<HedgePlanSeasonModel>}
     * @memberof UpdateHedgePlanSeasonSettingsResponse
     */
    'previousSeasons'?: Array<HedgePlanSeasonModel> | null;
}
/**
 * 
 * @export
 * @interface UpdateHedgePlanTimeTriggerModel
 */
export interface UpdateHedgePlanTimeTriggerModel {
    /**
     * 
     * @type {number}
     * @memberof UpdateHedgePlanTimeTriggerModel
     */
    'hedgePlanTimeTriggerId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateHedgePlanTimeTriggerModel
     */
    'triggerDate': string;
    /**
     * 
     * @type {number}
     * @memberof UpdateHedgePlanTimeTriggerModel
     */
    'targetHedgePercent'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateHedgePlanTimeTriggerModel
     */
    'disabled'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UpdateHedgePlanTimeTriggerModel
     */
    'note'?: string | null;
}
/**
 * 
 * @export
 * @interface UpdateHedgePlanTimeTriggersRequest
 */
export interface UpdateHedgePlanTimeTriggersRequest {
    /**
     * 
     * @type {number}
     * @memberof UpdateHedgePlanTimeTriggersRequest
     */
    'hedgePlanId': number;
    /**
     * 
     * @type {number}
     * @memberof UpdateHedgePlanTimeTriggersRequest
     */
    'year': number;
    /**
     * 
     * @type {MatrixTerm}
     * @memberof UpdateHedgePlanTimeTriggersRequest
     */
    'term'?: MatrixTerm;
    /**
     * 
     * @type {Array<UpdateHedgePlanTimeTriggerModel>}
     * @memberof UpdateHedgePlanTimeTriggersRequest
     */
    'triggers': Array<UpdateHedgePlanTimeTriggerModel>;
}
/**
 * 
 * @export
 * @interface UpdateHedgePlanTimeTriggersResponse
 */
export interface UpdateHedgePlanTimeTriggersResponse {
    /**
     * 
     * @type {Array<HedgePlanTimeTriggerModel>}
     * @memberof UpdateHedgePlanTimeTriggersResponse
     */
    'timeTriggers'?: Array<HedgePlanTimeTriggerModel> | null;
}
/**
 * 
 * @export
 * @interface UpdateHedgePlanTradeModel
 */
export interface UpdateHedgePlanTradeModel {
    /**
     * 
     * @type {number}
     * @memberof UpdateHedgePlanTradeModel
     */
    'hedgePlanTradeId'?: number | null;
    /**
     * 
     * @type {HedgePlanExecutionType}
     * @memberof UpdateHedgePlanTradeModel
     */
    'executionType'?: HedgePlanExecutionType;
    /**
     * 
     * @type {string}
     * @memberof UpdateHedgePlanTradeModel
     */
    'tradeDate': string;
    /**
     * 
     * @type {number}
     * @memberof UpdateHedgePlanTradeModel
     */
    'volumePercent'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateHedgePlanTradeModel
     */
    'volume'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateHedgePlanTradeModel
     */
    'price'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateHedgePlanTradeModel
     */
    'triggerDecilePercentile'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateHedgePlanTradeModel
     */
    'triggerPrice'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateHedgePlanTradeModel
     */
    'triggerDate'?: string | null;
}
/**
 * 
 * @export
 * @interface UpdateHedgePlanTradesRequest
 */
export interface UpdateHedgePlanTradesRequest {
    /**
     * 
     * @type {number}
     * @memberof UpdateHedgePlanTradesRequest
     */
    'hedgePlanId': number;
    /**
     * 
     * @type {number}
     * @memberof UpdateHedgePlanTradesRequest
     */
    'year': number;
    /**
     * 
     * @type {MatrixTerm}
     * @memberof UpdateHedgePlanTradesRequest
     */
    'term'?: MatrixTerm;
    /**
     * 
     * @type {Array<UpdateHedgePlanTradeModel>}
     * @memberof UpdateHedgePlanTradesRequest
     */
    'trades': Array<UpdateHedgePlanTradeModel>;
}
/**
 * 
 * @export
 * @interface UpdateHedgePlanTradesResponse
 */
export interface UpdateHedgePlanTradesResponse {
    /**
     * 
     * @type {Array<HedgePlanTradeModel>}
     * @memberof UpdateHedgePlanTradesResponse
     */
    'trades'?: Array<HedgePlanTradeModel> | null;
}
/**
 * 
 * @export
 * @interface UpdateHedgePlanValueTriggerModel
 */
export interface UpdateHedgePlanValueTriggerModel {
    /**
     * 
     * @type {number}
     * @memberof UpdateHedgePlanValueTriggerModel
     */
    'hedgePlanValueTriggerId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateHedgePlanValueTriggerModel
     */
    'decilePercentile'?: number;
    /**
     * 
     * @type {number}
     * @memberof UpdateHedgePlanValueTriggerModel
     */
    'targetHedgePercent'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateHedgePlanValueTriggerModel
     */
    'disabled'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UpdateHedgePlanValueTriggerModel
     */
    'note'?: string | null;
}
/**
 * 
 * @export
 * @interface UpdateHedgePlanValueTriggersRequest
 */
export interface UpdateHedgePlanValueTriggersRequest {
    /**
     * 
     * @type {number}
     * @memberof UpdateHedgePlanValueTriggersRequest
     */
    'hedgePlanId': number;
    /**
     * 
     * @type {number}
     * @memberof UpdateHedgePlanValueTriggersRequest
     */
    'year': number;
    /**
     * 
     * @type {MatrixTerm}
     * @memberof UpdateHedgePlanValueTriggersRequest
     */
    'term'?: MatrixTerm;
    /**
     * 
     * @type {Array<UpdateHedgePlanValueTriggerModel>}
     * @memberof UpdateHedgePlanValueTriggersRequest
     */
    'triggers': Array<UpdateHedgePlanValueTriggerModel>;
}
/**
 * 
 * @export
 * @interface UpdateHedgePlanValueTriggersResponse
 */
export interface UpdateHedgePlanValueTriggersResponse {
    /**
     * 
     * @type {Array<HedgePlanValueTriggerModel>}
     * @memberof UpdateHedgePlanValueTriggersResponse
     */
    'valueTriggers'?: Array<HedgePlanValueTriggerModel> | null;
}
/**
 * 
 * @export
 * @interface UpdateLocationResponse
 */
export interface UpdateLocationResponse {
    /**
     * 
     * @type {LocationModel}
     * @memberof UpdateLocationResponse
     */
    'location'?: LocationModel;
}
/**
 * 
 * @export
 * @interface UpdateMarketViewUserRequest
 */
export interface UpdateMarketViewUserRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateMarketViewUserRequest
     */
    'marketViewUserGuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateMarketViewUserRequest
     */
    'email'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateMarketViewUserRequest
     */
    'firstName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateMarketViewUserRequest
     */
    'lastName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateMarketViewUserRequest
     */
    'companyGuid'?: string | null;
    /**
     * 
     * @type {Array<MarketViewApplication>}
     * @memberof UpdateMarketViewUserRequest
     */
    'marketViewApplications'?: Array<MarketViewApplication> | null;
    /**
     * 
     * @type {Array<UserSiteAccessUpdateModel>}
     * @memberof UpdateMarketViewUserRequest
     */
    'commodityManagementUserSiteAccesses'?: Array<UserSiteAccessUpdateModel> | null;
}
/**
 * 
 * @export
 * @interface UpdateMarketViewUserResponse
 */
export interface UpdateMarketViewUserResponse {
    /**
     * 
     * @type {MarketViewUserModel}
     * @memberof UpdateMarketViewUserResponse
     */
    'user'?: MarketViewUserModel;
}
/**
 * 
 * @export
 * @interface UpdateNoteResponse
 */
export interface UpdateNoteResponse {
    /**
     * 
     * @type {NoteModel}
     * @memberof UpdateNoteResponse
     */
    'note'?: NoteModel;
}
/**
 * 
 * @export
 * @interface UpdatePortfolioResponse
 */
export interface UpdatePortfolioResponse {
    /**
     * 
     * @type {PortfolioModel}
     * @memberof UpdatePortfolioResponse
     */
    'portfolio'?: PortfolioModel;
}
/**
 * 
 * @export
 * @interface UpdatePositionModel
 */
export interface UpdatePositionModel {
    /**
     * 
     * @type {number}
     * @memberof UpdatePositionModel
     */
    'positionId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UpdatePositionModel
     */
    'locationId'?: number | null;
    /**
     * 
     * @type {ContractDate}
     * @memberof UpdatePositionModel
     */
    'budgetDate'?: ContractDate;
    /**
     * 
     * @type {ContractDate}
     * @memberof UpdatePositionModel
     */
    'contractDate'?: ContractDate;
    /**
     * 
     * @type {number}
     * @memberof UpdatePositionModel
     */
    'price': number;
    /**
     * 
     * @type {number}
     * @memberof UpdatePositionModel
     */
    'volume': number;
    /**
     * 
     * @type {PositionType}
     * @memberof UpdatePositionModel
     */
    'positionType'?: PositionType;
    /**
     * 
     * @type {boolean}
     * @memberof UpdatePositionModel
     */
    'isLastDay'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof UpdatePositionModel
     */
    'optionStrike'?: number | null;
    /**
     * 
     * @type {OptionType}
     * @memberof UpdatePositionModel
     */
    'optionType'?: OptionType;
    /**
     * 
     * @type {OptionStyle}
     * @memberof UpdatePositionModel
     */
    'optionStyle'?: OptionStyle;
    /**
     * 
     * @type {Side}
     * @memberof UpdatePositionModel
     */
    'side': Side;
    /**
     * 
     * @type {Unit}
     * @memberof UpdatePositionModel
     */
    'unit': Unit;
    /**
     * 
     * @type {Currency}
     * @memberof UpdatePositionModel
     */
    'currency': Currency;
    /**
     * 
     * @type {string}
     * @memberof UpdatePositionModel
     */
    'customData'?: string | null;
}
/**
 * 
 * @export
 * @interface UpdatePositionPricingComponentModel
 */
export interface UpdatePositionPricingComponentModel {
    /**
     * 
     * @type {number}
     * @memberof UpdatePositionPricingComponentModel
     */
    'positionPricingComponentId': number;
    /**
     * 
     * @type {ComponentType}
     * @memberof UpdatePositionPricingComponentModel
     */
    'componentType': ComponentType;
    /**
     * 
     * @type {MarketPriceProvider}
     * @memberof UpdatePositionPricingComponentModel
     */
    'marketPriceProvider'?: MarketPriceProvider;
    /**
     * 
     * @type {number}
     * @memberof UpdatePositionPricingComponentModel
     */
    'marketViewProductId'?: number | null;
    /**
     * 
     * @type {Unit}
     * @memberof UpdatePositionPricingComponentModel
     */
    'bushelUnit'?: Unit;
    /**
     * 
     * @type {number}
     * @memberof UpdatePositionPricingComponentModel
     */
    'bushelVolume'?: number | null;
    /**
     * 
     * @type {Unit}
     * @memberof UpdatePositionPricingComponentModel
     */
    'contractUnit'?: Unit;
    /**
     * 
     * @type {number}
     * @memberof UpdatePositionPricingComponentModel
     */
    'contractVolume'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof UpdatePositionPricingComponentModel
     */
    'settlementSymbol'?: string | null;
}
/**
 * 
 * @export
 * @interface UpdatePositionPricingStrategyModel
 */
export interface UpdatePositionPricingStrategyModel {
    /**
     * 
     * @type {number}
     * @memberof UpdatePositionPricingStrategyModel
     */
    'positionPricingStrategyId': number;
    /**
     * 
     * @type {string}
     * @memberof UpdatePositionPricingStrategyModel
     */
    'name': string;
    /**
     * 
     * @type {number}
     * @memberof UpdatePositionPricingStrategyModel
     */
    'commodityId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UpdatePositionPricingStrategyModel
     */
    'locationId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UpdatePositionPricingStrategyModel
     */
    'counterpartyId'?: number | null;
    /**
     * 
     * @type {ElectricityType}
     * @memberof UpdatePositionPricingStrategyModel
     */
    'electricityType'?: ElectricityType;
    /**
     * 
     * @type {Array<UpdatePositionPricingComponentModel>}
     * @memberof UpdatePositionPricingStrategyModel
     */
    'components': Array<UpdatePositionPricingComponentModel>;
}
/**
 * 
 * @export
 * @interface UpdatePricingStrategiesRequest
 */
export interface UpdatePricingStrategiesRequest {
    /**
     * 
     * @type {UpdateBudgetPricingStrategyModel}
     * @memberof UpdatePricingStrategiesRequest
     */
    'pricingStrategy': UpdateBudgetPricingStrategyModel;
}
/**
 * 
 * @export
 * @interface UpdatePricingStrategiesResponse
 */
export interface UpdatePricingStrategiesResponse {
    /**
     * 
     * @type {BudgetPricingStrategyModel}
     * @memberof UpdatePricingStrategiesResponse
     */
    'pricingStrategy'?: BudgetPricingStrategyModel;
}
/**
 * 
 * @export
 * @interface UpdateTierResponse
 */
export interface UpdateTierResponse {
    /**
     * 
     * @type {TierModel}
     * @memberof UpdateTierResponse
     */
    'tier'?: TierModel;
}
/**
 * 
 * @export
 * @interface UpdateWhatIfPositionModel
 */
export interface UpdateWhatIfPositionModel {
    /**
     * 
     * @type {number}
     * @memberof UpdateWhatIfPositionModel
     */
    'whatIfPositionId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateWhatIfPositionModel
     */
    'commodityId': number;
    /**
     * 
     * @type {number}
     * @memberof UpdateWhatIfPositionModel
     */
    'budgetMonth': number;
    /**
     * 
     * @type {number}
     * @memberof UpdateWhatIfPositionModel
     */
    'budgetYear': number;
    /**
     * 
     * @type {PositionType}
     * @memberof UpdateWhatIfPositionModel
     */
    'positionType': PositionType;
    /**
     * 
     * @type {Side}
     * @memberof UpdateWhatIfPositionModel
     */
    'side': Side;
    /**
     * 
     * @type {number}
     * @memberof UpdateWhatIfPositionModel
     */
    'price': number;
    /**
     * 
     * @type {number}
     * @memberof UpdateWhatIfPositionModel
     */
    'volume': number;
    /**
     * 
     * @type {number}
     * @memberof UpdateWhatIfPositionModel
     */
    'optionStrike'?: number | null;
    /**
     * 
     * @type {OptionType}
     * @memberof UpdateWhatIfPositionModel
     */
    'optionType'?: OptionType;
    /**
     * 
     * @type {OptionStyle}
     * @memberof UpdateWhatIfPositionModel
     */
    'optionStyle'?: OptionStyle;
    /**
     * 
     * @type {Unit}
     * @memberof UpdateWhatIfPositionModel
     */
    'unit': Unit;
}
/**
 * 
 * @export
 * @interface UpdateWhatIfStrategyRequest
 */
export interface UpdateWhatIfStrategyRequest {
    /**
     * 
     * @type {Array<UpdateWhatIfPositionModel>}
     * @memberof UpdateWhatIfStrategyRequest
     */
    'positions': Array<UpdateWhatIfPositionModel>;
    /**
     * 
     * @type {number}
     * @memberof UpdateWhatIfStrategyRequest
     */
    'whatIfStrategyId': number;
    /**
     * 
     * @type {string}
     * @memberof UpdateWhatIfStrategyRequest
     */
    'whatIfStrategyName': string;
}
/**
 * 
 * @export
 * @interface UpdateWhatIfStrategyResponse
 */
export interface UpdateWhatIfStrategyResponse {
    /**
     * 
     * @type {WhatIfStrategyModel}
     * @memberof UpdateWhatIfStrategyResponse
     */
    'whatIfStrategy'?: WhatIfStrategyModel;
}
/**
 * 
 * @export
 * @interface UpsertEmailScheduleRequest
 */
export interface UpsertEmailScheduleRequest {
    /**
     * 
     * @type {number}
     * @memberof UpsertEmailScheduleRequest
     */
    'emailScheduleId'?: number;
    /**
     * 
     * @type {EmailScheduleSource}
     * @memberof UpsertEmailScheduleRequest
     */
    'source': EmailScheduleSource;
    /**
     * 
     * @type {number}
     * @memberof UpsertEmailScheduleRequest
     */
    'sourceId': number;
    /**
     * 
     * @type {string}
     * @memberof UpsertEmailScheduleRequest
     */
    'siteGuid'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpsertEmailScheduleRequest
     */
    'subject'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpsertEmailScheduleRequest
     */
    'recipients': Array<string>;
    /**
     * 
     * @type {EmailScheduleFrequency}
     * @memberof UpsertEmailScheduleRequest
     */
    'frequency': EmailScheduleFrequency;
    /**
     * 
     * @type {DayOfWeek}
     * @memberof UpsertEmailScheduleRequest
     */
    'dayOfWeek'?: DayOfWeek;
    /**
     * 
     * @type {number}
     * @memberof UpsertEmailScheduleRequest
     */
    'dayOfMonth'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof UpsertEmailScheduleRequest
     */
    'timeOfDay': string;
    /**
     * 
     * @type {string}
     * @memberof UpsertEmailScheduleRequest
     */
    'timeZoneId': string;
    /**
     * 
     * @type {boolean}
     * @memberof UpsertEmailScheduleRequest
     */
    'isActive'?: boolean;
}
/**
 * 
 * @export
 * @interface UpsertEmailScheduleResponse
 */
export interface UpsertEmailScheduleResponse {
    /**
     * 
     * @type {EmailScheduleModel}
     * @memberof UpsertEmailScheduleResponse
     */
    'emailSchedule'?: EmailScheduleModel;
}
/**
 * 
 * @export
 * @interface UserAccessUpdateModel
 */
export interface UserAccessUpdateModel {
    /**
     * 
     * @type {string}
     * @memberof UserAccessUpdateModel
     */
    'marketViewUserGuid': string;
    /**
     * 
     * @type {boolean}
     * @memberof UserAccessUpdateModel
     */
    'isSiteManager': boolean;
    /**
     * 
     * @type {Array<CommodityManagementUserPermissions>}
     * @memberof UserAccessUpdateModel
     */
    'permissions': Array<CommodityManagementUserPermissions>;
}
/**
 * 
 * @export
 * @interface UserSiteAccessAddModel
 */
export interface UserSiteAccessAddModel {
    /**
     * 
     * @type {string}
     * @memberof UserSiteAccessAddModel
     */
    'siteGuid': string;
    /**
     * 
     * @type {boolean}
     * @memberof UserSiteAccessAddModel
     */
    'isSiteManager': boolean;
    /**
     * 
     * @type {Array<CommodityManagementUserPermissions>}
     * @memberof UserSiteAccessAddModel
     */
    'permissions': Array<CommodityManagementUserPermissions>;
}
/**
 * 
 * @export
 * @interface UserSiteAccessUpdateModel
 */
export interface UserSiteAccessUpdateModel {
    /**
     * 
     * @type {string}
     * @memberof UserSiteAccessUpdateModel
     */
    'marketViewUserGuid': string;
    /**
     * 
     * @type {string}
     * @memberof UserSiteAccessUpdateModel
     */
    'siteGuid': string;
    /**
     * 
     * @type {boolean}
     * @memberof UserSiteAccessUpdateModel
     */
    'isSiteManager': boolean;
    /**
     * 
     * @type {Array<CommodityManagementUserPermissions>}
     * @memberof UserSiteAccessUpdateModel
     */
    'permissions': Array<CommodityManagementUserPermissions>;
}
/**
 * 
 * @export
 * @interface Variance
 */
export interface Variance {
    /**
     * 
     * @type {Array<VarianceComponent>}
     * @memberof Variance
     */
    'components'?: Array<VarianceComponent> | null;
    /**
     * 
     * @type {number}
     * @memberof Variance
     */
    'allInHedgedPrice'?: number;
    /**
     * 
     * @type {number}
     * @memberof Variance
     */
    'allInHedgedValue'?: number;
    /**
     * 
     * @type {number}
     * @memberof Variance
     */
    'allInHedgedVolume'?: number;
    /**
     * 
     * @type {number}
     * @memberof Variance
     */
    'blendedPrice'?: number;
    /**
     * 
     * @type {number}
     * @memberof Variance
     */
    'blendedValue'?: number;
    /**
     * 
     * @type {number}
     * @memberof Variance
     */
    'budgetPrice'?: number;
    /**
     * 
     * @type {number}
     * @memberof Variance
     */
    'budgetValue'?: number;
    /**
     * 
     * @type {number}
     * @memberof Variance
     */
    'budgetVolume'?: number;
    /**
     * 
     * @type {number}
     * @memberof Variance
     */
    'effectiveBudgetVolume'?: number;
    /**
     * 
     * @type {number}
     * @memberof Variance
     */
    'hedgedValue'?: number;
    /**
     * 
     * @type {number}
     * @memberof Variance
     */
    'marketPrice'?: number;
    /**
     * 
     * @type {number}
     * @memberof Variance
     */
    'marketValue'?: number;
    /**
     * 
     * @type {number}
     * @memberof Variance
     */
    'openValue'?: number;
    /**
     * 
     * @type {number}
     * @memberof Variance
     */
    'profitAndLossPrice'?: number;
    /**
     * 
     * @type {number}
     * @memberof Variance
     */
    'profitAndLossValue'?: number;
    /**
     * 
     * @type {number}
     * @memberof Variance
     */
    'varianceToBudgetPrice'?: number;
    /**
     * 
     * @type {number}
     * @memberof Variance
     */
    'varianceToBudgetValue'?: number;
    /**
     * 
     * @type {number}
     * @memberof Variance
     */
    'varianceToMarketPrice'?: number;
    /**
     * 
     * @type {number}
     * @memberof Variance
     */
    'varianceToMarketValue'?: number;
    /**
     * 
     * @type {Unit}
     * @memberof Variance
     */
    'unit'?: Unit;
    /**
     * 
     * @type {Currency}
     * @memberof Variance
     */
    'currency'?: Currency;
}
/**
 * 
 * @export
 * @interface VarianceComponent
 */
export interface VarianceComponent {
    /**
     * 
     * @type {ComponentType}
     * @memberof VarianceComponent
     */
    'componentType'?: ComponentType;
    /**
     * 
     * @type {string}
     * @memberof VarianceComponent
     */
    'componentSubType'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof VarianceComponent
     */
    'blendedPrice'?: number;
    /**
     * 
     * @type {number}
     * @memberof VarianceComponent
     */
    'blendedValue'?: number;
    /**
     * 
     * @type {number}
     * @memberof VarianceComponent
     */
    'budgetPrice'?: number;
    /**
     * 
     * @type {number}
     * @memberof VarianceComponent
     */
    'budgetValue'?: number;
    /**
     * 
     * @type {number}
     * @memberof VarianceComponent
     */
    'budgetVolume'?: number;
    /**
     * 
     * @type {number}
     * @memberof VarianceComponent
     */
    'componentHedgedVolume'?: number;
    /**
     * 
     * @type {number}
     * @memberof VarianceComponent
     */
    'effectiveBudgetVolume'?: number;
    /**
     * 
     * @type {number}
     * @memberof VarianceComponent
     */
    'hedgedPercent'?: number;
    /**
     * 
     * @type {number}
     * @memberof VarianceComponent
     */
    'hedgedPrice'?: number;
    /**
     * 
     * @type {number}
     * @memberof VarianceComponent
     */
    'hedgedValue'?: number;
    /**
     * 
     * @type {number}
     * @memberof VarianceComponent
     */
    'hedgedVolume'?: number;
    /**
     * 
     * @type {number}
     * @memberof VarianceComponent
     */
    'marketPrice'?: number;
    /**
     * 
     * @type {number}
     * @memberof VarianceComponent
     */
    'marketValue'?: number;
    /**
     * 
     * @type {number}
     * @memberof VarianceComponent
     */
    'openPercent'?: number;
    /**
     * 
     * @type {number}
     * @memberof VarianceComponent
     */
    'openValue'?: number;
    /**
     * 
     * @type {number}
     * @memberof VarianceComponent
     */
    'openVolume'?: number;
    /**
     * 
     * @type {number}
     * @memberof VarianceComponent
     */
    'profitAndLossValue'?: number;
    /**
     * 
     * @type {number}
     * @memberof VarianceComponent
     */
    'varianceToBudgetPrice'?: number;
    /**
     * 
     * @type {number}
     * @memberof VarianceComponent
     */
    'varianceToBudgetValue'?: number;
    /**
     * 
     * @type {number}
     * @memberof VarianceComponent
     */
    'varianceToMarketPrice'?: number;
    /**
     * 
     * @type {number}
     * @memberof VarianceComponent
     */
    'varianceToMarketValue'?: number;
    /**
     * 
     * @type {PositionType}
     * @memberof VarianceComponent
     */
    'positionType'?: PositionType;
    /**
     * 
     * @type {OptionType}
     * @memberof VarianceComponent
     */
    'optionType'?: OptionType;
    /**
     * 
     * @type {string}
     * @memberof VarianceComponent
     */
    'positionDate'?: string;
    /**
     * 
     * @type {number}
     * @memberof VarianceComponent
     */
    'premium'?: number;
    /**
     * 
     * @type {number}
     * @memberof VarianceComponent
     */
    'markToMarketValue'?: number;
    /**
     * 
     * @type {number}
     * @memberof VarianceComponent
     */
    'markToMarketPrice'?: number;
    /**
     * 
     * @type {number}
     * @memberof VarianceComponent
     */
    'fixedHedgedVolume'?: number;
    /**
     * 
     * @type {number}
     * @memberof VarianceComponent
     */
    'fixedVarianceToMarketValue'?: number;
    /**
     * 
     * @type {number}
     * @memberof VarianceComponent
     */
    'callHedgedVolume'?: number;
    /**
     * 
     * @type {number}
     * @memberof VarianceComponent
     */
    'callStrikePrice'?: number;
    /**
     * 
     * @type {number}
     * @memberof VarianceComponent
     */
    'quoteMonthFixedHedgedVolume'?: number;
    /**
     * 
     * @type {number}
     * @memberof VarianceComponent
     */
    'quoteMonthFixedHedgedPrice'?: number;
    /**
     * 
     * @type {number}
     * @memberof VarianceComponent
     */
    'quoteMonthCallHedgedVolume'?: number;
    /**
     * 
     * @type {number}
     * @memberof VarianceComponent
     */
    'quoteMonthCallPremiumPrice'?: number;
    /**
     * 
     * @type {number}
     * @memberof VarianceComponent
     */
    'quoteMonthCallStrikePrice'?: number;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const VolumeSource = {
    None: 'None',
    CommodityManagement: 'CommodityManagement',
    KnowRiskEnergy: 'KnowRiskEnergy'
} as const;

export type VolumeSource = typeof VolumeSource[keyof typeof VolumeSource];


/**
 * 
 * @export
 * @interface WhatIfPositionModel
 */
export interface WhatIfPositionModel {
    /**
     * 
     * @type {number}
     * @memberof WhatIfPositionModel
     */
    'whatIfPositionId': number;
    /**
     * 
     * @type {number}
     * @memberof WhatIfPositionModel
     */
    'commodityId': number;
    /**
     * 
     * @type {CommodityModel}
     * @memberof WhatIfPositionModel
     */
    'commodity': CommodityModel;
    /**
     * 
     * @type {number}
     * @memberof WhatIfPositionModel
     */
    'budgetMonth': number;
    /**
     * 
     * @type {number}
     * @memberof WhatIfPositionModel
     */
    'budgetYear': number;
    /**
     * 
     * @type {PositionType}
     * @memberof WhatIfPositionModel
     */
    'positionType': PositionType;
    /**
     * 
     * @type {Side}
     * @memberof WhatIfPositionModel
     */
    'side': Side;
    /**
     * 
     * @type {number}
     * @memberof WhatIfPositionModel
     */
    'price': number;
    /**
     * 
     * @type {number}
     * @memberof WhatIfPositionModel
     */
    'volume': number;
    /**
     * 
     * @type {number}
     * @memberof WhatIfPositionModel
     */
    'optionStrike'?: number | null;
    /**
     * 
     * @type {OptionType}
     * @memberof WhatIfPositionModel
     */
    'optionType'?: OptionType;
    /**
     * 
     * @type {OptionStyle}
     * @memberof WhatIfPositionModel
     */
    'optionStyle'?: OptionStyle;
    /**
     * 
     * @type {Unit}
     * @memberof WhatIfPositionModel
     */
    'unit': Unit;
    /**
     * 
     * @type {ContractDate}
     * @memberof WhatIfPositionModel
     */
    'budgetDate': ContractDate;
}
/**
 * 
 * @export
 * @interface WhatIfStrategyModel
 */
export interface WhatIfStrategyModel {
    /**
     * 
     * @type {number}
     * @memberof WhatIfStrategyModel
     */
    'whatIfStrategyId': number;
    /**
     * 
     * @type {string}
     * @memberof WhatIfStrategyModel
     */
    'whatIfStrategyName': string;
    /**
     * 
     * @type {Array<WhatIfPositionModel>}
     * @memberof WhatIfStrategyModel
     */
    'positions': Array<WhatIfPositionModel>;
}
/**
 * 
 * @export
 * @interface YearAllotmentDataModel
 */
export interface YearAllotmentDataModel {
    /**
     * 
     * @type {number}
     * @memberof YearAllotmentDataModel
     */
    'year': number;
    /**
     * 
     * @type {number}
     * @memberof YearAllotmentDataModel
     */
    'count': number;
    /**
     * 
     * @type {number}
     * @memberof YearAllotmentDataModel
     */
    'commodityId': number;
    /**
     * 
     * @type {number}
     * @memberof YearAllotmentDataModel
     */
    'locationId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof YearAllotmentDataModel
     */
    'counterpartyId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof YearAllotmentDataModel
     */
    'portfolioId'?: number | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof YearAllotmentDataModel
     */
    'budgetRoundIds': Array<number>;
}
/**
 * 
 * @export
 * @interface YearDataModel
 */
export interface YearDataModel {
    /**
     * 
     * @type {number}
     * @memberof YearDataModel
     */
    'year': number;
    /**
     * 
     * @type {number}
     * @memberof YearDataModel
     */
    'count': number;
    /**
     * 
     * @type {Array<number>}
     * @memberof YearDataModel
     */
    'commodityIds': Array<number>;
}
/**
 * 
 * @export
 * @interface YearDefaultBudgetRoundModel
 */
export interface YearDefaultBudgetRoundModel {
    /**
     * 
     * @type {number}
     * @memberof YearDefaultBudgetRoundModel
     */
    'year': number;
    /**
     * 
     * @type {number}
     * @memberof YearDefaultBudgetRoundModel
     */
    'budgetRoundId': number;
    /**
     * 
     * @type {number}
     * @memberof YearDefaultBudgetRoundModel
     */
    'commodityId'?: number;
    /**
     * 
     * @type {number}
     * @memberof YearDefaultBudgetRoundModel
     */
    'locationId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof YearDefaultBudgetRoundModel
     */
    'counterpartyId'?: number | null;
}

/**
 * CommodityManagementApi - axios parameter creator
 * @export
 */
export const CommodityManagementApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {UpdateAllocationRequest} [updateAllocationRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addAllocation: async (updateAllocationRequest?: UpdateAllocationRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/commodity-management/allocations/allocation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateAllocationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UpdateAllocationGroupRequest} [updateAllocationGroupRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addAllocationGroup: async (updateAllocationGroupRequest?: UpdateAllocationGroupRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/commodity-management/allocations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateAllocationGroupRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} commodityName 
         * @param {Unit} displayUnit 
         * @param {number} displayPrecision 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addCommodity: async (commodityName: string, displayUnit: Unit, displayPrecision: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'commodityName' is not null or undefined
            assertParamExists('addCommodity', 'commodityName', commodityName)
            // verify required parameter 'displayUnit' is not null or undefined
            assertParamExists('addCommodity', 'displayUnit', displayUnit)
            // verify required parameter 'displayPrecision' is not null or undefined
            assertParamExists('addCommodity', 'displayPrecision', displayPrecision)
            const localVarPath = `/commodity-management/commodities`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (commodityName !== undefined) {
                localVarQueryParameter['CommodityName'] = commodityName;
            }

            if (displayUnit !== undefined) {
                localVarQueryParameter['DisplayUnit'] = displayUnit;
            }

            if (displayPrecision !== undefined) {
                localVarQueryParameter['DisplayPrecision'] = displayPrecision;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [counterpartyName] 
         * @param {number} [creditLimit] 
         * @param {boolean} [netting] 
         * @param {boolean} [setoff] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addCounterparty: async (counterpartyName?: string, creditLimit?: number, netting?: boolean, setoff?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/commodity-management/counterparties`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (counterpartyName !== undefined) {
                localVarQueryParameter['CounterpartyName'] = counterpartyName;
            }

            if (creditLimit !== undefined) {
                localVarQueryParameter['CreditLimit'] = creditLimit;
            }

            if (netting !== undefined) {
                localVarQueryParameter['Netting'] = netting;
            }

            if (setoff !== undefined) {
                localVarQueryParameter['Setoff'] = setoff;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} hedgePlanId 
         * @param {AddHedgePlanSeasonRequest} [addHedgePlanSeasonRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addHedgePlanSeason: async (hedgePlanId: string, addHedgePlanSeasonRequest?: AddHedgePlanSeasonRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'hedgePlanId' is not null or undefined
            assertParamExists('addHedgePlanSeason', 'hedgePlanId', hedgePlanId)
            const localVarPath = `/commodity-management/hedge-plans/{hedgePlanId}/seasons`
                .replace(`{${"hedgePlanId"}}`, encodeURIComponent(String(hedgePlanId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addHedgePlanSeasonRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} locationName 
         * @param {number} tierId 
         * @param {number} [parentLocationId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addLocation: async (locationName: string, tierId: number, parentLocationId?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'locationName' is not null or undefined
            assertParamExists('addLocation', 'locationName', locationName)
            // verify required parameter 'tierId' is not null or undefined
            assertParamExists('addLocation', 'tierId', tierId)
            const localVarPath = `/commodity-management/locations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (locationName !== undefined) {
                localVarQueryParameter['LocationName'] = locationName;
            }

            if (tierId !== undefined) {
                localVarQueryParameter['TierId'] = tierId;
            }

            if (parentLocationId !== undefined) {
                localVarQueryParameter['ParentLocationId'] = parentLocationId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {AddNoteRequest} [addNoteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addNote: async (addNoteRequest?: AddNoteRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/commodity-management/notes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addNoteRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} portfolioName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addPortfolio: async (portfolioName: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'portfolioName' is not null or undefined
            assertParamExists('addPortfolio', 'portfolioName', portfolioName)
            const localVarPath = `/commodity-management/portfolios`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (portfolioName !== undefined) {
                localVarQueryParameter['PortfolioName'] = portfolioName;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} tierRank 
         * @param {string} [tierName] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addTier: async (tierRank: number, tierName?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tierRank' is not null or undefined
            assertParamExists('addTier', 'tierRank', tierRank)
            const localVarPath = `/commodity-management/tiers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (tierName !== undefined) {
                localVarQueryParameter['TierName'] = tierName;
            }

            if (tierRank !== undefined) {
                localVarQueryParameter['TierRank'] = tierRank;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UpdateDealTicketRequest} [updateDealTicketRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addTrade: async (updateDealTicketRequest?: UpdateDealTicketRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/commodity-management/dealTickets`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateDealTicketRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<number>} customerReportIds 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        copyCustomerReports: async (customerReportIds: Array<number>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customerReportIds' is not null or undefined
            assertParamExists('copyCustomerReports', 'customerReportIds', customerReportIds)
            const localVarPath = `/commodity-management/customer/reports/copies`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (customerReportIds) {
                localVarQueryParameter['CustomerReportIds'] = customerReportIds;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} commodityId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCommodity: async (commodityId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'commodityId' is not null or undefined
            assertParamExists('deleteCommodity', 'commodityId', commodityId)
            const localVarPath = `/commodity-management/commodities/{commodityId}`
                .replace(`{${"commodityId"}}`, encodeURIComponent(String(commodityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} counterpartyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCounterparty: async (counterpartyId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'counterpartyId' is not null or undefined
            assertParamExists('deleteCounterparty', 'counterpartyId', counterpartyId)
            const localVarPath = `/commodity-management/counterparties/{counterpartyId}`
                .replace(`{${"counterpartyId"}}`, encodeURIComponent(String(counterpartyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} customerReportId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCustomerReport: async (customerReportId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customerReportId' is not null or undefined
            assertParamExists('deleteCustomerReport', 'customerReportId', customerReportId)
            const localVarPath = `/commodity-management/customer/reports/{customerReportId}`
                .replace(`{${"customerReportId"}}`, encodeURIComponent(String(customerReportId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} dealTicketId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDealTicket: async (dealTicketId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'dealTicketId' is not null or undefined
            assertParamExists('deleteDealTicket', 'dealTicketId', dealTicketId)
            const localVarPath = `/commodity-management/dealTickets/{dealTicketId}`
                .replace(`{${"dealTicketId"}}`, encodeURIComponent(String(dealTicketId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} hedgePlanId 
         * @param {number} year 
         * @param {MatrixTerm} [term] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteHedgePlanSeason: async (hedgePlanId: string, year: number, term?: MatrixTerm, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'hedgePlanId' is not null or undefined
            assertParamExists('deleteHedgePlanSeason', 'hedgePlanId', hedgePlanId)
            // verify required parameter 'year' is not null or undefined
            assertParamExists('deleteHedgePlanSeason', 'year', year)
            const localVarPath = `/commodity-management/hedge-plans/{hedgePlanId}/seasons`
                .replace(`{${"hedgePlanId"}}`, encodeURIComponent(String(hedgePlanId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (year !== undefined) {
                localVarQueryParameter['Year'] = year;
            }

            if (term !== undefined) {
                localVarQueryParameter['Term'] = term;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} locationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteLocation: async (locationId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'locationId' is not null or undefined
            assertParamExists('deleteLocation', 'locationId', locationId)
            const localVarPath = `/commodity-management/locations/{locationId}`
                .replace(`{${"locationId"}}`, encodeURIComponent(String(locationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} noteId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteNote: async (noteId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'noteId' is not null or undefined
            assertParamExists('deleteNote', 'noteId', noteId)
            const localVarPath = `/commodity-management/notes/{NoteId}`
                .replace(`{${"NoteId"}}`, encodeURIComponent(String(noteId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} portfolioId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePortfolio: async (portfolioId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'portfolioId' is not null or undefined
            assertParamExists('deletePortfolio', 'portfolioId', portfolioId)
            const localVarPath = `/commodity-management/portfolios/{portfolioId}`
                .replace(`{${"portfolioId"}}`, encodeURIComponent(String(portfolioId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} budgetPricingStrategyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePricingStrategy: async (budgetPricingStrategyId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'budgetPricingStrategyId' is not null or undefined
            assertParamExists('deletePricingStrategy', 'budgetPricingStrategyId', budgetPricingStrategyId)
            const localVarPath = `/commodity-management/pricing-strategies/{budgetPricingStrategyId}`
                .replace(`{${"budgetPricingStrategyId"}}`, encodeURIComponent(String(budgetPricingStrategyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} tierId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTier: async (tierId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tierId' is not null or undefined
            assertParamExists('deleteTier', 'tierId', tierId)
            const localVarPath = `/commodity-management/tiers/{tierId}`
                .replace(`{${"tierId"}}`, encodeURIComponent(String(tierId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} whatIfStrategyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteWhatIfStrategy: async (whatIfStrategyId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'whatIfStrategyId' is not null or undefined
            assertParamExists('deleteWhatIfStrategy', 'whatIfStrategyId', whatIfStrategyId)
            const localVarPath = `/commodity-management/what-if-strategies/{whatIfStrategyId}`
                .replace(`{${"whatIfStrategyId"}}`, encodeURIComponent(String(whatIfStrategyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [documentUrl] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadDocument: async (documentUrl?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/download`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (documentUrl !== undefined) {
                localVarQueryParameter['DocumentUrl'] = documentUrl;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} entityType 
         * @param {string} entityId 
         * @param {boolean} [includeUnchangedFields] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAuditTrail: async (entityType: string, entityId: string, includeUnchangedFields?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'entityType' is not null or undefined
            assertParamExists('getAuditTrail', 'entityType', entityType)
            // verify required parameter 'entityId' is not null or undefined
            assertParamExists('getAuditTrail', 'entityId', entityId)
            const localVarPath = `/{entityType}/{entityId}`
                .replace(`{${"entityType"}}`, encodeURIComponent(String(entityType)))
                .replace(`{${"entityId"}}`, encodeURIComponent(String(entityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (includeUnchangedFields !== undefined) {
                localVarQueryParameter['IncludeUnchangedFields'] = includeUnchangedFields;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} entityId 
         * @param {string} [entityType] 
         * @param {boolean} [includeUnchangedFields] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBudgetAuditTrail: async (entityId: string, entityType?: string, includeUnchangedFields?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'entityId' is not null or undefined
            assertParamExists('getBudgetAuditTrail', 'entityId', entityId)
            const localVarPath = `/budgets/{entityId}`
                .replace(`{${"entityId"}}`, encodeURIComponent(String(entityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (entityType !== undefined) {
                localVarQueryParameter['EntityType'] = entityType;
            }

            if (includeUnchangedFields !== undefined) {
                localVarQueryParameter['IncludeUnchangedFields'] = includeUnchangedFields;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomerData: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/commodity-management/customer/data`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomerReports: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/commodity-management/customer/reports`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomerSettings: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/commodity-management/customer/settings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} pricingStartDate 
         * @param {string} pricingEndDate 
         * @param {GetDailyPositionsReportRequest} [getDailyPositionsReportRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDailyPositionsExcelReport: async (pricingStartDate: string, pricingEndDate: string, getDailyPositionsReportRequest?: GetDailyPositionsReportRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pricingStartDate' is not null or undefined
            assertParamExists('getDailyPositionsExcelReport', 'pricingStartDate', pricingStartDate)
            // verify required parameter 'pricingEndDate' is not null or undefined
            assertParamExists('getDailyPositionsExcelReport', 'pricingEndDate', pricingEndDate)
            const localVarPath = `/commodity-management/reports/daily-positions/{pricingStartDate}/{pricingEndDate}export`
                .replace(`{${"pricingStartDate"}}`, encodeURIComponent(String(pricingStartDate)))
                .replace(`{${"pricingEndDate"}}`, encodeURIComponent(String(pricingEndDate)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getDailyPositionsReportRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} pricingStartDate 
         * @param {string} pricingEndDate 
         * @param {GetDailyPositionsReportRequest} [getDailyPositionsReportRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDailyPositionsReport: async (pricingStartDate: string, pricingEndDate: string, getDailyPositionsReportRequest?: GetDailyPositionsReportRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pricingStartDate' is not null or undefined
            assertParamExists('getDailyPositionsReport', 'pricingStartDate', pricingStartDate)
            // verify required parameter 'pricingEndDate' is not null or undefined
            assertParamExists('getDailyPositionsReport', 'pricingEndDate', pricingEndDate)
            const localVarPath = `/commodity-management/reports/daily-positions/{pricingStartDate}/{pricingEndDate}`
                .replace(`{${"pricingStartDate"}}`, encodeURIComponent(String(pricingStartDate)))
                .replace(`{${"pricingEndDate"}}`, encodeURIComponent(String(pricingEndDate)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getDailyPositionsReportRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} dealTicketId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDealTicket: async (dealTicketId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'dealTicketId' is not null or undefined
            assertParamExists('getDealTicket', 'dealTicketId', dealTicketId)
            const localVarPath = `/commodity-management/dealTickets/{dealTicketId}`
                .replace(`{${"dealTicketId"}}`, encodeURIComponent(String(dealTicketId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} quoteDate 
         * @param {number} customerReportId 
         * @param {Currency} [currency] 
         * @param {StressIncrementType} [stressIncrementType] 
         * @param {Array<number>} [stressIncrements] 
         * @param {string} [sortColumn] 
         * @param {SortDirection} [sortDirection] 
         * @param {number} [take] 
         * @param {number} [skip] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExposureExcelReport: async (quoteDate: string, customerReportId: number, currency?: Currency, stressIncrementType?: StressIncrementType, stressIncrements?: Array<number>, sortColumn?: string, sortDirection?: SortDirection, take?: number, skip?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'quoteDate' is not null or undefined
            assertParamExists('getExposureExcelReport', 'quoteDate', quoteDate)
            // verify required parameter 'customerReportId' is not null or undefined
            assertParamExists('getExposureExcelReport', 'customerReportId', customerReportId)
            const localVarPath = `/commodity-management/reports/exposure/{quoteDate}/export`
                .replace(`{${"quoteDate"}}`, encodeURIComponent(String(quoteDate)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (customerReportId !== undefined) {
                localVarQueryParameter['CustomerReportId'] = customerReportId;
            }

            if (currency !== undefined) {
                localVarQueryParameter['Currency'] = currency;
            }

            if (stressIncrementType !== undefined) {
                localVarQueryParameter['StressIncrementType'] = stressIncrementType;
            }

            if (stressIncrements) {
                localVarQueryParameter['StressIncrements'] = stressIncrements;
            }

            if (sortColumn !== undefined) {
                localVarQueryParameter['SortColumn'] = sortColumn;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['SortDirection'] = sortDirection;
            }

            if (take !== undefined) {
                localVarQueryParameter['Take'] = take;
            }

            if (skip !== undefined) {
                localVarQueryParameter['Skip'] = skip;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} quoteDate 
         * @param {number} customerReportId 
         * @param {Currency} [currency] 
         * @param {StressIncrementType} [stressIncrementType] 
         * @param {Array<number>} [stressIncrements] 
         * @param {string} [sortColumn] 
         * @param {SortDirection} [sortDirection] 
         * @param {number} [take] 
         * @param {number} [skip] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExposureReport: async (quoteDate: string, customerReportId: number, currency?: Currency, stressIncrementType?: StressIncrementType, stressIncrements?: Array<number>, sortColumn?: string, sortDirection?: SortDirection, take?: number, skip?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'quoteDate' is not null or undefined
            assertParamExists('getExposureReport', 'quoteDate', quoteDate)
            // verify required parameter 'customerReportId' is not null or undefined
            assertParamExists('getExposureReport', 'customerReportId', customerReportId)
            const localVarPath = `/commodity-management/reports/exposure/{quoteDate}`
                .replace(`{${"quoteDate"}}`, encodeURIComponent(String(quoteDate)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (customerReportId !== undefined) {
                localVarQueryParameter['CustomerReportId'] = customerReportId;
            }

            if (currency !== undefined) {
                localVarQueryParameter['Currency'] = currency;
            }

            if (stressIncrementType !== undefined) {
                localVarQueryParameter['StressIncrementType'] = stressIncrementType;
            }

            if (stressIncrements) {
                localVarQueryParameter['StressIncrements'] = stressIncrements;
            }

            if (sortColumn !== undefined) {
                localVarQueryParameter['SortColumn'] = sortColumn;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['SortDirection'] = sortDirection;
            }

            if (take !== undefined) {
                localVarQueryParameter['Take'] = take;
            }

            if (skip !== undefined) {
                localVarQueryParameter['Skip'] = skip;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} hedgePlanId 
         * @param {string} year 
         * @param {string} quoteDate 
         * @param {MatrixTerm} [term] 
         * @param {boolean} [weightByVolume] 
         * @param {boolean} [refreshCache] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHedgePlanReport: async (hedgePlanId: string, year: string, quoteDate: string, term?: MatrixTerm, weightByVolume?: boolean, refreshCache?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'hedgePlanId' is not null or undefined
            assertParamExists('getHedgePlanReport', 'hedgePlanId', hedgePlanId)
            // verify required parameter 'year' is not null or undefined
            assertParamExists('getHedgePlanReport', 'year', year)
            // verify required parameter 'quoteDate' is not null or undefined
            assertParamExists('getHedgePlanReport', 'quoteDate', quoteDate)
            const localVarPath = `/commodity-management/hedge-plans/{hedgePlanId}/years/{year}/report`
                .replace(`{${"hedgePlanId"}}`, encodeURIComponent(String(hedgePlanId)))
                .replace(`{${"year"}}`, encodeURIComponent(String(year)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (term !== undefined) {
                localVarQueryParameter['Term'] = term;
            }

            if (quoteDate !== undefined) {
                localVarQueryParameter['QuoteDate'] = (quoteDate as any instanceof Date) ?
                    (quoteDate as any).toISOString() :
                    quoteDate;
            }

            if (weightByVolume !== undefined) {
                localVarQueryParameter['WeightByVolume'] = weightByVolume;
            }

            if (refreshCache !== undefined) {
                localVarQueryParameter['RefreshCache'] = refreshCache;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} companyGuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLocationsForCompany: async (companyGuid: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyGuid' is not null or undefined
            assertParamExists('getLocationsForCompany', 'companyGuid', companyGuid)
            const localVarPath = `/commodity-management/know-risk-energy/companies/{companyGuid}/locations`
                .replace(`{${"companyGuid"}}`, encodeURIComponent(String(companyGuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} quoteDate 
         * @param {GetMarkToMarketReportRequest} [getMarkToMarketReportRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMarkToMarketExcelReport: async (quoteDate: string, getMarkToMarketReportRequest?: GetMarkToMarketReportRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'quoteDate' is not null or undefined
            assertParamExists('getMarkToMarketExcelReport', 'quoteDate', quoteDate)
            const localVarPath = `/commodity-management/reports/mark-to-market/{quoteDate}/export`
                .replace(`{${"quoteDate"}}`, encodeURIComponent(String(quoteDate)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getMarkToMarketReportRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} quoteDate 
         * @param {GetMarkToMarketReportRequest} [getMarkToMarketReportRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMarkToMarketReport: async (quoteDate: string, getMarkToMarketReportRequest?: GetMarkToMarketReportRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'quoteDate' is not null or undefined
            assertParamExists('getMarkToMarketReport', 'quoteDate', quoteDate)
            const localVarPath = `/commodity-management/reports/mark-to-market/{quoteDate}`
                .replace(`{${"quoteDate"}}`, encodeURIComponent(String(quoteDate)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getMarkToMarketReportRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} customerReportId 
         * @param {string} [quoteDate] 
         * @param {number} [budgetStartMonthYear] 
         * @param {number} [budgetStartMonthMonth] 
         * @param {string} [budgetStartMonthLabel] 
         * @param {number} [budgetEndMonthYear] 
         * @param {number} [budgetEndMonthMonth] 
         * @param {string} [budgetEndMonthLabel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPiedmontHedgingExcelReport: async (customerReportId: number, quoteDate?: string, budgetStartMonthYear?: number, budgetStartMonthMonth?: number, budgetStartMonthLabel?: string, budgetEndMonthYear?: number, budgetEndMonthMonth?: number, budgetEndMonthLabel?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customerReportId' is not null or undefined
            assertParamExists('getPiedmontHedgingExcelReport', 'customerReportId', customerReportId)
            const localVarPath = `/commodity-management/reports/piedmont-hedging/export`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (customerReportId !== undefined) {
                localVarQueryParameter['CustomerReportId'] = customerReportId;
            }

            if (quoteDate !== undefined) {
                localVarQueryParameter['QuoteDate'] = (quoteDate as any instanceof Date) ?
                    (quoteDate as any).toISOString() :
                    quoteDate;
            }

            if (budgetStartMonthYear !== undefined) {
                localVarQueryParameter['BudgetStartMonth.Year'] = budgetStartMonthYear;
            }

            if (budgetStartMonthMonth !== undefined) {
                localVarQueryParameter['BudgetStartMonth.Month'] = budgetStartMonthMonth;
            }

            if (budgetStartMonthLabel !== undefined) {
                localVarQueryParameter['BudgetStartMonth.Label'] = budgetStartMonthLabel;
            }

            if (budgetEndMonthYear !== undefined) {
                localVarQueryParameter['BudgetEndMonth.Year'] = budgetEndMonthYear;
            }

            if (budgetEndMonthMonth !== undefined) {
                localVarQueryParameter['BudgetEndMonth.Month'] = budgetEndMonthMonth;
            }

            if (budgetEndMonthLabel !== undefined) {
                localVarQueryParameter['BudgetEndMonth.Label'] = budgetEndMonthLabel;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} customerReportId 
         * @param {string} [quoteDate] 
         * @param {number} [budgetStartMonthYear] 
         * @param {number} [budgetStartMonthMonth] 
         * @param {string} [budgetStartMonthLabel] 
         * @param {number} [budgetEndMonthYear] 
         * @param {number} [budgetEndMonthMonth] 
         * @param {string} [budgetEndMonthLabel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPiedmontHedgingReport: async (customerReportId: number, quoteDate?: string, budgetStartMonthYear?: number, budgetStartMonthMonth?: number, budgetStartMonthLabel?: string, budgetEndMonthYear?: number, budgetEndMonthMonth?: number, budgetEndMonthLabel?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customerReportId' is not null or undefined
            assertParamExists('getPiedmontHedgingReport', 'customerReportId', customerReportId)
            const localVarPath = `/commodity-management/reports/piedmont-hedging`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (customerReportId !== undefined) {
                localVarQueryParameter['CustomerReportId'] = customerReportId;
            }

            if (quoteDate !== undefined) {
                localVarQueryParameter['QuoteDate'] = (quoteDate as any instanceof Date) ?
                    (quoteDate as any).toISOString() :
                    quoteDate;
            }

            if (budgetStartMonthYear !== undefined) {
                localVarQueryParameter['BudgetStartMonth.Year'] = budgetStartMonthYear;
            }

            if (budgetStartMonthMonth !== undefined) {
                localVarQueryParameter['BudgetStartMonth.Month'] = budgetStartMonthMonth;
            }

            if (budgetStartMonthLabel !== undefined) {
                localVarQueryParameter['BudgetStartMonth.Label'] = budgetStartMonthLabel;
            }

            if (budgetEndMonthYear !== undefined) {
                localVarQueryParameter['BudgetEndMonth.Year'] = budgetEndMonthYear;
            }

            if (budgetEndMonthMonth !== undefined) {
                localVarQueryParameter['BudgetEndMonth.Month'] = budgetEndMonthMonth;
            }

            if (budgetEndMonthLabel !== undefined) {
                localVarQueryParameter['BudgetEndMonth.Label'] = budgetEndMonthLabel;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} entityId 
         * @param {string} [entityType] 
         * @param {boolean} [includeUnchangedFields] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPositionAuditTrail: async (entityId: string, entityType?: string, includeUnchangedFields?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'entityId' is not null or undefined
            assertParamExists('getPositionAuditTrail', 'entityId', entityId)
            const localVarPath = `/positions/{entityId}`
                .replace(`{${"entityId"}}`, encodeURIComponent(String(entityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (entityType !== undefined) {
                localVarQueryParameter['EntityType'] = entityType;
            }

            if (includeUnchangedFields !== undefined) {
                localVarQueryParameter['IncludeUnchangedFields'] = includeUnchangedFields;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [quoteDate] 
         * @param {boolean} [includeExpirationDates] 
         * @param {boolean} [includeMarketPrices] 
         * @param {boolean} [useDisplayUnits] 
         * @param {Array<ScenarioMarketPriceModel>} [scenarioMarketPrices] 
         * @param {Array<number>} [commoditiesFilter] 
         * @param {Array<number>} [locationsFilter] 
         * @param {Array<number>} [counterpartiesFilter] 
         * @param {string} [tradeDateStartFilter] 
         * @param {string} [tradeDateEndFilter] 
         * @param {number} [budgetMonthStartFilterYear] 
         * @param {number} [budgetMonthStartFilterMonth] 
         * @param {string} [budgetMonthStartFilterLabel] 
         * @param {number} [budgetMonthEndFilterYear] 
         * @param {number} [budgetMonthEndFilterMonth] 
         * @param {string} [budgetMonthEndFilterLabel] 
         * @param {number} [contractMonthStartFilterYear] 
         * @param {number} [contractMonthStartFilterMonth] 
         * @param {string} [contractMonthStartFilterLabel] 
         * @param {number} [contractMonthEndFilterYear] 
         * @param {number} [contractMonthEndFilterMonth] 
         * @param {string} [contractMonthEndFilterLabel] 
         * @param {Array<PositionType>} [positionTypesFilter] 
         * @param {string} [dealTicketNumberFilter] 
         * @param {number} [dealTicketIdFilter] 
         * @param {Side} [sideFilter] 
         * @param {boolean} [validatedFilter] 
         * @param {Array<Currency>} [currencyFilter] 
         * @param {Currency} [currency] 
         * @param {ExpiryStatus} [expiryStatus] 
         * @param {boolean} [includeAllocations] 
         * @param {boolean} [includeAllocationOffset] 
         * @param {boolean} [filterByTradeDate] 
         * @param {string} [pricingStartDateStartFilter] 
         * @param {string} [pricingStartDateEndFilter] 
         * @param {string} [pricingEndDateStartFilter] 
         * @param {string} [pricingEndDateEndFilter] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPositionExcelExport: async (quoteDate?: string, includeExpirationDates?: boolean, includeMarketPrices?: boolean, useDisplayUnits?: boolean, scenarioMarketPrices?: Array<ScenarioMarketPriceModel>, commoditiesFilter?: Array<number>, locationsFilter?: Array<number>, counterpartiesFilter?: Array<number>, tradeDateStartFilter?: string, tradeDateEndFilter?: string, budgetMonthStartFilterYear?: number, budgetMonthStartFilterMonth?: number, budgetMonthStartFilterLabel?: string, budgetMonthEndFilterYear?: number, budgetMonthEndFilterMonth?: number, budgetMonthEndFilterLabel?: string, contractMonthStartFilterYear?: number, contractMonthStartFilterMonth?: number, contractMonthStartFilterLabel?: string, contractMonthEndFilterYear?: number, contractMonthEndFilterMonth?: number, contractMonthEndFilterLabel?: string, positionTypesFilter?: Array<PositionType>, dealTicketNumberFilter?: string, dealTicketIdFilter?: number, sideFilter?: Side, validatedFilter?: boolean, currencyFilter?: Array<Currency>, currency?: Currency, expiryStatus?: ExpiryStatus, includeAllocations?: boolean, includeAllocationOffset?: boolean, filterByTradeDate?: boolean, pricingStartDateStartFilter?: string, pricingStartDateEndFilter?: string, pricingEndDateStartFilter?: string, pricingEndDateEndFilter?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/export`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (quoteDate !== undefined) {
                localVarQueryParameter['QuoteDate'] = (quoteDate as any instanceof Date) ?
                    (quoteDate as any).toISOString() :
                    quoteDate;
            }

            if (includeExpirationDates !== undefined) {
                localVarQueryParameter['IncludeExpirationDates'] = includeExpirationDates;
            }

            if (includeMarketPrices !== undefined) {
                localVarQueryParameter['IncludeMarketPrices'] = includeMarketPrices;
            }

            if (useDisplayUnits !== undefined) {
                localVarQueryParameter['UseDisplayUnits'] = useDisplayUnits;
            }

            if (scenarioMarketPrices) {
                localVarQueryParameter['ScenarioMarketPrices'] = scenarioMarketPrices;
            }

            if (commoditiesFilter) {
                localVarQueryParameter['CommoditiesFilter'] = commoditiesFilter;
            }

            if (locationsFilter) {
                localVarQueryParameter['LocationsFilter'] = locationsFilter;
            }

            if (counterpartiesFilter) {
                localVarQueryParameter['CounterpartiesFilter'] = counterpartiesFilter;
            }

            if (tradeDateStartFilter !== undefined) {
                localVarQueryParameter['TradeDateStartFilter'] = (tradeDateStartFilter as any instanceof Date) ?
                    (tradeDateStartFilter as any).toISOString() :
                    tradeDateStartFilter;
            }

            if (tradeDateEndFilter !== undefined) {
                localVarQueryParameter['TradeDateEndFilter'] = (tradeDateEndFilter as any instanceof Date) ?
                    (tradeDateEndFilter as any).toISOString() :
                    tradeDateEndFilter;
            }

            if (budgetMonthStartFilterYear !== undefined) {
                localVarQueryParameter['BudgetMonthStartFilter.Year'] = budgetMonthStartFilterYear;
            }

            if (budgetMonthStartFilterMonth !== undefined) {
                localVarQueryParameter['BudgetMonthStartFilter.Month'] = budgetMonthStartFilterMonth;
            }

            if (budgetMonthStartFilterLabel !== undefined) {
                localVarQueryParameter['BudgetMonthStartFilter.Label'] = budgetMonthStartFilterLabel;
            }

            if (budgetMonthEndFilterYear !== undefined) {
                localVarQueryParameter['BudgetMonthEndFilter.Year'] = budgetMonthEndFilterYear;
            }

            if (budgetMonthEndFilterMonth !== undefined) {
                localVarQueryParameter['BudgetMonthEndFilter.Month'] = budgetMonthEndFilterMonth;
            }

            if (budgetMonthEndFilterLabel !== undefined) {
                localVarQueryParameter['BudgetMonthEndFilter.Label'] = budgetMonthEndFilterLabel;
            }

            if (contractMonthStartFilterYear !== undefined) {
                localVarQueryParameter['ContractMonthStartFilter.Year'] = contractMonthStartFilterYear;
            }

            if (contractMonthStartFilterMonth !== undefined) {
                localVarQueryParameter['ContractMonthStartFilter.Month'] = contractMonthStartFilterMonth;
            }

            if (contractMonthStartFilterLabel !== undefined) {
                localVarQueryParameter['ContractMonthStartFilter.Label'] = contractMonthStartFilterLabel;
            }

            if (contractMonthEndFilterYear !== undefined) {
                localVarQueryParameter['ContractMonthEndFilter.Year'] = contractMonthEndFilterYear;
            }

            if (contractMonthEndFilterMonth !== undefined) {
                localVarQueryParameter['ContractMonthEndFilter.Month'] = contractMonthEndFilterMonth;
            }

            if (contractMonthEndFilterLabel !== undefined) {
                localVarQueryParameter['ContractMonthEndFilter.Label'] = contractMonthEndFilterLabel;
            }

            if (positionTypesFilter) {
                localVarQueryParameter['PositionTypesFilter'] = positionTypesFilter;
            }

            if (dealTicketNumberFilter !== undefined) {
                localVarQueryParameter['DealTicketNumberFilter'] = dealTicketNumberFilter;
            }

            if (dealTicketIdFilter !== undefined) {
                localVarQueryParameter['DealTicketIdFilter'] = dealTicketIdFilter;
            }

            if (sideFilter !== undefined) {
                localVarQueryParameter['SideFilter'] = sideFilter;
            }

            if (validatedFilter !== undefined) {
                localVarQueryParameter['ValidatedFilter'] = validatedFilter;
            }

            if (currencyFilter) {
                localVarQueryParameter['CurrencyFilter'] = currencyFilter;
            }

            if (currency !== undefined) {
                localVarQueryParameter['Currency'] = currency;
            }

            if (expiryStatus !== undefined) {
                localVarQueryParameter['ExpiryStatus'] = expiryStatus;
            }

            if (includeAllocations !== undefined) {
                localVarQueryParameter['IncludeAllocations'] = includeAllocations;
            }

            if (includeAllocationOffset !== undefined) {
                localVarQueryParameter['IncludeAllocationOffset'] = includeAllocationOffset;
            }

            if (filterByTradeDate !== undefined) {
                localVarQueryParameter['FilterByTradeDate'] = filterByTradeDate;
            }

            if (pricingStartDateStartFilter !== undefined) {
                localVarQueryParameter['PricingStartDateStartFilter'] = (pricingStartDateStartFilter as any instanceof Date) ?
                    (pricingStartDateStartFilter as any).toISOString() :
                    pricingStartDateStartFilter;
            }

            if (pricingStartDateEndFilter !== undefined) {
                localVarQueryParameter['PricingStartDateEndFilter'] = (pricingStartDateEndFilter as any instanceof Date) ?
                    (pricingStartDateEndFilter as any).toISOString() :
                    pricingStartDateEndFilter;
            }

            if (pricingEndDateStartFilter !== undefined) {
                localVarQueryParameter['PricingEndDateStartFilter'] = (pricingEndDateStartFilter as any instanceof Date) ?
                    (pricingEndDateStartFilter as any).toISOString() :
                    pricingEndDateStartFilter;
            }

            if (pricingEndDateEndFilter !== undefined) {
                localVarQueryParameter['PricingEndDateEndFilter'] = (pricingEndDateEndFilter as any instanceof Date) ?
                    (pricingEndDateEndFilter as any).toISOString() :
                    pricingEndDateEndFilter;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} quoteDate 
         * @param {number} customerReportId 
         * @param {number} [budgetStartMonthYear] 
         * @param {number} [budgetStartMonthMonth] 
         * @param {string} [budgetStartMonthLabel] 
         * @param {number} [budgetEndMonthYear] 
         * @param {number} [budgetEndMonthMonth] 
         * @param {string} [budgetEndMonthLabel] 
         * @param {Array<number>} [commoditiesFilter] 
         * @param {Currency} [currency] 
         * @param {StressIncrementType} [stressIncrementType] 
         * @param {Array<number>} [stressIncrements] 
         * @param {Array<number>} [whatIfStrategyIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getScenarioExcelReport: async (quoteDate: string, customerReportId: number, budgetStartMonthYear?: number, budgetStartMonthMonth?: number, budgetStartMonthLabel?: string, budgetEndMonthYear?: number, budgetEndMonthMonth?: number, budgetEndMonthLabel?: string, commoditiesFilter?: Array<number>, currency?: Currency, stressIncrementType?: StressIncrementType, stressIncrements?: Array<number>, whatIfStrategyIds?: Array<number>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'quoteDate' is not null or undefined
            assertParamExists('getScenarioExcelReport', 'quoteDate', quoteDate)
            // verify required parameter 'customerReportId' is not null or undefined
            assertParamExists('getScenarioExcelReport', 'customerReportId', customerReportId)
            const localVarPath = `/commodity-management/reports/scenario/{quoteDate}/export`
                .replace(`{${"quoteDate"}}`, encodeURIComponent(String(quoteDate)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (customerReportId !== undefined) {
                localVarQueryParameter['CustomerReportId'] = customerReportId;
            }

            if (budgetStartMonthYear !== undefined) {
                localVarQueryParameter['BudgetStartMonth.Year'] = budgetStartMonthYear;
            }

            if (budgetStartMonthMonth !== undefined) {
                localVarQueryParameter['BudgetStartMonth.Month'] = budgetStartMonthMonth;
            }

            if (budgetStartMonthLabel !== undefined) {
                localVarQueryParameter['BudgetStartMonth.Label'] = budgetStartMonthLabel;
            }

            if (budgetEndMonthYear !== undefined) {
                localVarQueryParameter['BudgetEndMonth.Year'] = budgetEndMonthYear;
            }

            if (budgetEndMonthMonth !== undefined) {
                localVarQueryParameter['BudgetEndMonth.Month'] = budgetEndMonthMonth;
            }

            if (budgetEndMonthLabel !== undefined) {
                localVarQueryParameter['BudgetEndMonth.Label'] = budgetEndMonthLabel;
            }

            if (commoditiesFilter) {
                localVarQueryParameter['CommoditiesFilter'] = commoditiesFilter;
            }

            if (currency !== undefined) {
                localVarQueryParameter['Currency'] = currency;
            }

            if (stressIncrementType !== undefined) {
                localVarQueryParameter['StressIncrementType'] = stressIncrementType;
            }

            if (stressIncrements) {
                localVarQueryParameter['StressIncrements'] = stressIncrements;
            }

            if (whatIfStrategyIds) {
                localVarQueryParameter['WhatIfStrategyIds'] = whatIfStrategyIds;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getScenarioMarketPricesExcelTemplate: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/commodity-management/scenario-market-prices`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} quoteDate 
         * @param {number} customerReportId 
         * @param {number} [budgetStartMonthYear] 
         * @param {number} [budgetStartMonthMonth] 
         * @param {string} [budgetStartMonthLabel] 
         * @param {number} [budgetEndMonthYear] 
         * @param {number} [budgetEndMonthMonth] 
         * @param {string} [budgetEndMonthLabel] 
         * @param {Array<number>} [commoditiesFilter] 
         * @param {Currency} [currency] 
         * @param {StressIncrementType} [stressIncrementType] 
         * @param {Array<number>} [stressIncrements] 
         * @param {Array<number>} [whatIfStrategyIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getScenarioReport: async (quoteDate: string, customerReportId: number, budgetStartMonthYear?: number, budgetStartMonthMonth?: number, budgetStartMonthLabel?: string, budgetEndMonthYear?: number, budgetEndMonthMonth?: number, budgetEndMonthLabel?: string, commoditiesFilter?: Array<number>, currency?: Currency, stressIncrementType?: StressIncrementType, stressIncrements?: Array<number>, whatIfStrategyIds?: Array<number>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'quoteDate' is not null or undefined
            assertParamExists('getScenarioReport', 'quoteDate', quoteDate)
            // verify required parameter 'customerReportId' is not null or undefined
            assertParamExists('getScenarioReport', 'customerReportId', customerReportId)
            const localVarPath = `/commodity-management/reports/scenario/{quoteDate}`
                .replace(`{${"quoteDate"}}`, encodeURIComponent(String(quoteDate)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (customerReportId !== undefined) {
                localVarQueryParameter['CustomerReportId'] = customerReportId;
            }

            if (budgetStartMonthYear !== undefined) {
                localVarQueryParameter['BudgetStartMonth.Year'] = budgetStartMonthYear;
            }

            if (budgetStartMonthMonth !== undefined) {
                localVarQueryParameter['BudgetStartMonth.Month'] = budgetStartMonthMonth;
            }

            if (budgetStartMonthLabel !== undefined) {
                localVarQueryParameter['BudgetStartMonth.Label'] = budgetStartMonthLabel;
            }

            if (budgetEndMonthYear !== undefined) {
                localVarQueryParameter['BudgetEndMonth.Year'] = budgetEndMonthYear;
            }

            if (budgetEndMonthMonth !== undefined) {
                localVarQueryParameter['BudgetEndMonth.Month'] = budgetEndMonthMonth;
            }

            if (budgetEndMonthLabel !== undefined) {
                localVarQueryParameter['BudgetEndMonth.Label'] = budgetEndMonthLabel;
            }

            if (commoditiesFilter) {
                localVarQueryParameter['CommoditiesFilter'] = commoditiesFilter;
            }

            if (currency !== undefined) {
                localVarQueryParameter['Currency'] = currency;
            }

            if (stressIncrementType !== undefined) {
                localVarQueryParameter['StressIncrementType'] = stressIncrementType;
            }

            if (stressIncrements) {
                localVarQueryParameter['StressIncrements'] = stressIncrements;
            }

            if (whatIfStrategyIds) {
                localVarQueryParameter['WhatIfStrategyIds'] = whatIfStrategyIds;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} quoteDate 
         * @param {number} customerReportId 
         * @param {number} [budgetStartMonthYear] 
         * @param {number} [budgetStartMonthMonth] 
         * @param {string} [budgetStartMonthLabel] 
         * @param {number} [budgetEndMonthYear] 
         * @param {number} [budgetEndMonthMonth] 
         * @param {string} [budgetEndMonthLabel] 
         * @param {ExpiryStatus} [expiryStatus] 
         * @param {Currency} [currency] 
         * @param {string} [sortColumn] 
         * @param {SortDirection} [sortDirection] 
         * @param {number} [take] 
         * @param {number} [skip] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSummaryExcelReport: async (quoteDate: string, customerReportId: number, budgetStartMonthYear?: number, budgetStartMonthMonth?: number, budgetStartMonthLabel?: string, budgetEndMonthYear?: number, budgetEndMonthMonth?: number, budgetEndMonthLabel?: string, expiryStatus?: ExpiryStatus, currency?: Currency, sortColumn?: string, sortDirection?: SortDirection, take?: number, skip?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'quoteDate' is not null or undefined
            assertParamExists('getSummaryExcelReport', 'quoteDate', quoteDate)
            // verify required parameter 'customerReportId' is not null or undefined
            assertParamExists('getSummaryExcelReport', 'customerReportId', customerReportId)
            const localVarPath = `/commodity-management/reports/summary/{quoteDate}/export`
                .replace(`{${"quoteDate"}}`, encodeURIComponent(String(quoteDate)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (customerReportId !== undefined) {
                localVarQueryParameter['CustomerReportId'] = customerReportId;
            }

            if (budgetStartMonthYear !== undefined) {
                localVarQueryParameter['BudgetStartMonth.Year'] = budgetStartMonthYear;
            }

            if (budgetStartMonthMonth !== undefined) {
                localVarQueryParameter['BudgetStartMonth.Month'] = budgetStartMonthMonth;
            }

            if (budgetStartMonthLabel !== undefined) {
                localVarQueryParameter['BudgetStartMonth.Label'] = budgetStartMonthLabel;
            }

            if (budgetEndMonthYear !== undefined) {
                localVarQueryParameter['BudgetEndMonth.Year'] = budgetEndMonthYear;
            }

            if (budgetEndMonthMonth !== undefined) {
                localVarQueryParameter['BudgetEndMonth.Month'] = budgetEndMonthMonth;
            }

            if (budgetEndMonthLabel !== undefined) {
                localVarQueryParameter['BudgetEndMonth.Label'] = budgetEndMonthLabel;
            }

            if (expiryStatus !== undefined) {
                localVarQueryParameter['ExpiryStatus'] = expiryStatus;
            }

            if (currency !== undefined) {
                localVarQueryParameter['Currency'] = currency;
            }

            if (sortColumn !== undefined) {
                localVarQueryParameter['SortColumn'] = sortColumn;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['SortDirection'] = sortDirection;
            }

            if (take !== undefined) {
                localVarQueryParameter['Take'] = take;
            }

            if (skip !== undefined) {
                localVarQueryParameter['Skip'] = skip;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} quoteDate 
         * @param {number} numberOfMonths 
         * @param {number} minimumPercentage 
         * @param {number} maximumPercentage 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTimeTriggerReport: async (quoteDate: string, numberOfMonths: number, minimumPercentage: number, maximumPercentage: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'quoteDate' is not null or undefined
            assertParamExists('getTimeTriggerReport', 'quoteDate', quoteDate)
            // verify required parameter 'numberOfMonths' is not null or undefined
            assertParamExists('getTimeTriggerReport', 'numberOfMonths', numberOfMonths)
            // verify required parameter 'minimumPercentage' is not null or undefined
            assertParamExists('getTimeTriggerReport', 'minimumPercentage', minimumPercentage)
            // verify required parameter 'maximumPercentage' is not null or undefined
            assertParamExists('getTimeTriggerReport', 'maximumPercentage', maximumPercentage)
            const localVarPath = `/commodity-management/reports/time-trigger/{quoteDate}`
                .replace(`{${"quoteDate"}}`, encodeURIComponent(String(quoteDate)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (numberOfMonths !== undefined) {
                localVarQueryParameter['NumberOfMonths'] = numberOfMonths;
            }

            if (minimumPercentage !== undefined) {
                localVarQueryParameter['MinimumPercentage'] = minimumPercentage;
            }

            if (maximumPercentage !== undefined) {
                localVarQueryParameter['MaximumPercentage'] = maximumPercentage;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} quoteDate 
         * @param {number} customerReportId 
         * @param {number} [budgetStartMonthYear] 
         * @param {number} [budgetStartMonthMonth] 
         * @param {string} [budgetStartMonthLabel] 
         * @param {number} [budgetEndMonthYear] 
         * @param {number} [budgetEndMonthMonth] 
         * @param {string} [budgetEndMonthLabel] 
         * @param {ExpiryStatus} [expiryStatus] 
         * @param {Currency} [currency] 
         * @param {string} [sortColumn] 
         * @param {SortDirection} [sortDirection] 
         * @param {number} [take] 
         * @param {number} [skip] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVarianceExcelReport: async (quoteDate: string, customerReportId: number, budgetStartMonthYear?: number, budgetStartMonthMonth?: number, budgetStartMonthLabel?: string, budgetEndMonthYear?: number, budgetEndMonthMonth?: number, budgetEndMonthLabel?: string, expiryStatus?: ExpiryStatus, currency?: Currency, sortColumn?: string, sortDirection?: SortDirection, take?: number, skip?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'quoteDate' is not null or undefined
            assertParamExists('getVarianceExcelReport', 'quoteDate', quoteDate)
            // verify required parameter 'customerReportId' is not null or undefined
            assertParamExists('getVarianceExcelReport', 'customerReportId', customerReportId)
            const localVarPath = `/commodity-management/reports/variance/{quoteDate}/export`
                .replace(`{${"quoteDate"}}`, encodeURIComponent(String(quoteDate)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (customerReportId !== undefined) {
                localVarQueryParameter['CustomerReportId'] = customerReportId;
            }

            if (budgetStartMonthYear !== undefined) {
                localVarQueryParameter['BudgetStartMonth.Year'] = budgetStartMonthYear;
            }

            if (budgetStartMonthMonth !== undefined) {
                localVarQueryParameter['BudgetStartMonth.Month'] = budgetStartMonthMonth;
            }

            if (budgetStartMonthLabel !== undefined) {
                localVarQueryParameter['BudgetStartMonth.Label'] = budgetStartMonthLabel;
            }

            if (budgetEndMonthYear !== undefined) {
                localVarQueryParameter['BudgetEndMonth.Year'] = budgetEndMonthYear;
            }

            if (budgetEndMonthMonth !== undefined) {
                localVarQueryParameter['BudgetEndMonth.Month'] = budgetEndMonthMonth;
            }

            if (budgetEndMonthLabel !== undefined) {
                localVarQueryParameter['BudgetEndMonth.Label'] = budgetEndMonthLabel;
            }

            if (expiryStatus !== undefined) {
                localVarQueryParameter['ExpiryStatus'] = expiryStatus;
            }

            if (currency !== undefined) {
                localVarQueryParameter['Currency'] = currency;
            }

            if (sortColumn !== undefined) {
                localVarQueryParameter['SortColumn'] = sortColumn;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['SortDirection'] = sortDirection;
            }

            if (take !== undefined) {
                localVarQueryParameter['Take'] = take;
            }

            if (skip !== undefined) {
                localVarQueryParameter['Skip'] = skip;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} quoteDate 
         * @param {number} customerReportId 
         * @param {number} [budgetStartMonthYear] 
         * @param {number} [budgetStartMonthMonth] 
         * @param {string} [budgetStartMonthLabel] 
         * @param {number} [budgetEndMonthYear] 
         * @param {number} [budgetEndMonthMonth] 
         * @param {string} [budgetEndMonthLabel] 
         * @param {ExpiryStatus} [expiryStatus] 
         * @param {Currency} [currency] 
         * @param {string} [sortColumn] 
         * @param {SortDirection} [sortDirection] 
         * @param {number} [take] 
         * @param {number} [skip] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVarianceReport: async (quoteDate: string, customerReportId: number, budgetStartMonthYear?: number, budgetStartMonthMonth?: number, budgetStartMonthLabel?: string, budgetEndMonthYear?: number, budgetEndMonthMonth?: number, budgetEndMonthLabel?: string, expiryStatus?: ExpiryStatus, currency?: Currency, sortColumn?: string, sortDirection?: SortDirection, take?: number, skip?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'quoteDate' is not null or undefined
            assertParamExists('getVarianceReport', 'quoteDate', quoteDate)
            // verify required parameter 'customerReportId' is not null or undefined
            assertParamExists('getVarianceReport', 'customerReportId', customerReportId)
            const localVarPath = `/commodity-management/reports/variance/{quoteDate}`
                .replace(`{${"quoteDate"}}`, encodeURIComponent(String(quoteDate)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (customerReportId !== undefined) {
                localVarQueryParameter['CustomerReportId'] = customerReportId;
            }

            if (budgetStartMonthYear !== undefined) {
                localVarQueryParameter['BudgetStartMonth.Year'] = budgetStartMonthYear;
            }

            if (budgetStartMonthMonth !== undefined) {
                localVarQueryParameter['BudgetStartMonth.Month'] = budgetStartMonthMonth;
            }

            if (budgetStartMonthLabel !== undefined) {
                localVarQueryParameter['BudgetStartMonth.Label'] = budgetStartMonthLabel;
            }

            if (budgetEndMonthYear !== undefined) {
                localVarQueryParameter['BudgetEndMonth.Year'] = budgetEndMonthYear;
            }

            if (budgetEndMonthMonth !== undefined) {
                localVarQueryParameter['BudgetEndMonth.Month'] = budgetEndMonthMonth;
            }

            if (budgetEndMonthLabel !== undefined) {
                localVarQueryParameter['BudgetEndMonth.Label'] = budgetEndMonthLabel;
            }

            if (expiryStatus !== undefined) {
                localVarQueryParameter['ExpiryStatus'] = expiryStatus;
            }

            if (currency !== undefined) {
                localVarQueryParameter['Currency'] = currency;
            }

            if (sortColumn !== undefined) {
                localVarQueryParameter['SortColumn'] = sortColumn;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['SortDirection'] = sortDirection;
            }

            if (take !== undefined) {
                localVarQueryParameter['Take'] = take;
            }

            if (skip !== undefined) {
                localVarQueryParameter['Skip'] = skip;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<number>} [commoditiesFilter] 
         * @param {Array<number>} [locationsFilter] 
         * @param {Array<number>} [counterpartiesFilter] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAllocations: async (commoditiesFilter?: Array<number>, locationsFilter?: Array<number>, counterpartiesFilter?: Array<number>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/commodity-management/allocations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (commoditiesFilter) {
                localVarQueryParameter['CommoditiesFilter'] = commoditiesFilter;
            }

            if (locationsFilter) {
                localVarQueryParameter['LocationsFilter'] = locationsFilter;
            }

            if (counterpartiesFilter) {
                localVarQueryParameter['CounterpartiesFilter'] = counterpartiesFilter;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [commodityId] 
         * @param {number} [locationId] 
         * @param {number} [counterpartyId] 
         * @param {number} [portfolioId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listBudgetYearAllotmentProperties: async (commodityId?: number, locationId?: number, counterpartyId?: number, portfolioId?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/commodity-management/budgets/year-allotment-properties`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (commodityId !== undefined) {
                localVarQueryParameter['CommodityId'] = commodityId;
            }

            if (locationId !== undefined) {
                localVarQueryParameter['LocationId'] = locationId;
            }

            if (counterpartyId !== undefined) {
                localVarQueryParameter['CounterpartyId'] = counterpartyId;
            }

            if (portfolioId !== undefined) {
                localVarQueryParameter['PortfolioId'] = portfolioId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [locationId] 
         * @param {number} [commodityId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listBudgetYears: async (locationId?: number, commodityId?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/commodity-management/budgets/years`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (locationId !== undefined) {
                localVarQueryParameter['LocationId'] = locationId;
            }

            if (commodityId !== undefined) {
                localVarQueryParameter['CommodityId'] = commodityId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [quoteDate] 
         * @param {number} [budgetStartMonthYear] 
         * @param {number} [budgetStartMonthMonth] 
         * @param {string} [budgetStartMonthLabel] 
         * @param {number} [budgetEndMonthYear] 
         * @param {number} [budgetEndMonthMonth] 
         * @param {string} [budgetEndMonthLabel] 
         * @param {Array<number>} [fiscalYearsFilter] 
         * @param {Array<number>} [commoditiesFilter] 
         * @param {Array<number>} [locationsFilter] 
         * @param {Array<number>} [counterpartiesFilter] 
         * @param {Array<number>} [budgetRoundsFilter] 
         * @param {boolean} [includeExpirationDates] 
         * @param {boolean} [includePositions] 
         * @param {boolean} [includeMarketPrices] 
         * @param {boolean} [includeBudgetRounds] 
         * @param {ExpiryStatus} [expiryStatus] 
         * @param {Currency} [currency] 
         * @param {Unit} [unit] 
         * @param {string} [note] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listBudgets: async (quoteDate?: string, budgetStartMonthYear?: number, budgetStartMonthMonth?: number, budgetStartMonthLabel?: string, budgetEndMonthYear?: number, budgetEndMonthMonth?: number, budgetEndMonthLabel?: string, fiscalYearsFilter?: Array<number>, commoditiesFilter?: Array<number>, locationsFilter?: Array<number>, counterpartiesFilter?: Array<number>, budgetRoundsFilter?: Array<number>, includeExpirationDates?: boolean, includePositions?: boolean, includeMarketPrices?: boolean, includeBudgetRounds?: boolean, expiryStatus?: ExpiryStatus, currency?: Currency, unit?: Unit, note?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/commodity-management/budgets`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (quoteDate !== undefined) {
                localVarQueryParameter['QuoteDate'] = (quoteDate as any instanceof Date) ?
                    (quoteDate as any).toISOString() :
                    quoteDate;
            }

            if (budgetStartMonthYear !== undefined) {
                localVarQueryParameter['BudgetStartMonth.Year'] = budgetStartMonthYear;
            }

            if (budgetStartMonthMonth !== undefined) {
                localVarQueryParameter['BudgetStartMonth.Month'] = budgetStartMonthMonth;
            }

            if (budgetStartMonthLabel !== undefined) {
                localVarQueryParameter['BudgetStartMonth.Label'] = budgetStartMonthLabel;
            }

            if (budgetEndMonthYear !== undefined) {
                localVarQueryParameter['BudgetEndMonth.Year'] = budgetEndMonthYear;
            }

            if (budgetEndMonthMonth !== undefined) {
                localVarQueryParameter['BudgetEndMonth.Month'] = budgetEndMonthMonth;
            }

            if (budgetEndMonthLabel !== undefined) {
                localVarQueryParameter['BudgetEndMonth.Label'] = budgetEndMonthLabel;
            }

            if (fiscalYearsFilter) {
                localVarQueryParameter['FiscalYearsFilter'] = fiscalYearsFilter;
            }

            if (commoditiesFilter) {
                localVarQueryParameter['CommoditiesFilter'] = commoditiesFilter;
            }

            if (locationsFilter) {
                localVarQueryParameter['LocationsFilter'] = locationsFilter;
            }

            if (counterpartiesFilter) {
                localVarQueryParameter['CounterpartiesFilter'] = counterpartiesFilter;
            }

            if (budgetRoundsFilter) {
                localVarQueryParameter['BudgetRoundsFilter'] = budgetRoundsFilter;
            }

            if (includeExpirationDates !== undefined) {
                localVarQueryParameter['IncludeExpirationDates'] = includeExpirationDates;
            }

            if (includePositions !== undefined) {
                localVarQueryParameter['IncludePositions'] = includePositions;
            }

            if (includeMarketPrices !== undefined) {
                localVarQueryParameter['IncludeMarketPrices'] = includeMarketPrices;
            }

            if (includeBudgetRounds !== undefined) {
                localVarQueryParameter['IncludeBudgetRounds'] = includeBudgetRounds;
            }

            if (expiryStatus !== undefined) {
                localVarQueryParameter['ExpiryStatus'] = expiryStatus;
            }

            if (currency !== undefined) {
                localVarQueryParameter['Currency'] = currency;
            }

            if (unit !== undefined) {
                localVarQueryParameter['Unit'] = unit;
            }

            if (note !== undefined) {
                localVarQueryParameter['Note'] = note;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [commodityId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCommodityContractMonthMappings: async (commodityId?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/commodity-management/commodities/contract-month-mappings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (commodityId !== undefined) {
                localVarQueryParameter['CommodityId'] = commodityId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCustomers: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/commodity-management/know-risk-energy/customers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listDefaultBudgetRounds: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/commodity-management/budgets/default-rounds`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [vendorFilter] 
         * @param {string} [plantFilter] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listDeliveries: async (vendorFilter?: string, plantFilter?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/commodity-management/deliveries`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (vendorFilter !== undefined) {
                localVarQueryParameter['VendorFilter'] = vendorFilter;
            }

            if (plantFilter !== undefined) {
                localVarQueryParameter['PlantFilter'] = plantFilter;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [entityFilter] 
         * @param {number} [entityIdFilter] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listDocuments: async (entityFilter?: string, entityIdFilter?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/files`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (entityFilter !== undefined) {
                localVarQueryParameter['EntityFilter'] = entityFilter;
            }

            if (entityIdFilter !== undefined) {
                localVarQueryParameter['EntityIdFilter'] = entityIdFilter;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [sortColumn] 
         * @param {SortDirection} [sortDirection] 
         * @param {number} [take] 
         * @param {number} [skip] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listEiaNaturalGasStorageWeeks: async (sortColumn?: string, sortDirection?: SortDirection, take?: number, skip?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/commodity-management/eia/natural-gas-storage/weeks`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (sortColumn !== undefined) {
                localVarQueryParameter['SortColumn'] = sortColumn;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['SortDirection'] = sortDirection;
            }

            if (take !== undefined) {
                localVarQueryParameter['Take'] = take;
            }

            if (skip !== undefined) {
                localVarQueryParameter['Skip'] = skip;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} hedgePlanId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listHedgePlanData: async (hedgePlanId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'hedgePlanId' is not null or undefined
            assertParamExists('listHedgePlanData', 'hedgePlanId', hedgePlanId)
            const localVarPath = `/commodity-management/hedge-plans/{hedgePlanId}/data`
                .replace(`{${"hedgePlanId"}}`, encodeURIComponent(String(hedgePlanId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} hedgePlanId 
         * @param {string} [asOfDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listHedgePlanSeasons: async (hedgePlanId: string, asOfDate?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'hedgePlanId' is not null or undefined
            assertParamExists('listHedgePlanSeasons', 'hedgePlanId', hedgePlanId)
            const localVarPath = `/commodity-management/hedge-plans/{hedgePlanId}/seasons`
                .replace(`{${"hedgePlanId"}}`, encodeURIComponent(String(hedgePlanId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (asOfDate !== undefined) {
                localVarQueryParameter['AsOfDate'] = (asOfDate as any instanceof Date) ?
                    (asOfDate as any).toISOString() :
                    asOfDate;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} companyGuid 
         * @param {string} [sortColumn] 
         * @param {SortDirection} [sortDirection] 
         * @param {number} [take] 
         * @param {number} [skip] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listHedgePlans: async (companyGuid: string, sortColumn?: string, sortDirection?: SortDirection, take?: number, skip?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyGuid' is not null or undefined
            assertParamExists('listHedgePlans', 'companyGuid', companyGuid)
            const localVarPath = `/commodity-management/hedge-plans`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (companyGuid !== undefined) {
                localVarQueryParameter['CompanyGuid'] = companyGuid;
            }

            if (sortColumn !== undefined) {
                localVarQueryParameter['SortColumn'] = sortColumn;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['SortDirection'] = sortDirection;
            }

            if (take !== undefined) {
                localVarQueryParameter['Take'] = take;
            }

            if (skip !== undefined) {
                localVarQueryParameter['Skip'] = skip;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} customerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listLocations: async (customerId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customerId' is not null or undefined
            assertParamExists('listLocations', 'customerId', customerId)
            const localVarPath = `/commodity-management/know-risk-energy/customers/{customerId}/locations`
                .replace(`{${"customerId"}}`, encodeURIComponent(String(customerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listNotes: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/commodity-management/notes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [commodityId] 
         * @param {number} [locationId] 
         * @param {number} [counterpartyId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPositionYears: async (commodityId?: number, locationId?: number, counterpartyId?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/commodity-management/positions/years`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (commodityId !== undefined) {
                localVarQueryParameter['CommodityId'] = commodityId;
            }

            if (locationId !== undefined) {
                localVarQueryParameter['LocationId'] = locationId;
            }

            if (counterpartyId !== undefined) {
                localVarQueryParameter['CounterpartyId'] = counterpartyId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [quoteDate] 
         * @param {boolean} [includeExpirationDates] 
         * @param {boolean} [includeMarketPrices] 
         * @param {boolean} [useDisplayUnits] 
         * @param {Array<ScenarioMarketPriceModel>} [scenarioMarketPrices] 
         * @param {Array<number>} [commoditiesFilter] 
         * @param {Array<number>} [locationsFilter] 
         * @param {Array<number>} [counterpartiesFilter] 
         * @param {string} [tradeDateStartFilter] 
         * @param {string} [tradeDateEndFilter] 
         * @param {number} [budgetMonthStartFilterYear] 
         * @param {number} [budgetMonthStartFilterMonth] 
         * @param {string} [budgetMonthStartFilterLabel] 
         * @param {number} [budgetMonthEndFilterYear] 
         * @param {number} [budgetMonthEndFilterMonth] 
         * @param {string} [budgetMonthEndFilterLabel] 
         * @param {number} [contractMonthStartFilterYear] 
         * @param {number} [contractMonthStartFilterMonth] 
         * @param {string} [contractMonthStartFilterLabel] 
         * @param {number} [contractMonthEndFilterYear] 
         * @param {number} [contractMonthEndFilterMonth] 
         * @param {string} [contractMonthEndFilterLabel] 
         * @param {Array<PositionType>} [positionTypesFilter] 
         * @param {string} [dealTicketNumberFilter] 
         * @param {number} [dealTicketIdFilter] 
         * @param {Side} [sideFilter] 
         * @param {boolean} [validatedFilter] 
         * @param {Array<Currency>} [currencyFilter] 
         * @param {Currency} [currency] 
         * @param {ExpiryStatus} [expiryStatus] 
         * @param {boolean} [includeAllocations] 
         * @param {boolean} [includeAllocationOffset] 
         * @param {boolean} [filterByTradeDate] 
         * @param {string} [pricingStartDateStartFilter] 
         * @param {string} [pricingStartDateEndFilter] 
         * @param {string} [pricingEndDateStartFilter] 
         * @param {string} [pricingEndDateEndFilter] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPositions: async (quoteDate?: string, includeExpirationDates?: boolean, includeMarketPrices?: boolean, useDisplayUnits?: boolean, scenarioMarketPrices?: Array<ScenarioMarketPriceModel>, commoditiesFilter?: Array<number>, locationsFilter?: Array<number>, counterpartiesFilter?: Array<number>, tradeDateStartFilter?: string, tradeDateEndFilter?: string, budgetMonthStartFilterYear?: number, budgetMonthStartFilterMonth?: number, budgetMonthStartFilterLabel?: string, budgetMonthEndFilterYear?: number, budgetMonthEndFilterMonth?: number, budgetMonthEndFilterLabel?: string, contractMonthStartFilterYear?: number, contractMonthStartFilterMonth?: number, contractMonthStartFilterLabel?: string, contractMonthEndFilterYear?: number, contractMonthEndFilterMonth?: number, contractMonthEndFilterLabel?: string, positionTypesFilter?: Array<PositionType>, dealTicketNumberFilter?: string, dealTicketIdFilter?: number, sideFilter?: Side, validatedFilter?: boolean, currencyFilter?: Array<Currency>, currency?: Currency, expiryStatus?: ExpiryStatus, includeAllocations?: boolean, includeAllocationOffset?: boolean, filterByTradeDate?: boolean, pricingStartDateStartFilter?: string, pricingStartDateEndFilter?: string, pricingEndDateStartFilter?: string, pricingEndDateEndFilter?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/commodity-management/positions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (quoteDate !== undefined) {
                localVarQueryParameter['QuoteDate'] = (quoteDate as any instanceof Date) ?
                    (quoteDate as any).toISOString() :
                    quoteDate;
            }

            if (includeExpirationDates !== undefined) {
                localVarQueryParameter['IncludeExpirationDates'] = includeExpirationDates;
            }

            if (includeMarketPrices !== undefined) {
                localVarQueryParameter['IncludeMarketPrices'] = includeMarketPrices;
            }

            if (useDisplayUnits !== undefined) {
                localVarQueryParameter['UseDisplayUnits'] = useDisplayUnits;
            }

            if (scenarioMarketPrices) {
                localVarQueryParameter['ScenarioMarketPrices'] = scenarioMarketPrices;
            }

            if (commoditiesFilter) {
                localVarQueryParameter['CommoditiesFilter'] = commoditiesFilter;
            }

            if (locationsFilter) {
                localVarQueryParameter['LocationsFilter'] = locationsFilter;
            }

            if (counterpartiesFilter) {
                localVarQueryParameter['CounterpartiesFilter'] = counterpartiesFilter;
            }

            if (tradeDateStartFilter !== undefined) {
                localVarQueryParameter['TradeDateStartFilter'] = (tradeDateStartFilter as any instanceof Date) ?
                    (tradeDateStartFilter as any).toISOString() :
                    tradeDateStartFilter;
            }

            if (tradeDateEndFilter !== undefined) {
                localVarQueryParameter['TradeDateEndFilter'] = (tradeDateEndFilter as any instanceof Date) ?
                    (tradeDateEndFilter as any).toISOString() :
                    tradeDateEndFilter;
            }

            if (budgetMonthStartFilterYear !== undefined) {
                localVarQueryParameter['BudgetMonthStartFilter.Year'] = budgetMonthStartFilterYear;
            }

            if (budgetMonthStartFilterMonth !== undefined) {
                localVarQueryParameter['BudgetMonthStartFilter.Month'] = budgetMonthStartFilterMonth;
            }

            if (budgetMonthStartFilterLabel !== undefined) {
                localVarQueryParameter['BudgetMonthStartFilter.Label'] = budgetMonthStartFilterLabel;
            }

            if (budgetMonthEndFilterYear !== undefined) {
                localVarQueryParameter['BudgetMonthEndFilter.Year'] = budgetMonthEndFilterYear;
            }

            if (budgetMonthEndFilterMonth !== undefined) {
                localVarQueryParameter['BudgetMonthEndFilter.Month'] = budgetMonthEndFilterMonth;
            }

            if (budgetMonthEndFilterLabel !== undefined) {
                localVarQueryParameter['BudgetMonthEndFilter.Label'] = budgetMonthEndFilterLabel;
            }

            if (contractMonthStartFilterYear !== undefined) {
                localVarQueryParameter['ContractMonthStartFilter.Year'] = contractMonthStartFilterYear;
            }

            if (contractMonthStartFilterMonth !== undefined) {
                localVarQueryParameter['ContractMonthStartFilter.Month'] = contractMonthStartFilterMonth;
            }

            if (contractMonthStartFilterLabel !== undefined) {
                localVarQueryParameter['ContractMonthStartFilter.Label'] = contractMonthStartFilterLabel;
            }

            if (contractMonthEndFilterYear !== undefined) {
                localVarQueryParameter['ContractMonthEndFilter.Year'] = contractMonthEndFilterYear;
            }

            if (contractMonthEndFilterMonth !== undefined) {
                localVarQueryParameter['ContractMonthEndFilter.Month'] = contractMonthEndFilterMonth;
            }

            if (contractMonthEndFilterLabel !== undefined) {
                localVarQueryParameter['ContractMonthEndFilter.Label'] = contractMonthEndFilterLabel;
            }

            if (positionTypesFilter) {
                localVarQueryParameter['PositionTypesFilter'] = positionTypesFilter;
            }

            if (dealTicketNumberFilter !== undefined) {
                localVarQueryParameter['DealTicketNumberFilter'] = dealTicketNumberFilter;
            }

            if (dealTicketIdFilter !== undefined) {
                localVarQueryParameter['DealTicketIdFilter'] = dealTicketIdFilter;
            }

            if (sideFilter !== undefined) {
                localVarQueryParameter['SideFilter'] = sideFilter;
            }

            if (validatedFilter !== undefined) {
                localVarQueryParameter['ValidatedFilter'] = validatedFilter;
            }

            if (currencyFilter) {
                localVarQueryParameter['CurrencyFilter'] = currencyFilter;
            }

            if (currency !== undefined) {
                localVarQueryParameter['Currency'] = currency;
            }

            if (expiryStatus !== undefined) {
                localVarQueryParameter['ExpiryStatus'] = expiryStatus;
            }

            if (includeAllocations !== undefined) {
                localVarQueryParameter['IncludeAllocations'] = includeAllocations;
            }

            if (includeAllocationOffset !== undefined) {
                localVarQueryParameter['IncludeAllocationOffset'] = includeAllocationOffset;
            }

            if (filterByTradeDate !== undefined) {
                localVarQueryParameter['FilterByTradeDate'] = filterByTradeDate;
            }

            if (pricingStartDateStartFilter !== undefined) {
                localVarQueryParameter['PricingStartDateStartFilter'] = (pricingStartDateStartFilter as any instanceof Date) ?
                    (pricingStartDateStartFilter as any).toISOString() :
                    pricingStartDateStartFilter;
            }

            if (pricingStartDateEndFilter !== undefined) {
                localVarQueryParameter['PricingStartDateEndFilter'] = (pricingStartDateEndFilter as any instanceof Date) ?
                    (pricingStartDateEndFilter as any).toISOString() :
                    pricingStartDateEndFilter;
            }

            if (pricingEndDateStartFilter !== undefined) {
                localVarQueryParameter['PricingEndDateStartFilter'] = (pricingEndDateStartFilter as any instanceof Date) ?
                    (pricingEndDateStartFilter as any).toISOString() :
                    pricingEndDateStartFilter;
            }

            if (pricingEndDateEndFilter !== undefined) {
                localVarQueryParameter['PricingEndDateEndFilter'] = (pricingEndDateEndFilter as any instanceof Date) ?
                    (pricingEndDateEndFilter as any).toISOString() :
                    pricingEndDateEndFilter;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPricingStrategies: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/commodity-management/pricing-strategies`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {any} scenarioMarketPricesFile 
         * @param {string} [sortColumn] 
         * @param {SortDirection} [sortDirection] 
         * @param {number} [take] 
         * @param {number} [skip] 
         * @param {boolean} [validationResponseIsValid] 
         * @param {string} [validationResponseValidationMessage] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listScenarioMarketPricesFromUpload: async (scenarioMarketPricesFile: any, sortColumn?: string, sortDirection?: SortDirection, take?: number, skip?: number, validationResponseIsValid?: boolean, validationResponseValidationMessage?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'scenarioMarketPricesFile' is not null or undefined
            assertParamExists('listScenarioMarketPricesFromUpload', 'scenarioMarketPricesFile', scenarioMarketPricesFile)
            const localVarPath = `/commodity-management/scenario-market-prices`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            if (scenarioMarketPricesFile !== undefined) { 
                localVarFormParams.append('ScenarioMarketPricesFile', scenarioMarketPricesFile as any);
            }
    
            if (sortColumn !== undefined) { 
                localVarFormParams.append('SortColumn', sortColumn as any);
            }
    
            if (sortDirection !== undefined) { 
                localVarFormParams.append('SortDirection', new Blob([JSON.stringify(sortDirection)], { type: "application/json", }));
            }
    
            if (take !== undefined) { 
                localVarFormParams.append('Take', take as any);
            }
    
            if (skip !== undefined) { 
                localVarFormParams.append('Skip', skip as any);
            }
    
            if (validationResponseIsValid !== undefined) { 
                localVarFormParams.append('ValidationResponse.IsValid', validationResponseIsValid as any);
            }
    
            if (validationResponseValidationMessage !== undefined) { 
                localVarFormParams.append('ValidationResponse.ValidationMessage', validationResponseValidationMessage as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listWhatIfStrategies: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/commodity-management/what-if-strategies`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} customerReportId 
         * @param {SendCommodityManagementReportEmailRequest} [sendCommodityManagementReportEmailRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendCommodityManagementReportEmail: async (customerReportId: string, sendCommodityManagementReportEmailRequest?: SendCommodityManagementReportEmailRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customerReportId' is not null or undefined
            assertParamExists('sendCommodityManagementReportEmail', 'customerReportId', customerReportId)
            const localVarPath = `/commodity-management/reports/{customerReportId}/email`
                .replace(`{${"customerReportId"}}`, encodeURIComponent(String(customerReportId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(sendCommodityManagementReportEmailRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UpdateBudgetRoundRequest} [updateBudgetRoundRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateBudgetRound: async (updateBudgetRoundRequest?: UpdateBudgetRoundRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/commodity-management/budgetRounds`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateBudgetRoundRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UpdateBudgetsRequest} [updateBudgetsRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateBudgets: async (updateBudgetsRequest?: UpdateBudgetsRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/commodity-management/budgets`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateBudgetsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} commodityId 
         * @param {string} commodityName 
         * @param {Unit} displayUnit 
         * @param {number} displayPrecision 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCommodity: async (commodityId: string, commodityName: string, displayUnit: Unit, displayPrecision: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'commodityId' is not null or undefined
            assertParamExists('updateCommodity', 'commodityId', commodityId)
            // verify required parameter 'commodityName' is not null or undefined
            assertParamExists('updateCommodity', 'commodityName', commodityName)
            // verify required parameter 'displayUnit' is not null or undefined
            assertParamExists('updateCommodity', 'displayUnit', displayUnit)
            // verify required parameter 'displayPrecision' is not null or undefined
            assertParamExists('updateCommodity', 'displayPrecision', displayPrecision)
            const localVarPath = `/commodity-management/commodities/{commodityId}`
                .replace(`{${"commodityId"}}`, encodeURIComponent(String(commodityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (commodityName !== undefined) {
                localVarQueryParameter['CommodityName'] = commodityName;
            }

            if (displayUnit !== undefined) {
                localVarQueryParameter['DisplayUnit'] = displayUnit;
            }

            if (displayPrecision !== undefined) {
                localVarQueryParameter['DisplayPrecision'] = displayPrecision;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} commodityId 
         * @param {UpdateCommodityContractMonthMappingsRequest} [updateCommodityContractMonthMappingsRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCommodityContractMonthMappings: async (commodityId: string, updateCommodityContractMonthMappingsRequest?: UpdateCommodityContractMonthMappingsRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'commodityId' is not null or undefined
            assertParamExists('updateCommodityContractMonthMappings', 'commodityId', commodityId)
            const localVarPath = `/commodity-management/commodities/{commodityId}/contract-month-mappings`
                .replace(`{${"commodityId"}}`, encodeURIComponent(String(commodityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateCommodityContractMonthMappingsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} counterpartyId 
         * @param {string} counterpartyName 
         * @param {number} [creditLimit] 
         * @param {boolean} [netting] 
         * @param {boolean} [setoff] 
         * @param {boolean} [active] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCounterparty: async (counterpartyId: string, counterpartyName: string, creditLimit?: number, netting?: boolean, setoff?: boolean, active?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'counterpartyId' is not null or undefined
            assertParamExists('updateCounterparty', 'counterpartyId', counterpartyId)
            // verify required parameter 'counterpartyName' is not null or undefined
            assertParamExists('updateCounterparty', 'counterpartyName', counterpartyName)
            const localVarPath = `/commodity-management/counterparties/{counterpartyId}`
                .replace(`{${"counterpartyId"}}`, encodeURIComponent(String(counterpartyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (counterpartyName !== undefined) {
                localVarQueryParameter['CounterpartyName'] = counterpartyName;
            }

            if (creditLimit !== undefined) {
                localVarQueryParameter['CreditLimit'] = creditLimit;
            }

            if (netting !== undefined) {
                localVarQueryParameter['Netting'] = netting;
            }

            if (setoff !== undefined) {
                localVarQueryParameter['Setoff'] = setoff;
            }

            if (active !== undefined) {
                localVarQueryParameter['Active'] = active;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UpdateCustomerReportRequest} [updateCustomerReportRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCustomerReport: async (updateCustomerReportRequest?: UpdateCustomerReportRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/commodity-management/customer/reports`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateCustomerReportRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} customerReportId 
         * @param {string} [overrides] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCustomerReportUserOverrides: async (customerReportId: number, overrides?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customerReportId' is not null or undefined
            assertParamExists('updateCustomerReportUserOverrides', 'customerReportId', customerReportId)
            const localVarPath = `/commodity-management/customer/reports/overrides`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (customerReportId !== undefined) {
                localVarQueryParameter['CustomerReportId'] = customerReportId;
            }

            if (overrides !== undefined) {
                localVarQueryParameter['Overrides'] = overrides;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UpdateCustomerSettingsRequest} [updateCustomerSettingsRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCustomerSettings: async (updateCustomerSettingsRequest?: UpdateCustomerSettingsRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/commodity-management/customer/settings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateCustomerSettingsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} dealTicketId 
         * @param {Array<number>} [validatedPositionIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDealTicketPositionValidation: async (dealTicketId: string, validatedPositionIds?: Array<number>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'dealTicketId' is not null or undefined
            assertParamExists('updateDealTicketPositionValidation', 'dealTicketId', dealTicketId)
            const localVarPath = `/commodity-management/dealTickets/{dealTicketId}/validated`
                .replace(`{${"dealTicketId"}}`, encodeURIComponent(String(dealTicketId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (validatedPositionIds) {
                localVarQueryParameter['ValidatedPositionIds'] = validatedPositionIds;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UpdateDefaultBudgetRoundsRequest} [updateDefaultBudgetRoundsRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDefaultBudgetRounds: async (updateDefaultBudgetRoundsRequest?: UpdateDefaultBudgetRoundsRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/commodity-management/budgets/default-rounds`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateDefaultBudgetRoundsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UpdateDeliveriesRequest} [updateDeliveriesRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDeliveries: async (updateDeliveriesRequest?: UpdateDeliveriesRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/commodity-management/deliveries`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateDeliveriesRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UpdateHedgePlanRequest} [updateHedgePlanRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateHedgePlan: async (updateHedgePlanRequest?: UpdateHedgePlanRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/commodity-management/hedge-plans`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateHedgePlanRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} hedgePlanId 
         * @param {string} year 
         * @param {UpdateHedgePlanBudgetTriggersRequest} [updateHedgePlanBudgetTriggersRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateHedgePlanBudgetTriggers: async (hedgePlanId: string, year: string, updateHedgePlanBudgetTriggersRequest?: UpdateHedgePlanBudgetTriggersRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'hedgePlanId' is not null or undefined
            assertParamExists('updateHedgePlanBudgetTriggers', 'hedgePlanId', hedgePlanId)
            // verify required parameter 'year' is not null or undefined
            assertParamExists('updateHedgePlanBudgetTriggers', 'year', year)
            const localVarPath = `/commodity-management/hedge-plans/{hedgePlanId}/years/{year}/budget-triggers`
                .replace(`{${"hedgePlanId"}}`, encodeURIComponent(String(hedgePlanId)))
                .replace(`{${"year"}}`, encodeURIComponent(String(year)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateHedgePlanBudgetTriggersRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} hedgePlanId 
         * @param {string} year 
         * @param {UpdateHedgePlanSeasonSettingsRequest} [updateHedgePlanSeasonSettingsRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateHedgePlanSeasonSettings: async (hedgePlanId: string, year: string, updateHedgePlanSeasonSettingsRequest?: UpdateHedgePlanSeasonSettingsRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'hedgePlanId' is not null or undefined
            assertParamExists('updateHedgePlanSeasonSettings', 'hedgePlanId', hedgePlanId)
            // verify required parameter 'year' is not null or undefined
            assertParamExists('updateHedgePlanSeasonSettings', 'year', year)
            const localVarPath = `/commodity-management/hedge-plans/{hedgePlanId}/years/{year}/season-settings`
                .replace(`{${"hedgePlanId"}}`, encodeURIComponent(String(hedgePlanId)))
                .replace(`{${"year"}}`, encodeURIComponent(String(year)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateHedgePlanSeasonSettingsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} hedgePlanId 
         * @param {string} year 
         * @param {UpdateHedgePlanTimeTriggersRequest} [updateHedgePlanTimeTriggersRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateHedgePlanTimeTriggers: async (hedgePlanId: string, year: string, updateHedgePlanTimeTriggersRequest?: UpdateHedgePlanTimeTriggersRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'hedgePlanId' is not null or undefined
            assertParamExists('updateHedgePlanTimeTriggers', 'hedgePlanId', hedgePlanId)
            // verify required parameter 'year' is not null or undefined
            assertParamExists('updateHedgePlanTimeTriggers', 'year', year)
            const localVarPath = `/commodity-management/hedge-plans/{hedgePlanId}/years/{year}/time-triggers`
                .replace(`{${"hedgePlanId"}}`, encodeURIComponent(String(hedgePlanId)))
                .replace(`{${"year"}}`, encodeURIComponent(String(year)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateHedgePlanTimeTriggersRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} hedgePlanId 
         * @param {string} year 
         * @param {UpdateHedgePlanTradesRequest} [updateHedgePlanTradesRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateHedgePlanTrades: async (hedgePlanId: string, year: string, updateHedgePlanTradesRequest?: UpdateHedgePlanTradesRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'hedgePlanId' is not null or undefined
            assertParamExists('updateHedgePlanTrades', 'hedgePlanId', hedgePlanId)
            // verify required parameter 'year' is not null or undefined
            assertParamExists('updateHedgePlanTrades', 'year', year)
            const localVarPath = `/commodity-management/hedge-plans/{hedgePlanId}/years/{year}/trades`
                .replace(`{${"hedgePlanId"}}`, encodeURIComponent(String(hedgePlanId)))
                .replace(`{${"year"}}`, encodeURIComponent(String(year)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateHedgePlanTradesRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} hedgePlanId 
         * @param {string} year 
         * @param {UpdateHedgePlanValueTriggersRequest} [updateHedgePlanValueTriggersRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateHedgePlanValueTriggers: async (hedgePlanId: string, year: string, updateHedgePlanValueTriggersRequest?: UpdateHedgePlanValueTriggersRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'hedgePlanId' is not null or undefined
            assertParamExists('updateHedgePlanValueTriggers', 'hedgePlanId', hedgePlanId)
            // verify required parameter 'year' is not null or undefined
            assertParamExists('updateHedgePlanValueTriggers', 'year', year)
            const localVarPath = `/commodity-management/hedge-plans/{hedgePlanId}/years/{year}/value-triggers`
                .replace(`{${"hedgePlanId"}}`, encodeURIComponent(String(hedgePlanId)))
                .replace(`{${"year"}}`, encodeURIComponent(String(year)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateHedgePlanValueTriggersRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} locationId 
         * @param {string} locationName 
         * @param {number} tierId 
         * @param {number} [parentLocationId] 
         * @param {boolean} [active] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateLocation: async (locationId: string, locationName: string, tierId: number, parentLocationId?: number, active?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'locationId' is not null or undefined
            assertParamExists('updateLocation', 'locationId', locationId)
            // verify required parameter 'locationName' is not null or undefined
            assertParamExists('updateLocation', 'locationName', locationName)
            // verify required parameter 'tierId' is not null or undefined
            assertParamExists('updateLocation', 'tierId', tierId)
            const localVarPath = `/commodity-management/locations/{locationId}`
                .replace(`{${"locationId"}}`, encodeURIComponent(String(locationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (locationName !== undefined) {
                localVarQueryParameter['LocationName'] = locationName;
            }

            if (tierId !== undefined) {
                localVarQueryParameter['TierId'] = tierId;
            }

            if (parentLocationId !== undefined) {
                localVarQueryParameter['ParentLocationId'] = parentLocationId;
            }

            if (active !== undefined) {
                localVarQueryParameter['Active'] = active;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} noteId 
         * @param {string} subject 
         * @param {string} content 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateNote: async (noteId: string, subject: string, content: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'noteId' is not null or undefined
            assertParamExists('updateNote', 'noteId', noteId)
            // verify required parameter 'subject' is not null or undefined
            assertParamExists('updateNote', 'subject', subject)
            // verify required parameter 'content' is not null or undefined
            assertParamExists('updateNote', 'content', content)
            const localVarPath = `/commodity-management/notes/{NoteId}`
                .replace(`{${"NoteId"}}`, encodeURIComponent(String(noteId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (subject !== undefined) {
                localVarQueryParameter['Subject'] = subject;
            }

            if (content !== undefined) {
                localVarQueryParameter['Content'] = content;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} portfolioId 
         * @param {string} portfolioName 
         * @param {boolean} [active] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePortfolio: async (portfolioId: string, portfolioName: string, active?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'portfolioId' is not null or undefined
            assertParamExists('updatePortfolio', 'portfolioId', portfolioId)
            // verify required parameter 'portfolioName' is not null or undefined
            assertParamExists('updatePortfolio', 'portfolioName', portfolioName)
            const localVarPath = `/commodity-management/portfolios/{portfolioId}`
                .replace(`{${"portfolioId"}}`, encodeURIComponent(String(portfolioId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (portfolioName !== undefined) {
                localVarQueryParameter['PortfolioName'] = portfolioName;
            }

            if (active !== undefined) {
                localVarQueryParameter['Active'] = active;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UpdatePricingStrategiesRequest} [updatePricingStrategiesRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePricingStrategies: async (updatePricingStrategiesRequest?: UpdatePricingStrategiesRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/commodity-management/pricing-strategies`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updatePricingStrategiesRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} tierId 
         * @param {string} tierName 
         * @param {number} tierRank 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTier: async (tierId: string, tierName: string, tierRank: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tierId' is not null or undefined
            assertParamExists('updateTier', 'tierId', tierId)
            // verify required parameter 'tierName' is not null or undefined
            assertParamExists('updateTier', 'tierName', tierName)
            // verify required parameter 'tierRank' is not null or undefined
            assertParamExists('updateTier', 'tierRank', tierRank)
            const localVarPath = `/commodity-management/tiers/{tierId}`
                .replace(`{${"tierId"}}`, encodeURIComponent(String(tierId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (tierName !== undefined) {
                localVarQueryParameter['TierName'] = tierName;
            }

            if (tierRank !== undefined) {
                localVarQueryParameter['TierRank'] = tierRank;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UpdateWhatIfStrategyRequest} [updateWhatIfStrategyRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateWhatIfStrategy: async (updateWhatIfStrategyRequest?: UpdateWhatIfStrategyRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/commodity-management/what-if-strategies`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateWhatIfStrategyRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} entityName 
         * @param {string} documentUrl 
         * @param {any} file 
         * @param {number} [entityId] 
         * @param {string} [description] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        upload: async (entityName: string, documentUrl: string, file: any, entityId?: number, description?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'entityName' is not null or undefined
            assertParamExists('upload', 'entityName', entityName)
            // verify required parameter 'documentUrl' is not null or undefined
            assertParamExists('upload', 'documentUrl', documentUrl)
            // verify required parameter 'file' is not null or undefined
            assertParamExists('upload', 'file', file)
            const localVarPath = `/api/files/upload`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (entityName !== undefined) {
                localVarQueryParameter['EntityName'] = entityName;
            }

            if (entityId !== undefined) {
                localVarQueryParameter['EntityId'] = entityId;
            }

            if (documentUrl !== undefined) {
                localVarQueryParameter['DocumentUrl'] = documentUrl;
            }

            if (description !== undefined) {
                localVarQueryParameter['Description'] = description;
            }


            if (file !== undefined) { 
                localVarFormParams.append('File', file as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CommodityManagementApi - functional programming interface
 * @export
 */
export const CommodityManagementApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CommodityManagementApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {UpdateAllocationRequest} [updateAllocationRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addAllocation(updateAllocationRequest?: UpdateAllocationRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpdateAllocationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addAllocation(updateAllocationRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {UpdateAllocationGroupRequest} [updateAllocationGroupRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addAllocationGroup(updateAllocationGroupRequest?: UpdateAllocationGroupRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpdateAllocationGroupResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addAllocationGroup(updateAllocationGroupRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} commodityName 
         * @param {Unit} displayUnit 
         * @param {number} displayPrecision 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addCommodity(commodityName: string, displayUnit: Unit, displayPrecision: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AddCommodityResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addCommodity(commodityName, displayUnit, displayPrecision, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [counterpartyName] 
         * @param {number} [creditLimit] 
         * @param {boolean} [netting] 
         * @param {boolean} [setoff] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addCounterparty(counterpartyName?: string, creditLimit?: number, netting?: boolean, setoff?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AddCounterpartyResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addCounterparty(counterpartyName, creditLimit, netting, setoff, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} hedgePlanId 
         * @param {AddHedgePlanSeasonRequest} [addHedgePlanSeasonRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addHedgePlanSeason(hedgePlanId: string, addHedgePlanSeasonRequest?: AddHedgePlanSeasonRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AddHedgePlanSeasonResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addHedgePlanSeason(hedgePlanId, addHedgePlanSeasonRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} locationName 
         * @param {number} tierId 
         * @param {number} [parentLocationId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addLocation(locationName: string, tierId: number, parentLocationId?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AddLocationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addLocation(locationName, tierId, parentLocationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {AddNoteRequest} [addNoteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addNote(addNoteRequest?: AddNoteRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AddNoteResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addNote(addNoteRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} portfolioName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addPortfolio(portfolioName: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AddPortfolioResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addPortfolio(portfolioName, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} tierRank 
         * @param {string} [tierName] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addTier(tierRank: number, tierName?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AddTierResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addTier(tierRank, tierName, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {UpdateDealTicketRequest} [updateDealTicketRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addTrade(updateDealTicketRequest?: UpdateDealTicketRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpdateDealTicketResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addTrade(updateDealTicketRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {Array<number>} customerReportIds 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async copyCustomerReports(customerReportIds: Array<number>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CopyCustomerReportsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.copyCustomerReports(customerReportIds, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} commodityId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteCommodity(commodityId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteCommodity(commodityId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} counterpartyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteCounterparty(counterpartyId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteCounterparty(counterpartyId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} customerReportId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteCustomerReport(customerReportId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteCustomerReport(customerReportId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} dealTicketId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteDealTicket(dealTicketId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteDealTicket(dealTicketId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} hedgePlanId 
         * @param {number} year 
         * @param {MatrixTerm} [term] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteHedgePlanSeason(hedgePlanId: string, year: number, term?: MatrixTerm, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeleteHedgePlanSeasonResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteHedgePlanSeason(hedgePlanId, year, term, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} locationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteLocation(locationId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteLocation(locationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} noteId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteNote(noteId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteNote(noteId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} portfolioId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deletePortfolio(portfolioId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deletePortfolio(portfolioId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} budgetPricingStrategyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deletePricingStrategy(budgetPricingStrategyId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deletePricingStrategy(budgetPricingStrategyId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} tierId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteTier(tierId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteTier(tierId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} whatIfStrategyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteWhatIfStrategy(whatIfStrategyId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteWhatIfStrategy(whatIfStrategyId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [documentUrl] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadDocument(documentUrl?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DownloadDocumentResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadDocument(documentUrl, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} entityType 
         * @param {string} entityId 
         * @param {boolean} [includeUnchangedFields] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAuditTrail(entityType: string, entityId: string, includeUnchangedFields?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetAuditTrailResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAuditTrail(entityType, entityId, includeUnchangedFields, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} entityId 
         * @param {string} [entityType] 
         * @param {boolean} [includeUnchangedFields] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBudgetAuditTrail(entityId: string, entityType?: string, includeUnchangedFields?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetAuditTrailResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBudgetAuditTrail(entityId, entityType, includeUnchangedFields, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCustomerData(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetCustomerDataResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCustomerData(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCustomerReports(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetCustomerReportsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCustomerReports(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCustomerSettings(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetCustomerSettingsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCustomerSettings(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} pricingStartDate 
         * @param {string} pricingEndDate 
         * @param {GetDailyPositionsReportRequest} [getDailyPositionsReportRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDailyPositionsExcelReport(pricingStartDate: string, pricingEndDate: string, getDailyPositionsReportRequest?: GetDailyPositionsReportRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FileResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDailyPositionsExcelReport(pricingStartDate, pricingEndDate, getDailyPositionsReportRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} pricingStartDate 
         * @param {string} pricingEndDate 
         * @param {GetDailyPositionsReportRequest} [getDailyPositionsReportRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDailyPositionsReport(pricingStartDate: string, pricingEndDate: string, getDailyPositionsReportRequest?: GetDailyPositionsReportRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetDailyPositionsReportResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDailyPositionsReport(pricingStartDate, pricingEndDate, getDailyPositionsReportRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} dealTicketId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDealTicket(dealTicketId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetDealTicketResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDealTicket(dealTicketId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} quoteDate 
         * @param {number} customerReportId 
         * @param {Currency} [currency] 
         * @param {StressIncrementType} [stressIncrementType] 
         * @param {Array<number>} [stressIncrements] 
         * @param {string} [sortColumn] 
         * @param {SortDirection} [sortDirection] 
         * @param {number} [take] 
         * @param {number} [skip] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getExposureExcelReport(quoteDate: string, customerReportId: number, currency?: Currency, stressIncrementType?: StressIncrementType, stressIncrements?: Array<number>, sortColumn?: string, sortDirection?: SortDirection, take?: number, skip?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FileResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getExposureExcelReport(quoteDate, customerReportId, currency, stressIncrementType, stressIncrements, sortColumn, sortDirection, take, skip, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} quoteDate 
         * @param {number} customerReportId 
         * @param {Currency} [currency] 
         * @param {StressIncrementType} [stressIncrementType] 
         * @param {Array<number>} [stressIncrements] 
         * @param {string} [sortColumn] 
         * @param {SortDirection} [sortDirection] 
         * @param {number} [take] 
         * @param {number} [skip] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getExposureReport(quoteDate: string, customerReportId: number, currency?: Currency, stressIncrementType?: StressIncrementType, stressIncrements?: Array<number>, sortColumn?: string, sortDirection?: SortDirection, take?: number, skip?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetExposureReportResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getExposureReport(quoteDate, customerReportId, currency, stressIncrementType, stressIncrements, sortColumn, sortDirection, take, skip, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} hedgePlanId 
         * @param {string} year 
         * @param {string} quoteDate 
         * @param {MatrixTerm} [term] 
         * @param {boolean} [weightByVolume] 
         * @param {boolean} [refreshCache] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getHedgePlanReport(hedgePlanId: string, year: string, quoteDate: string, term?: MatrixTerm, weightByVolume?: boolean, refreshCache?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetHedgePlanReportResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getHedgePlanReport(hedgePlanId, year, quoteDate, term, weightByVolume, refreshCache, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} companyGuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLocationsForCompany(companyGuid: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetKnowRiskEnergyLocationsForCompanyResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLocationsForCompany(companyGuid, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} quoteDate 
         * @param {GetMarkToMarketReportRequest} [getMarkToMarketReportRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMarkToMarketExcelReport(quoteDate: string, getMarkToMarketReportRequest?: GetMarkToMarketReportRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FileResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMarkToMarketExcelReport(quoteDate, getMarkToMarketReportRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} quoteDate 
         * @param {GetMarkToMarketReportRequest} [getMarkToMarketReportRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMarkToMarketReport(quoteDate: string, getMarkToMarketReportRequest?: GetMarkToMarketReportRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetMarkToMarketReportResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMarkToMarketReport(quoteDate, getMarkToMarketReportRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} customerReportId 
         * @param {string} [quoteDate] 
         * @param {number} [budgetStartMonthYear] 
         * @param {number} [budgetStartMonthMonth] 
         * @param {string} [budgetStartMonthLabel] 
         * @param {number} [budgetEndMonthYear] 
         * @param {number} [budgetEndMonthMonth] 
         * @param {string} [budgetEndMonthLabel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPiedmontHedgingExcelReport(customerReportId: number, quoteDate?: string, budgetStartMonthYear?: number, budgetStartMonthMonth?: number, budgetStartMonthLabel?: string, budgetEndMonthYear?: number, budgetEndMonthMonth?: number, budgetEndMonthLabel?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FileResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPiedmontHedgingExcelReport(customerReportId, quoteDate, budgetStartMonthYear, budgetStartMonthMonth, budgetStartMonthLabel, budgetEndMonthYear, budgetEndMonthMonth, budgetEndMonthLabel, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} customerReportId 
         * @param {string} [quoteDate] 
         * @param {number} [budgetStartMonthYear] 
         * @param {number} [budgetStartMonthMonth] 
         * @param {string} [budgetStartMonthLabel] 
         * @param {number} [budgetEndMonthYear] 
         * @param {number} [budgetEndMonthMonth] 
         * @param {string} [budgetEndMonthLabel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPiedmontHedgingReport(customerReportId: number, quoteDate?: string, budgetStartMonthYear?: number, budgetStartMonthMonth?: number, budgetStartMonthLabel?: string, budgetEndMonthYear?: number, budgetEndMonthMonth?: number, budgetEndMonthLabel?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetPiedmontHedgingReportResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPiedmontHedgingReport(customerReportId, quoteDate, budgetStartMonthYear, budgetStartMonthMonth, budgetStartMonthLabel, budgetEndMonthYear, budgetEndMonthMonth, budgetEndMonthLabel, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} entityId 
         * @param {string} [entityType] 
         * @param {boolean} [includeUnchangedFields] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPositionAuditTrail(entityId: string, entityType?: string, includeUnchangedFields?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetAuditTrailResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPositionAuditTrail(entityId, entityType, includeUnchangedFields, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [quoteDate] 
         * @param {boolean} [includeExpirationDates] 
         * @param {boolean} [includeMarketPrices] 
         * @param {boolean} [useDisplayUnits] 
         * @param {Array<ScenarioMarketPriceModel>} [scenarioMarketPrices] 
         * @param {Array<number>} [commoditiesFilter] 
         * @param {Array<number>} [locationsFilter] 
         * @param {Array<number>} [counterpartiesFilter] 
         * @param {string} [tradeDateStartFilter] 
         * @param {string} [tradeDateEndFilter] 
         * @param {number} [budgetMonthStartFilterYear] 
         * @param {number} [budgetMonthStartFilterMonth] 
         * @param {string} [budgetMonthStartFilterLabel] 
         * @param {number} [budgetMonthEndFilterYear] 
         * @param {number} [budgetMonthEndFilterMonth] 
         * @param {string} [budgetMonthEndFilterLabel] 
         * @param {number} [contractMonthStartFilterYear] 
         * @param {number} [contractMonthStartFilterMonth] 
         * @param {string} [contractMonthStartFilterLabel] 
         * @param {number} [contractMonthEndFilterYear] 
         * @param {number} [contractMonthEndFilterMonth] 
         * @param {string} [contractMonthEndFilterLabel] 
         * @param {Array<PositionType>} [positionTypesFilter] 
         * @param {string} [dealTicketNumberFilter] 
         * @param {number} [dealTicketIdFilter] 
         * @param {Side} [sideFilter] 
         * @param {boolean} [validatedFilter] 
         * @param {Array<Currency>} [currencyFilter] 
         * @param {Currency} [currency] 
         * @param {ExpiryStatus} [expiryStatus] 
         * @param {boolean} [includeAllocations] 
         * @param {boolean} [includeAllocationOffset] 
         * @param {boolean} [filterByTradeDate] 
         * @param {string} [pricingStartDateStartFilter] 
         * @param {string} [pricingStartDateEndFilter] 
         * @param {string} [pricingEndDateStartFilter] 
         * @param {string} [pricingEndDateEndFilter] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPositionExcelExport(quoteDate?: string, includeExpirationDates?: boolean, includeMarketPrices?: boolean, useDisplayUnits?: boolean, scenarioMarketPrices?: Array<ScenarioMarketPriceModel>, commoditiesFilter?: Array<number>, locationsFilter?: Array<number>, counterpartiesFilter?: Array<number>, tradeDateStartFilter?: string, tradeDateEndFilter?: string, budgetMonthStartFilterYear?: number, budgetMonthStartFilterMonth?: number, budgetMonthStartFilterLabel?: string, budgetMonthEndFilterYear?: number, budgetMonthEndFilterMonth?: number, budgetMonthEndFilterLabel?: string, contractMonthStartFilterYear?: number, contractMonthStartFilterMonth?: number, contractMonthStartFilterLabel?: string, contractMonthEndFilterYear?: number, contractMonthEndFilterMonth?: number, contractMonthEndFilterLabel?: string, positionTypesFilter?: Array<PositionType>, dealTicketNumberFilter?: string, dealTicketIdFilter?: number, sideFilter?: Side, validatedFilter?: boolean, currencyFilter?: Array<Currency>, currency?: Currency, expiryStatus?: ExpiryStatus, includeAllocations?: boolean, includeAllocationOffset?: boolean, filterByTradeDate?: boolean, pricingStartDateStartFilter?: string, pricingStartDateEndFilter?: string, pricingEndDateStartFilter?: string, pricingEndDateEndFilter?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FileResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPositionExcelExport(quoteDate, includeExpirationDates, includeMarketPrices, useDisplayUnits, scenarioMarketPrices, commoditiesFilter, locationsFilter, counterpartiesFilter, tradeDateStartFilter, tradeDateEndFilter, budgetMonthStartFilterYear, budgetMonthStartFilterMonth, budgetMonthStartFilterLabel, budgetMonthEndFilterYear, budgetMonthEndFilterMonth, budgetMonthEndFilterLabel, contractMonthStartFilterYear, contractMonthStartFilterMonth, contractMonthStartFilterLabel, contractMonthEndFilterYear, contractMonthEndFilterMonth, contractMonthEndFilterLabel, positionTypesFilter, dealTicketNumberFilter, dealTicketIdFilter, sideFilter, validatedFilter, currencyFilter, currency, expiryStatus, includeAllocations, includeAllocationOffset, filterByTradeDate, pricingStartDateStartFilter, pricingStartDateEndFilter, pricingEndDateStartFilter, pricingEndDateEndFilter, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} quoteDate 
         * @param {number} customerReportId 
         * @param {number} [budgetStartMonthYear] 
         * @param {number} [budgetStartMonthMonth] 
         * @param {string} [budgetStartMonthLabel] 
         * @param {number} [budgetEndMonthYear] 
         * @param {number} [budgetEndMonthMonth] 
         * @param {string} [budgetEndMonthLabel] 
         * @param {Array<number>} [commoditiesFilter] 
         * @param {Currency} [currency] 
         * @param {StressIncrementType} [stressIncrementType] 
         * @param {Array<number>} [stressIncrements] 
         * @param {Array<number>} [whatIfStrategyIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getScenarioExcelReport(quoteDate: string, customerReportId: number, budgetStartMonthYear?: number, budgetStartMonthMonth?: number, budgetStartMonthLabel?: string, budgetEndMonthYear?: number, budgetEndMonthMonth?: number, budgetEndMonthLabel?: string, commoditiesFilter?: Array<number>, currency?: Currency, stressIncrementType?: StressIncrementType, stressIncrements?: Array<number>, whatIfStrategyIds?: Array<number>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FileResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getScenarioExcelReport(quoteDate, customerReportId, budgetStartMonthYear, budgetStartMonthMonth, budgetStartMonthLabel, budgetEndMonthYear, budgetEndMonthMonth, budgetEndMonthLabel, commoditiesFilter, currency, stressIncrementType, stressIncrements, whatIfStrategyIds, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getScenarioMarketPricesExcelTemplate(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FileResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getScenarioMarketPricesExcelTemplate(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} quoteDate 
         * @param {number} customerReportId 
         * @param {number} [budgetStartMonthYear] 
         * @param {number} [budgetStartMonthMonth] 
         * @param {string} [budgetStartMonthLabel] 
         * @param {number} [budgetEndMonthYear] 
         * @param {number} [budgetEndMonthMonth] 
         * @param {string} [budgetEndMonthLabel] 
         * @param {Array<number>} [commoditiesFilter] 
         * @param {Currency} [currency] 
         * @param {StressIncrementType} [stressIncrementType] 
         * @param {Array<number>} [stressIncrements] 
         * @param {Array<number>} [whatIfStrategyIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getScenarioReport(quoteDate: string, customerReportId: number, budgetStartMonthYear?: number, budgetStartMonthMonth?: number, budgetStartMonthLabel?: string, budgetEndMonthYear?: number, budgetEndMonthMonth?: number, budgetEndMonthLabel?: string, commoditiesFilter?: Array<number>, currency?: Currency, stressIncrementType?: StressIncrementType, stressIncrements?: Array<number>, whatIfStrategyIds?: Array<number>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetScenarioReportResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getScenarioReport(quoteDate, customerReportId, budgetStartMonthYear, budgetStartMonthMonth, budgetStartMonthLabel, budgetEndMonthYear, budgetEndMonthMonth, budgetEndMonthLabel, commoditiesFilter, currency, stressIncrementType, stressIncrements, whatIfStrategyIds, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} quoteDate 
         * @param {number} customerReportId 
         * @param {number} [budgetStartMonthYear] 
         * @param {number} [budgetStartMonthMonth] 
         * @param {string} [budgetStartMonthLabel] 
         * @param {number} [budgetEndMonthYear] 
         * @param {number} [budgetEndMonthMonth] 
         * @param {string} [budgetEndMonthLabel] 
         * @param {ExpiryStatus} [expiryStatus] 
         * @param {Currency} [currency] 
         * @param {string} [sortColumn] 
         * @param {SortDirection} [sortDirection] 
         * @param {number} [take] 
         * @param {number} [skip] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSummaryExcelReport(quoteDate: string, customerReportId: number, budgetStartMonthYear?: number, budgetStartMonthMonth?: number, budgetStartMonthLabel?: string, budgetEndMonthYear?: number, budgetEndMonthMonth?: number, budgetEndMonthLabel?: string, expiryStatus?: ExpiryStatus, currency?: Currency, sortColumn?: string, sortDirection?: SortDirection, take?: number, skip?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FileResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSummaryExcelReport(quoteDate, customerReportId, budgetStartMonthYear, budgetStartMonthMonth, budgetStartMonthLabel, budgetEndMonthYear, budgetEndMonthMonth, budgetEndMonthLabel, expiryStatus, currency, sortColumn, sortDirection, take, skip, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} quoteDate 
         * @param {number} numberOfMonths 
         * @param {number} minimumPercentage 
         * @param {number} maximumPercentage 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTimeTriggerReport(quoteDate: string, numberOfMonths: number, minimumPercentage: number, maximumPercentage: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetTimeTriggerReportResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTimeTriggerReport(quoteDate, numberOfMonths, minimumPercentage, maximumPercentage, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} quoteDate 
         * @param {number} customerReportId 
         * @param {number} [budgetStartMonthYear] 
         * @param {number} [budgetStartMonthMonth] 
         * @param {string} [budgetStartMonthLabel] 
         * @param {number} [budgetEndMonthYear] 
         * @param {number} [budgetEndMonthMonth] 
         * @param {string} [budgetEndMonthLabel] 
         * @param {ExpiryStatus} [expiryStatus] 
         * @param {Currency} [currency] 
         * @param {string} [sortColumn] 
         * @param {SortDirection} [sortDirection] 
         * @param {number} [take] 
         * @param {number} [skip] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getVarianceExcelReport(quoteDate: string, customerReportId: number, budgetStartMonthYear?: number, budgetStartMonthMonth?: number, budgetStartMonthLabel?: string, budgetEndMonthYear?: number, budgetEndMonthMonth?: number, budgetEndMonthLabel?: string, expiryStatus?: ExpiryStatus, currency?: Currency, sortColumn?: string, sortDirection?: SortDirection, take?: number, skip?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FileResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getVarianceExcelReport(quoteDate, customerReportId, budgetStartMonthYear, budgetStartMonthMonth, budgetStartMonthLabel, budgetEndMonthYear, budgetEndMonthMonth, budgetEndMonthLabel, expiryStatus, currency, sortColumn, sortDirection, take, skip, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} quoteDate 
         * @param {number} customerReportId 
         * @param {number} [budgetStartMonthYear] 
         * @param {number} [budgetStartMonthMonth] 
         * @param {string} [budgetStartMonthLabel] 
         * @param {number} [budgetEndMonthYear] 
         * @param {number} [budgetEndMonthMonth] 
         * @param {string} [budgetEndMonthLabel] 
         * @param {ExpiryStatus} [expiryStatus] 
         * @param {Currency} [currency] 
         * @param {string} [sortColumn] 
         * @param {SortDirection} [sortDirection] 
         * @param {number} [take] 
         * @param {number} [skip] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getVarianceReport(quoteDate: string, customerReportId: number, budgetStartMonthYear?: number, budgetStartMonthMonth?: number, budgetStartMonthLabel?: string, budgetEndMonthYear?: number, budgetEndMonthMonth?: number, budgetEndMonthLabel?: string, expiryStatus?: ExpiryStatus, currency?: Currency, sortColumn?: string, sortDirection?: SortDirection, take?: number, skip?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetVarianceReportResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getVarianceReport(quoteDate, customerReportId, budgetStartMonthYear, budgetStartMonthMonth, budgetStartMonthLabel, budgetEndMonthYear, budgetEndMonthMonth, budgetEndMonthLabel, expiryStatus, currency, sortColumn, sortDirection, take, skip, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {Array<number>} [commoditiesFilter] 
         * @param {Array<number>} [locationsFilter] 
         * @param {Array<number>} [counterpartiesFilter] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listAllocations(commoditiesFilter?: Array<number>, locationsFilter?: Array<number>, counterpartiesFilter?: Array<number>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListAllocationsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listAllocations(commoditiesFilter, locationsFilter, counterpartiesFilter, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} [commodityId] 
         * @param {number} [locationId] 
         * @param {number} [counterpartyId] 
         * @param {number} [portfolioId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listBudgetYearAllotmentProperties(commodityId?: number, locationId?: number, counterpartyId?: number, portfolioId?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListBudgetYearAllotmentPropertiesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listBudgetYearAllotmentProperties(commodityId, locationId, counterpartyId, portfolioId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} [locationId] 
         * @param {number} [commodityId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listBudgetYears(locationId?: number, commodityId?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListBudgetYearsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listBudgetYears(locationId, commodityId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [quoteDate] 
         * @param {number} [budgetStartMonthYear] 
         * @param {number} [budgetStartMonthMonth] 
         * @param {string} [budgetStartMonthLabel] 
         * @param {number} [budgetEndMonthYear] 
         * @param {number} [budgetEndMonthMonth] 
         * @param {string} [budgetEndMonthLabel] 
         * @param {Array<number>} [fiscalYearsFilter] 
         * @param {Array<number>} [commoditiesFilter] 
         * @param {Array<number>} [locationsFilter] 
         * @param {Array<number>} [counterpartiesFilter] 
         * @param {Array<number>} [budgetRoundsFilter] 
         * @param {boolean} [includeExpirationDates] 
         * @param {boolean} [includePositions] 
         * @param {boolean} [includeMarketPrices] 
         * @param {boolean} [includeBudgetRounds] 
         * @param {ExpiryStatus} [expiryStatus] 
         * @param {Currency} [currency] 
         * @param {Unit} [unit] 
         * @param {string} [note] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listBudgets(quoteDate?: string, budgetStartMonthYear?: number, budgetStartMonthMonth?: number, budgetStartMonthLabel?: string, budgetEndMonthYear?: number, budgetEndMonthMonth?: number, budgetEndMonthLabel?: string, fiscalYearsFilter?: Array<number>, commoditiesFilter?: Array<number>, locationsFilter?: Array<number>, counterpartiesFilter?: Array<number>, budgetRoundsFilter?: Array<number>, includeExpirationDates?: boolean, includePositions?: boolean, includeMarketPrices?: boolean, includeBudgetRounds?: boolean, expiryStatus?: ExpiryStatus, currency?: Currency, unit?: Unit, note?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListBudgetsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listBudgets(quoteDate, budgetStartMonthYear, budgetStartMonthMonth, budgetStartMonthLabel, budgetEndMonthYear, budgetEndMonthMonth, budgetEndMonthLabel, fiscalYearsFilter, commoditiesFilter, locationsFilter, counterpartiesFilter, budgetRoundsFilter, includeExpirationDates, includePositions, includeMarketPrices, includeBudgetRounds, expiryStatus, currency, unit, note, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} [commodityId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listCommodityContractMonthMappings(commodityId?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListCommodityContractMonthMappingsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listCommodityContractMonthMappings(commodityId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listCustomers(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListKnowRiskEnergyCustomersResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listCustomers(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listDefaultBudgetRounds(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListDefaultBudgetRoundsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listDefaultBudgetRounds(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [vendorFilter] 
         * @param {string} [plantFilter] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listDeliveries(vendorFilter?: string, plantFilter?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListDeliveriesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listDeliveries(vendorFilter, plantFilter, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [entityFilter] 
         * @param {number} [entityIdFilter] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listDocuments(entityFilter?: string, entityIdFilter?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListDocumentsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listDocuments(entityFilter, entityIdFilter, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [sortColumn] 
         * @param {SortDirection} [sortDirection] 
         * @param {number} [take] 
         * @param {number} [skip] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listEiaNaturalGasStorageWeeks(sortColumn?: string, sortDirection?: SortDirection, take?: number, skip?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListEiaNaturalGasStorageWeeksResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listEiaNaturalGasStorageWeeks(sortColumn, sortDirection, take, skip, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} hedgePlanId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listHedgePlanData(hedgePlanId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListHedgePlanDataResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listHedgePlanData(hedgePlanId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} hedgePlanId 
         * @param {string} [asOfDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listHedgePlanSeasons(hedgePlanId: string, asOfDate?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListHedgePlanSeasonsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listHedgePlanSeasons(hedgePlanId, asOfDate, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} companyGuid 
         * @param {string} [sortColumn] 
         * @param {SortDirection} [sortDirection] 
         * @param {number} [take] 
         * @param {number} [skip] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listHedgePlans(companyGuid: string, sortColumn?: string, sortDirection?: SortDirection, take?: number, skip?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListHedgePlansResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listHedgePlans(companyGuid, sortColumn, sortDirection, take, skip, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} customerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listLocations(customerId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListKnowRiskEnergyLocationsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listLocations(customerId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listNotes(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListNotesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listNotes(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} [commodityId] 
         * @param {number} [locationId] 
         * @param {number} [counterpartyId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listPositionYears(commodityId?: number, locationId?: number, counterpartyId?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListPositionYearsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listPositionYears(commodityId, locationId, counterpartyId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [quoteDate] 
         * @param {boolean} [includeExpirationDates] 
         * @param {boolean} [includeMarketPrices] 
         * @param {boolean} [useDisplayUnits] 
         * @param {Array<ScenarioMarketPriceModel>} [scenarioMarketPrices] 
         * @param {Array<number>} [commoditiesFilter] 
         * @param {Array<number>} [locationsFilter] 
         * @param {Array<number>} [counterpartiesFilter] 
         * @param {string} [tradeDateStartFilter] 
         * @param {string} [tradeDateEndFilter] 
         * @param {number} [budgetMonthStartFilterYear] 
         * @param {number} [budgetMonthStartFilterMonth] 
         * @param {string} [budgetMonthStartFilterLabel] 
         * @param {number} [budgetMonthEndFilterYear] 
         * @param {number} [budgetMonthEndFilterMonth] 
         * @param {string} [budgetMonthEndFilterLabel] 
         * @param {number} [contractMonthStartFilterYear] 
         * @param {number} [contractMonthStartFilterMonth] 
         * @param {string} [contractMonthStartFilterLabel] 
         * @param {number} [contractMonthEndFilterYear] 
         * @param {number} [contractMonthEndFilterMonth] 
         * @param {string} [contractMonthEndFilterLabel] 
         * @param {Array<PositionType>} [positionTypesFilter] 
         * @param {string} [dealTicketNumberFilter] 
         * @param {number} [dealTicketIdFilter] 
         * @param {Side} [sideFilter] 
         * @param {boolean} [validatedFilter] 
         * @param {Array<Currency>} [currencyFilter] 
         * @param {Currency} [currency] 
         * @param {ExpiryStatus} [expiryStatus] 
         * @param {boolean} [includeAllocations] 
         * @param {boolean} [includeAllocationOffset] 
         * @param {boolean} [filterByTradeDate] 
         * @param {string} [pricingStartDateStartFilter] 
         * @param {string} [pricingStartDateEndFilter] 
         * @param {string} [pricingEndDateStartFilter] 
         * @param {string} [pricingEndDateEndFilter] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listPositions(quoteDate?: string, includeExpirationDates?: boolean, includeMarketPrices?: boolean, useDisplayUnits?: boolean, scenarioMarketPrices?: Array<ScenarioMarketPriceModel>, commoditiesFilter?: Array<number>, locationsFilter?: Array<number>, counterpartiesFilter?: Array<number>, tradeDateStartFilter?: string, tradeDateEndFilter?: string, budgetMonthStartFilterYear?: number, budgetMonthStartFilterMonth?: number, budgetMonthStartFilterLabel?: string, budgetMonthEndFilterYear?: number, budgetMonthEndFilterMonth?: number, budgetMonthEndFilterLabel?: string, contractMonthStartFilterYear?: number, contractMonthStartFilterMonth?: number, contractMonthStartFilterLabel?: string, contractMonthEndFilterYear?: number, contractMonthEndFilterMonth?: number, contractMonthEndFilterLabel?: string, positionTypesFilter?: Array<PositionType>, dealTicketNumberFilter?: string, dealTicketIdFilter?: number, sideFilter?: Side, validatedFilter?: boolean, currencyFilter?: Array<Currency>, currency?: Currency, expiryStatus?: ExpiryStatus, includeAllocations?: boolean, includeAllocationOffset?: boolean, filterByTradeDate?: boolean, pricingStartDateStartFilter?: string, pricingStartDateEndFilter?: string, pricingEndDateStartFilter?: string, pricingEndDateEndFilter?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListPositionsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listPositions(quoteDate, includeExpirationDates, includeMarketPrices, useDisplayUnits, scenarioMarketPrices, commoditiesFilter, locationsFilter, counterpartiesFilter, tradeDateStartFilter, tradeDateEndFilter, budgetMonthStartFilterYear, budgetMonthStartFilterMonth, budgetMonthStartFilterLabel, budgetMonthEndFilterYear, budgetMonthEndFilterMonth, budgetMonthEndFilterLabel, contractMonthStartFilterYear, contractMonthStartFilterMonth, contractMonthStartFilterLabel, contractMonthEndFilterYear, contractMonthEndFilterMonth, contractMonthEndFilterLabel, positionTypesFilter, dealTicketNumberFilter, dealTicketIdFilter, sideFilter, validatedFilter, currencyFilter, currency, expiryStatus, includeAllocations, includeAllocationOffset, filterByTradeDate, pricingStartDateStartFilter, pricingStartDateEndFilter, pricingEndDateStartFilter, pricingEndDateEndFilter, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listPricingStrategies(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListPricingStrategiesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listPricingStrategies(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {any} scenarioMarketPricesFile 
         * @param {string} [sortColumn] 
         * @param {SortDirection} [sortDirection] 
         * @param {number} [take] 
         * @param {number} [skip] 
         * @param {boolean} [validationResponseIsValid] 
         * @param {string} [validationResponseValidationMessage] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listScenarioMarketPricesFromUpload(scenarioMarketPricesFile: any, sortColumn?: string, sortDirection?: SortDirection, take?: number, skip?: number, validationResponseIsValid?: boolean, validationResponseValidationMessage?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListScenarioMarketPricesFromUploadResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listScenarioMarketPricesFromUpload(scenarioMarketPricesFile, sortColumn, sortDirection, take, skip, validationResponseIsValid, validationResponseValidationMessage, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listWhatIfStrategies(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListWhatIfStrategyResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listWhatIfStrategies(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} customerReportId 
         * @param {SendCommodityManagementReportEmailRequest} [sendCommodityManagementReportEmailRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sendCommodityManagementReportEmail(customerReportId: string, sendCommodityManagementReportEmailRequest?: SendCommodityManagementReportEmailRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SendCommodityManagementReportEmailResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sendCommodityManagementReportEmail(customerReportId, sendCommodityManagementReportEmailRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {UpdateBudgetRoundRequest} [updateBudgetRoundRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateBudgetRound(updateBudgetRoundRequest?: UpdateBudgetRoundRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UodateBudgetRoundResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateBudgetRound(updateBudgetRoundRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {UpdateBudgetsRequest} [updateBudgetsRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateBudgets(updateBudgetsRequest?: UpdateBudgetsRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateBudgets(updateBudgetsRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} commodityId 
         * @param {string} commodityName 
         * @param {Unit} displayUnit 
         * @param {number} displayPrecision 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateCommodity(commodityId: string, commodityName: string, displayUnit: Unit, displayPrecision: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpdateCommodityResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateCommodity(commodityId, commodityName, displayUnit, displayPrecision, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} commodityId 
         * @param {UpdateCommodityContractMonthMappingsRequest} [updateCommodityContractMonthMappingsRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateCommodityContractMonthMappings(commodityId: string, updateCommodityContractMonthMappingsRequest?: UpdateCommodityContractMonthMappingsRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpdateCommodityContractMonthMappingsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateCommodityContractMonthMappings(commodityId, updateCommodityContractMonthMappingsRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} counterpartyId 
         * @param {string} counterpartyName 
         * @param {number} [creditLimit] 
         * @param {boolean} [netting] 
         * @param {boolean} [setoff] 
         * @param {boolean} [active] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateCounterparty(counterpartyId: string, counterpartyName: string, creditLimit?: number, netting?: boolean, setoff?: boolean, active?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpdateCounterpartyResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateCounterparty(counterpartyId, counterpartyName, creditLimit, netting, setoff, active, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {UpdateCustomerReportRequest} [updateCustomerReportRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateCustomerReport(updateCustomerReportRequest?: UpdateCustomerReportRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpdateCustomerReportResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateCustomerReport(updateCustomerReportRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} customerReportId 
         * @param {string} [overrides] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateCustomerReportUserOverrides(customerReportId: number, overrides?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateCustomerReportUserOverrides(customerReportId, overrides, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {UpdateCustomerSettingsRequest} [updateCustomerSettingsRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateCustomerSettings(updateCustomerSettingsRequest?: UpdateCustomerSettingsRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpdateCustomerSettingsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateCustomerSettings(updateCustomerSettingsRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} dealTicketId 
         * @param {Array<number>} [validatedPositionIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateDealTicketPositionValidation(dealTicketId: string, validatedPositionIds?: Array<number>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateDealTicketPositionValidation(dealTicketId, validatedPositionIds, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {UpdateDefaultBudgetRoundsRequest} [updateDefaultBudgetRoundsRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateDefaultBudgetRounds(updateDefaultBudgetRoundsRequest?: UpdateDefaultBudgetRoundsRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateDefaultBudgetRounds(updateDefaultBudgetRoundsRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {UpdateDeliveriesRequest} [updateDeliveriesRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateDeliveries(updateDeliveriesRequest?: UpdateDeliveriesRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateDeliveries(updateDeliveriesRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {UpdateHedgePlanRequest} [updateHedgePlanRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateHedgePlan(updateHedgePlanRequest?: UpdateHedgePlanRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpdateHedgePlanResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateHedgePlan(updateHedgePlanRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} hedgePlanId 
         * @param {string} year 
         * @param {UpdateHedgePlanBudgetTriggersRequest} [updateHedgePlanBudgetTriggersRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateHedgePlanBudgetTriggers(hedgePlanId: string, year: string, updateHedgePlanBudgetTriggersRequest?: UpdateHedgePlanBudgetTriggersRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpdateHedgePlanBudgetTriggersResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateHedgePlanBudgetTriggers(hedgePlanId, year, updateHedgePlanBudgetTriggersRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} hedgePlanId 
         * @param {string} year 
         * @param {UpdateHedgePlanSeasonSettingsRequest} [updateHedgePlanSeasonSettingsRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateHedgePlanSeasonSettings(hedgePlanId: string, year: string, updateHedgePlanSeasonSettingsRequest?: UpdateHedgePlanSeasonSettingsRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpdateHedgePlanSeasonSettingsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateHedgePlanSeasonSettings(hedgePlanId, year, updateHedgePlanSeasonSettingsRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} hedgePlanId 
         * @param {string} year 
         * @param {UpdateHedgePlanTimeTriggersRequest} [updateHedgePlanTimeTriggersRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateHedgePlanTimeTriggers(hedgePlanId: string, year: string, updateHedgePlanTimeTriggersRequest?: UpdateHedgePlanTimeTriggersRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpdateHedgePlanTimeTriggersResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateHedgePlanTimeTriggers(hedgePlanId, year, updateHedgePlanTimeTriggersRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} hedgePlanId 
         * @param {string} year 
         * @param {UpdateHedgePlanTradesRequest} [updateHedgePlanTradesRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateHedgePlanTrades(hedgePlanId: string, year: string, updateHedgePlanTradesRequest?: UpdateHedgePlanTradesRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpdateHedgePlanTradesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateHedgePlanTrades(hedgePlanId, year, updateHedgePlanTradesRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} hedgePlanId 
         * @param {string} year 
         * @param {UpdateHedgePlanValueTriggersRequest} [updateHedgePlanValueTriggersRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateHedgePlanValueTriggers(hedgePlanId: string, year: string, updateHedgePlanValueTriggersRequest?: UpdateHedgePlanValueTriggersRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpdateHedgePlanValueTriggersResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateHedgePlanValueTriggers(hedgePlanId, year, updateHedgePlanValueTriggersRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} locationId 
         * @param {string} locationName 
         * @param {number} tierId 
         * @param {number} [parentLocationId] 
         * @param {boolean} [active] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateLocation(locationId: string, locationName: string, tierId: number, parentLocationId?: number, active?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpdateLocationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateLocation(locationId, locationName, tierId, parentLocationId, active, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} noteId 
         * @param {string} subject 
         * @param {string} content 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateNote(noteId: string, subject: string, content: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpdateNoteResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateNote(noteId, subject, content, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} portfolioId 
         * @param {string} portfolioName 
         * @param {boolean} [active] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePortfolio(portfolioId: string, portfolioName: string, active?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpdatePortfolioResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatePortfolio(portfolioId, portfolioName, active, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {UpdatePricingStrategiesRequest} [updatePricingStrategiesRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePricingStrategies(updatePricingStrategiesRequest?: UpdatePricingStrategiesRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpdatePricingStrategiesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatePricingStrategies(updatePricingStrategiesRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} tierId 
         * @param {string} tierName 
         * @param {number} tierRank 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateTier(tierId: string, tierName: string, tierRank: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpdateTierResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateTier(tierId, tierName, tierRank, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {UpdateWhatIfStrategyRequest} [updateWhatIfStrategyRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateWhatIfStrategy(updateWhatIfStrategyRequest?: UpdateWhatIfStrategyRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpdateWhatIfStrategyResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateWhatIfStrategy(updateWhatIfStrategyRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} entityName 
         * @param {string} documentUrl 
         * @param {any} file 
         * @param {number} [entityId] 
         * @param {string} [description] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async upload(entityName: string, documentUrl: string, file: any, entityId?: number, description?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpdateDocumentsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.upload(entityName, documentUrl, file, entityId, description, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * CommodityManagementApi - factory interface
 * @export
 */
export const CommodityManagementApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CommodityManagementApiFp(configuration)
    return {
        /**
         * 
         * @param {UpdateAllocationRequest} [updateAllocationRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addAllocation(updateAllocationRequest?: UpdateAllocationRequest, options?: any): AxiosPromise<UpdateAllocationResponse> {
            return localVarFp.addAllocation(updateAllocationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UpdateAllocationGroupRequest} [updateAllocationGroupRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addAllocationGroup(updateAllocationGroupRequest?: UpdateAllocationGroupRequest, options?: any): AxiosPromise<UpdateAllocationGroupResponse> {
            return localVarFp.addAllocationGroup(updateAllocationGroupRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} commodityName 
         * @param {Unit} displayUnit 
         * @param {number} displayPrecision 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addCommodity(commodityName: string, displayUnit: Unit, displayPrecision: number, options?: any): AxiosPromise<AddCommodityResponse> {
            return localVarFp.addCommodity(commodityName, displayUnit, displayPrecision, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [counterpartyName] 
         * @param {number} [creditLimit] 
         * @param {boolean} [netting] 
         * @param {boolean} [setoff] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addCounterparty(counterpartyName?: string, creditLimit?: number, netting?: boolean, setoff?: boolean, options?: any): AxiosPromise<AddCounterpartyResponse> {
            return localVarFp.addCounterparty(counterpartyName, creditLimit, netting, setoff, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} hedgePlanId 
         * @param {AddHedgePlanSeasonRequest} [addHedgePlanSeasonRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addHedgePlanSeason(hedgePlanId: string, addHedgePlanSeasonRequest?: AddHedgePlanSeasonRequest, options?: any): AxiosPromise<AddHedgePlanSeasonResponse> {
            return localVarFp.addHedgePlanSeason(hedgePlanId, addHedgePlanSeasonRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} locationName 
         * @param {number} tierId 
         * @param {number} [parentLocationId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addLocation(locationName: string, tierId: number, parentLocationId?: number, options?: any): AxiosPromise<AddLocationResponse> {
            return localVarFp.addLocation(locationName, tierId, parentLocationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AddNoteRequest} [addNoteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addNote(addNoteRequest?: AddNoteRequest, options?: any): AxiosPromise<AddNoteResponse> {
            return localVarFp.addNote(addNoteRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} portfolioName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addPortfolio(portfolioName: string, options?: any): AxiosPromise<AddPortfolioResponse> {
            return localVarFp.addPortfolio(portfolioName, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} tierRank 
         * @param {string} [tierName] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addTier(tierRank: number, tierName?: string, options?: any): AxiosPromise<AddTierResponse> {
            return localVarFp.addTier(tierRank, tierName, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UpdateDealTicketRequest} [updateDealTicketRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addTrade(updateDealTicketRequest?: UpdateDealTicketRequest, options?: any): AxiosPromise<UpdateDealTicketResponse> {
            return localVarFp.addTrade(updateDealTicketRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Array<number>} customerReportIds 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        copyCustomerReports(customerReportIds: Array<number>, options?: any): AxiosPromise<CopyCustomerReportsResponse> {
            return localVarFp.copyCustomerReports(customerReportIds, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} commodityId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCommodity(commodityId: string, options?: any): AxiosPromise<object> {
            return localVarFp.deleteCommodity(commodityId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} counterpartyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCounterparty(counterpartyId: string, options?: any): AxiosPromise<object> {
            return localVarFp.deleteCounterparty(counterpartyId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} customerReportId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCustomerReport(customerReportId: string, options?: any): AxiosPromise<object> {
            return localVarFp.deleteCustomerReport(customerReportId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} dealTicketId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDealTicket(dealTicketId: string, options?: any): AxiosPromise<object> {
            return localVarFp.deleteDealTicket(dealTicketId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} hedgePlanId 
         * @param {number} year 
         * @param {MatrixTerm} [term] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteHedgePlanSeason(hedgePlanId: string, year: number, term?: MatrixTerm, options?: any): AxiosPromise<DeleteHedgePlanSeasonResponse> {
            return localVarFp.deleteHedgePlanSeason(hedgePlanId, year, term, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} locationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteLocation(locationId: string, options?: any): AxiosPromise<object> {
            return localVarFp.deleteLocation(locationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} noteId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteNote(noteId: string, options?: any): AxiosPromise<object> {
            return localVarFp.deleteNote(noteId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} portfolioId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePortfolio(portfolioId: string, options?: any): AxiosPromise<object> {
            return localVarFp.deletePortfolio(portfolioId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} budgetPricingStrategyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePricingStrategy(budgetPricingStrategyId: string, options?: any): AxiosPromise<object> {
            return localVarFp.deletePricingStrategy(budgetPricingStrategyId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} tierId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTier(tierId: string, options?: any): AxiosPromise<object> {
            return localVarFp.deleteTier(tierId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} whatIfStrategyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteWhatIfStrategy(whatIfStrategyId: string, options?: any): AxiosPromise<object> {
            return localVarFp.deleteWhatIfStrategy(whatIfStrategyId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [documentUrl] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadDocument(documentUrl?: string, options?: any): AxiosPromise<DownloadDocumentResponse> {
            return localVarFp.downloadDocument(documentUrl, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} entityType 
         * @param {string} entityId 
         * @param {boolean} [includeUnchangedFields] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAuditTrail(entityType: string, entityId: string, includeUnchangedFields?: boolean, options?: any): AxiosPromise<GetAuditTrailResponse> {
            return localVarFp.getAuditTrail(entityType, entityId, includeUnchangedFields, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} entityId 
         * @param {string} [entityType] 
         * @param {boolean} [includeUnchangedFields] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBudgetAuditTrail(entityId: string, entityType?: string, includeUnchangedFields?: boolean, options?: any): AxiosPromise<GetAuditTrailResponse> {
            return localVarFp.getBudgetAuditTrail(entityId, entityType, includeUnchangedFields, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomerData(options?: any): AxiosPromise<GetCustomerDataResponse> {
            return localVarFp.getCustomerData(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomerReports(options?: any): AxiosPromise<GetCustomerReportsResponse> {
            return localVarFp.getCustomerReports(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomerSettings(options?: any): AxiosPromise<GetCustomerSettingsResponse> {
            return localVarFp.getCustomerSettings(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} pricingStartDate 
         * @param {string} pricingEndDate 
         * @param {GetDailyPositionsReportRequest} [getDailyPositionsReportRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDailyPositionsExcelReport(pricingStartDate: string, pricingEndDate: string, getDailyPositionsReportRequest?: GetDailyPositionsReportRequest, options?: any): AxiosPromise<FileResponse> {
            return localVarFp.getDailyPositionsExcelReport(pricingStartDate, pricingEndDate, getDailyPositionsReportRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} pricingStartDate 
         * @param {string} pricingEndDate 
         * @param {GetDailyPositionsReportRequest} [getDailyPositionsReportRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDailyPositionsReport(pricingStartDate: string, pricingEndDate: string, getDailyPositionsReportRequest?: GetDailyPositionsReportRequest, options?: any): AxiosPromise<GetDailyPositionsReportResponse> {
            return localVarFp.getDailyPositionsReport(pricingStartDate, pricingEndDate, getDailyPositionsReportRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} dealTicketId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDealTicket(dealTicketId: string, options?: any): AxiosPromise<GetDealTicketResponse> {
            return localVarFp.getDealTicket(dealTicketId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} quoteDate 
         * @param {number} customerReportId 
         * @param {Currency} [currency] 
         * @param {StressIncrementType} [stressIncrementType] 
         * @param {Array<number>} [stressIncrements] 
         * @param {string} [sortColumn] 
         * @param {SortDirection} [sortDirection] 
         * @param {number} [take] 
         * @param {number} [skip] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExposureExcelReport(quoteDate: string, customerReportId: number, currency?: Currency, stressIncrementType?: StressIncrementType, stressIncrements?: Array<number>, sortColumn?: string, sortDirection?: SortDirection, take?: number, skip?: number, options?: any): AxiosPromise<FileResponse> {
            return localVarFp.getExposureExcelReport(quoteDate, customerReportId, currency, stressIncrementType, stressIncrements, sortColumn, sortDirection, take, skip, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} quoteDate 
         * @param {number} customerReportId 
         * @param {Currency} [currency] 
         * @param {StressIncrementType} [stressIncrementType] 
         * @param {Array<number>} [stressIncrements] 
         * @param {string} [sortColumn] 
         * @param {SortDirection} [sortDirection] 
         * @param {number} [take] 
         * @param {number} [skip] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExposureReport(quoteDate: string, customerReportId: number, currency?: Currency, stressIncrementType?: StressIncrementType, stressIncrements?: Array<number>, sortColumn?: string, sortDirection?: SortDirection, take?: number, skip?: number, options?: any): AxiosPromise<GetExposureReportResponse> {
            return localVarFp.getExposureReport(quoteDate, customerReportId, currency, stressIncrementType, stressIncrements, sortColumn, sortDirection, take, skip, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} hedgePlanId 
         * @param {string} year 
         * @param {string} quoteDate 
         * @param {MatrixTerm} [term] 
         * @param {boolean} [weightByVolume] 
         * @param {boolean} [refreshCache] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHedgePlanReport(hedgePlanId: string, year: string, quoteDate: string, term?: MatrixTerm, weightByVolume?: boolean, refreshCache?: boolean, options?: any): AxiosPromise<GetHedgePlanReportResponse> {
            return localVarFp.getHedgePlanReport(hedgePlanId, year, quoteDate, term, weightByVolume, refreshCache, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} companyGuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLocationsForCompany(companyGuid: string, options?: any): AxiosPromise<GetKnowRiskEnergyLocationsForCompanyResponse> {
            return localVarFp.getLocationsForCompany(companyGuid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} quoteDate 
         * @param {GetMarkToMarketReportRequest} [getMarkToMarketReportRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMarkToMarketExcelReport(quoteDate: string, getMarkToMarketReportRequest?: GetMarkToMarketReportRequest, options?: any): AxiosPromise<FileResponse> {
            return localVarFp.getMarkToMarketExcelReport(quoteDate, getMarkToMarketReportRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} quoteDate 
         * @param {GetMarkToMarketReportRequest} [getMarkToMarketReportRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMarkToMarketReport(quoteDate: string, getMarkToMarketReportRequest?: GetMarkToMarketReportRequest, options?: any): AxiosPromise<GetMarkToMarketReportResponse> {
            return localVarFp.getMarkToMarketReport(quoteDate, getMarkToMarketReportRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} customerReportId 
         * @param {string} [quoteDate] 
         * @param {number} [budgetStartMonthYear] 
         * @param {number} [budgetStartMonthMonth] 
         * @param {string} [budgetStartMonthLabel] 
         * @param {number} [budgetEndMonthYear] 
         * @param {number} [budgetEndMonthMonth] 
         * @param {string} [budgetEndMonthLabel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPiedmontHedgingExcelReport(customerReportId: number, quoteDate?: string, budgetStartMonthYear?: number, budgetStartMonthMonth?: number, budgetStartMonthLabel?: string, budgetEndMonthYear?: number, budgetEndMonthMonth?: number, budgetEndMonthLabel?: string, options?: any): AxiosPromise<FileResponse> {
            return localVarFp.getPiedmontHedgingExcelReport(customerReportId, quoteDate, budgetStartMonthYear, budgetStartMonthMonth, budgetStartMonthLabel, budgetEndMonthYear, budgetEndMonthMonth, budgetEndMonthLabel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} customerReportId 
         * @param {string} [quoteDate] 
         * @param {number} [budgetStartMonthYear] 
         * @param {number} [budgetStartMonthMonth] 
         * @param {string} [budgetStartMonthLabel] 
         * @param {number} [budgetEndMonthYear] 
         * @param {number} [budgetEndMonthMonth] 
         * @param {string} [budgetEndMonthLabel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPiedmontHedgingReport(customerReportId: number, quoteDate?: string, budgetStartMonthYear?: number, budgetStartMonthMonth?: number, budgetStartMonthLabel?: string, budgetEndMonthYear?: number, budgetEndMonthMonth?: number, budgetEndMonthLabel?: string, options?: any): AxiosPromise<GetPiedmontHedgingReportResponse> {
            return localVarFp.getPiedmontHedgingReport(customerReportId, quoteDate, budgetStartMonthYear, budgetStartMonthMonth, budgetStartMonthLabel, budgetEndMonthYear, budgetEndMonthMonth, budgetEndMonthLabel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} entityId 
         * @param {string} [entityType] 
         * @param {boolean} [includeUnchangedFields] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPositionAuditTrail(entityId: string, entityType?: string, includeUnchangedFields?: boolean, options?: any): AxiosPromise<GetAuditTrailResponse> {
            return localVarFp.getPositionAuditTrail(entityId, entityType, includeUnchangedFields, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [quoteDate] 
         * @param {boolean} [includeExpirationDates] 
         * @param {boolean} [includeMarketPrices] 
         * @param {boolean} [useDisplayUnits] 
         * @param {Array<ScenarioMarketPriceModel>} [scenarioMarketPrices] 
         * @param {Array<number>} [commoditiesFilter] 
         * @param {Array<number>} [locationsFilter] 
         * @param {Array<number>} [counterpartiesFilter] 
         * @param {string} [tradeDateStartFilter] 
         * @param {string} [tradeDateEndFilter] 
         * @param {number} [budgetMonthStartFilterYear] 
         * @param {number} [budgetMonthStartFilterMonth] 
         * @param {string} [budgetMonthStartFilterLabel] 
         * @param {number} [budgetMonthEndFilterYear] 
         * @param {number} [budgetMonthEndFilterMonth] 
         * @param {string} [budgetMonthEndFilterLabel] 
         * @param {number} [contractMonthStartFilterYear] 
         * @param {number} [contractMonthStartFilterMonth] 
         * @param {string} [contractMonthStartFilterLabel] 
         * @param {number} [contractMonthEndFilterYear] 
         * @param {number} [contractMonthEndFilterMonth] 
         * @param {string} [contractMonthEndFilterLabel] 
         * @param {Array<PositionType>} [positionTypesFilter] 
         * @param {string} [dealTicketNumberFilter] 
         * @param {number} [dealTicketIdFilter] 
         * @param {Side} [sideFilter] 
         * @param {boolean} [validatedFilter] 
         * @param {Array<Currency>} [currencyFilter] 
         * @param {Currency} [currency] 
         * @param {ExpiryStatus} [expiryStatus] 
         * @param {boolean} [includeAllocations] 
         * @param {boolean} [includeAllocationOffset] 
         * @param {boolean} [filterByTradeDate] 
         * @param {string} [pricingStartDateStartFilter] 
         * @param {string} [pricingStartDateEndFilter] 
         * @param {string} [pricingEndDateStartFilter] 
         * @param {string} [pricingEndDateEndFilter] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPositionExcelExport(quoteDate?: string, includeExpirationDates?: boolean, includeMarketPrices?: boolean, useDisplayUnits?: boolean, scenarioMarketPrices?: Array<ScenarioMarketPriceModel>, commoditiesFilter?: Array<number>, locationsFilter?: Array<number>, counterpartiesFilter?: Array<number>, tradeDateStartFilter?: string, tradeDateEndFilter?: string, budgetMonthStartFilterYear?: number, budgetMonthStartFilterMonth?: number, budgetMonthStartFilterLabel?: string, budgetMonthEndFilterYear?: number, budgetMonthEndFilterMonth?: number, budgetMonthEndFilterLabel?: string, contractMonthStartFilterYear?: number, contractMonthStartFilterMonth?: number, contractMonthStartFilterLabel?: string, contractMonthEndFilterYear?: number, contractMonthEndFilterMonth?: number, contractMonthEndFilterLabel?: string, positionTypesFilter?: Array<PositionType>, dealTicketNumberFilter?: string, dealTicketIdFilter?: number, sideFilter?: Side, validatedFilter?: boolean, currencyFilter?: Array<Currency>, currency?: Currency, expiryStatus?: ExpiryStatus, includeAllocations?: boolean, includeAllocationOffset?: boolean, filterByTradeDate?: boolean, pricingStartDateStartFilter?: string, pricingStartDateEndFilter?: string, pricingEndDateStartFilter?: string, pricingEndDateEndFilter?: string, options?: any): AxiosPromise<FileResponse> {
            return localVarFp.getPositionExcelExport(quoteDate, includeExpirationDates, includeMarketPrices, useDisplayUnits, scenarioMarketPrices, commoditiesFilter, locationsFilter, counterpartiesFilter, tradeDateStartFilter, tradeDateEndFilter, budgetMonthStartFilterYear, budgetMonthStartFilterMonth, budgetMonthStartFilterLabel, budgetMonthEndFilterYear, budgetMonthEndFilterMonth, budgetMonthEndFilterLabel, contractMonthStartFilterYear, contractMonthStartFilterMonth, contractMonthStartFilterLabel, contractMonthEndFilterYear, contractMonthEndFilterMonth, contractMonthEndFilterLabel, positionTypesFilter, dealTicketNumberFilter, dealTicketIdFilter, sideFilter, validatedFilter, currencyFilter, currency, expiryStatus, includeAllocations, includeAllocationOffset, filterByTradeDate, pricingStartDateStartFilter, pricingStartDateEndFilter, pricingEndDateStartFilter, pricingEndDateEndFilter, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} quoteDate 
         * @param {number} customerReportId 
         * @param {number} [budgetStartMonthYear] 
         * @param {number} [budgetStartMonthMonth] 
         * @param {string} [budgetStartMonthLabel] 
         * @param {number} [budgetEndMonthYear] 
         * @param {number} [budgetEndMonthMonth] 
         * @param {string} [budgetEndMonthLabel] 
         * @param {Array<number>} [commoditiesFilter] 
         * @param {Currency} [currency] 
         * @param {StressIncrementType} [stressIncrementType] 
         * @param {Array<number>} [stressIncrements] 
         * @param {Array<number>} [whatIfStrategyIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getScenarioExcelReport(quoteDate: string, customerReportId: number, budgetStartMonthYear?: number, budgetStartMonthMonth?: number, budgetStartMonthLabel?: string, budgetEndMonthYear?: number, budgetEndMonthMonth?: number, budgetEndMonthLabel?: string, commoditiesFilter?: Array<number>, currency?: Currency, stressIncrementType?: StressIncrementType, stressIncrements?: Array<number>, whatIfStrategyIds?: Array<number>, options?: any): AxiosPromise<FileResponse> {
            return localVarFp.getScenarioExcelReport(quoteDate, customerReportId, budgetStartMonthYear, budgetStartMonthMonth, budgetStartMonthLabel, budgetEndMonthYear, budgetEndMonthMonth, budgetEndMonthLabel, commoditiesFilter, currency, stressIncrementType, stressIncrements, whatIfStrategyIds, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getScenarioMarketPricesExcelTemplate(options?: any): AxiosPromise<FileResponse> {
            return localVarFp.getScenarioMarketPricesExcelTemplate(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} quoteDate 
         * @param {number} customerReportId 
         * @param {number} [budgetStartMonthYear] 
         * @param {number} [budgetStartMonthMonth] 
         * @param {string} [budgetStartMonthLabel] 
         * @param {number} [budgetEndMonthYear] 
         * @param {number} [budgetEndMonthMonth] 
         * @param {string} [budgetEndMonthLabel] 
         * @param {Array<number>} [commoditiesFilter] 
         * @param {Currency} [currency] 
         * @param {StressIncrementType} [stressIncrementType] 
         * @param {Array<number>} [stressIncrements] 
         * @param {Array<number>} [whatIfStrategyIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getScenarioReport(quoteDate: string, customerReportId: number, budgetStartMonthYear?: number, budgetStartMonthMonth?: number, budgetStartMonthLabel?: string, budgetEndMonthYear?: number, budgetEndMonthMonth?: number, budgetEndMonthLabel?: string, commoditiesFilter?: Array<number>, currency?: Currency, stressIncrementType?: StressIncrementType, stressIncrements?: Array<number>, whatIfStrategyIds?: Array<number>, options?: any): AxiosPromise<GetScenarioReportResponse> {
            return localVarFp.getScenarioReport(quoteDate, customerReportId, budgetStartMonthYear, budgetStartMonthMonth, budgetStartMonthLabel, budgetEndMonthYear, budgetEndMonthMonth, budgetEndMonthLabel, commoditiesFilter, currency, stressIncrementType, stressIncrements, whatIfStrategyIds, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} quoteDate 
         * @param {number} customerReportId 
         * @param {number} [budgetStartMonthYear] 
         * @param {number} [budgetStartMonthMonth] 
         * @param {string} [budgetStartMonthLabel] 
         * @param {number} [budgetEndMonthYear] 
         * @param {number} [budgetEndMonthMonth] 
         * @param {string} [budgetEndMonthLabel] 
         * @param {ExpiryStatus} [expiryStatus] 
         * @param {Currency} [currency] 
         * @param {string} [sortColumn] 
         * @param {SortDirection} [sortDirection] 
         * @param {number} [take] 
         * @param {number} [skip] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSummaryExcelReport(quoteDate: string, customerReportId: number, budgetStartMonthYear?: number, budgetStartMonthMonth?: number, budgetStartMonthLabel?: string, budgetEndMonthYear?: number, budgetEndMonthMonth?: number, budgetEndMonthLabel?: string, expiryStatus?: ExpiryStatus, currency?: Currency, sortColumn?: string, sortDirection?: SortDirection, take?: number, skip?: number, options?: any): AxiosPromise<FileResponse> {
            return localVarFp.getSummaryExcelReport(quoteDate, customerReportId, budgetStartMonthYear, budgetStartMonthMonth, budgetStartMonthLabel, budgetEndMonthYear, budgetEndMonthMonth, budgetEndMonthLabel, expiryStatus, currency, sortColumn, sortDirection, take, skip, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} quoteDate 
         * @param {number} numberOfMonths 
         * @param {number} minimumPercentage 
         * @param {number} maximumPercentage 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTimeTriggerReport(quoteDate: string, numberOfMonths: number, minimumPercentage: number, maximumPercentage: number, options?: any): AxiosPromise<GetTimeTriggerReportResponse> {
            return localVarFp.getTimeTriggerReport(quoteDate, numberOfMonths, minimumPercentage, maximumPercentage, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} quoteDate 
         * @param {number} customerReportId 
         * @param {number} [budgetStartMonthYear] 
         * @param {number} [budgetStartMonthMonth] 
         * @param {string} [budgetStartMonthLabel] 
         * @param {number} [budgetEndMonthYear] 
         * @param {number} [budgetEndMonthMonth] 
         * @param {string} [budgetEndMonthLabel] 
         * @param {ExpiryStatus} [expiryStatus] 
         * @param {Currency} [currency] 
         * @param {string} [sortColumn] 
         * @param {SortDirection} [sortDirection] 
         * @param {number} [take] 
         * @param {number} [skip] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVarianceExcelReport(quoteDate: string, customerReportId: number, budgetStartMonthYear?: number, budgetStartMonthMonth?: number, budgetStartMonthLabel?: string, budgetEndMonthYear?: number, budgetEndMonthMonth?: number, budgetEndMonthLabel?: string, expiryStatus?: ExpiryStatus, currency?: Currency, sortColumn?: string, sortDirection?: SortDirection, take?: number, skip?: number, options?: any): AxiosPromise<FileResponse> {
            return localVarFp.getVarianceExcelReport(quoteDate, customerReportId, budgetStartMonthYear, budgetStartMonthMonth, budgetStartMonthLabel, budgetEndMonthYear, budgetEndMonthMonth, budgetEndMonthLabel, expiryStatus, currency, sortColumn, sortDirection, take, skip, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} quoteDate 
         * @param {number} customerReportId 
         * @param {number} [budgetStartMonthYear] 
         * @param {number} [budgetStartMonthMonth] 
         * @param {string} [budgetStartMonthLabel] 
         * @param {number} [budgetEndMonthYear] 
         * @param {number} [budgetEndMonthMonth] 
         * @param {string} [budgetEndMonthLabel] 
         * @param {ExpiryStatus} [expiryStatus] 
         * @param {Currency} [currency] 
         * @param {string} [sortColumn] 
         * @param {SortDirection} [sortDirection] 
         * @param {number} [take] 
         * @param {number} [skip] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVarianceReport(quoteDate: string, customerReportId: number, budgetStartMonthYear?: number, budgetStartMonthMonth?: number, budgetStartMonthLabel?: string, budgetEndMonthYear?: number, budgetEndMonthMonth?: number, budgetEndMonthLabel?: string, expiryStatus?: ExpiryStatus, currency?: Currency, sortColumn?: string, sortDirection?: SortDirection, take?: number, skip?: number, options?: any): AxiosPromise<GetVarianceReportResponse> {
            return localVarFp.getVarianceReport(quoteDate, customerReportId, budgetStartMonthYear, budgetStartMonthMonth, budgetStartMonthLabel, budgetEndMonthYear, budgetEndMonthMonth, budgetEndMonthLabel, expiryStatus, currency, sortColumn, sortDirection, take, skip, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Array<number>} [commoditiesFilter] 
         * @param {Array<number>} [locationsFilter] 
         * @param {Array<number>} [counterpartiesFilter] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAllocations(commoditiesFilter?: Array<number>, locationsFilter?: Array<number>, counterpartiesFilter?: Array<number>, options?: any): AxiosPromise<ListAllocationsResponse> {
            return localVarFp.listAllocations(commoditiesFilter, locationsFilter, counterpartiesFilter, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [commodityId] 
         * @param {number} [locationId] 
         * @param {number} [counterpartyId] 
         * @param {number} [portfolioId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listBudgetYearAllotmentProperties(commodityId?: number, locationId?: number, counterpartyId?: number, portfolioId?: number, options?: any): AxiosPromise<ListBudgetYearAllotmentPropertiesResponse> {
            return localVarFp.listBudgetYearAllotmentProperties(commodityId, locationId, counterpartyId, portfolioId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [locationId] 
         * @param {number} [commodityId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listBudgetYears(locationId?: number, commodityId?: number, options?: any): AxiosPromise<ListBudgetYearsResponse> {
            return localVarFp.listBudgetYears(locationId, commodityId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [quoteDate] 
         * @param {number} [budgetStartMonthYear] 
         * @param {number} [budgetStartMonthMonth] 
         * @param {string} [budgetStartMonthLabel] 
         * @param {number} [budgetEndMonthYear] 
         * @param {number} [budgetEndMonthMonth] 
         * @param {string} [budgetEndMonthLabel] 
         * @param {Array<number>} [fiscalYearsFilter] 
         * @param {Array<number>} [commoditiesFilter] 
         * @param {Array<number>} [locationsFilter] 
         * @param {Array<number>} [counterpartiesFilter] 
         * @param {Array<number>} [budgetRoundsFilter] 
         * @param {boolean} [includeExpirationDates] 
         * @param {boolean} [includePositions] 
         * @param {boolean} [includeMarketPrices] 
         * @param {boolean} [includeBudgetRounds] 
         * @param {ExpiryStatus} [expiryStatus] 
         * @param {Currency} [currency] 
         * @param {Unit} [unit] 
         * @param {string} [note] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listBudgets(quoteDate?: string, budgetStartMonthYear?: number, budgetStartMonthMonth?: number, budgetStartMonthLabel?: string, budgetEndMonthYear?: number, budgetEndMonthMonth?: number, budgetEndMonthLabel?: string, fiscalYearsFilter?: Array<number>, commoditiesFilter?: Array<number>, locationsFilter?: Array<number>, counterpartiesFilter?: Array<number>, budgetRoundsFilter?: Array<number>, includeExpirationDates?: boolean, includePositions?: boolean, includeMarketPrices?: boolean, includeBudgetRounds?: boolean, expiryStatus?: ExpiryStatus, currency?: Currency, unit?: Unit, note?: string, options?: any): AxiosPromise<ListBudgetsResponse> {
            return localVarFp.listBudgets(quoteDate, budgetStartMonthYear, budgetStartMonthMonth, budgetStartMonthLabel, budgetEndMonthYear, budgetEndMonthMonth, budgetEndMonthLabel, fiscalYearsFilter, commoditiesFilter, locationsFilter, counterpartiesFilter, budgetRoundsFilter, includeExpirationDates, includePositions, includeMarketPrices, includeBudgetRounds, expiryStatus, currency, unit, note, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [commodityId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCommodityContractMonthMappings(commodityId?: number, options?: any): AxiosPromise<ListCommodityContractMonthMappingsResponse> {
            return localVarFp.listCommodityContractMonthMappings(commodityId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCustomers(options?: any): AxiosPromise<ListKnowRiskEnergyCustomersResponse> {
            return localVarFp.listCustomers(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listDefaultBudgetRounds(options?: any): AxiosPromise<ListDefaultBudgetRoundsResponse> {
            return localVarFp.listDefaultBudgetRounds(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [vendorFilter] 
         * @param {string} [plantFilter] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listDeliveries(vendorFilter?: string, plantFilter?: string, options?: any): AxiosPromise<ListDeliveriesResponse> {
            return localVarFp.listDeliveries(vendorFilter, plantFilter, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [entityFilter] 
         * @param {number} [entityIdFilter] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listDocuments(entityFilter?: string, entityIdFilter?: number, options?: any): AxiosPromise<ListDocumentsResponse> {
            return localVarFp.listDocuments(entityFilter, entityIdFilter, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [sortColumn] 
         * @param {SortDirection} [sortDirection] 
         * @param {number} [take] 
         * @param {number} [skip] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listEiaNaturalGasStorageWeeks(sortColumn?: string, sortDirection?: SortDirection, take?: number, skip?: number, options?: any): AxiosPromise<ListEiaNaturalGasStorageWeeksResponse> {
            return localVarFp.listEiaNaturalGasStorageWeeks(sortColumn, sortDirection, take, skip, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} hedgePlanId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listHedgePlanData(hedgePlanId: string, options?: any): AxiosPromise<ListHedgePlanDataResponse> {
            return localVarFp.listHedgePlanData(hedgePlanId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} hedgePlanId 
         * @param {string} [asOfDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listHedgePlanSeasons(hedgePlanId: string, asOfDate?: string, options?: any): AxiosPromise<ListHedgePlanSeasonsResponse> {
            return localVarFp.listHedgePlanSeasons(hedgePlanId, asOfDate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} companyGuid 
         * @param {string} [sortColumn] 
         * @param {SortDirection} [sortDirection] 
         * @param {number} [take] 
         * @param {number} [skip] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listHedgePlans(companyGuid: string, sortColumn?: string, sortDirection?: SortDirection, take?: number, skip?: number, options?: any): AxiosPromise<ListHedgePlansResponse> {
            return localVarFp.listHedgePlans(companyGuid, sortColumn, sortDirection, take, skip, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} customerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listLocations(customerId: string, options?: any): AxiosPromise<ListKnowRiskEnergyLocationsResponse> {
            return localVarFp.listLocations(customerId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listNotes(options?: any): AxiosPromise<ListNotesResponse> {
            return localVarFp.listNotes(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [commodityId] 
         * @param {number} [locationId] 
         * @param {number} [counterpartyId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPositionYears(commodityId?: number, locationId?: number, counterpartyId?: number, options?: any): AxiosPromise<ListPositionYearsResponse> {
            return localVarFp.listPositionYears(commodityId, locationId, counterpartyId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [quoteDate] 
         * @param {boolean} [includeExpirationDates] 
         * @param {boolean} [includeMarketPrices] 
         * @param {boolean} [useDisplayUnits] 
         * @param {Array<ScenarioMarketPriceModel>} [scenarioMarketPrices] 
         * @param {Array<number>} [commoditiesFilter] 
         * @param {Array<number>} [locationsFilter] 
         * @param {Array<number>} [counterpartiesFilter] 
         * @param {string} [tradeDateStartFilter] 
         * @param {string} [tradeDateEndFilter] 
         * @param {number} [budgetMonthStartFilterYear] 
         * @param {number} [budgetMonthStartFilterMonth] 
         * @param {string} [budgetMonthStartFilterLabel] 
         * @param {number} [budgetMonthEndFilterYear] 
         * @param {number} [budgetMonthEndFilterMonth] 
         * @param {string} [budgetMonthEndFilterLabel] 
         * @param {number} [contractMonthStartFilterYear] 
         * @param {number} [contractMonthStartFilterMonth] 
         * @param {string} [contractMonthStartFilterLabel] 
         * @param {number} [contractMonthEndFilterYear] 
         * @param {number} [contractMonthEndFilterMonth] 
         * @param {string} [contractMonthEndFilterLabel] 
         * @param {Array<PositionType>} [positionTypesFilter] 
         * @param {string} [dealTicketNumberFilter] 
         * @param {number} [dealTicketIdFilter] 
         * @param {Side} [sideFilter] 
         * @param {boolean} [validatedFilter] 
         * @param {Array<Currency>} [currencyFilter] 
         * @param {Currency} [currency] 
         * @param {ExpiryStatus} [expiryStatus] 
         * @param {boolean} [includeAllocations] 
         * @param {boolean} [includeAllocationOffset] 
         * @param {boolean} [filterByTradeDate] 
         * @param {string} [pricingStartDateStartFilter] 
         * @param {string} [pricingStartDateEndFilter] 
         * @param {string} [pricingEndDateStartFilter] 
         * @param {string} [pricingEndDateEndFilter] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPositions(quoteDate?: string, includeExpirationDates?: boolean, includeMarketPrices?: boolean, useDisplayUnits?: boolean, scenarioMarketPrices?: Array<ScenarioMarketPriceModel>, commoditiesFilter?: Array<number>, locationsFilter?: Array<number>, counterpartiesFilter?: Array<number>, tradeDateStartFilter?: string, tradeDateEndFilter?: string, budgetMonthStartFilterYear?: number, budgetMonthStartFilterMonth?: number, budgetMonthStartFilterLabel?: string, budgetMonthEndFilterYear?: number, budgetMonthEndFilterMonth?: number, budgetMonthEndFilterLabel?: string, contractMonthStartFilterYear?: number, contractMonthStartFilterMonth?: number, contractMonthStartFilterLabel?: string, contractMonthEndFilterYear?: number, contractMonthEndFilterMonth?: number, contractMonthEndFilterLabel?: string, positionTypesFilter?: Array<PositionType>, dealTicketNumberFilter?: string, dealTicketIdFilter?: number, sideFilter?: Side, validatedFilter?: boolean, currencyFilter?: Array<Currency>, currency?: Currency, expiryStatus?: ExpiryStatus, includeAllocations?: boolean, includeAllocationOffset?: boolean, filterByTradeDate?: boolean, pricingStartDateStartFilter?: string, pricingStartDateEndFilter?: string, pricingEndDateStartFilter?: string, pricingEndDateEndFilter?: string, options?: any): AxiosPromise<ListPositionsResponse> {
            return localVarFp.listPositions(quoteDate, includeExpirationDates, includeMarketPrices, useDisplayUnits, scenarioMarketPrices, commoditiesFilter, locationsFilter, counterpartiesFilter, tradeDateStartFilter, tradeDateEndFilter, budgetMonthStartFilterYear, budgetMonthStartFilterMonth, budgetMonthStartFilterLabel, budgetMonthEndFilterYear, budgetMonthEndFilterMonth, budgetMonthEndFilterLabel, contractMonthStartFilterYear, contractMonthStartFilterMonth, contractMonthStartFilterLabel, contractMonthEndFilterYear, contractMonthEndFilterMonth, contractMonthEndFilterLabel, positionTypesFilter, dealTicketNumberFilter, dealTicketIdFilter, sideFilter, validatedFilter, currencyFilter, currency, expiryStatus, includeAllocations, includeAllocationOffset, filterByTradeDate, pricingStartDateStartFilter, pricingStartDateEndFilter, pricingEndDateStartFilter, pricingEndDateEndFilter, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPricingStrategies(options?: any): AxiosPromise<ListPricingStrategiesResponse> {
            return localVarFp.listPricingStrategies(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {any} scenarioMarketPricesFile 
         * @param {string} [sortColumn] 
         * @param {SortDirection} [sortDirection] 
         * @param {number} [take] 
         * @param {number} [skip] 
         * @param {boolean} [validationResponseIsValid] 
         * @param {string} [validationResponseValidationMessage] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listScenarioMarketPricesFromUpload(scenarioMarketPricesFile: any, sortColumn?: string, sortDirection?: SortDirection, take?: number, skip?: number, validationResponseIsValid?: boolean, validationResponseValidationMessage?: string, options?: any): AxiosPromise<ListScenarioMarketPricesFromUploadResponse> {
            return localVarFp.listScenarioMarketPricesFromUpload(scenarioMarketPricesFile, sortColumn, sortDirection, take, skip, validationResponseIsValid, validationResponseValidationMessage, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listWhatIfStrategies(options?: any): AxiosPromise<ListWhatIfStrategyResponse> {
            return localVarFp.listWhatIfStrategies(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} customerReportId 
         * @param {SendCommodityManagementReportEmailRequest} [sendCommodityManagementReportEmailRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendCommodityManagementReportEmail(customerReportId: string, sendCommodityManagementReportEmailRequest?: SendCommodityManagementReportEmailRequest, options?: any): AxiosPromise<SendCommodityManagementReportEmailResponse> {
            return localVarFp.sendCommodityManagementReportEmail(customerReportId, sendCommodityManagementReportEmailRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UpdateBudgetRoundRequest} [updateBudgetRoundRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateBudgetRound(updateBudgetRoundRequest?: UpdateBudgetRoundRequest, options?: any): AxiosPromise<UodateBudgetRoundResponse> {
            return localVarFp.updateBudgetRound(updateBudgetRoundRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UpdateBudgetsRequest} [updateBudgetsRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateBudgets(updateBudgetsRequest?: UpdateBudgetsRequest, options?: any): AxiosPromise<object> {
            return localVarFp.updateBudgets(updateBudgetsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} commodityId 
         * @param {string} commodityName 
         * @param {Unit} displayUnit 
         * @param {number} displayPrecision 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCommodity(commodityId: string, commodityName: string, displayUnit: Unit, displayPrecision: number, options?: any): AxiosPromise<UpdateCommodityResponse> {
            return localVarFp.updateCommodity(commodityId, commodityName, displayUnit, displayPrecision, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} commodityId 
         * @param {UpdateCommodityContractMonthMappingsRequest} [updateCommodityContractMonthMappingsRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCommodityContractMonthMappings(commodityId: string, updateCommodityContractMonthMappingsRequest?: UpdateCommodityContractMonthMappingsRequest, options?: any): AxiosPromise<UpdateCommodityContractMonthMappingsResponse> {
            return localVarFp.updateCommodityContractMonthMappings(commodityId, updateCommodityContractMonthMappingsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} counterpartyId 
         * @param {string} counterpartyName 
         * @param {number} [creditLimit] 
         * @param {boolean} [netting] 
         * @param {boolean} [setoff] 
         * @param {boolean} [active] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCounterparty(counterpartyId: string, counterpartyName: string, creditLimit?: number, netting?: boolean, setoff?: boolean, active?: boolean, options?: any): AxiosPromise<UpdateCounterpartyResponse> {
            return localVarFp.updateCounterparty(counterpartyId, counterpartyName, creditLimit, netting, setoff, active, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UpdateCustomerReportRequest} [updateCustomerReportRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCustomerReport(updateCustomerReportRequest?: UpdateCustomerReportRequest, options?: any): AxiosPromise<UpdateCustomerReportResponse> {
            return localVarFp.updateCustomerReport(updateCustomerReportRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} customerReportId 
         * @param {string} [overrides] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCustomerReportUserOverrides(customerReportId: number, overrides?: string, options?: any): AxiosPromise<object> {
            return localVarFp.updateCustomerReportUserOverrides(customerReportId, overrides, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UpdateCustomerSettingsRequest} [updateCustomerSettingsRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCustomerSettings(updateCustomerSettingsRequest?: UpdateCustomerSettingsRequest, options?: any): AxiosPromise<UpdateCustomerSettingsResponse> {
            return localVarFp.updateCustomerSettings(updateCustomerSettingsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} dealTicketId 
         * @param {Array<number>} [validatedPositionIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDealTicketPositionValidation(dealTicketId: string, validatedPositionIds?: Array<number>, options?: any): AxiosPromise<object> {
            return localVarFp.updateDealTicketPositionValidation(dealTicketId, validatedPositionIds, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UpdateDefaultBudgetRoundsRequest} [updateDefaultBudgetRoundsRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDefaultBudgetRounds(updateDefaultBudgetRoundsRequest?: UpdateDefaultBudgetRoundsRequest, options?: any): AxiosPromise<object> {
            return localVarFp.updateDefaultBudgetRounds(updateDefaultBudgetRoundsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UpdateDeliveriesRequest} [updateDeliveriesRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDeliveries(updateDeliveriesRequest?: UpdateDeliveriesRequest, options?: any): AxiosPromise<object> {
            return localVarFp.updateDeliveries(updateDeliveriesRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UpdateHedgePlanRequest} [updateHedgePlanRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateHedgePlan(updateHedgePlanRequest?: UpdateHedgePlanRequest, options?: any): AxiosPromise<UpdateHedgePlanResponse> {
            return localVarFp.updateHedgePlan(updateHedgePlanRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} hedgePlanId 
         * @param {string} year 
         * @param {UpdateHedgePlanBudgetTriggersRequest} [updateHedgePlanBudgetTriggersRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateHedgePlanBudgetTriggers(hedgePlanId: string, year: string, updateHedgePlanBudgetTriggersRequest?: UpdateHedgePlanBudgetTriggersRequest, options?: any): AxiosPromise<UpdateHedgePlanBudgetTriggersResponse> {
            return localVarFp.updateHedgePlanBudgetTriggers(hedgePlanId, year, updateHedgePlanBudgetTriggersRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} hedgePlanId 
         * @param {string} year 
         * @param {UpdateHedgePlanSeasonSettingsRequest} [updateHedgePlanSeasonSettingsRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateHedgePlanSeasonSettings(hedgePlanId: string, year: string, updateHedgePlanSeasonSettingsRequest?: UpdateHedgePlanSeasonSettingsRequest, options?: any): AxiosPromise<UpdateHedgePlanSeasonSettingsResponse> {
            return localVarFp.updateHedgePlanSeasonSettings(hedgePlanId, year, updateHedgePlanSeasonSettingsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} hedgePlanId 
         * @param {string} year 
         * @param {UpdateHedgePlanTimeTriggersRequest} [updateHedgePlanTimeTriggersRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateHedgePlanTimeTriggers(hedgePlanId: string, year: string, updateHedgePlanTimeTriggersRequest?: UpdateHedgePlanTimeTriggersRequest, options?: any): AxiosPromise<UpdateHedgePlanTimeTriggersResponse> {
            return localVarFp.updateHedgePlanTimeTriggers(hedgePlanId, year, updateHedgePlanTimeTriggersRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} hedgePlanId 
         * @param {string} year 
         * @param {UpdateHedgePlanTradesRequest} [updateHedgePlanTradesRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateHedgePlanTrades(hedgePlanId: string, year: string, updateHedgePlanTradesRequest?: UpdateHedgePlanTradesRequest, options?: any): AxiosPromise<UpdateHedgePlanTradesResponse> {
            return localVarFp.updateHedgePlanTrades(hedgePlanId, year, updateHedgePlanTradesRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} hedgePlanId 
         * @param {string} year 
         * @param {UpdateHedgePlanValueTriggersRequest} [updateHedgePlanValueTriggersRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateHedgePlanValueTriggers(hedgePlanId: string, year: string, updateHedgePlanValueTriggersRequest?: UpdateHedgePlanValueTriggersRequest, options?: any): AxiosPromise<UpdateHedgePlanValueTriggersResponse> {
            return localVarFp.updateHedgePlanValueTriggers(hedgePlanId, year, updateHedgePlanValueTriggersRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} locationId 
         * @param {string} locationName 
         * @param {number} tierId 
         * @param {number} [parentLocationId] 
         * @param {boolean} [active] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateLocation(locationId: string, locationName: string, tierId: number, parentLocationId?: number, active?: boolean, options?: any): AxiosPromise<UpdateLocationResponse> {
            return localVarFp.updateLocation(locationId, locationName, tierId, parentLocationId, active, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} noteId 
         * @param {string} subject 
         * @param {string} content 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateNote(noteId: string, subject: string, content: string, options?: any): AxiosPromise<UpdateNoteResponse> {
            return localVarFp.updateNote(noteId, subject, content, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} portfolioId 
         * @param {string} portfolioName 
         * @param {boolean} [active] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePortfolio(portfolioId: string, portfolioName: string, active?: boolean, options?: any): AxiosPromise<UpdatePortfolioResponse> {
            return localVarFp.updatePortfolio(portfolioId, portfolioName, active, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UpdatePricingStrategiesRequest} [updatePricingStrategiesRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePricingStrategies(updatePricingStrategiesRequest?: UpdatePricingStrategiesRequest, options?: any): AxiosPromise<UpdatePricingStrategiesResponse> {
            return localVarFp.updatePricingStrategies(updatePricingStrategiesRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} tierId 
         * @param {string} tierName 
         * @param {number} tierRank 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTier(tierId: string, tierName: string, tierRank: number, options?: any): AxiosPromise<UpdateTierResponse> {
            return localVarFp.updateTier(tierId, tierName, tierRank, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UpdateWhatIfStrategyRequest} [updateWhatIfStrategyRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateWhatIfStrategy(updateWhatIfStrategyRequest?: UpdateWhatIfStrategyRequest, options?: any): AxiosPromise<UpdateWhatIfStrategyResponse> {
            return localVarFp.updateWhatIfStrategy(updateWhatIfStrategyRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} entityName 
         * @param {string} documentUrl 
         * @param {any} file 
         * @param {number} [entityId] 
         * @param {string} [description] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        upload(entityName: string, documentUrl: string, file: any, entityId?: number, description?: string, options?: any): AxiosPromise<UpdateDocumentsResponse> {
            return localVarFp.upload(entityName, documentUrl, file, entityId, description, options).then((request) => request(axios, basePath));
        },
    };
};



/**
 * CommodityManagementApi - object-oriented interface
 * @export
 * @class CommodityManagementApi
 * @extends {BaseAPI}
 */
export class CommodityManagementApi extends BaseAPI {
    /**
     * 
     * @param {UpdateAllocationRequest} [updateAllocationRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommodityManagementApi
     */
    public addAllocation(loadingStateSetter: null | undefined | ((state: LoadingState) => void | undefined | null), updateAllocationRequest?: UpdateAllocationRequest, options?: AxiosRequestConfig) {
        const promise = CommodityManagementApiFp(this.configuration).addAllocation(updateAllocationRequest, options).then((request) => request(this.axios, this.basePath));

        if (loadingStateSetter) {
            loadingStateSetter(LoadingState.Loading);
            promise.then(q => loadingStateSetter(LoadingState.Loaded));
            promise.catch(q => loadingStateSetter(LoadingState.Failed));
        }

        return promise;
    }

    /**
     * 
     * @param {UpdateAllocationGroupRequest} [updateAllocationGroupRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommodityManagementApi
     */
    public addAllocationGroup(loadingStateSetter: null | undefined | ((state: LoadingState) => void | undefined | null), updateAllocationGroupRequest?: UpdateAllocationGroupRequest, options?: AxiosRequestConfig) {
        const promise = CommodityManagementApiFp(this.configuration).addAllocationGroup(updateAllocationGroupRequest, options).then((request) => request(this.axios, this.basePath));

        if (loadingStateSetter) {
            loadingStateSetter(LoadingState.Loading);
            promise.then(q => loadingStateSetter(LoadingState.Loaded));
            promise.catch(q => loadingStateSetter(LoadingState.Failed));
        }

        return promise;
    }

    /**
     * 
     * @param {string} commodityName 
     * @param {Unit} displayUnit 
     * @param {number} displayPrecision 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommodityManagementApi
     */
    public addCommodity(loadingStateSetter: null | undefined | ((state: LoadingState) => void | undefined | null), commodityName: string, displayUnit: Unit, displayPrecision: number, options?: AxiosRequestConfig) {
        const promise = CommodityManagementApiFp(this.configuration).addCommodity(commodityName, displayUnit, displayPrecision, options).then((request) => request(this.axios, this.basePath));

        if (loadingStateSetter) {
            loadingStateSetter(LoadingState.Loading);
            promise.then(q => loadingStateSetter(LoadingState.Loaded));
            promise.catch(q => loadingStateSetter(LoadingState.Failed));
        }

        return promise;
    }

    /**
     * 
     * @param {string} [counterpartyName] 
     * @param {number} [creditLimit] 
     * @param {boolean} [netting] 
     * @param {boolean} [setoff] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommodityManagementApi
     */
    public addCounterparty(loadingStateSetter: null | undefined | ((state: LoadingState) => void | undefined | null), counterpartyName?: string, creditLimit?: number, netting?: boolean, setoff?: boolean, options?: AxiosRequestConfig) {
        const promise = CommodityManagementApiFp(this.configuration).addCounterparty(counterpartyName, creditLimit, netting, setoff, options).then((request) => request(this.axios, this.basePath));

        if (loadingStateSetter) {
            loadingStateSetter(LoadingState.Loading);
            promise.then(q => loadingStateSetter(LoadingState.Loaded));
            promise.catch(q => loadingStateSetter(LoadingState.Failed));
        }

        return promise;
    }

    /**
     * 
     * @param {string} hedgePlanId 
     * @param {AddHedgePlanSeasonRequest} [addHedgePlanSeasonRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommodityManagementApi
     */
    public addHedgePlanSeason(loadingStateSetter: null | undefined | ((state: LoadingState) => void | undefined | null), hedgePlanId: string, addHedgePlanSeasonRequest?: AddHedgePlanSeasonRequest, options?: AxiosRequestConfig) {
        const promise = CommodityManagementApiFp(this.configuration).addHedgePlanSeason(hedgePlanId, addHedgePlanSeasonRequest, options).then((request) => request(this.axios, this.basePath));

        if (loadingStateSetter) {
            loadingStateSetter(LoadingState.Loading);
            promise.then(q => loadingStateSetter(LoadingState.Loaded));
            promise.catch(q => loadingStateSetter(LoadingState.Failed));
        }

        return promise;
    }

    /**
     * 
     * @param {string} locationName 
     * @param {number} tierId 
     * @param {number} [parentLocationId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommodityManagementApi
     */
    public addLocation(loadingStateSetter: null | undefined | ((state: LoadingState) => void | undefined | null), locationName: string, tierId: number, parentLocationId?: number, options?: AxiosRequestConfig) {
        const promise = CommodityManagementApiFp(this.configuration).addLocation(locationName, tierId, parentLocationId, options).then((request) => request(this.axios, this.basePath));

        if (loadingStateSetter) {
            loadingStateSetter(LoadingState.Loading);
            promise.then(q => loadingStateSetter(LoadingState.Loaded));
            promise.catch(q => loadingStateSetter(LoadingState.Failed));
        }

        return promise;
    }

    /**
     * 
     * @param {AddNoteRequest} [addNoteRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommodityManagementApi
     */
    public addNote(loadingStateSetter: null | undefined | ((state: LoadingState) => void | undefined | null), addNoteRequest?: AddNoteRequest, options?: AxiosRequestConfig) {
        const promise = CommodityManagementApiFp(this.configuration).addNote(addNoteRequest, options).then((request) => request(this.axios, this.basePath));

        if (loadingStateSetter) {
            loadingStateSetter(LoadingState.Loading);
            promise.then(q => loadingStateSetter(LoadingState.Loaded));
            promise.catch(q => loadingStateSetter(LoadingState.Failed));
        }

        return promise;
    }

    /**
     * 
     * @param {string} portfolioName 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommodityManagementApi
     */
    public addPortfolio(loadingStateSetter: null | undefined | ((state: LoadingState) => void | undefined | null), portfolioName: string, options?: AxiosRequestConfig) {
        const promise = CommodityManagementApiFp(this.configuration).addPortfolio(portfolioName, options).then((request) => request(this.axios, this.basePath));

        if (loadingStateSetter) {
            loadingStateSetter(LoadingState.Loading);
            promise.then(q => loadingStateSetter(LoadingState.Loaded));
            promise.catch(q => loadingStateSetter(LoadingState.Failed));
        }

        return promise;
    }

    /**
     * 
     * @param {number} tierRank 
     * @param {string} [tierName] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommodityManagementApi
     */
    public addTier(loadingStateSetter: null | undefined | ((state: LoadingState) => void | undefined | null), tierRank: number, tierName?: string, options?: AxiosRequestConfig) {
        const promise = CommodityManagementApiFp(this.configuration).addTier(tierRank, tierName, options).then((request) => request(this.axios, this.basePath));

        if (loadingStateSetter) {
            loadingStateSetter(LoadingState.Loading);
            promise.then(q => loadingStateSetter(LoadingState.Loaded));
            promise.catch(q => loadingStateSetter(LoadingState.Failed));
        }

        return promise;
    }

    /**
     * 
     * @param {UpdateDealTicketRequest} [updateDealTicketRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommodityManagementApi
     */
    public addTrade(loadingStateSetter: null | undefined | ((state: LoadingState) => void | undefined | null), updateDealTicketRequest?: UpdateDealTicketRequest, options?: AxiosRequestConfig) {
        const promise = CommodityManagementApiFp(this.configuration).addTrade(updateDealTicketRequest, options).then((request) => request(this.axios, this.basePath));

        if (loadingStateSetter) {
            loadingStateSetter(LoadingState.Loading);
            promise.then(q => loadingStateSetter(LoadingState.Loaded));
            promise.catch(q => loadingStateSetter(LoadingState.Failed));
        }

        return promise;
    }

    /**
     * 
     * @param {Array<number>} customerReportIds 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommodityManagementApi
     */
    public copyCustomerReports(loadingStateSetter: null | undefined | ((state: LoadingState) => void | undefined | null), customerReportIds: Array<number>, options?: AxiosRequestConfig) {
        const promise = CommodityManagementApiFp(this.configuration).copyCustomerReports(customerReportIds, options).then((request) => request(this.axios, this.basePath));

        if (loadingStateSetter) {
            loadingStateSetter(LoadingState.Loading);
            promise.then(q => loadingStateSetter(LoadingState.Loaded));
            promise.catch(q => loadingStateSetter(LoadingState.Failed));
        }

        return promise;
    }

    /**
     * 
     * @param {string} commodityId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommodityManagementApi
     */
    public deleteCommodity(loadingStateSetter: null | undefined | ((state: LoadingState) => void | undefined | null), commodityId: string, options?: AxiosRequestConfig) {
        const promise = CommodityManagementApiFp(this.configuration).deleteCommodity(commodityId, options).then((request) => request(this.axios, this.basePath));

        if (loadingStateSetter) {
            loadingStateSetter(LoadingState.Loading);
            promise.then(q => loadingStateSetter(LoadingState.Loaded));
            promise.catch(q => loadingStateSetter(LoadingState.Failed));
        }

        return promise;
    }

    /**
     * 
     * @param {string} counterpartyId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommodityManagementApi
     */
    public deleteCounterparty(loadingStateSetter: null | undefined | ((state: LoadingState) => void | undefined | null), counterpartyId: string, options?: AxiosRequestConfig) {
        const promise = CommodityManagementApiFp(this.configuration).deleteCounterparty(counterpartyId, options).then((request) => request(this.axios, this.basePath));

        if (loadingStateSetter) {
            loadingStateSetter(LoadingState.Loading);
            promise.then(q => loadingStateSetter(LoadingState.Loaded));
            promise.catch(q => loadingStateSetter(LoadingState.Failed));
        }

        return promise;
    }

    /**
     * 
     * @param {string} customerReportId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommodityManagementApi
     */
    public deleteCustomerReport(loadingStateSetter: null | undefined | ((state: LoadingState) => void | undefined | null), customerReportId: string, options?: AxiosRequestConfig) {
        const promise = CommodityManagementApiFp(this.configuration).deleteCustomerReport(customerReportId, options).then((request) => request(this.axios, this.basePath));

        if (loadingStateSetter) {
            loadingStateSetter(LoadingState.Loading);
            promise.then(q => loadingStateSetter(LoadingState.Loaded));
            promise.catch(q => loadingStateSetter(LoadingState.Failed));
        }

        return promise;
    }

    /**
     * 
     * @param {string} dealTicketId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommodityManagementApi
     */
    public deleteDealTicket(loadingStateSetter: null | undefined | ((state: LoadingState) => void | undefined | null), dealTicketId: string, options?: AxiosRequestConfig) {
        const promise = CommodityManagementApiFp(this.configuration).deleteDealTicket(dealTicketId, options).then((request) => request(this.axios, this.basePath));

        if (loadingStateSetter) {
            loadingStateSetter(LoadingState.Loading);
            promise.then(q => loadingStateSetter(LoadingState.Loaded));
            promise.catch(q => loadingStateSetter(LoadingState.Failed));
        }

        return promise;
    }

    /**
     * 
     * @param {string} hedgePlanId 
     * @param {number} year 
     * @param {MatrixTerm} [term] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommodityManagementApi
     */
    public deleteHedgePlanSeason(loadingStateSetter: null | undefined | ((state: LoadingState) => void | undefined | null), hedgePlanId: string, year: number, term?: MatrixTerm, options?: AxiosRequestConfig) {
        const promise = CommodityManagementApiFp(this.configuration).deleteHedgePlanSeason(hedgePlanId, year, term, options).then((request) => request(this.axios, this.basePath));

        if (loadingStateSetter) {
            loadingStateSetter(LoadingState.Loading);
            promise.then(q => loadingStateSetter(LoadingState.Loaded));
            promise.catch(q => loadingStateSetter(LoadingState.Failed));
        }

        return promise;
    }

    /**
     * 
     * @param {string} locationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommodityManagementApi
     */
    public deleteLocation(loadingStateSetter: null | undefined | ((state: LoadingState) => void | undefined | null), locationId: string, options?: AxiosRequestConfig) {
        const promise = CommodityManagementApiFp(this.configuration).deleteLocation(locationId, options).then((request) => request(this.axios, this.basePath));

        if (loadingStateSetter) {
            loadingStateSetter(LoadingState.Loading);
            promise.then(q => loadingStateSetter(LoadingState.Loaded));
            promise.catch(q => loadingStateSetter(LoadingState.Failed));
        }

        return promise;
    }

    /**
     * 
     * @param {string} noteId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommodityManagementApi
     */
    public deleteNote(loadingStateSetter: null | undefined | ((state: LoadingState) => void | undefined | null), noteId: string, options?: AxiosRequestConfig) {
        const promise = CommodityManagementApiFp(this.configuration).deleteNote(noteId, options).then((request) => request(this.axios, this.basePath));

        if (loadingStateSetter) {
            loadingStateSetter(LoadingState.Loading);
            promise.then(q => loadingStateSetter(LoadingState.Loaded));
            promise.catch(q => loadingStateSetter(LoadingState.Failed));
        }

        return promise;
    }

    /**
     * 
     * @param {string} portfolioId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommodityManagementApi
     */
    public deletePortfolio(loadingStateSetter: null | undefined | ((state: LoadingState) => void | undefined | null), portfolioId: string, options?: AxiosRequestConfig) {
        const promise = CommodityManagementApiFp(this.configuration).deletePortfolio(portfolioId, options).then((request) => request(this.axios, this.basePath));

        if (loadingStateSetter) {
            loadingStateSetter(LoadingState.Loading);
            promise.then(q => loadingStateSetter(LoadingState.Loaded));
            promise.catch(q => loadingStateSetter(LoadingState.Failed));
        }

        return promise;
    }

    /**
     * 
     * @param {string} budgetPricingStrategyId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommodityManagementApi
     */
    public deletePricingStrategy(loadingStateSetter: null | undefined | ((state: LoadingState) => void | undefined | null), budgetPricingStrategyId: string, options?: AxiosRequestConfig) {
        const promise = CommodityManagementApiFp(this.configuration).deletePricingStrategy(budgetPricingStrategyId, options).then((request) => request(this.axios, this.basePath));

        if (loadingStateSetter) {
            loadingStateSetter(LoadingState.Loading);
            promise.then(q => loadingStateSetter(LoadingState.Loaded));
            promise.catch(q => loadingStateSetter(LoadingState.Failed));
        }

        return promise;
    }

    /**
     * 
     * @param {string} tierId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommodityManagementApi
     */
    public deleteTier(loadingStateSetter: null | undefined | ((state: LoadingState) => void | undefined | null), tierId: string, options?: AxiosRequestConfig) {
        const promise = CommodityManagementApiFp(this.configuration).deleteTier(tierId, options).then((request) => request(this.axios, this.basePath));

        if (loadingStateSetter) {
            loadingStateSetter(LoadingState.Loading);
            promise.then(q => loadingStateSetter(LoadingState.Loaded));
            promise.catch(q => loadingStateSetter(LoadingState.Failed));
        }

        return promise;
    }

    /**
     * 
     * @param {string} whatIfStrategyId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommodityManagementApi
     */
    public deleteWhatIfStrategy(loadingStateSetter: null | undefined | ((state: LoadingState) => void | undefined | null), whatIfStrategyId: string, options?: AxiosRequestConfig) {
        const promise = CommodityManagementApiFp(this.configuration).deleteWhatIfStrategy(whatIfStrategyId, options).then((request) => request(this.axios, this.basePath));

        if (loadingStateSetter) {
            loadingStateSetter(LoadingState.Loading);
            promise.then(q => loadingStateSetter(LoadingState.Loaded));
            promise.catch(q => loadingStateSetter(LoadingState.Failed));
        }

        return promise;
    }

    /**
     * 
     * @param {string} [documentUrl] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommodityManagementApi
     */
    public downloadDocument(loadingStateSetter: null | undefined | ((state: LoadingState) => void | undefined | null), documentUrl?: string, options?: AxiosRequestConfig) {
        const promise = CommodityManagementApiFp(this.configuration).downloadDocument(documentUrl, options).then((request) => request(this.axios, this.basePath));

        if (loadingStateSetter) {
            loadingStateSetter(LoadingState.Loading);
            promise.then(q => loadingStateSetter(LoadingState.Loaded));
            promise.catch(q => loadingStateSetter(LoadingState.Failed));
        }

        return promise;
    }

    /**
     * 
     * @param {string} entityType 
     * @param {string} entityId 
     * @param {boolean} [includeUnchangedFields] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommodityManagementApi
     */
    public getAuditTrail(loadingStateSetter: null | undefined | ((state: LoadingState) => void | undefined | null), entityType: string, entityId: string, includeUnchangedFields?: boolean, options?: AxiosRequestConfig) {
        const promise = CommodityManagementApiFp(this.configuration).getAuditTrail(entityType, entityId, includeUnchangedFields, options).then((request) => request(this.axios, this.basePath));

        if (loadingStateSetter) {
            loadingStateSetter(LoadingState.Loading);
            promise.then(q => loadingStateSetter(LoadingState.Loaded));
            promise.catch(q => loadingStateSetter(LoadingState.Failed));
        }

        return promise;
    }

    /**
     * 
     * @param {string} entityId 
     * @param {string} [entityType] 
     * @param {boolean} [includeUnchangedFields] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommodityManagementApi
     */
    public getBudgetAuditTrail(loadingStateSetter: null | undefined | ((state: LoadingState) => void | undefined | null), entityId: string, entityType?: string, includeUnchangedFields?: boolean, options?: AxiosRequestConfig) {
        const promise = CommodityManagementApiFp(this.configuration).getBudgetAuditTrail(entityId, entityType, includeUnchangedFields, options).then((request) => request(this.axios, this.basePath));

        if (loadingStateSetter) {
            loadingStateSetter(LoadingState.Loading);
            promise.then(q => loadingStateSetter(LoadingState.Loaded));
            promise.catch(q => loadingStateSetter(LoadingState.Failed));
        }

        return promise;
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommodityManagementApi
     */
    public getCustomerData(loadingStateSetter: null | undefined | ((state: LoadingState) => void | undefined | null), options?: AxiosRequestConfig) {
        const promise = CommodityManagementApiFp(this.configuration).getCustomerData(options).then((request) => request(this.axios, this.basePath));

        if (loadingStateSetter) {
            loadingStateSetter(LoadingState.Loading);
            promise.then(q => loadingStateSetter(LoadingState.Loaded));
            promise.catch(q => loadingStateSetter(LoadingState.Failed));
        }

        return promise;
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommodityManagementApi
     */
    public getCustomerReports(loadingStateSetter: null | undefined | ((state: LoadingState) => void | undefined | null), options?: AxiosRequestConfig) {
        const promise = CommodityManagementApiFp(this.configuration).getCustomerReports(options).then((request) => request(this.axios, this.basePath));

        if (loadingStateSetter) {
            loadingStateSetter(LoadingState.Loading);
            promise.then(q => loadingStateSetter(LoadingState.Loaded));
            promise.catch(q => loadingStateSetter(LoadingState.Failed));
        }

        return promise;
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommodityManagementApi
     */
    public getCustomerSettings(loadingStateSetter: null | undefined | ((state: LoadingState) => void | undefined | null), options?: AxiosRequestConfig) {
        const promise = CommodityManagementApiFp(this.configuration).getCustomerSettings(options).then((request) => request(this.axios, this.basePath));

        if (loadingStateSetter) {
            loadingStateSetter(LoadingState.Loading);
            promise.then(q => loadingStateSetter(LoadingState.Loaded));
            promise.catch(q => loadingStateSetter(LoadingState.Failed));
        }

        return promise;
    }

    /**
     * 
     * @param {string} pricingStartDate 
     * @param {string} pricingEndDate 
     * @param {GetDailyPositionsReportRequest} [getDailyPositionsReportRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommodityManagementApi
     */
    public getDailyPositionsExcelReport(loadingStateSetter: null | undefined | ((state: LoadingState) => void | undefined | null), pricingStartDate: string, pricingEndDate: string, getDailyPositionsReportRequest?: GetDailyPositionsReportRequest, options?: AxiosRequestConfig) {
        const promise = CommodityManagementApiFp(this.configuration).getDailyPositionsExcelReport(pricingStartDate, pricingEndDate, getDailyPositionsReportRequest, options).then((request) => request(this.axios, this.basePath));

        if (loadingStateSetter) {
            loadingStateSetter(LoadingState.Loading);
            promise.then(q => loadingStateSetter(LoadingState.Loaded));
            promise.catch(q => loadingStateSetter(LoadingState.Failed));
        }

        return promise;
    }

    /**
     * 
     * @param {string} pricingStartDate 
     * @param {string} pricingEndDate 
     * @param {GetDailyPositionsReportRequest} [getDailyPositionsReportRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommodityManagementApi
     */
    public getDailyPositionsReport(loadingStateSetter: null | undefined | ((state: LoadingState) => void | undefined | null), pricingStartDate: string, pricingEndDate: string, getDailyPositionsReportRequest?: GetDailyPositionsReportRequest, options?: AxiosRequestConfig) {
        const promise = CommodityManagementApiFp(this.configuration).getDailyPositionsReport(pricingStartDate, pricingEndDate, getDailyPositionsReportRequest, options).then((request) => request(this.axios, this.basePath));

        if (loadingStateSetter) {
            loadingStateSetter(LoadingState.Loading);
            promise.then(q => loadingStateSetter(LoadingState.Loaded));
            promise.catch(q => loadingStateSetter(LoadingState.Failed));
        }

        return promise;
    }

    /**
     * 
     * @param {string} dealTicketId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommodityManagementApi
     */
    public getDealTicket(loadingStateSetter: null | undefined | ((state: LoadingState) => void | undefined | null), dealTicketId: string, options?: AxiosRequestConfig) {
        const promise = CommodityManagementApiFp(this.configuration).getDealTicket(dealTicketId, options).then((request) => request(this.axios, this.basePath));

        if (loadingStateSetter) {
            loadingStateSetter(LoadingState.Loading);
            promise.then(q => loadingStateSetter(LoadingState.Loaded));
            promise.catch(q => loadingStateSetter(LoadingState.Failed));
        }

        return promise;
    }

    /**
     * 
     * @param {string} quoteDate 
     * @param {number} customerReportId 
     * @param {Currency} [currency] 
     * @param {StressIncrementType} [stressIncrementType] 
     * @param {Array<number>} [stressIncrements] 
     * @param {string} [sortColumn] 
     * @param {SortDirection} [sortDirection] 
     * @param {number} [take] 
     * @param {number} [skip] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommodityManagementApi
     */
    public getExposureExcelReport(loadingStateSetter: null | undefined | ((state: LoadingState) => void | undefined | null), quoteDate: string, customerReportId: number, currency?: Currency, stressIncrementType?: StressIncrementType, stressIncrements?: Array<number>, sortColumn?: string, sortDirection?: SortDirection, take?: number, skip?: number, options?: AxiosRequestConfig) {
        const promise = CommodityManagementApiFp(this.configuration).getExposureExcelReport(quoteDate, customerReportId, currency, stressIncrementType, stressIncrements, sortColumn, sortDirection, take, skip, options).then((request) => request(this.axios, this.basePath));

        if (loadingStateSetter) {
            loadingStateSetter(LoadingState.Loading);
            promise.then(q => loadingStateSetter(LoadingState.Loaded));
            promise.catch(q => loadingStateSetter(LoadingState.Failed));
        }

        return promise;
    }

    /**
     * 
     * @param {string} quoteDate 
     * @param {number} customerReportId 
     * @param {Currency} [currency] 
     * @param {StressIncrementType} [stressIncrementType] 
     * @param {Array<number>} [stressIncrements] 
     * @param {string} [sortColumn] 
     * @param {SortDirection} [sortDirection] 
     * @param {number} [take] 
     * @param {number} [skip] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommodityManagementApi
     */
    public getExposureReport(loadingStateSetter: null | undefined | ((state: LoadingState) => void | undefined | null), quoteDate: string, customerReportId: number, currency?: Currency, stressIncrementType?: StressIncrementType, stressIncrements?: Array<number>, sortColumn?: string, sortDirection?: SortDirection, take?: number, skip?: number, options?: AxiosRequestConfig) {
        const promise = CommodityManagementApiFp(this.configuration).getExposureReport(quoteDate, customerReportId, currency, stressIncrementType, stressIncrements, sortColumn, sortDirection, take, skip, options).then((request) => request(this.axios, this.basePath));

        if (loadingStateSetter) {
            loadingStateSetter(LoadingState.Loading);
            promise.then(q => loadingStateSetter(LoadingState.Loaded));
            promise.catch(q => loadingStateSetter(LoadingState.Failed));
        }

        return promise;
    }

    /**
     * 
     * @param {string} hedgePlanId 
     * @param {string} year 
     * @param {string} quoteDate 
     * @param {MatrixTerm} [term] 
     * @param {boolean} [weightByVolume] 
     * @param {boolean} [refreshCache] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommodityManagementApi
     */
    public getHedgePlanReport(loadingStateSetter: null | undefined | ((state: LoadingState) => void | undefined | null), hedgePlanId: string, year: string, quoteDate: string, term?: MatrixTerm, weightByVolume?: boolean, refreshCache?: boolean, options?: AxiosRequestConfig) {
        const promise = CommodityManagementApiFp(this.configuration).getHedgePlanReport(hedgePlanId, year, quoteDate, term, weightByVolume, refreshCache, options).then((request) => request(this.axios, this.basePath));

        if (loadingStateSetter) {
            loadingStateSetter(LoadingState.Loading);
            promise.then(q => loadingStateSetter(LoadingState.Loaded));
            promise.catch(q => loadingStateSetter(LoadingState.Failed));
        }

        return promise;
    }

    /**
     * 
     * @param {string} companyGuid 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommodityManagementApi
     */
    public getLocationsForCompany(loadingStateSetter: null | undefined | ((state: LoadingState) => void | undefined | null), companyGuid: string, options?: AxiosRequestConfig) {
        const promise = CommodityManagementApiFp(this.configuration).getLocationsForCompany(companyGuid, options).then((request) => request(this.axios, this.basePath));

        if (loadingStateSetter) {
            loadingStateSetter(LoadingState.Loading);
            promise.then(q => loadingStateSetter(LoadingState.Loaded));
            promise.catch(q => loadingStateSetter(LoadingState.Failed));
        }

        return promise;
    }

    /**
     * 
     * @param {string} quoteDate 
     * @param {GetMarkToMarketReportRequest} [getMarkToMarketReportRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommodityManagementApi
     */
    public getMarkToMarketExcelReport(loadingStateSetter: null | undefined | ((state: LoadingState) => void | undefined | null), quoteDate: string, getMarkToMarketReportRequest?: GetMarkToMarketReportRequest, options?: AxiosRequestConfig) {
        const promise = CommodityManagementApiFp(this.configuration).getMarkToMarketExcelReport(quoteDate, getMarkToMarketReportRequest, options).then((request) => request(this.axios, this.basePath));

        if (loadingStateSetter) {
            loadingStateSetter(LoadingState.Loading);
            promise.then(q => loadingStateSetter(LoadingState.Loaded));
            promise.catch(q => loadingStateSetter(LoadingState.Failed));
        }

        return promise;
    }

    /**
     * 
     * @param {string} quoteDate 
     * @param {GetMarkToMarketReportRequest} [getMarkToMarketReportRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommodityManagementApi
     */
    public getMarkToMarketReport(loadingStateSetter: null | undefined | ((state: LoadingState) => void | undefined | null), quoteDate: string, getMarkToMarketReportRequest?: GetMarkToMarketReportRequest, options?: AxiosRequestConfig) {
        const promise = CommodityManagementApiFp(this.configuration).getMarkToMarketReport(quoteDate, getMarkToMarketReportRequest, options).then((request) => request(this.axios, this.basePath));

        if (loadingStateSetter) {
            loadingStateSetter(LoadingState.Loading);
            promise.then(q => loadingStateSetter(LoadingState.Loaded));
            promise.catch(q => loadingStateSetter(LoadingState.Failed));
        }

        return promise;
    }

    /**
     * 
     * @param {number} customerReportId 
     * @param {string} [quoteDate] 
     * @param {number} [budgetStartMonthYear] 
     * @param {number} [budgetStartMonthMonth] 
     * @param {string} [budgetStartMonthLabel] 
     * @param {number} [budgetEndMonthYear] 
     * @param {number} [budgetEndMonthMonth] 
     * @param {string} [budgetEndMonthLabel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommodityManagementApi
     */
    public getPiedmontHedgingExcelReport(loadingStateSetter: null | undefined | ((state: LoadingState) => void | undefined | null), customerReportId: number, quoteDate?: string, budgetStartMonthYear?: number, budgetStartMonthMonth?: number, budgetStartMonthLabel?: string, budgetEndMonthYear?: number, budgetEndMonthMonth?: number, budgetEndMonthLabel?: string, options?: AxiosRequestConfig) {
        const promise = CommodityManagementApiFp(this.configuration).getPiedmontHedgingExcelReport(customerReportId, quoteDate, budgetStartMonthYear, budgetStartMonthMonth, budgetStartMonthLabel, budgetEndMonthYear, budgetEndMonthMonth, budgetEndMonthLabel, options).then((request) => request(this.axios, this.basePath));

        if (loadingStateSetter) {
            loadingStateSetter(LoadingState.Loading);
            promise.then(q => loadingStateSetter(LoadingState.Loaded));
            promise.catch(q => loadingStateSetter(LoadingState.Failed));
        }

        return promise;
    }

    /**
     * 
     * @param {number} customerReportId 
     * @param {string} [quoteDate] 
     * @param {number} [budgetStartMonthYear] 
     * @param {number} [budgetStartMonthMonth] 
     * @param {string} [budgetStartMonthLabel] 
     * @param {number} [budgetEndMonthYear] 
     * @param {number} [budgetEndMonthMonth] 
     * @param {string} [budgetEndMonthLabel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommodityManagementApi
     */
    public getPiedmontHedgingReport(loadingStateSetter: null | undefined | ((state: LoadingState) => void | undefined | null), customerReportId: number, quoteDate?: string, budgetStartMonthYear?: number, budgetStartMonthMonth?: number, budgetStartMonthLabel?: string, budgetEndMonthYear?: number, budgetEndMonthMonth?: number, budgetEndMonthLabel?: string, options?: AxiosRequestConfig) {
        const promise = CommodityManagementApiFp(this.configuration).getPiedmontHedgingReport(customerReportId, quoteDate, budgetStartMonthYear, budgetStartMonthMonth, budgetStartMonthLabel, budgetEndMonthYear, budgetEndMonthMonth, budgetEndMonthLabel, options).then((request) => request(this.axios, this.basePath));

        if (loadingStateSetter) {
            loadingStateSetter(LoadingState.Loading);
            promise.then(q => loadingStateSetter(LoadingState.Loaded));
            promise.catch(q => loadingStateSetter(LoadingState.Failed));
        }

        return promise;
    }

    /**
     * 
     * @param {string} entityId 
     * @param {string} [entityType] 
     * @param {boolean} [includeUnchangedFields] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommodityManagementApi
     */
    public getPositionAuditTrail(loadingStateSetter: null | undefined | ((state: LoadingState) => void | undefined | null), entityId: string, entityType?: string, includeUnchangedFields?: boolean, options?: AxiosRequestConfig) {
        const promise = CommodityManagementApiFp(this.configuration).getPositionAuditTrail(entityId, entityType, includeUnchangedFields, options).then((request) => request(this.axios, this.basePath));

        if (loadingStateSetter) {
            loadingStateSetter(LoadingState.Loading);
            promise.then(q => loadingStateSetter(LoadingState.Loaded));
            promise.catch(q => loadingStateSetter(LoadingState.Failed));
        }

        return promise;
    }

    /**
     * 
     * @param {string} [quoteDate] 
     * @param {boolean} [includeExpirationDates] 
     * @param {boolean} [includeMarketPrices] 
     * @param {boolean} [useDisplayUnits] 
     * @param {Array<ScenarioMarketPriceModel>} [scenarioMarketPrices] 
     * @param {Array<number>} [commoditiesFilter] 
     * @param {Array<number>} [locationsFilter] 
     * @param {Array<number>} [counterpartiesFilter] 
     * @param {string} [tradeDateStartFilter] 
     * @param {string} [tradeDateEndFilter] 
     * @param {number} [budgetMonthStartFilterYear] 
     * @param {number} [budgetMonthStartFilterMonth] 
     * @param {string} [budgetMonthStartFilterLabel] 
     * @param {number} [budgetMonthEndFilterYear] 
     * @param {number} [budgetMonthEndFilterMonth] 
     * @param {string} [budgetMonthEndFilterLabel] 
     * @param {number} [contractMonthStartFilterYear] 
     * @param {number} [contractMonthStartFilterMonth] 
     * @param {string} [contractMonthStartFilterLabel] 
     * @param {number} [contractMonthEndFilterYear] 
     * @param {number} [contractMonthEndFilterMonth] 
     * @param {string} [contractMonthEndFilterLabel] 
     * @param {Array<PositionType>} [positionTypesFilter] 
     * @param {string} [dealTicketNumberFilter] 
     * @param {number} [dealTicketIdFilter] 
     * @param {Side} [sideFilter] 
     * @param {boolean} [validatedFilter] 
     * @param {Array<Currency>} [currencyFilter] 
     * @param {Currency} [currency] 
     * @param {ExpiryStatus} [expiryStatus] 
     * @param {boolean} [includeAllocations] 
     * @param {boolean} [includeAllocationOffset] 
     * @param {boolean} [filterByTradeDate] 
     * @param {string} [pricingStartDateStartFilter] 
     * @param {string} [pricingStartDateEndFilter] 
     * @param {string} [pricingEndDateStartFilter] 
     * @param {string} [pricingEndDateEndFilter] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommodityManagementApi
     */
    public getPositionExcelExport(loadingStateSetter: null | undefined | ((state: LoadingState) => void | undefined | null), quoteDate?: string, includeExpirationDates?: boolean, includeMarketPrices?: boolean, useDisplayUnits?: boolean, scenarioMarketPrices?: Array<ScenarioMarketPriceModel>, commoditiesFilter?: Array<number>, locationsFilter?: Array<number>, counterpartiesFilter?: Array<number>, tradeDateStartFilter?: string, tradeDateEndFilter?: string, budgetMonthStartFilterYear?: number, budgetMonthStartFilterMonth?: number, budgetMonthStartFilterLabel?: string, budgetMonthEndFilterYear?: number, budgetMonthEndFilterMonth?: number, budgetMonthEndFilterLabel?: string, contractMonthStartFilterYear?: number, contractMonthStartFilterMonth?: number, contractMonthStartFilterLabel?: string, contractMonthEndFilterYear?: number, contractMonthEndFilterMonth?: number, contractMonthEndFilterLabel?: string, positionTypesFilter?: Array<PositionType>, dealTicketNumberFilter?: string, dealTicketIdFilter?: number, sideFilter?: Side, validatedFilter?: boolean, currencyFilter?: Array<Currency>, currency?: Currency, expiryStatus?: ExpiryStatus, includeAllocations?: boolean, includeAllocationOffset?: boolean, filterByTradeDate?: boolean, pricingStartDateStartFilter?: string, pricingStartDateEndFilter?: string, pricingEndDateStartFilter?: string, pricingEndDateEndFilter?: string, options?: AxiosRequestConfig) {
        const promise = CommodityManagementApiFp(this.configuration).getPositionExcelExport(quoteDate, includeExpirationDates, includeMarketPrices, useDisplayUnits, scenarioMarketPrices, commoditiesFilter, locationsFilter, counterpartiesFilter, tradeDateStartFilter, tradeDateEndFilter, budgetMonthStartFilterYear, budgetMonthStartFilterMonth, budgetMonthStartFilterLabel, budgetMonthEndFilterYear, budgetMonthEndFilterMonth, budgetMonthEndFilterLabel, contractMonthStartFilterYear, contractMonthStartFilterMonth, contractMonthStartFilterLabel, contractMonthEndFilterYear, contractMonthEndFilterMonth, contractMonthEndFilterLabel, positionTypesFilter, dealTicketNumberFilter, dealTicketIdFilter, sideFilter, validatedFilter, currencyFilter, currency, expiryStatus, includeAllocations, includeAllocationOffset, filterByTradeDate, pricingStartDateStartFilter, pricingStartDateEndFilter, pricingEndDateStartFilter, pricingEndDateEndFilter, options).then((request) => request(this.axios, this.basePath));

        if (loadingStateSetter) {
            loadingStateSetter(LoadingState.Loading);
            promise.then(q => loadingStateSetter(LoadingState.Loaded));
            promise.catch(q => loadingStateSetter(LoadingState.Failed));
        }

        return promise;
    }

    /**
     * 
     * @param {string} quoteDate 
     * @param {number} customerReportId 
     * @param {number} [budgetStartMonthYear] 
     * @param {number} [budgetStartMonthMonth] 
     * @param {string} [budgetStartMonthLabel] 
     * @param {number} [budgetEndMonthYear] 
     * @param {number} [budgetEndMonthMonth] 
     * @param {string} [budgetEndMonthLabel] 
     * @param {Array<number>} [commoditiesFilter] 
     * @param {Currency} [currency] 
     * @param {StressIncrementType} [stressIncrementType] 
     * @param {Array<number>} [stressIncrements] 
     * @param {Array<number>} [whatIfStrategyIds] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommodityManagementApi
     */
    public getScenarioExcelReport(loadingStateSetter: null | undefined | ((state: LoadingState) => void | undefined | null), quoteDate: string, customerReportId: number, budgetStartMonthYear?: number, budgetStartMonthMonth?: number, budgetStartMonthLabel?: string, budgetEndMonthYear?: number, budgetEndMonthMonth?: number, budgetEndMonthLabel?: string, commoditiesFilter?: Array<number>, currency?: Currency, stressIncrementType?: StressIncrementType, stressIncrements?: Array<number>, whatIfStrategyIds?: Array<number>, options?: AxiosRequestConfig) {
        const promise = CommodityManagementApiFp(this.configuration).getScenarioExcelReport(quoteDate, customerReportId, budgetStartMonthYear, budgetStartMonthMonth, budgetStartMonthLabel, budgetEndMonthYear, budgetEndMonthMonth, budgetEndMonthLabel, commoditiesFilter, currency, stressIncrementType, stressIncrements, whatIfStrategyIds, options).then((request) => request(this.axios, this.basePath));

        if (loadingStateSetter) {
            loadingStateSetter(LoadingState.Loading);
            promise.then(q => loadingStateSetter(LoadingState.Loaded));
            promise.catch(q => loadingStateSetter(LoadingState.Failed));
        }

        return promise;
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommodityManagementApi
     */
    public getScenarioMarketPricesExcelTemplate(loadingStateSetter: null | undefined | ((state: LoadingState) => void | undefined | null), options?: AxiosRequestConfig) {
        const promise = CommodityManagementApiFp(this.configuration).getScenarioMarketPricesExcelTemplate(options).then((request) => request(this.axios, this.basePath));

        if (loadingStateSetter) {
            loadingStateSetter(LoadingState.Loading);
            promise.then(q => loadingStateSetter(LoadingState.Loaded));
            promise.catch(q => loadingStateSetter(LoadingState.Failed));
        }

        return promise;
    }

    /**
     * 
     * @param {string} quoteDate 
     * @param {number} customerReportId 
     * @param {number} [budgetStartMonthYear] 
     * @param {number} [budgetStartMonthMonth] 
     * @param {string} [budgetStartMonthLabel] 
     * @param {number} [budgetEndMonthYear] 
     * @param {number} [budgetEndMonthMonth] 
     * @param {string} [budgetEndMonthLabel] 
     * @param {Array<number>} [commoditiesFilter] 
     * @param {Currency} [currency] 
     * @param {StressIncrementType} [stressIncrementType] 
     * @param {Array<number>} [stressIncrements] 
     * @param {Array<number>} [whatIfStrategyIds] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommodityManagementApi
     */
    public getScenarioReport(loadingStateSetter: null | undefined | ((state: LoadingState) => void | undefined | null), quoteDate: string, customerReportId: number, budgetStartMonthYear?: number, budgetStartMonthMonth?: number, budgetStartMonthLabel?: string, budgetEndMonthYear?: number, budgetEndMonthMonth?: number, budgetEndMonthLabel?: string, commoditiesFilter?: Array<number>, currency?: Currency, stressIncrementType?: StressIncrementType, stressIncrements?: Array<number>, whatIfStrategyIds?: Array<number>, options?: AxiosRequestConfig) {
        const promise = CommodityManagementApiFp(this.configuration).getScenarioReport(quoteDate, customerReportId, budgetStartMonthYear, budgetStartMonthMonth, budgetStartMonthLabel, budgetEndMonthYear, budgetEndMonthMonth, budgetEndMonthLabel, commoditiesFilter, currency, stressIncrementType, stressIncrements, whatIfStrategyIds, options).then((request) => request(this.axios, this.basePath));

        if (loadingStateSetter) {
            loadingStateSetter(LoadingState.Loading);
            promise.then(q => loadingStateSetter(LoadingState.Loaded));
            promise.catch(q => loadingStateSetter(LoadingState.Failed));
        }

        return promise;
    }

    /**
     * 
     * @param {string} quoteDate 
     * @param {number} customerReportId 
     * @param {number} [budgetStartMonthYear] 
     * @param {number} [budgetStartMonthMonth] 
     * @param {string} [budgetStartMonthLabel] 
     * @param {number} [budgetEndMonthYear] 
     * @param {number} [budgetEndMonthMonth] 
     * @param {string} [budgetEndMonthLabel] 
     * @param {ExpiryStatus} [expiryStatus] 
     * @param {Currency} [currency] 
     * @param {string} [sortColumn] 
     * @param {SortDirection} [sortDirection] 
     * @param {number} [take] 
     * @param {number} [skip] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommodityManagementApi
     */
    public getSummaryExcelReport(loadingStateSetter: null | undefined | ((state: LoadingState) => void | undefined | null), quoteDate: string, customerReportId: number, budgetStartMonthYear?: number, budgetStartMonthMonth?: number, budgetStartMonthLabel?: string, budgetEndMonthYear?: number, budgetEndMonthMonth?: number, budgetEndMonthLabel?: string, expiryStatus?: ExpiryStatus, currency?: Currency, sortColumn?: string, sortDirection?: SortDirection, take?: number, skip?: number, options?: AxiosRequestConfig) {
        const promise = CommodityManagementApiFp(this.configuration).getSummaryExcelReport(quoteDate, customerReportId, budgetStartMonthYear, budgetStartMonthMonth, budgetStartMonthLabel, budgetEndMonthYear, budgetEndMonthMonth, budgetEndMonthLabel, expiryStatus, currency, sortColumn, sortDirection, take, skip, options).then((request) => request(this.axios, this.basePath));

        if (loadingStateSetter) {
            loadingStateSetter(LoadingState.Loading);
            promise.then(q => loadingStateSetter(LoadingState.Loaded));
            promise.catch(q => loadingStateSetter(LoadingState.Failed));
        }

        return promise;
    }

    /**
     * 
     * @param {string} quoteDate 
     * @param {number} numberOfMonths 
     * @param {number} minimumPercentage 
     * @param {number} maximumPercentage 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommodityManagementApi
     */
    public getTimeTriggerReport(loadingStateSetter: null | undefined | ((state: LoadingState) => void | undefined | null), quoteDate: string, numberOfMonths: number, minimumPercentage: number, maximumPercentage: number, options?: AxiosRequestConfig) {
        const promise = CommodityManagementApiFp(this.configuration).getTimeTriggerReport(quoteDate, numberOfMonths, minimumPercentage, maximumPercentage, options).then((request) => request(this.axios, this.basePath));

        if (loadingStateSetter) {
            loadingStateSetter(LoadingState.Loading);
            promise.then(q => loadingStateSetter(LoadingState.Loaded));
            promise.catch(q => loadingStateSetter(LoadingState.Failed));
        }

        return promise;
    }

    /**
     * 
     * @param {string} quoteDate 
     * @param {number} customerReportId 
     * @param {number} [budgetStartMonthYear] 
     * @param {number} [budgetStartMonthMonth] 
     * @param {string} [budgetStartMonthLabel] 
     * @param {number} [budgetEndMonthYear] 
     * @param {number} [budgetEndMonthMonth] 
     * @param {string} [budgetEndMonthLabel] 
     * @param {ExpiryStatus} [expiryStatus] 
     * @param {Currency} [currency] 
     * @param {string} [sortColumn] 
     * @param {SortDirection} [sortDirection] 
     * @param {number} [take] 
     * @param {number} [skip] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommodityManagementApi
     */
    public getVarianceExcelReport(loadingStateSetter: null | undefined | ((state: LoadingState) => void | undefined | null), quoteDate: string, customerReportId: number, budgetStartMonthYear?: number, budgetStartMonthMonth?: number, budgetStartMonthLabel?: string, budgetEndMonthYear?: number, budgetEndMonthMonth?: number, budgetEndMonthLabel?: string, expiryStatus?: ExpiryStatus, currency?: Currency, sortColumn?: string, sortDirection?: SortDirection, take?: number, skip?: number, options?: AxiosRequestConfig) {
        const promise = CommodityManagementApiFp(this.configuration).getVarianceExcelReport(quoteDate, customerReportId, budgetStartMonthYear, budgetStartMonthMonth, budgetStartMonthLabel, budgetEndMonthYear, budgetEndMonthMonth, budgetEndMonthLabel, expiryStatus, currency, sortColumn, sortDirection, take, skip, options).then((request) => request(this.axios, this.basePath));

        if (loadingStateSetter) {
            loadingStateSetter(LoadingState.Loading);
            promise.then(q => loadingStateSetter(LoadingState.Loaded));
            promise.catch(q => loadingStateSetter(LoadingState.Failed));
        }

        return promise;
    }

    /**
     * 
     * @param {string} quoteDate 
     * @param {number} customerReportId 
     * @param {number} [budgetStartMonthYear] 
     * @param {number} [budgetStartMonthMonth] 
     * @param {string} [budgetStartMonthLabel] 
     * @param {number} [budgetEndMonthYear] 
     * @param {number} [budgetEndMonthMonth] 
     * @param {string} [budgetEndMonthLabel] 
     * @param {ExpiryStatus} [expiryStatus] 
     * @param {Currency} [currency] 
     * @param {string} [sortColumn] 
     * @param {SortDirection} [sortDirection] 
     * @param {number} [take] 
     * @param {number} [skip] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommodityManagementApi
     */
    public getVarianceReport(loadingStateSetter: null | undefined | ((state: LoadingState) => void | undefined | null), quoteDate: string, customerReportId: number, budgetStartMonthYear?: number, budgetStartMonthMonth?: number, budgetStartMonthLabel?: string, budgetEndMonthYear?: number, budgetEndMonthMonth?: number, budgetEndMonthLabel?: string, expiryStatus?: ExpiryStatus, currency?: Currency, sortColumn?: string, sortDirection?: SortDirection, take?: number, skip?: number, options?: AxiosRequestConfig) {
        const promise = CommodityManagementApiFp(this.configuration).getVarianceReport(quoteDate, customerReportId, budgetStartMonthYear, budgetStartMonthMonth, budgetStartMonthLabel, budgetEndMonthYear, budgetEndMonthMonth, budgetEndMonthLabel, expiryStatus, currency, sortColumn, sortDirection, take, skip, options).then((request) => request(this.axios, this.basePath));

        if (loadingStateSetter) {
            loadingStateSetter(LoadingState.Loading);
            promise.then(q => loadingStateSetter(LoadingState.Loaded));
            promise.catch(q => loadingStateSetter(LoadingState.Failed));
        }

        return promise;
    }

    /**
     * 
     * @param {Array<number>} [commoditiesFilter] 
     * @param {Array<number>} [locationsFilter] 
     * @param {Array<number>} [counterpartiesFilter] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommodityManagementApi
     */
    public listAllocations(loadingStateSetter: null | undefined | ((state: LoadingState) => void | undefined | null), commoditiesFilter?: Array<number>, locationsFilter?: Array<number>, counterpartiesFilter?: Array<number>, options?: AxiosRequestConfig) {
        const promise = CommodityManagementApiFp(this.configuration).listAllocations(commoditiesFilter, locationsFilter, counterpartiesFilter, options).then((request) => request(this.axios, this.basePath));

        if (loadingStateSetter) {
            loadingStateSetter(LoadingState.Loading);
            promise.then(q => loadingStateSetter(LoadingState.Loaded));
            promise.catch(q => loadingStateSetter(LoadingState.Failed));
        }

        return promise;
    }

    /**
     * 
     * @param {number} [commodityId] 
     * @param {number} [locationId] 
     * @param {number} [counterpartyId] 
     * @param {number} [portfolioId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommodityManagementApi
     */
    public listBudgetYearAllotmentProperties(loadingStateSetter: null | undefined | ((state: LoadingState) => void | undefined | null), commodityId?: number, locationId?: number, counterpartyId?: number, portfolioId?: number, options?: AxiosRequestConfig) {
        const promise = CommodityManagementApiFp(this.configuration).listBudgetYearAllotmentProperties(commodityId, locationId, counterpartyId, portfolioId, options).then((request) => request(this.axios, this.basePath));

        if (loadingStateSetter) {
            loadingStateSetter(LoadingState.Loading);
            promise.then(q => loadingStateSetter(LoadingState.Loaded));
            promise.catch(q => loadingStateSetter(LoadingState.Failed));
        }

        return promise;
    }

    /**
     * 
     * @param {number} [locationId] 
     * @param {number} [commodityId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommodityManagementApi
     */
    public listBudgetYears(loadingStateSetter: null | undefined | ((state: LoadingState) => void | undefined | null), locationId?: number, commodityId?: number, options?: AxiosRequestConfig) {
        const promise = CommodityManagementApiFp(this.configuration).listBudgetYears(locationId, commodityId, options).then((request) => request(this.axios, this.basePath));

        if (loadingStateSetter) {
            loadingStateSetter(LoadingState.Loading);
            promise.then(q => loadingStateSetter(LoadingState.Loaded));
            promise.catch(q => loadingStateSetter(LoadingState.Failed));
        }

        return promise;
    }

    /**
     * 
     * @param {string} [quoteDate] 
     * @param {number} [budgetStartMonthYear] 
     * @param {number} [budgetStartMonthMonth] 
     * @param {string} [budgetStartMonthLabel] 
     * @param {number} [budgetEndMonthYear] 
     * @param {number} [budgetEndMonthMonth] 
     * @param {string} [budgetEndMonthLabel] 
     * @param {Array<number>} [fiscalYearsFilter] 
     * @param {Array<number>} [commoditiesFilter] 
     * @param {Array<number>} [locationsFilter] 
     * @param {Array<number>} [counterpartiesFilter] 
     * @param {Array<number>} [budgetRoundsFilter] 
     * @param {boolean} [includeExpirationDates] 
     * @param {boolean} [includePositions] 
     * @param {boolean} [includeMarketPrices] 
     * @param {boolean} [includeBudgetRounds] 
     * @param {ExpiryStatus} [expiryStatus] 
     * @param {Currency} [currency] 
     * @param {Unit} [unit] 
     * @param {string} [note] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommodityManagementApi
     */
    public listBudgets(loadingStateSetter: null | undefined | ((state: LoadingState) => void | undefined | null), quoteDate?: string, budgetStartMonthYear?: number, budgetStartMonthMonth?: number, budgetStartMonthLabel?: string, budgetEndMonthYear?: number, budgetEndMonthMonth?: number, budgetEndMonthLabel?: string, fiscalYearsFilter?: Array<number>, commoditiesFilter?: Array<number>, locationsFilter?: Array<number>, counterpartiesFilter?: Array<number>, budgetRoundsFilter?: Array<number>, includeExpirationDates?: boolean, includePositions?: boolean, includeMarketPrices?: boolean, includeBudgetRounds?: boolean, expiryStatus?: ExpiryStatus, currency?: Currency, unit?: Unit, note?: string, options?: AxiosRequestConfig) {
        const promise = CommodityManagementApiFp(this.configuration).listBudgets(quoteDate, budgetStartMonthYear, budgetStartMonthMonth, budgetStartMonthLabel, budgetEndMonthYear, budgetEndMonthMonth, budgetEndMonthLabel, fiscalYearsFilter, commoditiesFilter, locationsFilter, counterpartiesFilter, budgetRoundsFilter, includeExpirationDates, includePositions, includeMarketPrices, includeBudgetRounds, expiryStatus, currency, unit, note, options).then((request) => request(this.axios, this.basePath));

        if (loadingStateSetter) {
            loadingStateSetter(LoadingState.Loading);
            promise.then(q => loadingStateSetter(LoadingState.Loaded));
            promise.catch(q => loadingStateSetter(LoadingState.Failed));
        }

        return promise;
    }

    /**
     * 
     * @param {number} [commodityId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommodityManagementApi
     */
    public listCommodityContractMonthMappings(loadingStateSetter: null | undefined | ((state: LoadingState) => void | undefined | null), commodityId?: number, options?: AxiosRequestConfig) {
        const promise = CommodityManagementApiFp(this.configuration).listCommodityContractMonthMappings(commodityId, options).then((request) => request(this.axios, this.basePath));

        if (loadingStateSetter) {
            loadingStateSetter(LoadingState.Loading);
            promise.then(q => loadingStateSetter(LoadingState.Loaded));
            promise.catch(q => loadingStateSetter(LoadingState.Failed));
        }

        return promise;
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommodityManagementApi
     */
    public listCustomers(loadingStateSetter: null | undefined | ((state: LoadingState) => void | undefined | null), options?: AxiosRequestConfig) {
        const promise = CommodityManagementApiFp(this.configuration).listCustomers(options).then((request) => request(this.axios, this.basePath));

        if (loadingStateSetter) {
            loadingStateSetter(LoadingState.Loading);
            promise.then(q => loadingStateSetter(LoadingState.Loaded));
            promise.catch(q => loadingStateSetter(LoadingState.Failed));
        }

        return promise;
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommodityManagementApi
     */
    public listDefaultBudgetRounds(loadingStateSetter: null | undefined | ((state: LoadingState) => void | undefined | null), options?: AxiosRequestConfig) {
        const promise = CommodityManagementApiFp(this.configuration).listDefaultBudgetRounds(options).then((request) => request(this.axios, this.basePath));

        if (loadingStateSetter) {
            loadingStateSetter(LoadingState.Loading);
            promise.then(q => loadingStateSetter(LoadingState.Loaded));
            promise.catch(q => loadingStateSetter(LoadingState.Failed));
        }

        return promise;
    }

    /**
     * 
     * @param {string} [vendorFilter] 
     * @param {string} [plantFilter] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommodityManagementApi
     */
    public listDeliveries(loadingStateSetter: null | undefined | ((state: LoadingState) => void | undefined | null), vendorFilter?: string, plantFilter?: string, options?: AxiosRequestConfig) {
        const promise = CommodityManagementApiFp(this.configuration).listDeliveries(vendorFilter, plantFilter, options).then((request) => request(this.axios, this.basePath));

        if (loadingStateSetter) {
            loadingStateSetter(LoadingState.Loading);
            promise.then(q => loadingStateSetter(LoadingState.Loaded));
            promise.catch(q => loadingStateSetter(LoadingState.Failed));
        }

        return promise;
    }

    /**
     * 
     * @param {string} [entityFilter] 
     * @param {number} [entityIdFilter] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommodityManagementApi
     */
    public listDocuments(loadingStateSetter: null | undefined | ((state: LoadingState) => void | undefined | null), entityFilter?: string, entityIdFilter?: number, options?: AxiosRequestConfig) {
        const promise = CommodityManagementApiFp(this.configuration).listDocuments(entityFilter, entityIdFilter, options).then((request) => request(this.axios, this.basePath));

        if (loadingStateSetter) {
            loadingStateSetter(LoadingState.Loading);
            promise.then(q => loadingStateSetter(LoadingState.Loaded));
            promise.catch(q => loadingStateSetter(LoadingState.Failed));
        }

        return promise;
    }

    /**
     * 
     * @param {string} [sortColumn] 
     * @param {SortDirection} [sortDirection] 
     * @param {number} [take] 
     * @param {number} [skip] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommodityManagementApi
     */
    public listEiaNaturalGasStorageWeeks(loadingStateSetter: null | undefined | ((state: LoadingState) => void | undefined | null), sortColumn?: string, sortDirection?: SortDirection, take?: number, skip?: number, options?: AxiosRequestConfig) {
        const promise = CommodityManagementApiFp(this.configuration).listEiaNaturalGasStorageWeeks(sortColumn, sortDirection, take, skip, options).then((request) => request(this.axios, this.basePath));

        if (loadingStateSetter) {
            loadingStateSetter(LoadingState.Loading);
            promise.then(q => loadingStateSetter(LoadingState.Loaded));
            promise.catch(q => loadingStateSetter(LoadingState.Failed));
        }

        return promise;
    }

    /**
     * 
     * @param {string} hedgePlanId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommodityManagementApi
     */
    public listHedgePlanData(loadingStateSetter: null | undefined | ((state: LoadingState) => void | undefined | null), hedgePlanId: string, options?: AxiosRequestConfig) {
        const promise = CommodityManagementApiFp(this.configuration).listHedgePlanData(hedgePlanId, options).then((request) => request(this.axios, this.basePath));

        if (loadingStateSetter) {
            loadingStateSetter(LoadingState.Loading);
            promise.then(q => loadingStateSetter(LoadingState.Loaded));
            promise.catch(q => loadingStateSetter(LoadingState.Failed));
        }

        return promise;
    }

    /**
     * 
     * @param {string} hedgePlanId 
     * @param {string} [asOfDate] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommodityManagementApi
     */
    public listHedgePlanSeasons(loadingStateSetter: null | undefined | ((state: LoadingState) => void | undefined | null), hedgePlanId: string, asOfDate?: string, options?: AxiosRequestConfig) {
        const promise = CommodityManagementApiFp(this.configuration).listHedgePlanSeasons(hedgePlanId, asOfDate, options).then((request) => request(this.axios, this.basePath));

        if (loadingStateSetter) {
            loadingStateSetter(LoadingState.Loading);
            promise.then(q => loadingStateSetter(LoadingState.Loaded));
            promise.catch(q => loadingStateSetter(LoadingState.Failed));
        }

        return promise;
    }

    /**
     * 
     * @param {string} companyGuid 
     * @param {string} [sortColumn] 
     * @param {SortDirection} [sortDirection] 
     * @param {number} [take] 
     * @param {number} [skip] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommodityManagementApi
     */
    public listHedgePlans(loadingStateSetter: null | undefined | ((state: LoadingState) => void | undefined | null), companyGuid: string, sortColumn?: string, sortDirection?: SortDirection, take?: number, skip?: number, options?: AxiosRequestConfig) {
        const promise = CommodityManagementApiFp(this.configuration).listHedgePlans(companyGuid, sortColumn, sortDirection, take, skip, options).then((request) => request(this.axios, this.basePath));

        if (loadingStateSetter) {
            loadingStateSetter(LoadingState.Loading);
            promise.then(q => loadingStateSetter(LoadingState.Loaded));
            promise.catch(q => loadingStateSetter(LoadingState.Failed));
        }

        return promise;
    }

    /**
     * 
     * @param {string} customerId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommodityManagementApi
     */
    public listLocations(loadingStateSetter: null | undefined | ((state: LoadingState) => void | undefined | null), customerId: string, options?: AxiosRequestConfig) {
        const promise = CommodityManagementApiFp(this.configuration).listLocations(customerId, options).then((request) => request(this.axios, this.basePath));

        if (loadingStateSetter) {
            loadingStateSetter(LoadingState.Loading);
            promise.then(q => loadingStateSetter(LoadingState.Loaded));
            promise.catch(q => loadingStateSetter(LoadingState.Failed));
        }

        return promise;
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommodityManagementApi
     */
    public listNotes(loadingStateSetter: null | undefined | ((state: LoadingState) => void | undefined | null), options?: AxiosRequestConfig) {
        const promise = CommodityManagementApiFp(this.configuration).listNotes(options).then((request) => request(this.axios, this.basePath));

        if (loadingStateSetter) {
            loadingStateSetter(LoadingState.Loading);
            promise.then(q => loadingStateSetter(LoadingState.Loaded));
            promise.catch(q => loadingStateSetter(LoadingState.Failed));
        }

        return promise;
    }

    /**
     * 
     * @param {number} [commodityId] 
     * @param {number} [locationId] 
     * @param {number} [counterpartyId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommodityManagementApi
     */
    public listPositionYears(loadingStateSetter: null | undefined | ((state: LoadingState) => void | undefined | null), commodityId?: number, locationId?: number, counterpartyId?: number, options?: AxiosRequestConfig) {
        const promise = CommodityManagementApiFp(this.configuration).listPositionYears(commodityId, locationId, counterpartyId, options).then((request) => request(this.axios, this.basePath));

        if (loadingStateSetter) {
            loadingStateSetter(LoadingState.Loading);
            promise.then(q => loadingStateSetter(LoadingState.Loaded));
            promise.catch(q => loadingStateSetter(LoadingState.Failed));
        }

        return promise;
    }

    /**
     * 
     * @param {string} [quoteDate] 
     * @param {boolean} [includeExpirationDates] 
     * @param {boolean} [includeMarketPrices] 
     * @param {boolean} [useDisplayUnits] 
     * @param {Array<ScenarioMarketPriceModel>} [scenarioMarketPrices] 
     * @param {Array<number>} [commoditiesFilter] 
     * @param {Array<number>} [locationsFilter] 
     * @param {Array<number>} [counterpartiesFilter] 
     * @param {string} [tradeDateStartFilter] 
     * @param {string} [tradeDateEndFilter] 
     * @param {number} [budgetMonthStartFilterYear] 
     * @param {number} [budgetMonthStartFilterMonth] 
     * @param {string} [budgetMonthStartFilterLabel] 
     * @param {number} [budgetMonthEndFilterYear] 
     * @param {number} [budgetMonthEndFilterMonth] 
     * @param {string} [budgetMonthEndFilterLabel] 
     * @param {number} [contractMonthStartFilterYear] 
     * @param {number} [contractMonthStartFilterMonth] 
     * @param {string} [contractMonthStartFilterLabel] 
     * @param {number} [contractMonthEndFilterYear] 
     * @param {number} [contractMonthEndFilterMonth] 
     * @param {string} [contractMonthEndFilterLabel] 
     * @param {Array<PositionType>} [positionTypesFilter] 
     * @param {string} [dealTicketNumberFilter] 
     * @param {number} [dealTicketIdFilter] 
     * @param {Side} [sideFilter] 
     * @param {boolean} [validatedFilter] 
     * @param {Array<Currency>} [currencyFilter] 
     * @param {Currency} [currency] 
     * @param {ExpiryStatus} [expiryStatus] 
     * @param {boolean} [includeAllocations] 
     * @param {boolean} [includeAllocationOffset] 
     * @param {boolean} [filterByTradeDate] 
     * @param {string} [pricingStartDateStartFilter] 
     * @param {string} [pricingStartDateEndFilter] 
     * @param {string} [pricingEndDateStartFilter] 
     * @param {string} [pricingEndDateEndFilter] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommodityManagementApi
     */
    public listPositions(loadingStateSetter: null | undefined | ((state: LoadingState) => void | undefined | null), quoteDate?: string, includeExpirationDates?: boolean, includeMarketPrices?: boolean, useDisplayUnits?: boolean, scenarioMarketPrices?: Array<ScenarioMarketPriceModel>, commoditiesFilter?: Array<number>, locationsFilter?: Array<number>, counterpartiesFilter?: Array<number>, tradeDateStartFilter?: string, tradeDateEndFilter?: string, budgetMonthStartFilterYear?: number, budgetMonthStartFilterMonth?: number, budgetMonthStartFilterLabel?: string, budgetMonthEndFilterYear?: number, budgetMonthEndFilterMonth?: number, budgetMonthEndFilterLabel?: string, contractMonthStartFilterYear?: number, contractMonthStartFilterMonth?: number, contractMonthStartFilterLabel?: string, contractMonthEndFilterYear?: number, contractMonthEndFilterMonth?: number, contractMonthEndFilterLabel?: string, positionTypesFilter?: Array<PositionType>, dealTicketNumberFilter?: string, dealTicketIdFilter?: number, sideFilter?: Side, validatedFilter?: boolean, currencyFilter?: Array<Currency>, currency?: Currency, expiryStatus?: ExpiryStatus, includeAllocations?: boolean, includeAllocationOffset?: boolean, filterByTradeDate?: boolean, pricingStartDateStartFilter?: string, pricingStartDateEndFilter?: string, pricingEndDateStartFilter?: string, pricingEndDateEndFilter?: string, options?: AxiosRequestConfig) {
        const promise = CommodityManagementApiFp(this.configuration).listPositions(quoteDate, includeExpirationDates, includeMarketPrices, useDisplayUnits, scenarioMarketPrices, commoditiesFilter, locationsFilter, counterpartiesFilter, tradeDateStartFilter, tradeDateEndFilter, budgetMonthStartFilterYear, budgetMonthStartFilterMonth, budgetMonthStartFilterLabel, budgetMonthEndFilterYear, budgetMonthEndFilterMonth, budgetMonthEndFilterLabel, contractMonthStartFilterYear, contractMonthStartFilterMonth, contractMonthStartFilterLabel, contractMonthEndFilterYear, contractMonthEndFilterMonth, contractMonthEndFilterLabel, positionTypesFilter, dealTicketNumberFilter, dealTicketIdFilter, sideFilter, validatedFilter, currencyFilter, currency, expiryStatus, includeAllocations, includeAllocationOffset, filterByTradeDate, pricingStartDateStartFilter, pricingStartDateEndFilter, pricingEndDateStartFilter, pricingEndDateEndFilter, options).then((request) => request(this.axios, this.basePath));

        if (loadingStateSetter) {
            loadingStateSetter(LoadingState.Loading);
            promise.then(q => loadingStateSetter(LoadingState.Loaded));
            promise.catch(q => loadingStateSetter(LoadingState.Failed));
        }

        return promise;
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommodityManagementApi
     */
    public listPricingStrategies(loadingStateSetter: null | undefined | ((state: LoadingState) => void | undefined | null), options?: AxiosRequestConfig) {
        const promise = CommodityManagementApiFp(this.configuration).listPricingStrategies(options).then((request) => request(this.axios, this.basePath));

        if (loadingStateSetter) {
            loadingStateSetter(LoadingState.Loading);
            promise.then(q => loadingStateSetter(LoadingState.Loaded));
            promise.catch(q => loadingStateSetter(LoadingState.Failed));
        }

        return promise;
    }

    /**
     * 
     * @param {any} scenarioMarketPricesFile 
     * @param {string} [sortColumn] 
     * @param {SortDirection} [sortDirection] 
     * @param {number} [take] 
     * @param {number} [skip] 
     * @param {boolean} [validationResponseIsValid] 
     * @param {string} [validationResponseValidationMessage] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommodityManagementApi
     */
    public listScenarioMarketPricesFromUpload(loadingStateSetter: null | undefined | ((state: LoadingState) => void | undefined | null), scenarioMarketPricesFile: any, sortColumn?: string, sortDirection?: SortDirection, take?: number, skip?: number, validationResponseIsValid?: boolean, validationResponseValidationMessage?: string, options?: AxiosRequestConfig) {
        const promise = CommodityManagementApiFp(this.configuration).listScenarioMarketPricesFromUpload(scenarioMarketPricesFile, sortColumn, sortDirection, take, skip, validationResponseIsValid, validationResponseValidationMessage, options).then((request) => request(this.axios, this.basePath));

        if (loadingStateSetter) {
            loadingStateSetter(LoadingState.Loading);
            promise.then(q => loadingStateSetter(LoadingState.Loaded));
            promise.catch(q => loadingStateSetter(LoadingState.Failed));
        }

        return promise;
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommodityManagementApi
     */
    public listWhatIfStrategies(loadingStateSetter: null | undefined | ((state: LoadingState) => void | undefined | null), options?: AxiosRequestConfig) {
        const promise = CommodityManagementApiFp(this.configuration).listWhatIfStrategies(options).then((request) => request(this.axios, this.basePath));

        if (loadingStateSetter) {
            loadingStateSetter(LoadingState.Loading);
            promise.then(q => loadingStateSetter(LoadingState.Loaded));
            promise.catch(q => loadingStateSetter(LoadingState.Failed));
        }

        return promise;
    }

    /**
     * 
     * @param {string} customerReportId 
     * @param {SendCommodityManagementReportEmailRequest} [sendCommodityManagementReportEmailRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommodityManagementApi
     */
    public sendCommodityManagementReportEmail(loadingStateSetter: null | undefined | ((state: LoadingState) => void | undefined | null), customerReportId: string, sendCommodityManagementReportEmailRequest?: SendCommodityManagementReportEmailRequest, options?: AxiosRequestConfig) {
        const promise = CommodityManagementApiFp(this.configuration).sendCommodityManagementReportEmail(customerReportId, sendCommodityManagementReportEmailRequest, options).then((request) => request(this.axios, this.basePath));

        if (loadingStateSetter) {
            loadingStateSetter(LoadingState.Loading);
            promise.then(q => loadingStateSetter(LoadingState.Loaded));
            promise.catch(q => loadingStateSetter(LoadingState.Failed));
        }

        return promise;
    }

    /**
     * 
     * @param {UpdateBudgetRoundRequest} [updateBudgetRoundRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommodityManagementApi
     */
    public updateBudgetRound(loadingStateSetter: null | undefined | ((state: LoadingState) => void | undefined | null), updateBudgetRoundRequest?: UpdateBudgetRoundRequest, options?: AxiosRequestConfig) {
        const promise = CommodityManagementApiFp(this.configuration).updateBudgetRound(updateBudgetRoundRequest, options).then((request) => request(this.axios, this.basePath));

        if (loadingStateSetter) {
            loadingStateSetter(LoadingState.Loading);
            promise.then(q => loadingStateSetter(LoadingState.Loaded));
            promise.catch(q => loadingStateSetter(LoadingState.Failed));
        }

        return promise;
    }

    /**
     * 
     * @param {UpdateBudgetsRequest} [updateBudgetsRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommodityManagementApi
     */
    public updateBudgets(loadingStateSetter: null | undefined | ((state: LoadingState) => void | undefined | null), updateBudgetsRequest?: UpdateBudgetsRequest, options?: AxiosRequestConfig) {
        const promise = CommodityManagementApiFp(this.configuration).updateBudgets(updateBudgetsRequest, options).then((request) => request(this.axios, this.basePath));

        if (loadingStateSetter) {
            loadingStateSetter(LoadingState.Loading);
            promise.then(q => loadingStateSetter(LoadingState.Loaded));
            promise.catch(q => loadingStateSetter(LoadingState.Failed));
        }

        return promise;
    }

    /**
     * 
     * @param {string} commodityId 
     * @param {string} commodityName 
     * @param {Unit} displayUnit 
     * @param {number} displayPrecision 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommodityManagementApi
     */
    public updateCommodity(loadingStateSetter: null | undefined | ((state: LoadingState) => void | undefined | null), commodityId: string, commodityName: string, displayUnit: Unit, displayPrecision: number, options?: AxiosRequestConfig) {
        const promise = CommodityManagementApiFp(this.configuration).updateCommodity(commodityId, commodityName, displayUnit, displayPrecision, options).then((request) => request(this.axios, this.basePath));

        if (loadingStateSetter) {
            loadingStateSetter(LoadingState.Loading);
            promise.then(q => loadingStateSetter(LoadingState.Loaded));
            promise.catch(q => loadingStateSetter(LoadingState.Failed));
        }

        return promise;
    }

    /**
     * 
     * @param {string} commodityId 
     * @param {UpdateCommodityContractMonthMappingsRequest} [updateCommodityContractMonthMappingsRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommodityManagementApi
     */
    public updateCommodityContractMonthMappings(loadingStateSetter: null | undefined | ((state: LoadingState) => void | undefined | null), commodityId: string, updateCommodityContractMonthMappingsRequest?: UpdateCommodityContractMonthMappingsRequest, options?: AxiosRequestConfig) {
        const promise = CommodityManagementApiFp(this.configuration).updateCommodityContractMonthMappings(commodityId, updateCommodityContractMonthMappingsRequest, options).then((request) => request(this.axios, this.basePath));

        if (loadingStateSetter) {
            loadingStateSetter(LoadingState.Loading);
            promise.then(q => loadingStateSetter(LoadingState.Loaded));
            promise.catch(q => loadingStateSetter(LoadingState.Failed));
        }

        return promise;
    }

    /**
     * 
     * @param {string} counterpartyId 
     * @param {string} counterpartyName 
     * @param {number} [creditLimit] 
     * @param {boolean} [netting] 
     * @param {boolean} [setoff] 
     * @param {boolean} [active] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommodityManagementApi
     */
    public updateCounterparty(loadingStateSetter: null | undefined | ((state: LoadingState) => void | undefined | null), counterpartyId: string, counterpartyName: string, creditLimit?: number, netting?: boolean, setoff?: boolean, active?: boolean, options?: AxiosRequestConfig) {
        const promise = CommodityManagementApiFp(this.configuration).updateCounterparty(counterpartyId, counterpartyName, creditLimit, netting, setoff, active, options).then((request) => request(this.axios, this.basePath));

        if (loadingStateSetter) {
            loadingStateSetter(LoadingState.Loading);
            promise.then(q => loadingStateSetter(LoadingState.Loaded));
            promise.catch(q => loadingStateSetter(LoadingState.Failed));
        }

        return promise;
    }

    /**
     * 
     * @param {UpdateCustomerReportRequest} [updateCustomerReportRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommodityManagementApi
     */
    public updateCustomerReport(loadingStateSetter: null | undefined | ((state: LoadingState) => void | undefined | null), updateCustomerReportRequest?: UpdateCustomerReportRequest, options?: AxiosRequestConfig) {
        const promise = CommodityManagementApiFp(this.configuration).updateCustomerReport(updateCustomerReportRequest, options).then((request) => request(this.axios, this.basePath));

        if (loadingStateSetter) {
            loadingStateSetter(LoadingState.Loading);
            promise.then(q => loadingStateSetter(LoadingState.Loaded));
            promise.catch(q => loadingStateSetter(LoadingState.Failed));
        }

        return promise;
    }

    /**
     * 
     * @param {number} customerReportId 
     * @param {string} [overrides] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommodityManagementApi
     */
    public updateCustomerReportUserOverrides(loadingStateSetter: null | undefined | ((state: LoadingState) => void | undefined | null), customerReportId: number, overrides?: string, options?: AxiosRequestConfig) {
        const promise = CommodityManagementApiFp(this.configuration).updateCustomerReportUserOverrides(customerReportId, overrides, options).then((request) => request(this.axios, this.basePath));

        if (loadingStateSetter) {
            loadingStateSetter(LoadingState.Loading);
            promise.then(q => loadingStateSetter(LoadingState.Loaded));
            promise.catch(q => loadingStateSetter(LoadingState.Failed));
        }

        return promise;
    }

    /**
     * 
     * @param {UpdateCustomerSettingsRequest} [updateCustomerSettingsRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommodityManagementApi
     */
    public updateCustomerSettings(loadingStateSetter: null | undefined | ((state: LoadingState) => void | undefined | null), updateCustomerSettingsRequest?: UpdateCustomerSettingsRequest, options?: AxiosRequestConfig) {
        const promise = CommodityManagementApiFp(this.configuration).updateCustomerSettings(updateCustomerSettingsRequest, options).then((request) => request(this.axios, this.basePath));

        if (loadingStateSetter) {
            loadingStateSetter(LoadingState.Loading);
            promise.then(q => loadingStateSetter(LoadingState.Loaded));
            promise.catch(q => loadingStateSetter(LoadingState.Failed));
        }

        return promise;
    }

    /**
     * 
     * @param {string} dealTicketId 
     * @param {Array<number>} [validatedPositionIds] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommodityManagementApi
     */
    public updateDealTicketPositionValidation(loadingStateSetter: null | undefined | ((state: LoadingState) => void | undefined | null), dealTicketId: string, validatedPositionIds?: Array<number>, options?: AxiosRequestConfig) {
        const promise = CommodityManagementApiFp(this.configuration).updateDealTicketPositionValidation(dealTicketId, validatedPositionIds, options).then((request) => request(this.axios, this.basePath));

        if (loadingStateSetter) {
            loadingStateSetter(LoadingState.Loading);
            promise.then(q => loadingStateSetter(LoadingState.Loaded));
            promise.catch(q => loadingStateSetter(LoadingState.Failed));
        }

        return promise;
    }

    /**
     * 
     * @param {UpdateDefaultBudgetRoundsRequest} [updateDefaultBudgetRoundsRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommodityManagementApi
     */
    public updateDefaultBudgetRounds(loadingStateSetter: null | undefined | ((state: LoadingState) => void | undefined | null), updateDefaultBudgetRoundsRequest?: UpdateDefaultBudgetRoundsRequest, options?: AxiosRequestConfig) {
        const promise = CommodityManagementApiFp(this.configuration).updateDefaultBudgetRounds(updateDefaultBudgetRoundsRequest, options).then((request) => request(this.axios, this.basePath));

        if (loadingStateSetter) {
            loadingStateSetter(LoadingState.Loading);
            promise.then(q => loadingStateSetter(LoadingState.Loaded));
            promise.catch(q => loadingStateSetter(LoadingState.Failed));
        }

        return promise;
    }

    /**
     * 
     * @param {UpdateDeliveriesRequest} [updateDeliveriesRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommodityManagementApi
     */
    public updateDeliveries(loadingStateSetter: null | undefined | ((state: LoadingState) => void | undefined | null), updateDeliveriesRequest?: UpdateDeliveriesRequest, options?: AxiosRequestConfig) {
        const promise = CommodityManagementApiFp(this.configuration).updateDeliveries(updateDeliveriesRequest, options).then((request) => request(this.axios, this.basePath));

        if (loadingStateSetter) {
            loadingStateSetter(LoadingState.Loading);
            promise.then(q => loadingStateSetter(LoadingState.Loaded));
            promise.catch(q => loadingStateSetter(LoadingState.Failed));
        }

        return promise;
    }

    /**
     * 
     * @param {UpdateHedgePlanRequest} [updateHedgePlanRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommodityManagementApi
     */
    public updateHedgePlan(loadingStateSetter: null | undefined | ((state: LoadingState) => void | undefined | null), updateHedgePlanRequest?: UpdateHedgePlanRequest, options?: AxiosRequestConfig) {
        const promise = CommodityManagementApiFp(this.configuration).updateHedgePlan(updateHedgePlanRequest, options).then((request) => request(this.axios, this.basePath));

        if (loadingStateSetter) {
            loadingStateSetter(LoadingState.Loading);
            promise.then(q => loadingStateSetter(LoadingState.Loaded));
            promise.catch(q => loadingStateSetter(LoadingState.Failed));
        }

        return promise;
    }

    /**
     * 
     * @param {string} hedgePlanId 
     * @param {string} year 
     * @param {UpdateHedgePlanBudgetTriggersRequest} [updateHedgePlanBudgetTriggersRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommodityManagementApi
     */
    public updateHedgePlanBudgetTriggers(loadingStateSetter: null | undefined | ((state: LoadingState) => void | undefined | null), hedgePlanId: string, year: string, updateHedgePlanBudgetTriggersRequest?: UpdateHedgePlanBudgetTriggersRequest, options?: AxiosRequestConfig) {
        const promise = CommodityManagementApiFp(this.configuration).updateHedgePlanBudgetTriggers(hedgePlanId, year, updateHedgePlanBudgetTriggersRequest, options).then((request) => request(this.axios, this.basePath));

        if (loadingStateSetter) {
            loadingStateSetter(LoadingState.Loading);
            promise.then(q => loadingStateSetter(LoadingState.Loaded));
            promise.catch(q => loadingStateSetter(LoadingState.Failed));
        }

        return promise;
    }

    /**
     * 
     * @param {string} hedgePlanId 
     * @param {string} year 
     * @param {UpdateHedgePlanSeasonSettingsRequest} [updateHedgePlanSeasonSettingsRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommodityManagementApi
     */
    public updateHedgePlanSeasonSettings(loadingStateSetter: null | undefined | ((state: LoadingState) => void | undefined | null), hedgePlanId: string, year: string, updateHedgePlanSeasonSettingsRequest?: UpdateHedgePlanSeasonSettingsRequest, options?: AxiosRequestConfig) {
        const promise = CommodityManagementApiFp(this.configuration).updateHedgePlanSeasonSettings(hedgePlanId, year, updateHedgePlanSeasonSettingsRequest, options).then((request) => request(this.axios, this.basePath));

        if (loadingStateSetter) {
            loadingStateSetter(LoadingState.Loading);
            promise.then(q => loadingStateSetter(LoadingState.Loaded));
            promise.catch(q => loadingStateSetter(LoadingState.Failed));
        }

        return promise;
    }

    /**
     * 
     * @param {string} hedgePlanId 
     * @param {string} year 
     * @param {UpdateHedgePlanTimeTriggersRequest} [updateHedgePlanTimeTriggersRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommodityManagementApi
     */
    public updateHedgePlanTimeTriggers(loadingStateSetter: null | undefined | ((state: LoadingState) => void | undefined | null), hedgePlanId: string, year: string, updateHedgePlanTimeTriggersRequest?: UpdateHedgePlanTimeTriggersRequest, options?: AxiosRequestConfig) {
        const promise = CommodityManagementApiFp(this.configuration).updateHedgePlanTimeTriggers(hedgePlanId, year, updateHedgePlanTimeTriggersRequest, options).then((request) => request(this.axios, this.basePath));

        if (loadingStateSetter) {
            loadingStateSetter(LoadingState.Loading);
            promise.then(q => loadingStateSetter(LoadingState.Loaded));
            promise.catch(q => loadingStateSetter(LoadingState.Failed));
        }

        return promise;
    }

    /**
     * 
     * @param {string} hedgePlanId 
     * @param {string} year 
     * @param {UpdateHedgePlanTradesRequest} [updateHedgePlanTradesRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommodityManagementApi
     */
    public updateHedgePlanTrades(loadingStateSetter: null | undefined | ((state: LoadingState) => void | undefined | null), hedgePlanId: string, year: string, updateHedgePlanTradesRequest?: UpdateHedgePlanTradesRequest, options?: AxiosRequestConfig) {
        const promise = CommodityManagementApiFp(this.configuration).updateHedgePlanTrades(hedgePlanId, year, updateHedgePlanTradesRequest, options).then((request) => request(this.axios, this.basePath));

        if (loadingStateSetter) {
            loadingStateSetter(LoadingState.Loading);
            promise.then(q => loadingStateSetter(LoadingState.Loaded));
            promise.catch(q => loadingStateSetter(LoadingState.Failed));
        }

        return promise;
    }

    /**
     * 
     * @param {string} hedgePlanId 
     * @param {string} year 
     * @param {UpdateHedgePlanValueTriggersRequest} [updateHedgePlanValueTriggersRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommodityManagementApi
     */
    public updateHedgePlanValueTriggers(loadingStateSetter: null | undefined | ((state: LoadingState) => void | undefined | null), hedgePlanId: string, year: string, updateHedgePlanValueTriggersRequest?: UpdateHedgePlanValueTriggersRequest, options?: AxiosRequestConfig) {
        const promise = CommodityManagementApiFp(this.configuration).updateHedgePlanValueTriggers(hedgePlanId, year, updateHedgePlanValueTriggersRequest, options).then((request) => request(this.axios, this.basePath));

        if (loadingStateSetter) {
            loadingStateSetter(LoadingState.Loading);
            promise.then(q => loadingStateSetter(LoadingState.Loaded));
            promise.catch(q => loadingStateSetter(LoadingState.Failed));
        }

        return promise;
    }

    /**
     * 
     * @param {string} locationId 
     * @param {string} locationName 
     * @param {number} tierId 
     * @param {number} [parentLocationId] 
     * @param {boolean} [active] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommodityManagementApi
     */
    public updateLocation(loadingStateSetter: null | undefined | ((state: LoadingState) => void | undefined | null), locationId: string, locationName: string, tierId: number, parentLocationId?: number, active?: boolean, options?: AxiosRequestConfig) {
        const promise = CommodityManagementApiFp(this.configuration).updateLocation(locationId, locationName, tierId, parentLocationId, active, options).then((request) => request(this.axios, this.basePath));

        if (loadingStateSetter) {
            loadingStateSetter(LoadingState.Loading);
            promise.then(q => loadingStateSetter(LoadingState.Loaded));
            promise.catch(q => loadingStateSetter(LoadingState.Failed));
        }

        return promise;
    }

    /**
     * 
     * @param {string} noteId 
     * @param {string} subject 
     * @param {string} content 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommodityManagementApi
     */
    public updateNote(loadingStateSetter: null | undefined | ((state: LoadingState) => void | undefined | null), noteId: string, subject: string, content: string, options?: AxiosRequestConfig) {
        const promise = CommodityManagementApiFp(this.configuration).updateNote(noteId, subject, content, options).then((request) => request(this.axios, this.basePath));

        if (loadingStateSetter) {
            loadingStateSetter(LoadingState.Loading);
            promise.then(q => loadingStateSetter(LoadingState.Loaded));
            promise.catch(q => loadingStateSetter(LoadingState.Failed));
        }

        return promise;
    }

    /**
     * 
     * @param {string} portfolioId 
     * @param {string} portfolioName 
     * @param {boolean} [active] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommodityManagementApi
     */
    public updatePortfolio(loadingStateSetter: null | undefined | ((state: LoadingState) => void | undefined | null), portfolioId: string, portfolioName: string, active?: boolean, options?: AxiosRequestConfig) {
        const promise = CommodityManagementApiFp(this.configuration).updatePortfolio(portfolioId, portfolioName, active, options).then((request) => request(this.axios, this.basePath));

        if (loadingStateSetter) {
            loadingStateSetter(LoadingState.Loading);
            promise.then(q => loadingStateSetter(LoadingState.Loaded));
            promise.catch(q => loadingStateSetter(LoadingState.Failed));
        }

        return promise;
    }

    /**
     * 
     * @param {UpdatePricingStrategiesRequest} [updatePricingStrategiesRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommodityManagementApi
     */
    public updatePricingStrategies(loadingStateSetter: null | undefined | ((state: LoadingState) => void | undefined | null), updatePricingStrategiesRequest?: UpdatePricingStrategiesRequest, options?: AxiosRequestConfig) {
        const promise = CommodityManagementApiFp(this.configuration).updatePricingStrategies(updatePricingStrategiesRequest, options).then((request) => request(this.axios, this.basePath));

        if (loadingStateSetter) {
            loadingStateSetter(LoadingState.Loading);
            promise.then(q => loadingStateSetter(LoadingState.Loaded));
            promise.catch(q => loadingStateSetter(LoadingState.Failed));
        }

        return promise;
    }

    /**
     * 
     * @param {string} tierId 
     * @param {string} tierName 
     * @param {number} tierRank 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommodityManagementApi
     */
    public updateTier(loadingStateSetter: null | undefined | ((state: LoadingState) => void | undefined | null), tierId: string, tierName: string, tierRank: number, options?: AxiosRequestConfig) {
        const promise = CommodityManagementApiFp(this.configuration).updateTier(tierId, tierName, tierRank, options).then((request) => request(this.axios, this.basePath));

        if (loadingStateSetter) {
            loadingStateSetter(LoadingState.Loading);
            promise.then(q => loadingStateSetter(LoadingState.Loaded));
            promise.catch(q => loadingStateSetter(LoadingState.Failed));
        }

        return promise;
    }

    /**
     * 
     * @param {UpdateWhatIfStrategyRequest} [updateWhatIfStrategyRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommodityManagementApi
     */
    public updateWhatIfStrategy(loadingStateSetter: null | undefined | ((state: LoadingState) => void | undefined | null), updateWhatIfStrategyRequest?: UpdateWhatIfStrategyRequest, options?: AxiosRequestConfig) {
        const promise = CommodityManagementApiFp(this.configuration).updateWhatIfStrategy(updateWhatIfStrategyRequest, options).then((request) => request(this.axios, this.basePath));

        if (loadingStateSetter) {
            loadingStateSetter(LoadingState.Loading);
            promise.then(q => loadingStateSetter(LoadingState.Loaded));
            promise.catch(q => loadingStateSetter(LoadingState.Failed));
        }

        return promise;
    }

    /**
     * 
     * @param {string} entityName 
     * @param {string} documentUrl 
     * @param {any} file 
     * @param {number} [entityId] 
     * @param {string} [description] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommodityManagementApi
     */
    public upload(loadingStateSetter: null | undefined | ((state: LoadingState) => void | undefined | null), entityName: string, documentUrl: string, file: any, entityId?: number, description?: string, options?: AxiosRequestConfig) {
        const promise = CommodityManagementApiFp(this.configuration).upload(entityName, documentUrl, file, entityId, description, options).then((request) => request(this.axios, this.basePath));

        if (loadingStateSetter) {
            loadingStateSetter(LoadingState.Loading);
            promise.then(q => loadingStateSetter(LoadingState.Loaded));
            promise.catch(q => loadingStateSetter(LoadingState.Failed));
        }

        return promise;
    }
}


/**
 * HealthApi - axios parameter creator
 * @export
 */
export const HealthApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApplicationHealth: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/health`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * HealthApi - functional programming interface
 * @export
 */
export const HealthApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = HealthApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getApplicationHealth(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: boolean; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getApplicationHealth(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * HealthApi - factory interface
 * @export
 */
export const HealthApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = HealthApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApplicationHealth(options?: any): AxiosPromise<{ [key: string]: boolean; }> {
            return localVarFp.getApplicationHealth(options).then((request) => request(axios, basePath));
        },
    };
};



/**
 * HealthApi - object-oriented interface
 * @export
 * @class HealthApi
 * @extends {BaseAPI}
 */
export class HealthApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HealthApi
     */
    public getApplicationHealth(loadingStateSetter: null | undefined | ((state: LoadingState) => void | undefined | null), options?: AxiosRequestConfig) {
        const promise = HealthApiFp(this.configuration).getApplicationHealth(options).then((request) => request(this.axios, this.basePath));

        if (loadingStateSetter) {
            loadingStateSetter(LoadingState.Loading);
            promise.then(q => loadingStateSetter(LoadingState.Loaded));
            promise.catch(q => loadingStateSetter(LoadingState.Failed));
        }

        return promise;
    }
}


/**
 * MarketViewApi - axios parameter creator
 * @export
 */
export const MarketViewApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} siteName 
         * @param {string} companyGuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addCommodityManagementSite: async (siteName: string, companyGuid: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'siteName' is not null or undefined
            assertParamExists('addCommodityManagementSite', 'siteName', siteName)
            // verify required parameter 'companyGuid' is not null or undefined
            assertParamExists('addCommodityManagementSite', 'companyGuid', companyGuid)
            const localVarPath = `/market-view/commodity-management/sites`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (siteName !== undefined) {
                localVarQueryParameter['SiteName'] = siteName;
            }

            if (companyGuid !== undefined) {
                localVarQueryParameter['CompanyGuid'] = companyGuid;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} siteGuid 
         * @param {string} marketViewUserGuid 
         * @param {string} [email] 
         * @param {string} [firstName] 
         * @param {string} [lastName] 
         * @param {boolean} [isSiteManager] 
         * @param {Array<CommodityManagementUserPermissions>} [permissions] 
         * @param {boolean} [initializeAccessIfNew] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addCommodityManagementUserSiteAccess: async (siteGuid: string, marketViewUserGuid: string, email?: string, firstName?: string, lastName?: string, isSiteManager?: boolean, permissions?: Array<CommodityManagementUserPermissions>, initializeAccessIfNew?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'siteGuid' is not null or undefined
            assertParamExists('addCommodityManagementUserSiteAccess', 'siteGuid', siteGuid)
            // verify required parameter 'marketViewUserGuid' is not null or undefined
            assertParamExists('addCommodityManagementUserSiteAccess', 'marketViewUserGuid', marketViewUserGuid)
            const localVarPath = `/market-view/commodity-management/sites/{siteGuid}/{marketViewUserGuid}`
                .replace(`{${"siteGuid"}}`, encodeURIComponent(String(siteGuid)))
                .replace(`{${"marketViewUserGuid"}}`, encodeURIComponent(String(marketViewUserGuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (email !== undefined) {
                localVarQueryParameter['Email'] = email;
            }

            if (firstName !== undefined) {
                localVarQueryParameter['FirstName'] = firstName;
            }

            if (lastName !== undefined) {
                localVarQueryParameter['LastName'] = lastName;
            }

            if (isSiteManager !== undefined) {
                localVarQueryParameter['IsSiteManager'] = isSiteManager;
            }

            if (permissions) {
                localVarQueryParameter['Permissions'] = permissions;
            }

            if (initializeAccessIfNew !== undefined) {
                localVarQueryParameter['InitializeAccessIfNew'] = initializeAccessIfNew;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {AddCompanyRequest} [addCompanyRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addCompany: async (addCompanyRequest?: AddCompanyRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/market-view/companies`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addCompanyRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} savedQueryId 
         * @param {string} name 
         * @param {Array<MarkItViewQuerySavedParameters>} markItViewQuerySavedParameters 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addMarketViewSavedQuery: async (savedQueryId: number, name: string, markItViewQuerySavedParameters: Array<MarkItViewQuerySavedParameters>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'savedQueryId' is not null or undefined
            assertParamExists('addMarketViewSavedQuery', 'savedQueryId', savedQueryId)
            // verify required parameter 'name' is not null or undefined
            assertParamExists('addMarketViewSavedQuery', 'name', name)
            // verify required parameter 'markItViewQuerySavedParameters' is not null or undefined
            assertParamExists('addMarketViewSavedQuery', 'markItViewQuerySavedParameters', markItViewQuerySavedParameters)
            const localVarPath = `/market-view/saved-queries`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (savedQueryId !== undefined) {
                localVarQueryParameter['SavedQueryId'] = savedQueryId;
            }

            if (name !== undefined) {
                localVarQueryParameter['Name'] = name;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(markItViewQuerySavedParameters, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {AddMarketViewUserRequest} [addMarketViewUserRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addMarketViewUser: async (addMarketViewUserRequest?: AddMarketViewUserRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/market-view/users`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addMarketViewUserRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} productId 
         * @param {AddMarketViewUserFavoritedProductRequest} [addMarketViewUserFavoritedProductRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addMarketViewUserFavoritedProduct: async (productId: string, addMarketViewUserFavoritedProductRequest?: AddMarketViewUserFavoritedProductRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'productId' is not null or undefined
            assertParamExists('addMarketViewUserFavoritedProduct', 'productId', productId)
            const localVarPath = `/market-view/products/{productId}/favorites`
                .replace(`{${"productId"}}`, encodeURIComponent(String(productId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addMarketViewUserFavoritedProductRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} userVolumeId 
         * @param {string} name 
         * @param {{ [key: string]: number; }} volumes 
         * @param {string} [sortColumn] 
         * @param {SortDirection} [sortDirection] 
         * @param {number} [take] 
         * @param {number} [skip] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addMarketViewVolume: async (userVolumeId: number, name: string, volumes: { [key: string]: number; }, sortColumn?: string, sortDirection?: SortDirection, take?: number, skip?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userVolumeId' is not null or undefined
            assertParamExists('addMarketViewVolume', 'userVolumeId', userVolumeId)
            // verify required parameter 'name' is not null or undefined
            assertParamExists('addMarketViewVolume', 'name', name)
            // verify required parameter 'volumes' is not null or undefined
            assertParamExists('addMarketViewVolume', 'volumes', volumes)
            const localVarPath = `/market-view/volumes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (userVolumeId !== undefined) {
                localVarQueryParameter['UserVolumeId'] = userVolumeId;
            }

            if (name !== undefined) {
                localVarQueryParameter['Name'] = name;
            }

            if (volumes !== undefined) {
                localVarQueryParameter['Volumes'] = volumes;
            }

            if (sortColumn !== undefined) {
                localVarQueryParameter['SortColumn'] = sortColumn;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['SortDirection'] = sortDirection;
            }

            if (take !== undefined) {
                localVarQueryParameter['Take'] = take;
            }

            if (skip !== undefined) {
                localVarQueryParameter['Skip'] = skip;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {AgreeToMarketViewTermsAndConditionsRequest} [agreeToMarketViewTermsAndConditionsRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agreeToDemeterTermsAndConditions: async (agreeToMarketViewTermsAndConditionsRequest?: AgreeToMarketViewTermsAndConditionsRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/market-view/users/terms-and-conditions/agree`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(agreeToMarketViewTermsAndConditionsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CalculateMatrixRequest} [calculateMatrixRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        calculateMatrix: async (calculateMatrixRequest?: CalculateMatrixRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/market-view/matrix/calculate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(calculateMatrixRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} siteGuid 
         * @param {string} marketViewUserGuid 
         * @param {boolean} [disableUserIfNoOtherSites] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCommodityManagementUserSiteAccess: async (siteGuid: string, marketViewUserGuid: string, disableUserIfNoOtherSites?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'siteGuid' is not null or undefined
            assertParamExists('deleteCommodityManagementUserSiteAccess', 'siteGuid', siteGuid)
            // verify required parameter 'marketViewUserGuid' is not null or undefined
            assertParamExists('deleteCommodityManagementUserSiteAccess', 'marketViewUserGuid', marketViewUserGuid)
            const localVarPath = `/market-view/commodity-management/sites/{siteGuid}/{marketViewUserGuid}`
                .replace(`{${"siteGuid"}}`, encodeURIComponent(String(siteGuid)))
                .replace(`{${"marketViewUserGuid"}}`, encodeURIComponent(String(marketViewUserGuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (disableUserIfNoOtherSites !== undefined) {
                localVarQueryParameter['DisableUserIfNoOtherSites'] = disableUserIfNoOtherSites;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} emailScheduleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEmailSchedule: async (emailScheduleId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'emailScheduleId' is not null or undefined
            assertParamExists('deleteEmailSchedule', 'emailScheduleId', emailScheduleId)
            const localVarPath = `/market-view/email-schedules/{emailScheduleId}`
                .replace(`{${"emailScheduleId"}}`, encodeURIComponent(String(emailScheduleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} savedQueryId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteMarketViewSavedQuery: async (savedQueryId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'savedQueryId' is not null or undefined
            assertParamExists('deleteMarketViewSavedQuery', 'savedQueryId', savedQueryId)
            const localVarPath = `/market-view/saved-queries/{savedQueryId}`
                .replace(`{${"savedQueryId"}}`, encodeURIComponent(String(savedQueryId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} productId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteMarketViewUserFavoritedProduct: async (productId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'productId' is not null or undefined
            assertParamExists('deleteMarketViewUserFavoritedProduct', 'productId', productId)
            const localVarPath = `/market-view/products/{productId}/favorites`
                .replace(`{${"productId"}}`, encodeURIComponent(String(productId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} savedQueryId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportMarketViewSavedQuery: async (savedQueryId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'savedQueryId' is not null or undefined
            assertParamExists('exportMarketViewSavedQuery', 'savedQueryId', savedQueryId)
            const localVarPath = `/market-view/saved-queries/{savedQueryId}/export`
                .replace(`{${"savedQueryId"}}`, encodeURIComponent(String(savedQueryId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} companyGuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompany: async (companyGuid: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyGuid' is not null or undefined
            assertParamExists('getCompany', 'companyGuid', companyGuid)
            const localVarPath = `/market-view/companies/{companyGuid}`
                .replace(`{${"companyGuid"}}`, encodeURIComponent(String(companyGuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} startDate 
         * @param {string} endDate 
         * @param {string} commodity 
         * @param {string} [markToMarketDate] 
         * @param {string} [sortColumn] 
         * @param {SortDirection} [sortDirection] 
         * @param {number} [take] 
         * @param {number} [skip] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDecisiveBasisPrices: async (startDate: string, endDate: string, commodity: string, markToMarketDate?: string, sortColumn?: string, sortDirection?: SortDirection, take?: number, skip?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'startDate' is not null or undefined
            assertParamExists('getDecisiveBasisPrices', 'startDate', startDate)
            // verify required parameter 'endDate' is not null or undefined
            assertParamExists('getDecisiveBasisPrices', 'endDate', endDate)
            // verify required parameter 'commodity' is not null or undefined
            assertParamExists('getDecisiveBasisPrices', 'commodity', commodity)
            const localVarPath = `/market-view/decisive/mfmbasisprices/{startDate}/{endDate}/{commodity}`
                .replace(`{${"startDate"}}`, encodeURIComponent(String(startDate)))
                .replace(`{${"endDate"}}`, encodeURIComponent(String(endDate)))
                .replace(`{${"commodity"}}`, encodeURIComponent(String(commodity)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (markToMarketDate !== undefined) {
                localVarQueryParameter['MarkToMarketDate'] = (markToMarketDate as any instanceof Date) ?
                    (markToMarketDate as any).toISOString() :
                    markToMarketDate;
            }

            if (sortColumn !== undefined) {
                localVarQueryParameter['SortColumn'] = sortColumn;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['SortDirection'] = sortDirection;
            }

            if (take !== undefined) {
                localVarQueryParameter['Take'] = take;
            }

            if (skip !== undefined) {
                localVarQueryParameter['Skip'] = skip;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} startDate 
         * @param {string} endDate 
         * @param {string} commodity 
         * @param {string} [markToMarketDate] 
         * @param {string} [sortColumn] 
         * @param {SortDirection} [sortDirection] 
         * @param {number} [take] 
         * @param {number} [skip] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDecisiveFutureBasisPricesRangeByCommodity: async (startDate: string, endDate: string, commodity: string, markToMarketDate?: string, sortColumn?: string, sortDirection?: SortDirection, take?: number, skip?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'startDate' is not null or undefined
            assertParamExists('getDecisiveFutureBasisPricesRangeByCommodity', 'startDate', startDate)
            // verify required parameter 'endDate' is not null or undefined
            assertParamExists('getDecisiveFutureBasisPricesRangeByCommodity', 'endDate', endDate)
            // verify required parameter 'commodity' is not null or undefined
            assertParamExists('getDecisiveFutureBasisPricesRangeByCommodity', 'commodity', commodity)
            const localVarPath = `/market-view/decisive/mfmfuturesbasisprices/{startDate}/{endDate}/{commodity}`
                .replace(`{${"startDate"}}`, encodeURIComponent(String(startDate)))
                .replace(`{${"endDate"}}`, encodeURIComponent(String(endDate)))
                .replace(`{${"commodity"}}`, encodeURIComponent(String(commodity)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (markToMarketDate !== undefined) {
                localVarQueryParameter['MarkToMarketDate'] = (markToMarketDate as any instanceof Date) ?
                    (markToMarketDate as any).toISOString() :
                    markToMarketDate;
            }

            if (sortColumn !== undefined) {
                localVarQueryParameter['SortColumn'] = sortColumn;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['SortDirection'] = sortDirection;
            }

            if (take !== undefined) {
                localVarQueryParameter['Take'] = take;
            }

            if (skip !== undefined) {
                localVarQueryParameter['Skip'] = skip;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} startDate 
         * @param {string} endDate 
         * @param {string} commodity 
         * @param {string} [markToMarketDate] 
         * @param {string} [sortColumn] 
         * @param {SortDirection} [sortDirection] 
         * @param {number} [take] 
         * @param {number} [skip] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDecisiveFuturePricesRangeByCommodity: async (startDate: string, endDate: string, commodity: string, markToMarketDate?: string, sortColumn?: string, sortDirection?: SortDirection, take?: number, skip?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'startDate' is not null or undefined
            assertParamExists('getDecisiveFuturePricesRangeByCommodity', 'startDate', startDate)
            // verify required parameter 'endDate' is not null or undefined
            assertParamExists('getDecisiveFuturePricesRangeByCommodity', 'endDate', endDate)
            // verify required parameter 'commodity' is not null or undefined
            assertParamExists('getDecisiveFuturePricesRangeByCommodity', 'commodity', commodity)
            const localVarPath = `/market-view/decisive/mfmfuturesprices/{startDate}/{endDate}/{commodity}`
                .replace(`{${"startDate"}}`, encodeURIComponent(String(startDate)))
                .replace(`{${"endDate"}}`, encodeURIComponent(String(endDate)))
                .replace(`{${"commodity"}}`, encodeURIComponent(String(commodity)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (markToMarketDate !== undefined) {
                localVarQueryParameter['MarkToMarketDate'] = (markToMarketDate as any instanceof Date) ?
                    (markToMarketDate as any).toISOString() :
                    markToMarketDate;
            }

            if (sortColumn !== undefined) {
                localVarQueryParameter['SortColumn'] = sortColumn;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['SortDirection'] = sortDirection;
            }

            if (take !== undefined) {
                localVarQueryParameter['Take'] = take;
            }

            if (skip !== undefined) {
                localVarQueryParameter['Skip'] = skip;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} startDate 
         * @param {string} endDate 
         * @param {string} commodity 
         * @param {string} [markToMarketDate] 
         * @param {string} [sortColumn] 
         * @param {SortDirection} [sortDirection] 
         * @param {number} [take] 
         * @param {number} [skip] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDecisiveSpecialtyCropPricesRangeByCommodity: async (startDate: string, endDate: string, commodity: string, markToMarketDate?: string, sortColumn?: string, sortDirection?: SortDirection, take?: number, skip?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'startDate' is not null or undefined
            assertParamExists('getDecisiveSpecialtyCropPricesRangeByCommodity', 'startDate', startDate)
            // verify required parameter 'endDate' is not null or undefined
            assertParamExists('getDecisiveSpecialtyCropPricesRangeByCommodity', 'endDate', endDate)
            // verify required parameter 'commodity' is not null or undefined
            assertParamExists('getDecisiveSpecialtyCropPricesRangeByCommodity', 'commodity', commodity)
            const localVarPath = `/market-view/decisive/mfmspecialtycrops/{startDate}/{endDate}/{commodity}`
                .replace(`{${"startDate"}}`, encodeURIComponent(String(startDate)))
                .replace(`{${"endDate"}}`, encodeURIComponent(String(endDate)))
                .replace(`{${"commodity"}}`, encodeURIComponent(String(commodity)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (markToMarketDate !== undefined) {
                localVarQueryParameter['MarkToMarketDate'] = (markToMarketDate as any instanceof Date) ?
                    (markToMarketDate as any).toISOString() :
                    markToMarketDate;
            }

            if (sortColumn !== undefined) {
                localVarQueryParameter['SortColumn'] = sortColumn;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['SortDirection'] = sortDirection;
            }

            if (take !== undefined) {
                localVarQueryParameter['Take'] = take;
            }

            if (skip !== undefined) {
                localVarQueryParameter['Skip'] = skip;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} productId 
         * @param {number} [forecastHistoryYears] 
         * @param {string} [quoteDate] 
         * @param {number} [recentHistoryDays] 
         * @param {number} [historicalMedianYears] 
         * @param {number} [startContractDateYear] 
         * @param {number} [startContractDateMonth] 
         * @param {string} [startContractDateLabel] 
         * @param {number} [monthsAhead] 
         * @param {boolean} [applyPpi] 
         * @param {boolean} [refreshCache] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getForecastInternal: async (productId: string, forecastHistoryYears?: number, quoteDate?: string, recentHistoryDays?: number, historicalMedianYears?: number, startContractDateYear?: number, startContractDateMonth?: number, startContractDateLabel?: string, monthsAhead?: number, applyPpi?: boolean, refreshCache?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'productId' is not null or undefined
            assertParamExists('getForecastInternal', 'productId', productId)
            const localVarPath = `/market-view/internal/forecast/{productId}`
                .replace(`{${"productId"}}`, encodeURIComponent(String(productId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (forecastHistoryYears !== undefined) {
                localVarQueryParameter['ForecastHistoryYears'] = forecastHistoryYears;
            }

            if (quoteDate !== undefined) {
                localVarQueryParameter['QuoteDate'] = (quoteDate as any instanceof Date) ?
                    (quoteDate as any).toISOString() :
                    quoteDate;
            }

            if (recentHistoryDays !== undefined) {
                localVarQueryParameter['RecentHistoryDays'] = recentHistoryDays;
            }

            if (historicalMedianYears !== undefined) {
                localVarQueryParameter['HistoricalMedianYears'] = historicalMedianYears;
            }

            if (startContractDateYear !== undefined) {
                localVarQueryParameter['StartContractDate.Year'] = startContractDateYear;
            }

            if (startContractDateMonth !== undefined) {
                localVarQueryParameter['StartContractDate.Month'] = startContractDateMonth;
            }

            if (startContractDateLabel !== undefined) {
                localVarQueryParameter['StartContractDate.Label'] = startContractDateLabel;
            }

            if (monthsAhead !== undefined) {
                localVarQueryParameter['MonthsAhead'] = monthsAhead;
            }

            if (applyPpi !== undefined) {
                localVarQueryParameter['ApplyPpi'] = applyPpi;
            }

            if (refreshCache !== undefined) {
                localVarQueryParameter['RefreshCache'] = refreshCache;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} productId 
         * @param {string} [quoteDate] 
         * @param {number} [recentHistoryDays] 
         * @param {number} [historicalMedianYears] 
         * @param {number} [forecastHistoryYears] 
         * @param {number} [startContractDateYear] 
         * @param {number} [startContractDateMonth] 
         * @param {string} [startContractDateLabel] 
         * @param {number} [monthsAhead] 
         * @param {boolean} [applyPpi] 
         * @param {boolean} [refreshCache] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getForecastWithHistory: async (productId: string, quoteDate?: string, recentHistoryDays?: number, historicalMedianYears?: number, forecastHistoryYears?: number, startContractDateYear?: number, startContractDateMonth?: number, startContractDateLabel?: string, monthsAhead?: number, applyPpi?: boolean, refreshCache?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'productId' is not null or undefined
            assertParamExists('getForecastWithHistory', 'productId', productId)
            const localVarPath = `/market-view/webtools/forecast/{productId}`
                .replace(`{${"productId"}}`, encodeURIComponent(String(productId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (quoteDate !== undefined) {
                localVarQueryParameter['QuoteDate'] = (quoteDate as any instanceof Date) ?
                    (quoteDate as any).toISOString() :
                    quoteDate;
            }

            if (recentHistoryDays !== undefined) {
                localVarQueryParameter['RecentHistoryDays'] = recentHistoryDays;
            }

            if (historicalMedianYears !== undefined) {
                localVarQueryParameter['HistoricalMedianYears'] = historicalMedianYears;
            }

            if (forecastHistoryYears !== undefined) {
                localVarQueryParameter['ForecastHistoryYears'] = forecastHistoryYears;
            }

            if (startContractDateYear !== undefined) {
                localVarQueryParameter['StartContractDate.Year'] = startContractDateYear;
            }

            if (startContractDateMonth !== undefined) {
                localVarQueryParameter['StartContractDate.Month'] = startContractDateMonth;
            }

            if (startContractDateLabel !== undefined) {
                localVarQueryParameter['StartContractDate.Label'] = startContractDateLabel;
            }

            if (monthsAhead !== undefined) {
                localVarQueryParameter['MonthsAhead'] = monthsAhead;
            }

            if (applyPpi !== undefined) {
                localVarQueryParameter['ApplyPpi'] = applyPpi;
            }

            if (refreshCache !== undefined) {
                localVarQueryParameter['RefreshCache'] = refreshCache;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} productId 
         * @param {string} [quoteDate] 
         * @param {number} [recentHistoryDays] 
         * @param {number} [historicalMedianYears] 
         * @param {number} [forecastHistoryYears] 
         * @param {number} [startContractDateYear] 
         * @param {number} [startContractDateMonth] 
         * @param {string} [startContractDateLabel] 
         * @param {number} [monthsAhead] 
         * @param {boolean} [applyPpi] 
         * @param {boolean} [refreshCache] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getForecastWithHistoryInternal: async (productId: string, quoteDate?: string, recentHistoryDays?: number, historicalMedianYears?: number, forecastHistoryYears?: number, startContractDateYear?: number, startContractDateMonth?: number, startContractDateLabel?: string, monthsAhead?: number, applyPpi?: boolean, refreshCache?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'productId' is not null or undefined
            assertParamExists('getForecastWithHistoryInternal', 'productId', productId)
            const localVarPath = `/market-view/internal/forecast/{productId}/history`
                .replace(`{${"productId"}}`, encodeURIComponent(String(productId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (quoteDate !== undefined) {
                localVarQueryParameter['QuoteDate'] = (quoteDate as any instanceof Date) ?
                    (quoteDate as any).toISOString() :
                    quoteDate;
            }

            if (recentHistoryDays !== undefined) {
                localVarQueryParameter['RecentHistoryDays'] = recentHistoryDays;
            }

            if (historicalMedianYears !== undefined) {
                localVarQueryParameter['HistoricalMedianYears'] = historicalMedianYears;
            }

            if (forecastHistoryYears !== undefined) {
                localVarQueryParameter['ForecastHistoryYears'] = forecastHistoryYears;
            }

            if (startContractDateYear !== undefined) {
                localVarQueryParameter['StartContractDate.Year'] = startContractDateYear;
            }

            if (startContractDateMonth !== undefined) {
                localVarQueryParameter['StartContractDate.Month'] = startContractDateMonth;
            }

            if (startContractDateLabel !== undefined) {
                localVarQueryParameter['StartContractDate.Label'] = startContractDateLabel;
            }

            if (monthsAhead !== undefined) {
                localVarQueryParameter['MonthsAhead'] = monthsAhead;
            }

            if (applyPpi !== undefined) {
                localVarQueryParameter['ApplyPpi'] = applyPpi;
            }

            if (refreshCache !== undefined) {
                localVarQueryParameter['RefreshCache'] = refreshCache;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} symbolId 
         * @param {string} [asOfDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMarketViewLastQuoteDate: async (symbolId: string, asOfDate?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'symbolId' is not null or undefined
            assertParamExists('getMarketViewLastQuoteDate', 'symbolId', symbolId)
            const localVarPath = `/market-view/prices/{symbolId}/last-quote-dates`
                .replace(`{${"symbolId"}}`, encodeURIComponent(String(symbolId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (asOfDate !== undefined) {
                localVarQueryParameter['AsOfDate'] = (asOfDate as any instanceof Date) ?
                    (asOfDate as any).toISOString() :
                    asOfDate;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} symbolId 
         * @param {string} [asOfDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMarketViewLastQuoteDateApi: async (symbolId: string, asOfDate?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'symbolId' is not null or undefined
            assertParamExists('getMarketViewLastQuoteDateApi', 'symbolId', symbolId)
            const localVarPath = `/market-view/api/prices/{symbolId}/last-quote-dates`
                .replace(`{${"symbolId"}}`, encodeURIComponent(String(symbolId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (asOfDate !== undefined) {
                localVarQueryParameter['AsOfDate'] = (asOfDate as any instanceof Date) ?
                    (asOfDate as any).toISOString() :
                    asOfDate;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} marketViewUserGuid 
         * @param {string} [stoneXUserGuid] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMarketViewUser: async (marketViewUserGuid: string, stoneXUserGuid?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'marketViewUserGuid' is not null or undefined
            assertParamExists('getMarketViewUser', 'marketViewUserGuid', marketViewUserGuid)
            const localVarPath = `/market-view/users/{marketViewUserGuid}`
                .replace(`{${"marketViewUserGuid"}}`, encodeURIComponent(String(marketViewUserGuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (stoneXUserGuid !== undefined) {
                localVarQueryParameter['StoneXUserGuid'] = stoneXUserGuid;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} siteGuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCommodityManagementSiteUsers: async (siteGuid: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'siteGuid' is not null or undefined
            assertParamExists('listCommodityManagementSiteUsers', 'siteGuid', siteGuid)
            const localVarPath = `/market-view/commodity-management/sites/{siteGuid}/users`
                .replace(`{${"siteGuid"}}`, encodeURIComponent(String(siteGuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {boolean} [includeUserSiteAccess] 
         * @param {string} [sortColumn] 
         * @param {SortDirection} [sortDirection] 
         * @param {number} [take] 
         * @param {number} [skip] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCommodityManagementSites: async (includeUserSiteAccess?: boolean, sortColumn?: string, sortDirection?: SortDirection, take?: number, skip?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/market-view/commodity-management/sites`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (includeUserSiteAccess !== undefined) {
                localVarQueryParameter['IncludeUserSiteAccess'] = includeUserSiteAccess;
            }

            if (sortColumn !== undefined) {
                localVarQueryParameter['SortColumn'] = sortColumn;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['SortDirection'] = sortDirection;
            }

            if (take !== undefined) {
                localVarQueryParameter['Take'] = take;
            }

            if (skip !== undefined) {
                localVarQueryParameter['Skip'] = skip;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [sortColumn] 
         * @param {SortDirection} [sortDirection] 
         * @param {number} [take] 
         * @param {number} [skip] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCompanies: async (sortColumn?: string, sortDirection?: SortDirection, take?: number, skip?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/market-view/companies`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (sortColumn !== undefined) {
                localVarQueryParameter['SortColumn'] = sortColumn;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['SortDirection'] = sortDirection;
            }

            if (take !== undefined) {
                localVarQueryParameter['Take'] = take;
            }

            if (skip !== undefined) {
                localVarQueryParameter['Skip'] = skip;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {EmailScheduleSource} [source] 
         * @param {number} [sourceId] 
         * @param {string} [sortColumn] 
         * @param {SortDirection} [sortDirection] 
         * @param {number} [take] 
         * @param {number} [skip] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listEmailSchedules: async (source?: EmailScheduleSource, sourceId?: number, sortColumn?: string, sortDirection?: SortDirection, take?: number, skip?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/market-view/email-schedules`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (source !== undefined) {
                localVarQueryParameter['Source'] = source;
            }

            if (sourceId !== undefined) {
                localVarQueryParameter['SourceId'] = sourceId;
            }

            if (sortColumn !== undefined) {
                localVarQueryParameter['SortColumn'] = sortColumn;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['SortDirection'] = sortDirection;
            }

            if (take !== undefined) {
                localVarQueryParameter['Take'] = take;
            }

            if (skip !== undefined) {
                localVarQueryParameter['Skip'] = skip;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ListMarketViewContractPricesRequest} [listMarketViewContractPricesRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMarketViewContractPricesApi: async (listMarketViewContractPricesRequest?: ListMarketViewContractPricesRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/market-view/api/prices/contract-prices`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(listMarketViewContractPricesRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} quoteDate 
         * @param {Array<Currency>} currencies 
         * @param {Array<ContractDate>} contractMonths 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMarketViewCurrencySpotRates: async (quoteDate: string, currencies: Array<Currency>, contractMonths: Array<ContractDate>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'quoteDate' is not null or undefined
            assertParamExists('listMarketViewCurrencySpotRates', 'quoteDate', quoteDate)
            // verify required parameter 'currencies' is not null or undefined
            assertParamExists('listMarketViewCurrencySpotRates', 'currencies', currencies)
            // verify required parameter 'contractMonths' is not null or undefined
            assertParamExists('listMarketViewCurrencySpotRates', 'contractMonths', contractMonths)
            const localVarPath = `/market-view/prices/spot-rates`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (quoteDate !== undefined) {
                localVarQueryParameter['QuoteDate'] = (quoteDate as any instanceof Date) ?
                    (quoteDate as any).toISOString() :
                    quoteDate;
            }

            if (currencies) {
                localVarQueryParameter['Currencies'] = currencies;
            }

            if (contractMonths) {
                localVarQueryParameter['ContractMonths'] = contractMonths;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} quoteDate 
         * @param {Array<Currency>} currencies 
         * @param {Array<ContractDate>} contractMonths 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMarketViewCurrencySpotRatesApi: async (quoteDate: string, currencies: Array<Currency>, contractMonths: Array<ContractDate>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'quoteDate' is not null or undefined
            assertParamExists('listMarketViewCurrencySpotRatesApi', 'quoteDate', quoteDate)
            // verify required parameter 'currencies' is not null or undefined
            assertParamExists('listMarketViewCurrencySpotRatesApi', 'currencies', currencies)
            // verify required parameter 'contractMonths' is not null or undefined
            assertParamExists('listMarketViewCurrencySpotRatesApi', 'contractMonths', contractMonths)
            const localVarPath = `/market-view/api/prices/spot-rates`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (quoteDate !== undefined) {
                localVarQueryParameter['QuoteDate'] = (quoteDate as any instanceof Date) ?
                    (quoteDate as any).toISOString() :
                    quoteDate;
            }

            if (currencies) {
                localVarQueryParameter['Currencies'] = currencies;
            }

            if (contractMonths) {
                localVarQueryParameter['ContractMonths'] = contractMonths;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} productId 
         * @param {string} [quoteDateRangeStart] 
         * @param {string} [quoteDateRangeEnd] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMarketViewDailyPrices: async (productId: string, quoteDateRangeStart?: string, quoteDateRangeEnd?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'productId' is not null or undefined
            assertParamExists('listMarketViewDailyPrices', 'productId', productId)
            const localVarPath = `/market-view/prices/{productId}/daily`
                .replace(`{${"productId"}}`, encodeURIComponent(String(productId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (quoteDateRangeStart !== undefined) {
                localVarQueryParameter['QuoteDateRange.Start'] = (quoteDateRangeStart as any instanceof Date) ?
                    (quoteDateRangeStart as any).toISOString().substr(0,10) :
                    quoteDateRangeStart;
            }

            if (quoteDateRangeEnd !== undefined) {
                localVarQueryParameter['QuoteDateRange.End'] = (quoteDateRangeEnd as any instanceof Date) ?
                    (quoteDateRangeEnd as any).toISOString().substr(0,10) :
                    quoteDateRangeEnd;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<number>} productIds 
         * @param {boolean} [refreshCache] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMarketViewExpirationDates: async (productIds: Array<number>, refreshCache?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'productIds' is not null or undefined
            assertParamExists('listMarketViewExpirationDates', 'productIds', productIds)
            const localVarPath = `/market-view/expiration-dates`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (productIds) {
                localVarQueryParameter['ProductIds'] = productIds;
            }

            if (refreshCache !== undefined) {
                localVarQueryParameter['RefreshCache'] = refreshCache;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<number>} productIds 
         * @param {boolean} [refreshCache] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMarketViewExpirationDatesApi: async (productIds: Array<number>, refreshCache?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'productIds' is not null or undefined
            assertParamExists('listMarketViewExpirationDatesApi', 'productIds', productIds)
            const localVarPath = `/market-view/api/expiration-dates`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (productIds) {
                localVarQueryParameter['ProductIds'] = productIds;
            }

            if (refreshCache !== undefined) {
                localVarQueryParameter['RefreshCache'] = refreshCache;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} productId 
         * @param {string} quoteDate 
         * @param {number} [numberOfMonths] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMarketViewForwardCurveQuery: async (productId: string, quoteDate: string, numberOfMonths?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'productId' is not null or undefined
            assertParamExists('listMarketViewForwardCurveQuery', 'productId', productId)
            // verify required parameter 'quoteDate' is not null or undefined
            assertParamExists('listMarketViewForwardCurveQuery', 'quoteDate', quoteDate)
            const localVarPath = `/market-view/prices/{productId}/forward-curve`
                .replace(`{${"productId"}}`, encodeURIComponent(String(productId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (quoteDate !== undefined) {
                localVarQueryParameter['QuoteDate'] = (quoteDate as any instanceof Date) ?
                    (quoteDate as any).toISOString() :
                    quoteDate;
            }

            if (numberOfMonths !== undefined) {
                localVarQueryParameter['NumberOfMonths'] = numberOfMonths;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} productId 
         * @param {string} quoteDate 
         * @param {number} [numberOfMonths] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMarketViewForwardCurveQueryApi: async (productId: string, quoteDate: string, numberOfMonths?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'productId' is not null or undefined
            assertParamExists('listMarketViewForwardCurveQueryApi', 'productId', productId)
            // verify required parameter 'quoteDate' is not null or undefined
            assertParamExists('listMarketViewForwardCurveQueryApi', 'quoteDate', quoteDate)
            const localVarPath = `/market-view/api/prices/{productId}/forward-curve`
                .replace(`{${"productId"}}`, encodeURIComponent(String(productId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (quoteDate !== undefined) {
                localVarQueryParameter['QuoteDate'] = (quoteDate as any instanceof Date) ?
                    (quoteDate as any).toISOString() :
                    quoteDate;
            }

            if (numberOfMonths !== undefined) {
                localVarQueryParameter['NumberOfMonths'] = numberOfMonths;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<number>} symbolIds 
         * @param {string} [asOfDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMarketViewLastQuoteDate: async (symbolIds: Array<number>, asOfDate?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'symbolIds' is not null or undefined
            assertParamExists('listMarketViewLastQuoteDate', 'symbolIds', symbolIds)
            const localVarPath = `/market-view/prices/last-quote-dates`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (symbolIds) {
                localVarQueryParameter['SymbolIds'] = symbolIds;
            }

            if (asOfDate !== undefined) {
                localVarQueryParameter['AsOfDate'] = (asOfDate as any instanceof Date) ?
                    (asOfDate as any).toISOString() :
                    asOfDate;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<number>} symbolIds 
         * @param {string} [asOfDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMarketViewLastQuoteDateApi: async (symbolIds: Array<number>, asOfDate?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'symbolIds' is not null or undefined
            assertParamExists('listMarketViewLastQuoteDateApi', 'symbolIds', symbolIds)
            const localVarPath = `/market-view/api/prices/last-quote-dates`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (symbolIds) {
                localVarQueryParameter['SymbolIds'] = symbolIds;
            }

            if (asOfDate !== undefined) {
                localVarQueryParameter['AsOfDate'] = (asOfDate as any instanceof Date) ?
                    (asOfDate as any).toISOString() :
                    asOfDate;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} productId 
         * @param {Array<number>} years 
         * @param {string} [quoteDateRangeStart] 
         * @param {string} [quoteDateRangeEnd] 
         * @param {number} [userVolumeId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMarketViewPriceQueryCalendarStripAvearge: async (productId: string, years: Array<number>, quoteDateRangeStart?: string, quoteDateRangeEnd?: string, userVolumeId?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'productId' is not null or undefined
            assertParamExists('listMarketViewPriceQueryCalendarStripAvearge', 'productId', productId)
            // verify required parameter 'years' is not null or undefined
            assertParamExists('listMarketViewPriceQueryCalendarStripAvearge', 'years', years)
            const localVarPath = `/market-view/prices/{productId}/calendar-strip-average`
                .replace(`{${"productId"}}`, encodeURIComponent(String(productId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (quoteDateRangeStart !== undefined) {
                localVarQueryParameter['QuoteDateRange.Start'] = (quoteDateRangeStart as any instanceof Date) ?
                    (quoteDateRangeStart as any).toISOString().substr(0,10) :
                    quoteDateRangeStart;
            }

            if (quoteDateRangeEnd !== undefined) {
                localVarQueryParameter['QuoteDateRange.End'] = (quoteDateRangeEnd as any instanceof Date) ?
                    (quoteDateRangeEnd as any).toISOString().substr(0,10) :
                    quoteDateRangeEnd;
            }

            if (years) {
                localVarQueryParameter['Years'] = years;
            }

            if (userVolumeId !== undefined) {
                localVarQueryParameter['UserVolumeId'] = userVolumeId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} productId 
         * @param {Array<number>} years 
         * @param {string} [quoteDateRangeStart] 
         * @param {string} [quoteDateRangeEnd] 
         * @param {number} [userVolumeId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMarketViewPriceQueryCalendarStripAverageApi: async (productId: string, years: Array<number>, quoteDateRangeStart?: string, quoteDateRangeEnd?: string, userVolumeId?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'productId' is not null or undefined
            assertParamExists('listMarketViewPriceQueryCalendarStripAverageApi', 'productId', productId)
            // verify required parameter 'years' is not null or undefined
            assertParamExists('listMarketViewPriceQueryCalendarStripAverageApi', 'years', years)
            const localVarPath = `/market-view/api/prices/{productId}/calendar-strip-average`
                .replace(`{${"productId"}}`, encodeURIComponent(String(productId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (quoteDateRangeStart !== undefined) {
                localVarQueryParameter['QuoteDateRange.Start'] = (quoteDateRangeStart as any instanceof Date) ?
                    (quoteDateRangeStart as any).toISOString().substr(0,10) :
                    quoteDateRangeStart;
            }

            if (quoteDateRangeEnd !== undefined) {
                localVarQueryParameter['QuoteDateRange.End'] = (quoteDateRangeEnd as any instanceof Date) ?
                    (quoteDateRangeEnd as any).toISOString().substr(0,10) :
                    quoteDateRangeEnd;
            }

            if (years) {
                localVarQueryParameter['Years'] = years;
            }

            if (userVolumeId !== undefined) {
                localVarQueryParameter['UserVolumeId'] = userVolumeId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} productId 
         * @param {number} monthsAhead 
         * @param {string} [quoteDateRangeStart] 
         * @param {string} [quoteDateRangeEnd] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMarketViewPriceQueryRollingMonthAhead: async (productId: string, monthsAhead: number, quoteDateRangeStart?: string, quoteDateRangeEnd?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'productId' is not null or undefined
            assertParamExists('listMarketViewPriceQueryRollingMonthAhead', 'productId', productId)
            // verify required parameter 'monthsAhead' is not null or undefined
            assertParamExists('listMarketViewPriceQueryRollingMonthAhead', 'monthsAhead', monthsAhead)
            const localVarPath = `/market-view/prices/{productId}/rolling-month-ahead`
                .replace(`{${"productId"}}`, encodeURIComponent(String(productId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (quoteDateRangeStart !== undefined) {
                localVarQueryParameter['QuoteDateRange.Start'] = (quoteDateRangeStart as any instanceof Date) ?
                    (quoteDateRangeStart as any).toISOString().substr(0,10) :
                    quoteDateRangeStart;
            }

            if (quoteDateRangeEnd !== undefined) {
                localVarQueryParameter['QuoteDateRange.End'] = (quoteDateRangeEnd as any instanceof Date) ?
                    (quoteDateRangeEnd as any).toISOString().substr(0,10) :
                    quoteDateRangeEnd;
            }

            if (monthsAhead !== undefined) {
                localVarQueryParameter['MonthsAhead'] = monthsAhead;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} productId 
         * @param {number} monthsAhead 
         * @param {string} [quoteDateRangeStart] 
         * @param {string} [quoteDateRangeEnd] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMarketViewPriceQueryRollingMonthAheadApi: async (productId: string, monthsAhead: number, quoteDateRangeStart?: string, quoteDateRangeEnd?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'productId' is not null or undefined
            assertParamExists('listMarketViewPriceQueryRollingMonthAheadApi', 'productId', productId)
            // verify required parameter 'monthsAhead' is not null or undefined
            assertParamExists('listMarketViewPriceQueryRollingMonthAheadApi', 'monthsAhead', monthsAhead)
            const localVarPath = `/market-view/api/prices/{productId}/rolling-month-ahead`
                .replace(`{${"productId"}}`, encodeURIComponent(String(productId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (quoteDateRangeStart !== undefined) {
                localVarQueryParameter['QuoteDateRange.Start'] = (quoteDateRangeStart as any instanceof Date) ?
                    (quoteDateRangeStart as any).toISOString().substr(0,10) :
                    quoteDateRangeStart;
            }

            if (quoteDateRangeEnd !== undefined) {
                localVarQueryParameter['QuoteDateRange.End'] = (quoteDateRangeEnd as any instanceof Date) ?
                    (quoteDateRangeEnd as any).toISOString().substr(0,10) :
                    quoteDateRangeEnd;
            }

            if (monthsAhead !== undefined) {
                localVarQueryParameter['MonthsAhead'] = monthsAhead;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} productId 
         * @param {Array<number>} years 
         * @param {Array<number>} months 
         * @param {string} [quoteDateRangeStart] 
         * @param {string} [quoteDateRangeEnd] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMarketViewPrices: async (productId: string, years: Array<number>, months: Array<number>, quoteDateRangeStart?: string, quoteDateRangeEnd?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'productId' is not null or undefined
            assertParamExists('listMarketViewPrices', 'productId', productId)
            // verify required parameter 'years' is not null or undefined
            assertParamExists('listMarketViewPrices', 'years', years)
            // verify required parameter 'months' is not null or undefined
            assertParamExists('listMarketViewPrices', 'months', months)
            const localVarPath = `/market-view/prices/{productId}`
                .replace(`{${"productId"}}`, encodeURIComponent(String(productId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (quoteDateRangeStart !== undefined) {
                localVarQueryParameter['QuoteDateRange.Start'] = (quoteDateRangeStart as any instanceof Date) ?
                    (quoteDateRangeStart as any).toISOString().substr(0,10) :
                    quoteDateRangeStart;
            }

            if (quoteDateRangeEnd !== undefined) {
                localVarQueryParameter['QuoteDateRange.End'] = (quoteDateRangeEnd as any instanceof Date) ?
                    (quoteDateRangeEnd as any).toISOString().substr(0,10) :
                    quoteDateRangeEnd;
            }

            if (years) {
                localVarQueryParameter['Years'] = years;
            }

            if (months) {
                localVarQueryParameter['Months'] = months;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} productId 
         * @param {Array<number>} years 
         * @param {Array<number>} months 
         * @param {string} [quoteDateRangeStart] 
         * @param {string} [quoteDateRangeEnd] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMarketViewPricesApi: async (productId: string, years: Array<number>, months: Array<number>, quoteDateRangeStart?: string, quoteDateRangeEnd?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'productId' is not null or undefined
            assertParamExists('listMarketViewPricesApi', 'productId', productId)
            // verify required parameter 'years' is not null or undefined
            assertParamExists('listMarketViewPricesApi', 'years', years)
            // verify required parameter 'months' is not null or undefined
            assertParamExists('listMarketViewPricesApi', 'months', months)
            const localVarPath = `/market-view/api/prices/{productId}`
                .replace(`{${"productId"}}`, encodeURIComponent(String(productId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (quoteDateRangeStart !== undefined) {
                localVarQueryParameter['QuoteDateRange.Start'] = (quoteDateRangeStart as any instanceof Date) ?
                    (quoteDateRangeStart as any).toISOString().substr(0,10) :
                    quoteDateRangeStart;
            }

            if (quoteDateRangeEnd !== undefined) {
                localVarQueryParameter['QuoteDateRange.End'] = (quoteDateRangeEnd as any instanceof Date) ?
                    (quoteDateRangeEnd as any).toISOString().substr(0,10) :
                    quoteDateRangeEnd;
            }

            if (years) {
                localVarQueryParameter['Years'] = years;
            }

            if (months) {
                localVarQueryParameter['Months'] = months;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} symbolId 
         * @param {string} contractYear 
         * @param {string} contractMonth 
         * @param {string} [sortColumn] 
         * @param {SortDirection} [sortDirection] 
         * @param {number} [take] 
         * @param {number} [skip] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMarketViewPricesBySymbol: async (symbolId: string, contractYear: string, contractMonth: string, sortColumn?: string, sortDirection?: SortDirection, take?: number, skip?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'symbolId' is not null or undefined
            assertParamExists('listMarketViewPricesBySymbol', 'symbolId', symbolId)
            // verify required parameter 'contractYear' is not null or undefined
            assertParamExists('listMarketViewPricesBySymbol', 'contractYear', contractYear)
            // verify required parameter 'contractMonth' is not null or undefined
            assertParamExists('listMarketViewPricesBySymbol', 'contractMonth', contractMonth)
            const localVarPath = `/market-view/prices/{symbolId}/{contractYear}/{contractMonth}`
                .replace(`{${"symbolId"}}`, encodeURIComponent(String(symbolId)))
                .replace(`{${"contractYear"}}`, encodeURIComponent(String(contractYear)))
                .replace(`{${"contractMonth"}}`, encodeURIComponent(String(contractMonth)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (sortColumn !== undefined) {
                localVarQueryParameter['SortColumn'] = sortColumn;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['SortDirection'] = sortDirection;
            }

            if (take !== undefined) {
                localVarQueryParameter['Take'] = take;
            }

            if (skip !== undefined) {
                localVarQueryParameter['Skip'] = skip;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} symbolId 
         * @param {string} contractYear 
         * @param {string} contractMonth 
         * @param {string} [sortColumn] 
         * @param {SortDirection} [sortDirection] 
         * @param {number} [take] 
         * @param {number} [skip] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMarketViewPricesBySymbolApi: async (symbolId: string, contractYear: string, contractMonth: string, sortColumn?: string, sortDirection?: SortDirection, take?: number, skip?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'symbolId' is not null or undefined
            assertParamExists('listMarketViewPricesBySymbolApi', 'symbolId', symbolId)
            // verify required parameter 'contractYear' is not null or undefined
            assertParamExists('listMarketViewPricesBySymbolApi', 'contractYear', contractYear)
            // verify required parameter 'contractMonth' is not null or undefined
            assertParamExists('listMarketViewPricesBySymbolApi', 'contractMonth', contractMonth)
            const localVarPath = `/market-view/api/prices/{symbolId}/{contractYear}/{contractMonth}`
                .replace(`{${"symbolId"}}`, encodeURIComponent(String(symbolId)))
                .replace(`{${"contractYear"}}`, encodeURIComponent(String(contractYear)))
                .replace(`{${"contractMonth"}}`, encodeURIComponent(String(contractMonth)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (sortColumn !== undefined) {
                localVarQueryParameter['SortColumn'] = sortColumn;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['SortDirection'] = sortDirection;
            }

            if (take !== undefined) {
                localVarQueryParameter['Take'] = take;
            }

            if (skip !== undefined) {
                localVarQueryParameter['Skip'] = skip;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} productId 
         * @param {Array<number>} years 
         * @param {Array<number>} months 
         * @param {string} [quoteDateRangeStart] 
         * @param {string} [quoteDateRangeEnd] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMarketViewPricesInternal: async (productId: string, years: Array<number>, months: Array<number>, quoteDateRangeStart?: string, quoteDateRangeEnd?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'productId' is not null or undefined
            assertParamExists('listMarketViewPricesInternal', 'productId', productId)
            // verify required parameter 'years' is not null or undefined
            assertParamExists('listMarketViewPricesInternal', 'years', years)
            // verify required parameter 'months' is not null or undefined
            assertParamExists('listMarketViewPricesInternal', 'months', months)
            const localVarPath = `/market-view/internal/prices/{productId}`
                .replace(`{${"productId"}}`, encodeURIComponent(String(productId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (quoteDateRangeStart !== undefined) {
                localVarQueryParameter['QuoteDateRange.Start'] = (quoteDateRangeStart as any instanceof Date) ?
                    (quoteDateRangeStart as any).toISOString().substr(0,10) :
                    quoteDateRangeStart;
            }

            if (quoteDateRangeEnd !== undefined) {
                localVarQueryParameter['QuoteDateRange.End'] = (quoteDateRangeEnd as any instanceof Date) ?
                    (quoteDateRangeEnd as any).toISOString().substr(0,10) :
                    quoteDateRangeEnd;
            }

            if (years) {
                localVarQueryParameter['Years'] = years;
            }

            if (months) {
                localVarQueryParameter['Months'] = months;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} productId 
         * @param {string} [quoteDateRangeStart] 
         * @param {string} [quoteDateRangeEnd] 
         * @param {number} [contractDateRangeStartYear] 
         * @param {number} [contractDateRangeStartMonth] 
         * @param {number} [contractDateRangeEndYear] 
         * @param {number} [contractDateRangeEndMonth] 
         * @param {number} [contractDateRangeStartContractDateYear] 
         * @param {number} [contractDateRangeStartContractDateMonth] 
         * @param {string} [contractDateRangeStartContractDateLabel] 
         * @param {number} [contractDateRangeEndContractDateYear] 
         * @param {number} [contractDateRangeEndContractDateMonth] 
         * @param {string} [contractDateRangeEndContractDateLabel] 
         * @param {number} [userVolumeId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMarketViewPricesStripAverage: async (productId: string, quoteDateRangeStart?: string, quoteDateRangeEnd?: string, contractDateRangeStartYear?: number, contractDateRangeStartMonth?: number, contractDateRangeEndYear?: number, contractDateRangeEndMonth?: number, contractDateRangeStartContractDateYear?: number, contractDateRangeStartContractDateMonth?: number, contractDateRangeStartContractDateLabel?: string, contractDateRangeEndContractDateYear?: number, contractDateRangeEndContractDateMonth?: number, contractDateRangeEndContractDateLabel?: string, userVolumeId?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'productId' is not null or undefined
            assertParamExists('listMarketViewPricesStripAverage', 'productId', productId)
            const localVarPath = `/market-view/prices/{productId}/strip-average`
                .replace(`{${"productId"}}`, encodeURIComponent(String(productId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (quoteDateRangeStart !== undefined) {
                localVarQueryParameter['QuoteDateRange.Start'] = (quoteDateRangeStart as any instanceof Date) ?
                    (quoteDateRangeStart as any).toISOString().substr(0,10) :
                    quoteDateRangeStart;
            }

            if (quoteDateRangeEnd !== undefined) {
                localVarQueryParameter['QuoteDateRange.End'] = (quoteDateRangeEnd as any instanceof Date) ?
                    (quoteDateRangeEnd as any).toISOString().substr(0,10) :
                    quoteDateRangeEnd;
            }

            if (contractDateRangeStartYear !== undefined) {
                localVarQueryParameter['ContractDateRange.StartYear'] = contractDateRangeStartYear;
            }

            if (contractDateRangeStartMonth !== undefined) {
                localVarQueryParameter['ContractDateRange.StartMonth'] = contractDateRangeStartMonth;
            }

            if (contractDateRangeEndYear !== undefined) {
                localVarQueryParameter['ContractDateRange.EndYear'] = contractDateRangeEndYear;
            }

            if (contractDateRangeEndMonth !== undefined) {
                localVarQueryParameter['ContractDateRange.EndMonth'] = contractDateRangeEndMonth;
            }

            if (contractDateRangeStartContractDateYear !== undefined) {
                localVarQueryParameter['ContractDateRange.StartContractDate.Year'] = contractDateRangeStartContractDateYear;
            }

            if (contractDateRangeStartContractDateMonth !== undefined) {
                localVarQueryParameter['ContractDateRange.StartContractDate.Month'] = contractDateRangeStartContractDateMonth;
            }

            if (contractDateRangeStartContractDateLabel !== undefined) {
                localVarQueryParameter['ContractDateRange.StartContractDate.Label'] = contractDateRangeStartContractDateLabel;
            }

            if (contractDateRangeEndContractDateYear !== undefined) {
                localVarQueryParameter['ContractDateRange.EndContractDate.Year'] = contractDateRangeEndContractDateYear;
            }

            if (contractDateRangeEndContractDateMonth !== undefined) {
                localVarQueryParameter['ContractDateRange.EndContractDate.Month'] = contractDateRangeEndContractDateMonth;
            }

            if (contractDateRangeEndContractDateLabel !== undefined) {
                localVarQueryParameter['ContractDateRange.EndContractDate.Label'] = contractDateRangeEndContractDateLabel;
            }

            if (userVolumeId !== undefined) {
                localVarQueryParameter['UserVolumeId'] = userVolumeId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} productId 
         * @param {string} [quoteDateRangeStart] 
         * @param {string} [quoteDateRangeEnd] 
         * @param {number} [contractDateRangeStartYear] 
         * @param {number} [contractDateRangeStartMonth] 
         * @param {number} [contractDateRangeEndYear] 
         * @param {number} [contractDateRangeEndMonth] 
         * @param {number} [contractDateRangeStartContractDateYear] 
         * @param {number} [contractDateRangeStartContractDateMonth] 
         * @param {string} [contractDateRangeStartContractDateLabel] 
         * @param {number} [contractDateRangeEndContractDateYear] 
         * @param {number} [contractDateRangeEndContractDateMonth] 
         * @param {string} [contractDateRangeEndContractDateLabel] 
         * @param {number} [userVolumeId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMarketViewPricesStripAverageApi: async (productId: string, quoteDateRangeStart?: string, quoteDateRangeEnd?: string, contractDateRangeStartYear?: number, contractDateRangeStartMonth?: number, contractDateRangeEndYear?: number, contractDateRangeEndMonth?: number, contractDateRangeStartContractDateYear?: number, contractDateRangeStartContractDateMonth?: number, contractDateRangeStartContractDateLabel?: string, contractDateRangeEndContractDateYear?: number, contractDateRangeEndContractDateMonth?: number, contractDateRangeEndContractDateLabel?: string, userVolumeId?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'productId' is not null or undefined
            assertParamExists('listMarketViewPricesStripAverageApi', 'productId', productId)
            const localVarPath = `/market-view/api/prices/{productId}/strip-average`
                .replace(`{${"productId"}}`, encodeURIComponent(String(productId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (quoteDateRangeStart !== undefined) {
                localVarQueryParameter['QuoteDateRange.Start'] = (quoteDateRangeStart as any instanceof Date) ?
                    (quoteDateRangeStart as any).toISOString().substr(0,10) :
                    quoteDateRangeStart;
            }

            if (quoteDateRangeEnd !== undefined) {
                localVarQueryParameter['QuoteDateRange.End'] = (quoteDateRangeEnd as any instanceof Date) ?
                    (quoteDateRangeEnd as any).toISOString().substr(0,10) :
                    quoteDateRangeEnd;
            }

            if (contractDateRangeStartYear !== undefined) {
                localVarQueryParameter['ContractDateRange.StartYear'] = contractDateRangeStartYear;
            }

            if (contractDateRangeStartMonth !== undefined) {
                localVarQueryParameter['ContractDateRange.StartMonth'] = contractDateRangeStartMonth;
            }

            if (contractDateRangeEndYear !== undefined) {
                localVarQueryParameter['ContractDateRange.EndYear'] = contractDateRangeEndYear;
            }

            if (contractDateRangeEndMonth !== undefined) {
                localVarQueryParameter['ContractDateRange.EndMonth'] = contractDateRangeEndMonth;
            }

            if (contractDateRangeStartContractDateYear !== undefined) {
                localVarQueryParameter['ContractDateRange.StartContractDate.Year'] = contractDateRangeStartContractDateYear;
            }

            if (contractDateRangeStartContractDateMonth !== undefined) {
                localVarQueryParameter['ContractDateRange.StartContractDate.Month'] = contractDateRangeStartContractDateMonth;
            }

            if (contractDateRangeStartContractDateLabel !== undefined) {
                localVarQueryParameter['ContractDateRange.StartContractDate.Label'] = contractDateRangeStartContractDateLabel;
            }

            if (contractDateRangeEndContractDateYear !== undefined) {
                localVarQueryParameter['ContractDateRange.EndContractDate.Year'] = contractDateRangeEndContractDateYear;
            }

            if (contractDateRangeEndContractDateMonth !== undefined) {
                localVarQueryParameter['ContractDateRange.EndContractDate.Month'] = contractDateRangeEndContractDateMonth;
            }

            if (contractDateRangeEndContractDateLabel !== undefined) {
                localVarQueryParameter['ContractDateRange.EndContractDate.Label'] = contractDateRangeEndContractDateLabel;
            }

            if (userVolumeId !== undefined) {
                localVarQueryParameter['UserVolumeId'] = userVolumeId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMarketViewProductTypes: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/market-view/products/types`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CommodityType} [commodityType] 
         * @param {Array<number>} [productIds] 
         * @param {number} [minimumHistoryYears] 
         * @param {number} [lastQuoteDateThresholdDays] 
         * @param {boolean} [refreshCache] 
         * @param {string} [sortColumn] 
         * @param {SortDirection} [sortDirection] 
         * @param {number} [take] 
         * @param {number} [skip] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMarketViewProducts: async (commodityType?: CommodityType, productIds?: Array<number>, minimumHistoryYears?: number, lastQuoteDateThresholdDays?: number, refreshCache?: boolean, sortColumn?: string, sortDirection?: SortDirection, take?: number, skip?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/market-view/products`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (commodityType !== undefined) {
                localVarQueryParameter['CommodityType'] = commodityType;
            }

            if (productIds) {
                localVarQueryParameter['ProductIds'] = productIds;
            }

            if (minimumHistoryYears !== undefined) {
                localVarQueryParameter['MinimumHistoryYears'] = minimumHistoryYears;
            }

            if (lastQuoteDateThresholdDays !== undefined) {
                localVarQueryParameter['LastQuoteDateThresholdDays'] = lastQuoteDateThresholdDays;
            }

            if (refreshCache !== undefined) {
                localVarQueryParameter['RefreshCache'] = refreshCache;
            }

            if (sortColumn !== undefined) {
                localVarQueryParameter['SortColumn'] = sortColumn;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['SortDirection'] = sortDirection;
            }

            if (take !== undefined) {
                localVarQueryParameter['Take'] = take;
            }

            if (skip !== undefined) {
                localVarQueryParameter['Skip'] = skip;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CommodityType} [commodityType] 
         * @param {PriceType} [priceType] 
         * @param {Array<number>} [productIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMarketViewProductsInternal: async (commodityType?: CommodityType, priceType?: PriceType, productIds?: Array<number>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/market-view/internal/products`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (commodityType !== undefined) {
                localVarQueryParameter['CommodityType'] = commodityType;
            }

            if (priceType !== undefined) {
                localVarQueryParameter['PriceType'] = priceType;
            }

            if (productIds) {
                localVarQueryParameter['ProductIds'] = productIds;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [sortColumn] 
         * @param {SortDirection} [sortDirection] 
         * @param {number} [take] 
         * @param {number} [skip] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMarketViewSavedQuery: async (sortColumn?: string, sortDirection?: SortDirection, take?: number, skip?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/market-view/saved-queries`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (sortColumn !== undefined) {
                localVarQueryParameter['SortColumn'] = sortColumn;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['SortDirection'] = sortDirection;
            }

            if (take !== undefined) {
                localVarQueryParameter['Take'] = take;
            }

            if (skip !== undefined) {
                localVarQueryParameter['Skip'] = skip;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} productId 
         * @param {string} [quoteDateRangeStart] 
         * @param {string} [quoteDateRangeEnd] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMarketViewSettlementPrices: async (productId: string, quoteDateRangeStart?: string, quoteDateRangeEnd?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'productId' is not null or undefined
            assertParamExists('listMarketViewSettlementPrices', 'productId', productId)
            const localVarPath = `/market-view/prices/{productId}/settlements`
                .replace(`{${"productId"}}`, encodeURIComponent(String(productId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (quoteDateRangeStart !== undefined) {
                localVarQueryParameter['QuoteDateRange.Start'] = (quoteDateRangeStart as any instanceof Date) ?
                    (quoteDateRangeStart as any).toISOString().substr(0,10) :
                    quoteDateRangeStart;
            }

            if (quoteDateRangeEnd !== undefined) {
                localVarQueryParameter['QuoteDateRange.End'] = (quoteDateRangeEnd as any instanceof Date) ?
                    (quoteDateRangeEnd as any).toISOString().substr(0,10) :
                    quoteDateRangeEnd;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} productId 
         * @param {string} [quoteDateRangeStart] 
         * @param {string} [quoteDateRangeEnd] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMarketViewSettlementPricesApi: async (productId: string, quoteDateRangeStart?: string, quoteDateRangeEnd?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'productId' is not null or undefined
            assertParamExists('listMarketViewSettlementPricesApi', 'productId', productId)
            const localVarPath = `/market-view/api/prices/{productId}/settlements`
                .replace(`{${"productId"}}`, encodeURIComponent(String(productId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (quoteDateRangeStart !== undefined) {
                localVarQueryParameter['QuoteDateRange.Start'] = (quoteDateRangeStart as any instanceof Date) ?
                    (quoteDateRangeStart as any).toISOString().substr(0,10) :
                    quoteDateRangeStart;
            }

            if (quoteDateRangeEnd !== undefined) {
                localVarQueryParameter['QuoteDateRange.End'] = (quoteDateRangeEnd as any instanceof Date) ?
                    (quoteDateRangeEnd as any).toISOString().substr(0,10) :
                    quoteDateRangeEnd;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<string>} [marketViewUserGuids] 
         * @param {string} [companyGuid] 
         * @param {boolean} [includeSites] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMarketViewUsers: async (marketViewUserGuids?: Array<string>, companyGuid?: string, includeSites?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/market-view/users`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (marketViewUserGuids) {
                localVarQueryParameter['MarketViewUserGuids'] = marketViewUserGuids;
            }

            if (companyGuid !== undefined) {
                localVarQueryParameter['CompanyGuid'] = companyGuid;
            }

            if (includeSites !== undefined) {
                localVarQueryParameter['IncludeSites'] = includeSites;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMarketViewVolumes: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/market-view/volumes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} productId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        marketViewProductTradingMonths: async (productId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'productId' is not null or undefined
            assertParamExists('marketViewProductTradingMonths', 'productId', productId)
            const localVarPath = `/market-view/products/{productId}/trading-months`
                .replace(`{${"productId"}}`, encodeURIComponent(String(productId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        marketViewUserAuthorizationCallback: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/market-view/authorization`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} emailScheduleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendEmailScheduleNow: async (emailScheduleId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'emailScheduleId' is not null or undefined
            assertParamExists('sendEmailScheduleNow', 'emailScheduleId', emailScheduleId)
            const localVarPath = `/market-view/email-schedules/{emailScheduleId}/send`
                .replace(`{${"emailScheduleId"}}`, encodeURIComponent(String(emailScheduleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} savedQueryId 
         * @param {SendMarketViewSavedQueryEmailRequest} [sendMarketViewSavedQueryEmailRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendMarketViewSavedQueryEmail: async (savedQueryId: string, sendMarketViewSavedQueryEmailRequest?: SendMarketViewSavedQueryEmailRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'savedQueryId' is not null or undefined
            assertParamExists('sendMarketViewSavedQueryEmail', 'savedQueryId', savedQueryId)
            const localVarPath = `/market-view/saved-queries/{savedQueryId}/email`
                .replace(`{${"savedQueryId"}}`, encodeURIComponent(String(savedQueryId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(sendMarketViewSavedQueryEmailRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} siteGuid 
         * @param {string} siteName 
         * @param {string} companyGuid 
         * @param {Array<UserAccessUpdateModel>} userSiteAccesses 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCommodityManagementSite: async (siteGuid: string, siteName: string, companyGuid: string, userSiteAccesses: Array<UserAccessUpdateModel>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'siteGuid' is not null or undefined
            assertParamExists('updateCommodityManagementSite', 'siteGuid', siteGuid)
            // verify required parameter 'siteName' is not null or undefined
            assertParamExists('updateCommodityManagementSite', 'siteName', siteName)
            // verify required parameter 'companyGuid' is not null or undefined
            assertParamExists('updateCommodityManagementSite', 'companyGuid', companyGuid)
            // verify required parameter 'userSiteAccesses' is not null or undefined
            assertParamExists('updateCommodityManagementSite', 'userSiteAccesses', userSiteAccesses)
            const localVarPath = `/market-view/commodity-management/sites`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (siteGuid !== undefined) {
                localVarQueryParameter['SiteGuid'] = siteGuid;
            }

            if (siteName !== undefined) {
                localVarQueryParameter['SiteName'] = siteName;
            }

            if (companyGuid !== undefined) {
                localVarQueryParameter['CompanyGuid'] = companyGuid;
            }

            if (userSiteAccesses) {
                localVarQueryParameter['UserSiteAccesses'] = userSiteAccesses;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} siteGuid 
         * @param {string} marketViewUserGuid 
         * @param {boolean} [isSiteManager] 
         * @param {Array<CommodityManagementUserPermissions>} [permissions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCommodityManagementUserSiteAccess: async (siteGuid: string, marketViewUserGuid: string, isSiteManager?: boolean, permissions?: Array<CommodityManagementUserPermissions>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'siteGuid' is not null or undefined
            assertParamExists('updateCommodityManagementUserSiteAccess', 'siteGuid', siteGuid)
            // verify required parameter 'marketViewUserGuid' is not null or undefined
            assertParamExists('updateCommodityManagementUserSiteAccess', 'marketViewUserGuid', marketViewUserGuid)
            const localVarPath = `/market-view/commodity-management/sites/{siteGuid}/{marketViewUserGuid}`
                .replace(`{${"siteGuid"}}`, encodeURIComponent(String(siteGuid)))
                .replace(`{${"marketViewUserGuid"}}`, encodeURIComponent(String(marketViewUserGuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (isSiteManager !== undefined) {
                localVarQueryParameter['IsSiteManager'] = isSiteManager;
            }

            if (permissions) {
                localVarQueryParameter['Permissions'] = permissions;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} companyGuid 
         * @param {UpdateCompanyRequest} [updateCompanyRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCompany: async (companyGuid: string, updateCompanyRequest?: UpdateCompanyRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyGuid' is not null or undefined
            assertParamExists('updateCompany', 'companyGuid', companyGuid)
            const localVarPath = `/market-view/companies/{companyGuid}`
                .replace(`{${"companyGuid"}}`, encodeURIComponent(String(companyGuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateCompanyRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} companyGuid 
         * @param {boolean} isEnabled 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCompanyEnabled: async (companyGuid: string, isEnabled: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyGuid' is not null or undefined
            assertParamExists('updateCompanyEnabled', 'companyGuid', companyGuid)
            // verify required parameter 'isEnabled' is not null or undefined
            assertParamExists('updateCompanyEnabled', 'isEnabled', isEnabled)
            const localVarPath = `/market-view/companies/{companyGuid}/enabled`
                .replace(`{${"companyGuid"}}`, encodeURIComponent(String(companyGuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (isEnabled !== undefined) {
                localVarQueryParameter['IsEnabled'] = isEnabled;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} marketViewUserGuid 
         * @param {UpdateMarketViewUserRequest} [updateMarketViewUserRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMarketViewUser: async (marketViewUserGuid: string, updateMarketViewUserRequest?: UpdateMarketViewUserRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'marketViewUserGuid' is not null or undefined
            assertParamExists('updateMarketViewUser', 'marketViewUserGuid', marketViewUserGuid)
            const localVarPath = `/market-view/users/{marketViewUserGuid}`
                .replace(`{${"marketViewUserGuid"}}`, encodeURIComponent(String(marketViewUserGuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateMarketViewUserRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} marketViewUserGuid 
         * @param {boolean} isEnabled 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMarketViewUserEnabled: async (marketViewUserGuid: string, isEnabled: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'marketViewUserGuid' is not null or undefined
            assertParamExists('updateMarketViewUserEnabled', 'marketViewUserGuid', marketViewUserGuid)
            // verify required parameter 'isEnabled' is not null or undefined
            assertParamExists('updateMarketViewUserEnabled', 'isEnabled', isEnabled)
            const localVarPath = `/market-view/users/{marketViewUserGuid}/enabled`
                .replace(`{${"marketViewUserGuid"}}`, encodeURIComponent(String(marketViewUserGuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (isEnabled !== undefined) {
                localVarQueryParameter['IsEnabled'] = isEnabled;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UpsertEmailScheduleRequest} [upsertEmailScheduleRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        upsertEmailSchedule: async (upsertEmailScheduleRequest?: UpsertEmailScheduleRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/market-view/email-schedules`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(upsertEmailScheduleRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MarketViewApi - functional programming interface
 * @export
 */
export const MarketViewApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MarketViewApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} siteName 
         * @param {string} companyGuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addCommodityManagementSite(siteName: string, companyGuid: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AddCommodityManagementSiteResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addCommodityManagementSite(siteName, companyGuid, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} siteGuid 
         * @param {string} marketViewUserGuid 
         * @param {string} [email] 
         * @param {string} [firstName] 
         * @param {string} [lastName] 
         * @param {boolean} [isSiteManager] 
         * @param {Array<CommodityManagementUserPermissions>} [permissions] 
         * @param {boolean} [initializeAccessIfNew] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addCommodityManagementUserSiteAccess(siteGuid: string, marketViewUserGuid: string, email?: string, firstName?: string, lastName?: string, isSiteManager?: boolean, permissions?: Array<CommodityManagementUserPermissions>, initializeAccessIfNew?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addCommodityManagementUserSiteAccess(siteGuid, marketViewUserGuid, email, firstName, lastName, isSiteManager, permissions, initializeAccessIfNew, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {AddCompanyRequest} [addCompanyRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addCompany(addCompanyRequest?: AddCompanyRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AddCompanyResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addCompany(addCompanyRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} savedQueryId 
         * @param {string} name 
         * @param {Array<MarkItViewQuerySavedParameters>} markItViewQuerySavedParameters 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addMarketViewSavedQuery(savedQueryId: number, name: string, markItViewQuerySavedParameters: Array<MarkItViewQuerySavedParameters>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AddMarketViewSavedQueryResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addMarketViewSavedQuery(savedQueryId, name, markItViewQuerySavedParameters, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {AddMarketViewUserRequest} [addMarketViewUserRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addMarketViewUser(addMarketViewUserRequest?: AddMarketViewUserRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AddMarketViewUserResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addMarketViewUser(addMarketViewUserRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} productId 
         * @param {AddMarketViewUserFavoritedProductRequest} [addMarketViewUserFavoritedProductRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addMarketViewUserFavoritedProduct(productId: string, addMarketViewUserFavoritedProductRequest?: AddMarketViewUserFavoritedProductRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addMarketViewUserFavoritedProduct(productId, addMarketViewUserFavoritedProductRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} userVolumeId 
         * @param {string} name 
         * @param {{ [key: string]: number; }} volumes 
         * @param {string} [sortColumn] 
         * @param {SortDirection} [sortDirection] 
         * @param {number} [take] 
         * @param {number} [skip] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addMarketViewVolume(userVolumeId: number, name: string, volumes: { [key: string]: number; }, sortColumn?: string, sortDirection?: SortDirection, take?: number, skip?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AddMarketViewVolumeResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addMarketViewVolume(userVolumeId, name, volumes, sortColumn, sortDirection, take, skip, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {AgreeToMarketViewTermsAndConditionsRequest} [agreeToMarketViewTermsAndConditionsRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async agreeToDemeterTermsAndConditions(agreeToMarketViewTermsAndConditionsRequest?: AgreeToMarketViewTermsAndConditionsRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.agreeToDemeterTermsAndConditions(agreeToMarketViewTermsAndConditionsRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CalculateMatrixRequest} [calculateMatrixRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async calculateMatrix(calculateMatrixRequest?: CalculateMatrixRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CalculateMatrixResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.calculateMatrix(calculateMatrixRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} siteGuid 
         * @param {string} marketViewUserGuid 
         * @param {boolean} [disableUserIfNoOtherSites] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteCommodityManagementUserSiteAccess(siteGuid: string, marketViewUserGuid: string, disableUserIfNoOtherSites?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteCommodityManagementUserSiteAccess(siteGuid, marketViewUserGuid, disableUserIfNoOtherSites, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} emailScheduleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteEmailSchedule(emailScheduleId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteEmailSchedule(emailScheduleId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} savedQueryId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteMarketViewSavedQuery(savedQueryId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteMarketViewSavedQuery(savedQueryId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} productId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteMarketViewUserFavoritedProduct(productId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteMarketViewUserFavoritedProduct(productId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} savedQueryId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async exportMarketViewSavedQuery(savedQueryId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FileResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.exportMarketViewSavedQuery(savedQueryId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} companyGuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCompany(companyGuid: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetCompanyResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCompany(companyGuid, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} startDate 
         * @param {string} endDate 
         * @param {string} commodity 
         * @param {string} [markToMarketDate] 
         * @param {string} [sortColumn] 
         * @param {SortDirection} [sortDirection] 
         * @param {number} [take] 
         * @param {number} [skip] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDecisiveBasisPrices(startDate: string, endDate: string, commodity: string, markToMarketDate?: string, sortColumn?: string, sortDirection?: SortDirection, take?: number, skip?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DecisiveMarketPriceModel>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDecisiveBasisPrices(startDate, endDate, commodity, markToMarketDate, sortColumn, sortDirection, take, skip, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} startDate 
         * @param {string} endDate 
         * @param {string} commodity 
         * @param {string} [markToMarketDate] 
         * @param {string} [sortColumn] 
         * @param {SortDirection} [sortDirection] 
         * @param {number} [take] 
         * @param {number} [skip] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDecisiveFutureBasisPricesRangeByCommodity(startDate: string, endDate: string, commodity: string, markToMarketDate?: string, sortColumn?: string, sortDirection?: SortDirection, take?: number, skip?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DecisiveMarketPriceModel>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDecisiveFutureBasisPricesRangeByCommodity(startDate, endDate, commodity, markToMarketDate, sortColumn, sortDirection, take, skip, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} startDate 
         * @param {string} endDate 
         * @param {string} commodity 
         * @param {string} [markToMarketDate] 
         * @param {string} [sortColumn] 
         * @param {SortDirection} [sortDirection] 
         * @param {number} [take] 
         * @param {number} [skip] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDecisiveFuturePricesRangeByCommodity(startDate: string, endDate: string, commodity: string, markToMarketDate?: string, sortColumn?: string, sortDirection?: SortDirection, take?: number, skip?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DecisiveMarketPriceModel>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDecisiveFuturePricesRangeByCommodity(startDate, endDate, commodity, markToMarketDate, sortColumn, sortDirection, take, skip, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} startDate 
         * @param {string} endDate 
         * @param {string} commodity 
         * @param {string} [markToMarketDate] 
         * @param {string} [sortColumn] 
         * @param {SortDirection} [sortDirection] 
         * @param {number} [take] 
         * @param {number} [skip] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDecisiveSpecialtyCropPricesRangeByCommodity(startDate: string, endDate: string, commodity: string, markToMarketDate?: string, sortColumn?: string, sortDirection?: SortDirection, take?: number, skip?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DecisiveMarketPriceModel>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDecisiveSpecialtyCropPricesRangeByCommodity(startDate, endDate, commodity, markToMarketDate, sortColumn, sortDirection, take, skip, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} productId 
         * @param {number} [forecastHistoryYears] 
         * @param {string} [quoteDate] 
         * @param {number} [recentHistoryDays] 
         * @param {number} [historicalMedianYears] 
         * @param {number} [startContractDateYear] 
         * @param {number} [startContractDateMonth] 
         * @param {string} [startContractDateLabel] 
         * @param {number} [monthsAhead] 
         * @param {boolean} [applyPpi] 
         * @param {boolean} [refreshCache] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getForecastInternal(productId: string, forecastHistoryYears?: number, quoteDate?: string, recentHistoryDays?: number, historicalMedianYears?: number, startContractDateYear?: number, startContractDateMonth?: number, startContractDateLabel?: string, monthsAhead?: number, applyPpi?: boolean, refreshCache?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetForecastResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getForecastInternal(productId, forecastHistoryYears, quoteDate, recentHistoryDays, historicalMedianYears, startContractDateYear, startContractDateMonth, startContractDateLabel, monthsAhead, applyPpi, refreshCache, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} productId 
         * @param {string} [quoteDate] 
         * @param {number} [recentHistoryDays] 
         * @param {number} [historicalMedianYears] 
         * @param {number} [forecastHistoryYears] 
         * @param {number} [startContractDateYear] 
         * @param {number} [startContractDateMonth] 
         * @param {string} [startContractDateLabel] 
         * @param {number} [monthsAhead] 
         * @param {boolean} [applyPpi] 
         * @param {boolean} [refreshCache] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getForecastWithHistory(productId: string, quoteDate?: string, recentHistoryDays?: number, historicalMedianYears?: number, forecastHistoryYears?: number, startContractDateYear?: number, startContractDateMonth?: number, startContractDateLabel?: string, monthsAhead?: number, applyPpi?: boolean, refreshCache?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetForecastWithHistoryResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getForecastWithHistory(productId, quoteDate, recentHistoryDays, historicalMedianYears, forecastHistoryYears, startContractDateYear, startContractDateMonth, startContractDateLabel, monthsAhead, applyPpi, refreshCache, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} productId 
         * @param {string} [quoteDate] 
         * @param {number} [recentHistoryDays] 
         * @param {number} [historicalMedianYears] 
         * @param {number} [forecastHistoryYears] 
         * @param {number} [startContractDateYear] 
         * @param {number} [startContractDateMonth] 
         * @param {string} [startContractDateLabel] 
         * @param {number} [monthsAhead] 
         * @param {boolean} [applyPpi] 
         * @param {boolean} [refreshCache] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getForecastWithHistoryInternal(productId: string, quoteDate?: string, recentHistoryDays?: number, historicalMedianYears?: number, forecastHistoryYears?: number, startContractDateYear?: number, startContractDateMonth?: number, startContractDateLabel?: string, monthsAhead?: number, applyPpi?: boolean, refreshCache?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetForecastWithHistoryResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getForecastWithHistoryInternal(productId, quoteDate, recentHistoryDays, historicalMedianYears, forecastHistoryYears, startContractDateYear, startContractDateMonth, startContractDateLabel, monthsAhead, applyPpi, refreshCache, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} symbolId 
         * @param {string} [asOfDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMarketViewLastQuoteDate(symbolId: string, asOfDate?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetMarketViewLastQuoteDateResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMarketViewLastQuoteDate(symbolId, asOfDate, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} symbolId 
         * @param {string} [asOfDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMarketViewLastQuoteDateApi(symbolId: string, asOfDate?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetMarketViewLastQuoteDateResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMarketViewLastQuoteDateApi(symbolId, asOfDate, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} marketViewUserGuid 
         * @param {string} [stoneXUserGuid] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMarketViewUser(marketViewUserGuid: string, stoneXUserGuid?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetMarketViewUserResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMarketViewUser(marketViewUserGuid, stoneXUserGuid, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} siteGuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listCommodityManagementSiteUsers(siteGuid: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListCommodityManagementSiteUsersResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listCommodityManagementSiteUsers(siteGuid, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {boolean} [includeUserSiteAccess] 
         * @param {string} [sortColumn] 
         * @param {SortDirection} [sortDirection] 
         * @param {number} [take] 
         * @param {number} [skip] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listCommodityManagementSites(includeUserSiteAccess?: boolean, sortColumn?: string, sortDirection?: SortDirection, take?: number, skip?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListCommodityManagementSitesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listCommodityManagementSites(includeUserSiteAccess, sortColumn, sortDirection, take, skip, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [sortColumn] 
         * @param {SortDirection} [sortDirection] 
         * @param {number} [take] 
         * @param {number} [skip] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listCompanies(sortColumn?: string, sortDirection?: SortDirection, take?: number, skip?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListCompaniesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listCompanies(sortColumn, sortDirection, take, skip, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {EmailScheduleSource} [source] 
         * @param {number} [sourceId] 
         * @param {string} [sortColumn] 
         * @param {SortDirection} [sortDirection] 
         * @param {number} [take] 
         * @param {number} [skip] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listEmailSchedules(source?: EmailScheduleSource, sourceId?: number, sortColumn?: string, sortDirection?: SortDirection, take?: number, skip?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListEmailSchedulesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listEmailSchedules(source, sourceId, sortColumn, sortDirection, take, skip, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ListMarketViewContractPricesRequest} [listMarketViewContractPricesRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listMarketViewContractPricesApi(listMarketViewContractPricesRequest?: ListMarketViewContractPricesRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListMarketViewContractPricesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listMarketViewContractPricesApi(listMarketViewContractPricesRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} quoteDate 
         * @param {Array<Currency>} currencies 
         * @param {Array<ContractDate>} contractMonths 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listMarketViewCurrencySpotRates(quoteDate: string, currencies: Array<Currency>, contractMonths: Array<ContractDate>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListMarketViewCurrencySpotRatesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listMarketViewCurrencySpotRates(quoteDate, currencies, contractMonths, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} quoteDate 
         * @param {Array<Currency>} currencies 
         * @param {Array<ContractDate>} contractMonths 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listMarketViewCurrencySpotRatesApi(quoteDate: string, currencies: Array<Currency>, contractMonths: Array<ContractDate>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListMarketViewCurrencySpotRatesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listMarketViewCurrencySpotRatesApi(quoteDate, currencies, contractMonths, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} productId 
         * @param {string} [quoteDateRangeStart] 
         * @param {string} [quoteDateRangeEnd] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listMarketViewDailyPrices(productId: string, quoteDateRangeStart?: string, quoteDateRangeEnd?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MarketViewQueryDailyPricesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listMarketViewDailyPrices(productId, quoteDateRangeStart, quoteDateRangeEnd, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {Array<number>} productIds 
         * @param {boolean} [refreshCache] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listMarketViewExpirationDates(productIds: Array<number>, refreshCache?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListMarketViewExpirationDatesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listMarketViewExpirationDates(productIds, refreshCache, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {Array<number>} productIds 
         * @param {boolean} [refreshCache] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listMarketViewExpirationDatesApi(productIds: Array<number>, refreshCache?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListMarketViewExpirationDatesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listMarketViewExpirationDatesApi(productIds, refreshCache, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} productId 
         * @param {string} quoteDate 
         * @param {number} [numberOfMonths] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listMarketViewForwardCurveQuery(productId: string, quoteDate: string, numberOfMonths?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MarketViewQueryForwardCurveResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listMarketViewForwardCurveQuery(productId, quoteDate, numberOfMonths, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} productId 
         * @param {string} quoteDate 
         * @param {number} [numberOfMonths] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listMarketViewForwardCurveQueryApi(productId: string, quoteDate: string, numberOfMonths?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MarketViewQueryForwardCurveResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listMarketViewForwardCurveQueryApi(productId, quoteDate, numberOfMonths, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {Array<number>} symbolIds 
         * @param {string} [asOfDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listMarketViewLastQuoteDate(symbolIds: Array<number>, asOfDate?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListMarketViewLastQuoteDateResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listMarketViewLastQuoteDate(symbolIds, asOfDate, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {Array<number>} symbolIds 
         * @param {string} [asOfDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listMarketViewLastQuoteDateApi(symbolIds: Array<number>, asOfDate?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListMarketViewLastQuoteDateResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listMarketViewLastQuoteDateApi(symbolIds, asOfDate, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} productId 
         * @param {Array<number>} years 
         * @param {string} [quoteDateRangeStart] 
         * @param {string} [quoteDateRangeEnd] 
         * @param {number} [userVolumeId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listMarketViewPriceQueryCalendarStripAvearge(productId: string, years: Array<number>, quoteDateRangeStart?: string, quoteDateRangeEnd?: string, userVolumeId?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MarketViewQueryCalendarStripAverageResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listMarketViewPriceQueryCalendarStripAvearge(productId, years, quoteDateRangeStart, quoteDateRangeEnd, userVolumeId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} productId 
         * @param {Array<number>} years 
         * @param {string} [quoteDateRangeStart] 
         * @param {string} [quoteDateRangeEnd] 
         * @param {number} [userVolumeId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listMarketViewPriceQueryCalendarStripAverageApi(productId: string, years: Array<number>, quoteDateRangeStart?: string, quoteDateRangeEnd?: string, userVolumeId?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MarketViewQueryCalendarStripAverageResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listMarketViewPriceQueryCalendarStripAverageApi(productId, years, quoteDateRangeStart, quoteDateRangeEnd, userVolumeId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} productId 
         * @param {number} monthsAhead 
         * @param {string} [quoteDateRangeStart] 
         * @param {string} [quoteDateRangeEnd] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listMarketViewPriceQueryRollingMonthAhead(productId: string, monthsAhead: number, quoteDateRangeStart?: string, quoteDateRangeEnd?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MarketViewQueryRollingMonthAheadResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listMarketViewPriceQueryRollingMonthAhead(productId, monthsAhead, quoteDateRangeStart, quoteDateRangeEnd, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} productId 
         * @param {number} monthsAhead 
         * @param {string} [quoteDateRangeStart] 
         * @param {string} [quoteDateRangeEnd] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listMarketViewPriceQueryRollingMonthAheadApi(productId: string, monthsAhead: number, quoteDateRangeStart?: string, quoteDateRangeEnd?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MarketViewQueryRollingMonthAheadResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listMarketViewPriceQueryRollingMonthAheadApi(productId, monthsAhead, quoteDateRangeStart, quoteDateRangeEnd, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} productId 
         * @param {Array<number>} years 
         * @param {Array<number>} months 
         * @param {string} [quoteDateRangeStart] 
         * @param {string} [quoteDateRangeEnd] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listMarketViewPrices(productId: string, years: Array<number>, months: Array<number>, quoteDateRangeStart?: string, quoteDateRangeEnd?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MarketViewQueryPriceResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listMarketViewPrices(productId, years, months, quoteDateRangeStart, quoteDateRangeEnd, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} productId 
         * @param {Array<number>} years 
         * @param {Array<number>} months 
         * @param {string} [quoteDateRangeStart] 
         * @param {string} [quoteDateRangeEnd] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listMarketViewPricesApi(productId: string, years: Array<number>, months: Array<number>, quoteDateRangeStart?: string, quoteDateRangeEnd?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MarketViewQueryPriceResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listMarketViewPricesApi(productId, years, months, quoteDateRangeStart, quoteDateRangeEnd, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} symbolId 
         * @param {string} contractYear 
         * @param {string} contractMonth 
         * @param {string} [sortColumn] 
         * @param {SortDirection} [sortDirection] 
         * @param {number} [take] 
         * @param {number} [skip] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listMarketViewPricesBySymbol(symbolId: string, contractYear: string, contractMonth: string, sortColumn?: string, sortDirection?: SortDirection, take?: number, skip?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListMarketViewPricesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listMarketViewPricesBySymbol(symbolId, contractYear, contractMonth, sortColumn, sortDirection, take, skip, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} symbolId 
         * @param {string} contractYear 
         * @param {string} contractMonth 
         * @param {string} [sortColumn] 
         * @param {SortDirection} [sortDirection] 
         * @param {number} [take] 
         * @param {number} [skip] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listMarketViewPricesBySymbolApi(symbolId: string, contractYear: string, contractMonth: string, sortColumn?: string, sortDirection?: SortDirection, take?: number, skip?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListMarketViewPricesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listMarketViewPricesBySymbolApi(symbolId, contractYear, contractMonth, sortColumn, sortDirection, take, skip, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} productId 
         * @param {Array<number>} years 
         * @param {Array<number>} months 
         * @param {string} [quoteDateRangeStart] 
         * @param {string} [quoteDateRangeEnd] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listMarketViewPricesInternal(productId: string, years: Array<number>, months: Array<number>, quoteDateRangeStart?: string, quoteDateRangeEnd?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MarketViewQueryPriceResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listMarketViewPricesInternal(productId, years, months, quoteDateRangeStart, quoteDateRangeEnd, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} productId 
         * @param {string} [quoteDateRangeStart] 
         * @param {string} [quoteDateRangeEnd] 
         * @param {number} [contractDateRangeStartYear] 
         * @param {number} [contractDateRangeStartMonth] 
         * @param {number} [contractDateRangeEndYear] 
         * @param {number} [contractDateRangeEndMonth] 
         * @param {number} [contractDateRangeStartContractDateYear] 
         * @param {number} [contractDateRangeStartContractDateMonth] 
         * @param {string} [contractDateRangeStartContractDateLabel] 
         * @param {number} [contractDateRangeEndContractDateYear] 
         * @param {number} [contractDateRangeEndContractDateMonth] 
         * @param {string} [contractDateRangeEndContractDateLabel] 
         * @param {number} [userVolumeId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listMarketViewPricesStripAverage(productId: string, quoteDateRangeStart?: string, quoteDateRangeEnd?: string, contractDateRangeStartYear?: number, contractDateRangeStartMonth?: number, contractDateRangeEndYear?: number, contractDateRangeEndMonth?: number, contractDateRangeStartContractDateYear?: number, contractDateRangeStartContractDateMonth?: number, contractDateRangeStartContractDateLabel?: string, contractDateRangeEndContractDateYear?: number, contractDateRangeEndContractDateMonth?: number, contractDateRangeEndContractDateLabel?: string, userVolumeId?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MarketViewQueryStripAverageResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listMarketViewPricesStripAverage(productId, quoteDateRangeStart, quoteDateRangeEnd, contractDateRangeStartYear, contractDateRangeStartMonth, contractDateRangeEndYear, contractDateRangeEndMonth, contractDateRangeStartContractDateYear, contractDateRangeStartContractDateMonth, contractDateRangeStartContractDateLabel, contractDateRangeEndContractDateYear, contractDateRangeEndContractDateMonth, contractDateRangeEndContractDateLabel, userVolumeId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} productId 
         * @param {string} [quoteDateRangeStart] 
         * @param {string} [quoteDateRangeEnd] 
         * @param {number} [contractDateRangeStartYear] 
         * @param {number} [contractDateRangeStartMonth] 
         * @param {number} [contractDateRangeEndYear] 
         * @param {number} [contractDateRangeEndMonth] 
         * @param {number} [contractDateRangeStartContractDateYear] 
         * @param {number} [contractDateRangeStartContractDateMonth] 
         * @param {string} [contractDateRangeStartContractDateLabel] 
         * @param {number} [contractDateRangeEndContractDateYear] 
         * @param {number} [contractDateRangeEndContractDateMonth] 
         * @param {string} [contractDateRangeEndContractDateLabel] 
         * @param {number} [userVolumeId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listMarketViewPricesStripAverageApi(productId: string, quoteDateRangeStart?: string, quoteDateRangeEnd?: string, contractDateRangeStartYear?: number, contractDateRangeStartMonth?: number, contractDateRangeEndYear?: number, contractDateRangeEndMonth?: number, contractDateRangeStartContractDateYear?: number, contractDateRangeStartContractDateMonth?: number, contractDateRangeStartContractDateLabel?: string, contractDateRangeEndContractDateYear?: number, contractDateRangeEndContractDateMonth?: number, contractDateRangeEndContractDateLabel?: string, userVolumeId?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MarketViewQueryStripAverageResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listMarketViewPricesStripAverageApi(productId, quoteDateRangeStart, quoteDateRangeEnd, contractDateRangeStartYear, contractDateRangeStartMonth, contractDateRangeEndYear, contractDateRangeEndMonth, contractDateRangeStartContractDateYear, contractDateRangeStartContractDateMonth, contractDateRangeStartContractDateLabel, contractDateRangeEndContractDateYear, contractDateRangeEndContractDateMonth, contractDateRangeEndContractDateLabel, userVolumeId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listMarketViewProductTypes(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListMarketViewProductTypesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listMarketViewProductTypes(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CommodityType} [commodityType] 
         * @param {Array<number>} [productIds] 
         * @param {number} [minimumHistoryYears] 
         * @param {number} [lastQuoteDateThresholdDays] 
         * @param {boolean} [refreshCache] 
         * @param {string} [sortColumn] 
         * @param {SortDirection} [sortDirection] 
         * @param {number} [take] 
         * @param {number} [skip] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listMarketViewProducts(commodityType?: CommodityType, productIds?: Array<number>, minimumHistoryYears?: number, lastQuoteDateThresholdDays?: number, refreshCache?: boolean, sortColumn?: string, sortDirection?: SortDirection, take?: number, skip?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListMarketViewProductsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listMarketViewProducts(commodityType, productIds, minimumHistoryYears, lastQuoteDateThresholdDays, refreshCache, sortColumn, sortDirection, take, skip, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CommodityType} [commodityType] 
         * @param {PriceType} [priceType] 
         * @param {Array<number>} [productIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listMarketViewProductsInternal(commodityType?: CommodityType, priceType?: PriceType, productIds?: Array<number>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListMarketViewInternalProductsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listMarketViewProductsInternal(commodityType, priceType, productIds, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [sortColumn] 
         * @param {SortDirection} [sortDirection] 
         * @param {number} [take] 
         * @param {number} [skip] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listMarketViewSavedQuery(sortColumn?: string, sortDirection?: SortDirection, take?: number, skip?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListMarketViewSavedQueryResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listMarketViewSavedQuery(sortColumn, sortDirection, take, skip, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} productId 
         * @param {string} [quoteDateRangeStart] 
         * @param {string} [quoteDateRangeEnd] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listMarketViewSettlementPrices(productId: string, quoteDateRangeStart?: string, quoteDateRangeEnd?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MarketViewQuerySettlementsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listMarketViewSettlementPrices(productId, quoteDateRangeStart, quoteDateRangeEnd, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} productId 
         * @param {string} [quoteDateRangeStart] 
         * @param {string} [quoteDateRangeEnd] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listMarketViewSettlementPricesApi(productId: string, quoteDateRangeStart?: string, quoteDateRangeEnd?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MarketViewQuerySettlementsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listMarketViewSettlementPricesApi(productId, quoteDateRangeStart, quoteDateRangeEnd, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {Array<string>} [marketViewUserGuids] 
         * @param {string} [companyGuid] 
         * @param {boolean} [includeSites] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listMarketViewUsers(marketViewUserGuids?: Array<string>, companyGuid?: string, includeSites?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListMarketViewUsersResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listMarketViewUsers(marketViewUserGuids, companyGuid, includeSites, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listMarketViewVolumes(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MarketViewVolumesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listMarketViewVolumes(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} productId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async marketViewProductTradingMonths(productId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MarketViewProductTradingMonthsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.marketViewProductTradingMonths(productId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async marketViewUserAuthorizationCallback(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetMarketViewUserAuthorizationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.marketViewUserAuthorizationCallback(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} emailScheduleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sendEmailScheduleNow(emailScheduleId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SendEmailScheduleResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sendEmailScheduleNow(emailScheduleId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} savedQueryId 
         * @param {SendMarketViewSavedQueryEmailRequest} [sendMarketViewSavedQueryEmailRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sendMarketViewSavedQueryEmail(savedQueryId: string, sendMarketViewSavedQueryEmailRequest?: SendMarketViewSavedQueryEmailRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SendMarketViewSavedQueryEmailResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sendMarketViewSavedQueryEmail(savedQueryId, sendMarketViewSavedQueryEmailRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} siteGuid 
         * @param {string} siteName 
         * @param {string} companyGuid 
         * @param {Array<UserAccessUpdateModel>} userSiteAccesses 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateCommodityManagementSite(siteGuid: string, siteName: string, companyGuid: string, userSiteAccesses: Array<UserAccessUpdateModel>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpdateCommodityManagementSiteResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateCommodityManagementSite(siteGuid, siteName, companyGuid, userSiteAccesses, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} siteGuid 
         * @param {string} marketViewUserGuid 
         * @param {boolean} [isSiteManager] 
         * @param {Array<CommodityManagementUserPermissions>} [permissions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateCommodityManagementUserSiteAccess(siteGuid: string, marketViewUserGuid: string, isSiteManager?: boolean, permissions?: Array<CommodityManagementUserPermissions>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateCommodityManagementUserSiteAccess(siteGuid, marketViewUserGuid, isSiteManager, permissions, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} companyGuid 
         * @param {UpdateCompanyRequest} [updateCompanyRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateCompany(companyGuid: string, updateCompanyRequest?: UpdateCompanyRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpdateCompanyResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateCompany(companyGuid, updateCompanyRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} companyGuid 
         * @param {boolean} isEnabled 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateCompanyEnabled(companyGuid: string, isEnabled: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateCompanyEnabled(companyGuid, isEnabled, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} marketViewUserGuid 
         * @param {UpdateMarketViewUserRequest} [updateMarketViewUserRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateMarketViewUser(marketViewUserGuid: string, updateMarketViewUserRequest?: UpdateMarketViewUserRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpdateMarketViewUserResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateMarketViewUser(marketViewUserGuid, updateMarketViewUserRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} marketViewUserGuid 
         * @param {boolean} isEnabled 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateMarketViewUserEnabled(marketViewUserGuid: string, isEnabled: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateMarketViewUserEnabled(marketViewUserGuid, isEnabled, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {UpsertEmailScheduleRequest} [upsertEmailScheduleRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async upsertEmailSchedule(upsertEmailScheduleRequest?: UpsertEmailScheduleRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpsertEmailScheduleResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.upsertEmailSchedule(upsertEmailScheduleRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * MarketViewApi - factory interface
 * @export
 */
export const MarketViewApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MarketViewApiFp(configuration)
    return {
        /**
         * 
         * @param {string} siteName 
         * @param {string} companyGuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addCommodityManagementSite(siteName: string, companyGuid: string, options?: any): AxiosPromise<AddCommodityManagementSiteResponse> {
            return localVarFp.addCommodityManagementSite(siteName, companyGuid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} siteGuid 
         * @param {string} marketViewUserGuid 
         * @param {string} [email] 
         * @param {string} [firstName] 
         * @param {string} [lastName] 
         * @param {boolean} [isSiteManager] 
         * @param {Array<CommodityManagementUserPermissions>} [permissions] 
         * @param {boolean} [initializeAccessIfNew] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addCommodityManagementUserSiteAccess(siteGuid: string, marketViewUserGuid: string, email?: string, firstName?: string, lastName?: string, isSiteManager?: boolean, permissions?: Array<CommodityManagementUserPermissions>, initializeAccessIfNew?: boolean, options?: any): AxiosPromise<object> {
            return localVarFp.addCommodityManagementUserSiteAccess(siteGuid, marketViewUserGuid, email, firstName, lastName, isSiteManager, permissions, initializeAccessIfNew, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AddCompanyRequest} [addCompanyRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addCompany(addCompanyRequest?: AddCompanyRequest, options?: any): AxiosPromise<AddCompanyResponse> {
            return localVarFp.addCompany(addCompanyRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} savedQueryId 
         * @param {string} name 
         * @param {Array<MarkItViewQuerySavedParameters>} markItViewQuerySavedParameters 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addMarketViewSavedQuery(savedQueryId: number, name: string, markItViewQuerySavedParameters: Array<MarkItViewQuerySavedParameters>, options?: any): AxiosPromise<AddMarketViewSavedQueryResponse> {
            return localVarFp.addMarketViewSavedQuery(savedQueryId, name, markItViewQuerySavedParameters, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AddMarketViewUserRequest} [addMarketViewUserRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addMarketViewUser(addMarketViewUserRequest?: AddMarketViewUserRequest, options?: any): AxiosPromise<AddMarketViewUserResponse> {
            return localVarFp.addMarketViewUser(addMarketViewUserRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} productId 
         * @param {AddMarketViewUserFavoritedProductRequest} [addMarketViewUserFavoritedProductRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addMarketViewUserFavoritedProduct(productId: string, addMarketViewUserFavoritedProductRequest?: AddMarketViewUserFavoritedProductRequest, options?: any): AxiosPromise<object> {
            return localVarFp.addMarketViewUserFavoritedProduct(productId, addMarketViewUserFavoritedProductRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} userVolumeId 
         * @param {string} name 
         * @param {{ [key: string]: number; }} volumes 
         * @param {string} [sortColumn] 
         * @param {SortDirection} [sortDirection] 
         * @param {number} [take] 
         * @param {number} [skip] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addMarketViewVolume(userVolumeId: number, name: string, volumes: { [key: string]: number; }, sortColumn?: string, sortDirection?: SortDirection, take?: number, skip?: number, options?: any): AxiosPromise<AddMarketViewVolumeResponse> {
            return localVarFp.addMarketViewVolume(userVolumeId, name, volumes, sortColumn, sortDirection, take, skip, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AgreeToMarketViewTermsAndConditionsRequest} [agreeToMarketViewTermsAndConditionsRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agreeToDemeterTermsAndConditions(agreeToMarketViewTermsAndConditionsRequest?: AgreeToMarketViewTermsAndConditionsRequest, options?: any): AxiosPromise<object> {
            return localVarFp.agreeToDemeterTermsAndConditions(agreeToMarketViewTermsAndConditionsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CalculateMatrixRequest} [calculateMatrixRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        calculateMatrix(calculateMatrixRequest?: CalculateMatrixRequest, options?: any): AxiosPromise<CalculateMatrixResponse> {
            return localVarFp.calculateMatrix(calculateMatrixRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} siteGuid 
         * @param {string} marketViewUserGuid 
         * @param {boolean} [disableUserIfNoOtherSites] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCommodityManagementUserSiteAccess(siteGuid: string, marketViewUserGuid: string, disableUserIfNoOtherSites?: boolean, options?: any): AxiosPromise<object> {
            return localVarFp.deleteCommodityManagementUserSiteAccess(siteGuid, marketViewUserGuid, disableUserIfNoOtherSites, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} emailScheduleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEmailSchedule(emailScheduleId: string, options?: any): AxiosPromise<object> {
            return localVarFp.deleteEmailSchedule(emailScheduleId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} savedQueryId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteMarketViewSavedQuery(savedQueryId: string, options?: any): AxiosPromise<object> {
            return localVarFp.deleteMarketViewSavedQuery(savedQueryId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} productId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteMarketViewUserFavoritedProduct(productId: string, options?: any): AxiosPromise<object> {
            return localVarFp.deleteMarketViewUserFavoritedProduct(productId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} savedQueryId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportMarketViewSavedQuery(savedQueryId: string, options?: any): AxiosPromise<FileResponse> {
            return localVarFp.exportMarketViewSavedQuery(savedQueryId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} companyGuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompany(companyGuid: string, options?: any): AxiosPromise<GetCompanyResponse> {
            return localVarFp.getCompany(companyGuid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} startDate 
         * @param {string} endDate 
         * @param {string} commodity 
         * @param {string} [markToMarketDate] 
         * @param {string} [sortColumn] 
         * @param {SortDirection} [sortDirection] 
         * @param {number} [take] 
         * @param {number} [skip] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDecisiveBasisPrices(startDate: string, endDate: string, commodity: string, markToMarketDate?: string, sortColumn?: string, sortDirection?: SortDirection, take?: number, skip?: number, options?: any): AxiosPromise<Array<DecisiveMarketPriceModel>> {
            return localVarFp.getDecisiveBasisPrices(startDate, endDate, commodity, markToMarketDate, sortColumn, sortDirection, take, skip, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} startDate 
         * @param {string} endDate 
         * @param {string} commodity 
         * @param {string} [markToMarketDate] 
         * @param {string} [sortColumn] 
         * @param {SortDirection} [sortDirection] 
         * @param {number} [take] 
         * @param {number} [skip] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDecisiveFutureBasisPricesRangeByCommodity(startDate: string, endDate: string, commodity: string, markToMarketDate?: string, sortColumn?: string, sortDirection?: SortDirection, take?: number, skip?: number, options?: any): AxiosPromise<Array<DecisiveMarketPriceModel>> {
            return localVarFp.getDecisiveFutureBasisPricesRangeByCommodity(startDate, endDate, commodity, markToMarketDate, sortColumn, sortDirection, take, skip, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} startDate 
         * @param {string} endDate 
         * @param {string} commodity 
         * @param {string} [markToMarketDate] 
         * @param {string} [sortColumn] 
         * @param {SortDirection} [sortDirection] 
         * @param {number} [take] 
         * @param {number} [skip] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDecisiveFuturePricesRangeByCommodity(startDate: string, endDate: string, commodity: string, markToMarketDate?: string, sortColumn?: string, sortDirection?: SortDirection, take?: number, skip?: number, options?: any): AxiosPromise<Array<DecisiveMarketPriceModel>> {
            return localVarFp.getDecisiveFuturePricesRangeByCommodity(startDate, endDate, commodity, markToMarketDate, sortColumn, sortDirection, take, skip, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} startDate 
         * @param {string} endDate 
         * @param {string} commodity 
         * @param {string} [markToMarketDate] 
         * @param {string} [sortColumn] 
         * @param {SortDirection} [sortDirection] 
         * @param {number} [take] 
         * @param {number} [skip] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDecisiveSpecialtyCropPricesRangeByCommodity(startDate: string, endDate: string, commodity: string, markToMarketDate?: string, sortColumn?: string, sortDirection?: SortDirection, take?: number, skip?: number, options?: any): AxiosPromise<Array<DecisiveMarketPriceModel>> {
            return localVarFp.getDecisiveSpecialtyCropPricesRangeByCommodity(startDate, endDate, commodity, markToMarketDate, sortColumn, sortDirection, take, skip, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} productId 
         * @param {number} [forecastHistoryYears] 
         * @param {string} [quoteDate] 
         * @param {number} [recentHistoryDays] 
         * @param {number} [historicalMedianYears] 
         * @param {number} [startContractDateYear] 
         * @param {number} [startContractDateMonth] 
         * @param {string} [startContractDateLabel] 
         * @param {number} [monthsAhead] 
         * @param {boolean} [applyPpi] 
         * @param {boolean} [refreshCache] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getForecastInternal(productId: string, forecastHistoryYears?: number, quoteDate?: string, recentHistoryDays?: number, historicalMedianYears?: number, startContractDateYear?: number, startContractDateMonth?: number, startContractDateLabel?: string, monthsAhead?: number, applyPpi?: boolean, refreshCache?: boolean, options?: any): AxiosPromise<GetForecastResponse> {
            return localVarFp.getForecastInternal(productId, forecastHistoryYears, quoteDate, recentHistoryDays, historicalMedianYears, startContractDateYear, startContractDateMonth, startContractDateLabel, monthsAhead, applyPpi, refreshCache, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} productId 
         * @param {string} [quoteDate] 
         * @param {number} [recentHistoryDays] 
         * @param {number} [historicalMedianYears] 
         * @param {number} [forecastHistoryYears] 
         * @param {number} [startContractDateYear] 
         * @param {number} [startContractDateMonth] 
         * @param {string} [startContractDateLabel] 
         * @param {number} [monthsAhead] 
         * @param {boolean} [applyPpi] 
         * @param {boolean} [refreshCache] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getForecastWithHistory(productId: string, quoteDate?: string, recentHistoryDays?: number, historicalMedianYears?: number, forecastHistoryYears?: number, startContractDateYear?: number, startContractDateMonth?: number, startContractDateLabel?: string, monthsAhead?: number, applyPpi?: boolean, refreshCache?: boolean, options?: any): AxiosPromise<GetForecastWithHistoryResponse> {
            return localVarFp.getForecastWithHistory(productId, quoteDate, recentHistoryDays, historicalMedianYears, forecastHistoryYears, startContractDateYear, startContractDateMonth, startContractDateLabel, monthsAhead, applyPpi, refreshCache, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} productId 
         * @param {string} [quoteDate] 
         * @param {number} [recentHistoryDays] 
         * @param {number} [historicalMedianYears] 
         * @param {number} [forecastHistoryYears] 
         * @param {number} [startContractDateYear] 
         * @param {number} [startContractDateMonth] 
         * @param {string} [startContractDateLabel] 
         * @param {number} [monthsAhead] 
         * @param {boolean} [applyPpi] 
         * @param {boolean} [refreshCache] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getForecastWithHistoryInternal(productId: string, quoteDate?: string, recentHistoryDays?: number, historicalMedianYears?: number, forecastHistoryYears?: number, startContractDateYear?: number, startContractDateMonth?: number, startContractDateLabel?: string, monthsAhead?: number, applyPpi?: boolean, refreshCache?: boolean, options?: any): AxiosPromise<GetForecastWithHistoryResponse> {
            return localVarFp.getForecastWithHistoryInternal(productId, quoteDate, recentHistoryDays, historicalMedianYears, forecastHistoryYears, startContractDateYear, startContractDateMonth, startContractDateLabel, monthsAhead, applyPpi, refreshCache, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} symbolId 
         * @param {string} [asOfDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMarketViewLastQuoteDate(symbolId: string, asOfDate?: string, options?: any): AxiosPromise<GetMarketViewLastQuoteDateResponse> {
            return localVarFp.getMarketViewLastQuoteDate(symbolId, asOfDate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} symbolId 
         * @param {string} [asOfDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMarketViewLastQuoteDateApi(symbolId: string, asOfDate?: string, options?: any): AxiosPromise<GetMarketViewLastQuoteDateResponse> {
            return localVarFp.getMarketViewLastQuoteDateApi(symbolId, asOfDate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} marketViewUserGuid 
         * @param {string} [stoneXUserGuid] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMarketViewUser(marketViewUserGuid: string, stoneXUserGuid?: string, options?: any): AxiosPromise<GetMarketViewUserResponse> {
            return localVarFp.getMarketViewUser(marketViewUserGuid, stoneXUserGuid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} siteGuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCommodityManagementSiteUsers(siteGuid: string, options?: any): AxiosPromise<ListCommodityManagementSiteUsersResponse> {
            return localVarFp.listCommodityManagementSiteUsers(siteGuid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {boolean} [includeUserSiteAccess] 
         * @param {string} [sortColumn] 
         * @param {SortDirection} [sortDirection] 
         * @param {number} [take] 
         * @param {number} [skip] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCommodityManagementSites(includeUserSiteAccess?: boolean, sortColumn?: string, sortDirection?: SortDirection, take?: number, skip?: number, options?: any): AxiosPromise<ListCommodityManagementSitesResponse> {
            return localVarFp.listCommodityManagementSites(includeUserSiteAccess, sortColumn, sortDirection, take, skip, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [sortColumn] 
         * @param {SortDirection} [sortDirection] 
         * @param {number} [take] 
         * @param {number} [skip] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCompanies(sortColumn?: string, sortDirection?: SortDirection, take?: number, skip?: number, options?: any): AxiosPromise<ListCompaniesResponse> {
            return localVarFp.listCompanies(sortColumn, sortDirection, take, skip, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {EmailScheduleSource} [source] 
         * @param {number} [sourceId] 
         * @param {string} [sortColumn] 
         * @param {SortDirection} [sortDirection] 
         * @param {number} [take] 
         * @param {number} [skip] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listEmailSchedules(source?: EmailScheduleSource, sourceId?: number, sortColumn?: string, sortDirection?: SortDirection, take?: number, skip?: number, options?: any): AxiosPromise<ListEmailSchedulesResponse> {
            return localVarFp.listEmailSchedules(source, sourceId, sortColumn, sortDirection, take, skip, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ListMarketViewContractPricesRequest} [listMarketViewContractPricesRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMarketViewContractPricesApi(listMarketViewContractPricesRequest?: ListMarketViewContractPricesRequest, options?: any): AxiosPromise<ListMarketViewContractPricesResponse> {
            return localVarFp.listMarketViewContractPricesApi(listMarketViewContractPricesRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} quoteDate 
         * @param {Array<Currency>} currencies 
         * @param {Array<ContractDate>} contractMonths 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMarketViewCurrencySpotRates(quoteDate: string, currencies: Array<Currency>, contractMonths: Array<ContractDate>, options?: any): AxiosPromise<ListMarketViewCurrencySpotRatesResponse> {
            return localVarFp.listMarketViewCurrencySpotRates(quoteDate, currencies, contractMonths, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} quoteDate 
         * @param {Array<Currency>} currencies 
         * @param {Array<ContractDate>} contractMonths 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMarketViewCurrencySpotRatesApi(quoteDate: string, currencies: Array<Currency>, contractMonths: Array<ContractDate>, options?: any): AxiosPromise<ListMarketViewCurrencySpotRatesResponse> {
            return localVarFp.listMarketViewCurrencySpotRatesApi(quoteDate, currencies, contractMonths, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} productId 
         * @param {string} [quoteDateRangeStart] 
         * @param {string} [quoteDateRangeEnd] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMarketViewDailyPrices(productId: string, quoteDateRangeStart?: string, quoteDateRangeEnd?: string, options?: any): AxiosPromise<MarketViewQueryDailyPricesResponse> {
            return localVarFp.listMarketViewDailyPrices(productId, quoteDateRangeStart, quoteDateRangeEnd, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Array<number>} productIds 
         * @param {boolean} [refreshCache] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMarketViewExpirationDates(productIds: Array<number>, refreshCache?: boolean, options?: any): AxiosPromise<ListMarketViewExpirationDatesResponse> {
            return localVarFp.listMarketViewExpirationDates(productIds, refreshCache, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Array<number>} productIds 
         * @param {boolean} [refreshCache] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMarketViewExpirationDatesApi(productIds: Array<number>, refreshCache?: boolean, options?: any): AxiosPromise<ListMarketViewExpirationDatesResponse> {
            return localVarFp.listMarketViewExpirationDatesApi(productIds, refreshCache, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} productId 
         * @param {string} quoteDate 
         * @param {number} [numberOfMonths] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMarketViewForwardCurveQuery(productId: string, quoteDate: string, numberOfMonths?: number, options?: any): AxiosPromise<MarketViewQueryForwardCurveResponse> {
            return localVarFp.listMarketViewForwardCurveQuery(productId, quoteDate, numberOfMonths, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} productId 
         * @param {string} quoteDate 
         * @param {number} [numberOfMonths] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMarketViewForwardCurveQueryApi(productId: string, quoteDate: string, numberOfMonths?: number, options?: any): AxiosPromise<MarketViewQueryForwardCurveResponse> {
            return localVarFp.listMarketViewForwardCurveQueryApi(productId, quoteDate, numberOfMonths, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Array<number>} symbolIds 
         * @param {string} [asOfDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMarketViewLastQuoteDate(symbolIds: Array<number>, asOfDate?: string, options?: any): AxiosPromise<ListMarketViewLastQuoteDateResponse> {
            return localVarFp.listMarketViewLastQuoteDate(symbolIds, asOfDate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Array<number>} symbolIds 
         * @param {string} [asOfDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMarketViewLastQuoteDateApi(symbolIds: Array<number>, asOfDate?: string, options?: any): AxiosPromise<ListMarketViewLastQuoteDateResponse> {
            return localVarFp.listMarketViewLastQuoteDateApi(symbolIds, asOfDate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} productId 
         * @param {Array<number>} years 
         * @param {string} [quoteDateRangeStart] 
         * @param {string} [quoteDateRangeEnd] 
         * @param {number} [userVolumeId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMarketViewPriceQueryCalendarStripAvearge(productId: string, years: Array<number>, quoteDateRangeStart?: string, quoteDateRangeEnd?: string, userVolumeId?: number, options?: any): AxiosPromise<MarketViewQueryCalendarStripAverageResponse> {
            return localVarFp.listMarketViewPriceQueryCalendarStripAvearge(productId, years, quoteDateRangeStart, quoteDateRangeEnd, userVolumeId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} productId 
         * @param {Array<number>} years 
         * @param {string} [quoteDateRangeStart] 
         * @param {string} [quoteDateRangeEnd] 
         * @param {number} [userVolumeId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMarketViewPriceQueryCalendarStripAverageApi(productId: string, years: Array<number>, quoteDateRangeStart?: string, quoteDateRangeEnd?: string, userVolumeId?: number, options?: any): AxiosPromise<MarketViewQueryCalendarStripAverageResponse> {
            return localVarFp.listMarketViewPriceQueryCalendarStripAverageApi(productId, years, quoteDateRangeStart, quoteDateRangeEnd, userVolumeId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} productId 
         * @param {number} monthsAhead 
         * @param {string} [quoteDateRangeStart] 
         * @param {string} [quoteDateRangeEnd] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMarketViewPriceQueryRollingMonthAhead(productId: string, monthsAhead: number, quoteDateRangeStart?: string, quoteDateRangeEnd?: string, options?: any): AxiosPromise<MarketViewQueryRollingMonthAheadResponse> {
            return localVarFp.listMarketViewPriceQueryRollingMonthAhead(productId, monthsAhead, quoteDateRangeStart, quoteDateRangeEnd, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} productId 
         * @param {number} monthsAhead 
         * @param {string} [quoteDateRangeStart] 
         * @param {string} [quoteDateRangeEnd] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMarketViewPriceQueryRollingMonthAheadApi(productId: string, monthsAhead: number, quoteDateRangeStart?: string, quoteDateRangeEnd?: string, options?: any): AxiosPromise<MarketViewQueryRollingMonthAheadResponse> {
            return localVarFp.listMarketViewPriceQueryRollingMonthAheadApi(productId, monthsAhead, quoteDateRangeStart, quoteDateRangeEnd, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} productId 
         * @param {Array<number>} years 
         * @param {Array<number>} months 
         * @param {string} [quoteDateRangeStart] 
         * @param {string} [quoteDateRangeEnd] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMarketViewPrices(productId: string, years: Array<number>, months: Array<number>, quoteDateRangeStart?: string, quoteDateRangeEnd?: string, options?: any): AxiosPromise<MarketViewQueryPriceResponse> {
            return localVarFp.listMarketViewPrices(productId, years, months, quoteDateRangeStart, quoteDateRangeEnd, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} productId 
         * @param {Array<number>} years 
         * @param {Array<number>} months 
         * @param {string} [quoteDateRangeStart] 
         * @param {string} [quoteDateRangeEnd] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMarketViewPricesApi(productId: string, years: Array<number>, months: Array<number>, quoteDateRangeStart?: string, quoteDateRangeEnd?: string, options?: any): AxiosPromise<MarketViewQueryPriceResponse> {
            return localVarFp.listMarketViewPricesApi(productId, years, months, quoteDateRangeStart, quoteDateRangeEnd, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} symbolId 
         * @param {string} contractYear 
         * @param {string} contractMonth 
         * @param {string} [sortColumn] 
         * @param {SortDirection} [sortDirection] 
         * @param {number} [take] 
         * @param {number} [skip] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMarketViewPricesBySymbol(symbolId: string, contractYear: string, contractMonth: string, sortColumn?: string, sortDirection?: SortDirection, take?: number, skip?: number, options?: any): AxiosPromise<ListMarketViewPricesResponse> {
            return localVarFp.listMarketViewPricesBySymbol(symbolId, contractYear, contractMonth, sortColumn, sortDirection, take, skip, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} symbolId 
         * @param {string} contractYear 
         * @param {string} contractMonth 
         * @param {string} [sortColumn] 
         * @param {SortDirection} [sortDirection] 
         * @param {number} [take] 
         * @param {number} [skip] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMarketViewPricesBySymbolApi(symbolId: string, contractYear: string, contractMonth: string, sortColumn?: string, sortDirection?: SortDirection, take?: number, skip?: number, options?: any): AxiosPromise<ListMarketViewPricesResponse> {
            return localVarFp.listMarketViewPricesBySymbolApi(symbolId, contractYear, contractMonth, sortColumn, sortDirection, take, skip, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} productId 
         * @param {Array<number>} years 
         * @param {Array<number>} months 
         * @param {string} [quoteDateRangeStart] 
         * @param {string} [quoteDateRangeEnd] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMarketViewPricesInternal(productId: string, years: Array<number>, months: Array<number>, quoteDateRangeStart?: string, quoteDateRangeEnd?: string, options?: any): AxiosPromise<MarketViewQueryPriceResponse> {
            return localVarFp.listMarketViewPricesInternal(productId, years, months, quoteDateRangeStart, quoteDateRangeEnd, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} productId 
         * @param {string} [quoteDateRangeStart] 
         * @param {string} [quoteDateRangeEnd] 
         * @param {number} [contractDateRangeStartYear] 
         * @param {number} [contractDateRangeStartMonth] 
         * @param {number} [contractDateRangeEndYear] 
         * @param {number} [contractDateRangeEndMonth] 
         * @param {number} [contractDateRangeStartContractDateYear] 
         * @param {number} [contractDateRangeStartContractDateMonth] 
         * @param {string} [contractDateRangeStartContractDateLabel] 
         * @param {number} [contractDateRangeEndContractDateYear] 
         * @param {number} [contractDateRangeEndContractDateMonth] 
         * @param {string} [contractDateRangeEndContractDateLabel] 
         * @param {number} [userVolumeId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMarketViewPricesStripAverage(productId: string, quoteDateRangeStart?: string, quoteDateRangeEnd?: string, contractDateRangeStartYear?: number, contractDateRangeStartMonth?: number, contractDateRangeEndYear?: number, contractDateRangeEndMonth?: number, contractDateRangeStartContractDateYear?: number, contractDateRangeStartContractDateMonth?: number, contractDateRangeStartContractDateLabel?: string, contractDateRangeEndContractDateYear?: number, contractDateRangeEndContractDateMonth?: number, contractDateRangeEndContractDateLabel?: string, userVolumeId?: number, options?: any): AxiosPromise<MarketViewQueryStripAverageResponse> {
            return localVarFp.listMarketViewPricesStripAverage(productId, quoteDateRangeStart, quoteDateRangeEnd, contractDateRangeStartYear, contractDateRangeStartMonth, contractDateRangeEndYear, contractDateRangeEndMonth, contractDateRangeStartContractDateYear, contractDateRangeStartContractDateMonth, contractDateRangeStartContractDateLabel, contractDateRangeEndContractDateYear, contractDateRangeEndContractDateMonth, contractDateRangeEndContractDateLabel, userVolumeId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} productId 
         * @param {string} [quoteDateRangeStart] 
         * @param {string} [quoteDateRangeEnd] 
         * @param {number} [contractDateRangeStartYear] 
         * @param {number} [contractDateRangeStartMonth] 
         * @param {number} [contractDateRangeEndYear] 
         * @param {number} [contractDateRangeEndMonth] 
         * @param {number} [contractDateRangeStartContractDateYear] 
         * @param {number} [contractDateRangeStartContractDateMonth] 
         * @param {string} [contractDateRangeStartContractDateLabel] 
         * @param {number} [contractDateRangeEndContractDateYear] 
         * @param {number} [contractDateRangeEndContractDateMonth] 
         * @param {string} [contractDateRangeEndContractDateLabel] 
         * @param {number} [userVolumeId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMarketViewPricesStripAverageApi(productId: string, quoteDateRangeStart?: string, quoteDateRangeEnd?: string, contractDateRangeStartYear?: number, contractDateRangeStartMonth?: number, contractDateRangeEndYear?: number, contractDateRangeEndMonth?: number, contractDateRangeStartContractDateYear?: number, contractDateRangeStartContractDateMonth?: number, contractDateRangeStartContractDateLabel?: string, contractDateRangeEndContractDateYear?: number, contractDateRangeEndContractDateMonth?: number, contractDateRangeEndContractDateLabel?: string, userVolumeId?: number, options?: any): AxiosPromise<MarketViewQueryStripAverageResponse> {
            return localVarFp.listMarketViewPricesStripAverageApi(productId, quoteDateRangeStart, quoteDateRangeEnd, contractDateRangeStartYear, contractDateRangeStartMonth, contractDateRangeEndYear, contractDateRangeEndMonth, contractDateRangeStartContractDateYear, contractDateRangeStartContractDateMonth, contractDateRangeStartContractDateLabel, contractDateRangeEndContractDateYear, contractDateRangeEndContractDateMonth, contractDateRangeEndContractDateLabel, userVolumeId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMarketViewProductTypes(options?: any): AxiosPromise<ListMarketViewProductTypesResponse> {
            return localVarFp.listMarketViewProductTypes(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CommodityType} [commodityType] 
         * @param {Array<number>} [productIds] 
         * @param {number} [minimumHistoryYears] 
         * @param {number} [lastQuoteDateThresholdDays] 
         * @param {boolean} [refreshCache] 
         * @param {string} [sortColumn] 
         * @param {SortDirection} [sortDirection] 
         * @param {number} [take] 
         * @param {number} [skip] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMarketViewProducts(commodityType?: CommodityType, productIds?: Array<number>, minimumHistoryYears?: number, lastQuoteDateThresholdDays?: number, refreshCache?: boolean, sortColumn?: string, sortDirection?: SortDirection, take?: number, skip?: number, options?: any): AxiosPromise<ListMarketViewProductsResponse> {
            return localVarFp.listMarketViewProducts(commodityType, productIds, minimumHistoryYears, lastQuoteDateThresholdDays, refreshCache, sortColumn, sortDirection, take, skip, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CommodityType} [commodityType] 
         * @param {PriceType} [priceType] 
         * @param {Array<number>} [productIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMarketViewProductsInternal(commodityType?: CommodityType, priceType?: PriceType, productIds?: Array<number>, options?: any): AxiosPromise<ListMarketViewInternalProductsResponse> {
            return localVarFp.listMarketViewProductsInternal(commodityType, priceType, productIds, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [sortColumn] 
         * @param {SortDirection} [sortDirection] 
         * @param {number} [take] 
         * @param {number} [skip] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMarketViewSavedQuery(sortColumn?: string, sortDirection?: SortDirection, take?: number, skip?: number, options?: any): AxiosPromise<ListMarketViewSavedQueryResponse> {
            return localVarFp.listMarketViewSavedQuery(sortColumn, sortDirection, take, skip, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} productId 
         * @param {string} [quoteDateRangeStart] 
         * @param {string} [quoteDateRangeEnd] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMarketViewSettlementPrices(productId: string, quoteDateRangeStart?: string, quoteDateRangeEnd?: string, options?: any): AxiosPromise<MarketViewQuerySettlementsResponse> {
            return localVarFp.listMarketViewSettlementPrices(productId, quoteDateRangeStart, quoteDateRangeEnd, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} productId 
         * @param {string} [quoteDateRangeStart] 
         * @param {string} [quoteDateRangeEnd] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMarketViewSettlementPricesApi(productId: string, quoteDateRangeStart?: string, quoteDateRangeEnd?: string, options?: any): AxiosPromise<MarketViewQuerySettlementsResponse> {
            return localVarFp.listMarketViewSettlementPricesApi(productId, quoteDateRangeStart, quoteDateRangeEnd, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Array<string>} [marketViewUserGuids] 
         * @param {string} [companyGuid] 
         * @param {boolean} [includeSites] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMarketViewUsers(marketViewUserGuids?: Array<string>, companyGuid?: string, includeSites?: boolean, options?: any): AxiosPromise<ListMarketViewUsersResponse> {
            return localVarFp.listMarketViewUsers(marketViewUserGuids, companyGuid, includeSites, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMarketViewVolumes(options?: any): AxiosPromise<MarketViewVolumesResponse> {
            return localVarFp.listMarketViewVolumes(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} productId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        marketViewProductTradingMonths(productId: string, options?: any): AxiosPromise<MarketViewProductTradingMonthsResponse> {
            return localVarFp.marketViewProductTradingMonths(productId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        marketViewUserAuthorizationCallback(options?: any): AxiosPromise<GetMarketViewUserAuthorizationResponse> {
            return localVarFp.marketViewUserAuthorizationCallback(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} emailScheduleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendEmailScheduleNow(emailScheduleId: string, options?: any): AxiosPromise<SendEmailScheduleResponse> {
            return localVarFp.sendEmailScheduleNow(emailScheduleId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} savedQueryId 
         * @param {SendMarketViewSavedQueryEmailRequest} [sendMarketViewSavedQueryEmailRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendMarketViewSavedQueryEmail(savedQueryId: string, sendMarketViewSavedQueryEmailRequest?: SendMarketViewSavedQueryEmailRequest, options?: any): AxiosPromise<SendMarketViewSavedQueryEmailResponse> {
            return localVarFp.sendMarketViewSavedQueryEmail(savedQueryId, sendMarketViewSavedQueryEmailRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} siteGuid 
         * @param {string} siteName 
         * @param {string} companyGuid 
         * @param {Array<UserAccessUpdateModel>} userSiteAccesses 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCommodityManagementSite(siteGuid: string, siteName: string, companyGuid: string, userSiteAccesses: Array<UserAccessUpdateModel>, options?: any): AxiosPromise<UpdateCommodityManagementSiteResponse> {
            return localVarFp.updateCommodityManagementSite(siteGuid, siteName, companyGuid, userSiteAccesses, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} siteGuid 
         * @param {string} marketViewUserGuid 
         * @param {boolean} [isSiteManager] 
         * @param {Array<CommodityManagementUserPermissions>} [permissions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCommodityManagementUserSiteAccess(siteGuid: string, marketViewUserGuid: string, isSiteManager?: boolean, permissions?: Array<CommodityManagementUserPermissions>, options?: any): AxiosPromise<object> {
            return localVarFp.updateCommodityManagementUserSiteAccess(siteGuid, marketViewUserGuid, isSiteManager, permissions, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} companyGuid 
         * @param {UpdateCompanyRequest} [updateCompanyRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCompany(companyGuid: string, updateCompanyRequest?: UpdateCompanyRequest, options?: any): AxiosPromise<UpdateCompanyResponse> {
            return localVarFp.updateCompany(companyGuid, updateCompanyRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} companyGuid 
         * @param {boolean} isEnabled 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCompanyEnabled(companyGuid: string, isEnabled: boolean, options?: any): AxiosPromise<object> {
            return localVarFp.updateCompanyEnabled(companyGuid, isEnabled, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} marketViewUserGuid 
         * @param {UpdateMarketViewUserRequest} [updateMarketViewUserRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMarketViewUser(marketViewUserGuid: string, updateMarketViewUserRequest?: UpdateMarketViewUserRequest, options?: any): AxiosPromise<UpdateMarketViewUserResponse> {
            return localVarFp.updateMarketViewUser(marketViewUserGuid, updateMarketViewUserRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} marketViewUserGuid 
         * @param {boolean} isEnabled 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMarketViewUserEnabled(marketViewUserGuid: string, isEnabled: boolean, options?: any): AxiosPromise<object> {
            return localVarFp.updateMarketViewUserEnabled(marketViewUserGuid, isEnabled, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UpsertEmailScheduleRequest} [upsertEmailScheduleRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        upsertEmailSchedule(upsertEmailScheduleRequest?: UpsertEmailScheduleRequest, options?: any): AxiosPromise<UpsertEmailScheduleResponse> {
            return localVarFp.upsertEmailSchedule(upsertEmailScheduleRequest, options).then((request) => request(axios, basePath));
        },
    };
};



/**
 * MarketViewApi - object-oriented interface
 * @export
 * @class MarketViewApi
 * @extends {BaseAPI}
 */
export class MarketViewApi extends BaseAPI {
    /**
     * 
     * @param {string} siteName 
     * @param {string} companyGuid 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MarketViewApi
     */
    public addCommodityManagementSite(loadingStateSetter: null | undefined | ((state: LoadingState) => void | undefined | null), siteName: string, companyGuid: string, options?: AxiosRequestConfig) {
        const promise = MarketViewApiFp(this.configuration).addCommodityManagementSite(siteName, companyGuid, options).then((request) => request(this.axios, this.basePath));

        if (loadingStateSetter) {
            loadingStateSetter(LoadingState.Loading);
            promise.then(q => loadingStateSetter(LoadingState.Loaded));
            promise.catch(q => loadingStateSetter(LoadingState.Failed));
        }

        return promise;
    }

    /**
     * 
     * @param {string} siteGuid 
     * @param {string} marketViewUserGuid 
     * @param {string} [email] 
     * @param {string} [firstName] 
     * @param {string} [lastName] 
     * @param {boolean} [isSiteManager] 
     * @param {Array<CommodityManagementUserPermissions>} [permissions] 
     * @param {boolean} [initializeAccessIfNew] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MarketViewApi
     */
    public addCommodityManagementUserSiteAccess(loadingStateSetter: null | undefined | ((state: LoadingState) => void | undefined | null), siteGuid: string, marketViewUserGuid: string, email?: string, firstName?: string, lastName?: string, isSiteManager?: boolean, permissions?: Array<CommodityManagementUserPermissions>, initializeAccessIfNew?: boolean, options?: AxiosRequestConfig) {
        const promise = MarketViewApiFp(this.configuration).addCommodityManagementUserSiteAccess(siteGuid, marketViewUserGuid, email, firstName, lastName, isSiteManager, permissions, initializeAccessIfNew, options).then((request) => request(this.axios, this.basePath));

        if (loadingStateSetter) {
            loadingStateSetter(LoadingState.Loading);
            promise.then(q => loadingStateSetter(LoadingState.Loaded));
            promise.catch(q => loadingStateSetter(LoadingState.Failed));
        }

        return promise;
    }

    /**
     * 
     * @param {AddCompanyRequest} [addCompanyRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MarketViewApi
     */
    public addCompany(loadingStateSetter: null | undefined | ((state: LoadingState) => void | undefined | null), addCompanyRequest?: AddCompanyRequest, options?: AxiosRequestConfig) {
        const promise = MarketViewApiFp(this.configuration).addCompany(addCompanyRequest, options).then((request) => request(this.axios, this.basePath));

        if (loadingStateSetter) {
            loadingStateSetter(LoadingState.Loading);
            promise.then(q => loadingStateSetter(LoadingState.Loaded));
            promise.catch(q => loadingStateSetter(LoadingState.Failed));
        }

        return promise;
    }

    /**
     * 
     * @param {number} savedQueryId 
     * @param {string} name 
     * @param {Array<MarkItViewQuerySavedParameters>} markItViewQuerySavedParameters 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MarketViewApi
     */
    public addMarketViewSavedQuery(loadingStateSetter: null | undefined | ((state: LoadingState) => void | undefined | null), savedQueryId: number, name: string, markItViewQuerySavedParameters: Array<MarkItViewQuerySavedParameters>, options?: AxiosRequestConfig) {
        const promise = MarketViewApiFp(this.configuration).addMarketViewSavedQuery(savedQueryId, name, markItViewQuerySavedParameters, options).then((request) => request(this.axios, this.basePath));

        if (loadingStateSetter) {
            loadingStateSetter(LoadingState.Loading);
            promise.then(q => loadingStateSetter(LoadingState.Loaded));
            promise.catch(q => loadingStateSetter(LoadingState.Failed));
        }

        return promise;
    }

    /**
     * 
     * @param {AddMarketViewUserRequest} [addMarketViewUserRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MarketViewApi
     */
    public addMarketViewUser(loadingStateSetter: null | undefined | ((state: LoadingState) => void | undefined | null), addMarketViewUserRequest?: AddMarketViewUserRequest, options?: AxiosRequestConfig) {
        const promise = MarketViewApiFp(this.configuration).addMarketViewUser(addMarketViewUserRequest, options).then((request) => request(this.axios, this.basePath));

        if (loadingStateSetter) {
            loadingStateSetter(LoadingState.Loading);
            promise.then(q => loadingStateSetter(LoadingState.Loaded));
            promise.catch(q => loadingStateSetter(LoadingState.Failed));
        }

        return promise;
    }

    /**
     * 
     * @param {string} productId 
     * @param {AddMarketViewUserFavoritedProductRequest} [addMarketViewUserFavoritedProductRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MarketViewApi
     */
    public addMarketViewUserFavoritedProduct(loadingStateSetter: null | undefined | ((state: LoadingState) => void | undefined | null), productId: string, addMarketViewUserFavoritedProductRequest?: AddMarketViewUserFavoritedProductRequest, options?: AxiosRequestConfig) {
        const promise = MarketViewApiFp(this.configuration).addMarketViewUserFavoritedProduct(productId, addMarketViewUserFavoritedProductRequest, options).then((request) => request(this.axios, this.basePath));

        if (loadingStateSetter) {
            loadingStateSetter(LoadingState.Loading);
            promise.then(q => loadingStateSetter(LoadingState.Loaded));
            promise.catch(q => loadingStateSetter(LoadingState.Failed));
        }

        return promise;
    }

    /**
     * 
     * @param {number} userVolumeId 
     * @param {string} name 
     * @param {{ [key: string]: number; }} volumes 
     * @param {string} [sortColumn] 
     * @param {SortDirection} [sortDirection] 
     * @param {number} [take] 
     * @param {number} [skip] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MarketViewApi
     */
    public addMarketViewVolume(loadingStateSetter: null | undefined | ((state: LoadingState) => void | undefined | null), userVolumeId: number, name: string, volumes: { [key: string]: number; }, sortColumn?: string, sortDirection?: SortDirection, take?: number, skip?: number, options?: AxiosRequestConfig) {
        const promise = MarketViewApiFp(this.configuration).addMarketViewVolume(userVolumeId, name, volumes, sortColumn, sortDirection, take, skip, options).then((request) => request(this.axios, this.basePath));

        if (loadingStateSetter) {
            loadingStateSetter(LoadingState.Loading);
            promise.then(q => loadingStateSetter(LoadingState.Loaded));
            promise.catch(q => loadingStateSetter(LoadingState.Failed));
        }

        return promise;
    }

    /**
     * 
     * @param {AgreeToMarketViewTermsAndConditionsRequest} [agreeToMarketViewTermsAndConditionsRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MarketViewApi
     */
    public agreeToDemeterTermsAndConditions(loadingStateSetter: null | undefined | ((state: LoadingState) => void | undefined | null), agreeToMarketViewTermsAndConditionsRequest?: AgreeToMarketViewTermsAndConditionsRequest, options?: AxiosRequestConfig) {
        const promise = MarketViewApiFp(this.configuration).agreeToDemeterTermsAndConditions(agreeToMarketViewTermsAndConditionsRequest, options).then((request) => request(this.axios, this.basePath));

        if (loadingStateSetter) {
            loadingStateSetter(LoadingState.Loading);
            promise.then(q => loadingStateSetter(LoadingState.Loaded));
            promise.catch(q => loadingStateSetter(LoadingState.Failed));
        }

        return promise;
    }

    /**
     * 
     * @param {CalculateMatrixRequest} [calculateMatrixRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MarketViewApi
     */
    public calculateMatrix(loadingStateSetter: null | undefined | ((state: LoadingState) => void | undefined | null), calculateMatrixRequest?: CalculateMatrixRequest, options?: AxiosRequestConfig) {
        const promise = MarketViewApiFp(this.configuration).calculateMatrix(calculateMatrixRequest, options).then((request) => request(this.axios, this.basePath));

        if (loadingStateSetter) {
            loadingStateSetter(LoadingState.Loading);
            promise.then(q => loadingStateSetter(LoadingState.Loaded));
            promise.catch(q => loadingStateSetter(LoadingState.Failed));
        }

        return promise;
    }

    /**
     * 
     * @param {string} siteGuid 
     * @param {string} marketViewUserGuid 
     * @param {boolean} [disableUserIfNoOtherSites] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MarketViewApi
     */
    public deleteCommodityManagementUserSiteAccess(loadingStateSetter: null | undefined | ((state: LoadingState) => void | undefined | null), siteGuid: string, marketViewUserGuid: string, disableUserIfNoOtherSites?: boolean, options?: AxiosRequestConfig) {
        const promise = MarketViewApiFp(this.configuration).deleteCommodityManagementUserSiteAccess(siteGuid, marketViewUserGuid, disableUserIfNoOtherSites, options).then((request) => request(this.axios, this.basePath));

        if (loadingStateSetter) {
            loadingStateSetter(LoadingState.Loading);
            promise.then(q => loadingStateSetter(LoadingState.Loaded));
            promise.catch(q => loadingStateSetter(LoadingState.Failed));
        }

        return promise;
    }

    /**
     * 
     * @param {string} emailScheduleId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MarketViewApi
     */
    public deleteEmailSchedule(loadingStateSetter: null | undefined | ((state: LoadingState) => void | undefined | null), emailScheduleId: string, options?: AxiosRequestConfig) {
        const promise = MarketViewApiFp(this.configuration).deleteEmailSchedule(emailScheduleId, options).then((request) => request(this.axios, this.basePath));

        if (loadingStateSetter) {
            loadingStateSetter(LoadingState.Loading);
            promise.then(q => loadingStateSetter(LoadingState.Loaded));
            promise.catch(q => loadingStateSetter(LoadingState.Failed));
        }

        return promise;
    }

    /**
     * 
     * @param {string} savedQueryId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MarketViewApi
     */
    public deleteMarketViewSavedQuery(loadingStateSetter: null | undefined | ((state: LoadingState) => void | undefined | null), savedQueryId: string, options?: AxiosRequestConfig) {
        const promise = MarketViewApiFp(this.configuration).deleteMarketViewSavedQuery(savedQueryId, options).then((request) => request(this.axios, this.basePath));

        if (loadingStateSetter) {
            loadingStateSetter(LoadingState.Loading);
            promise.then(q => loadingStateSetter(LoadingState.Loaded));
            promise.catch(q => loadingStateSetter(LoadingState.Failed));
        }

        return promise;
    }

    /**
     * 
     * @param {string} productId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MarketViewApi
     */
    public deleteMarketViewUserFavoritedProduct(loadingStateSetter: null | undefined | ((state: LoadingState) => void | undefined | null), productId: string, options?: AxiosRequestConfig) {
        const promise = MarketViewApiFp(this.configuration).deleteMarketViewUserFavoritedProduct(productId, options).then((request) => request(this.axios, this.basePath));

        if (loadingStateSetter) {
            loadingStateSetter(LoadingState.Loading);
            promise.then(q => loadingStateSetter(LoadingState.Loaded));
            promise.catch(q => loadingStateSetter(LoadingState.Failed));
        }

        return promise;
    }

    /**
     * 
     * @param {string} savedQueryId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MarketViewApi
     */
    public exportMarketViewSavedQuery(loadingStateSetter: null | undefined | ((state: LoadingState) => void | undefined | null), savedQueryId: string, options?: AxiosRequestConfig) {
        const promise = MarketViewApiFp(this.configuration).exportMarketViewSavedQuery(savedQueryId, options).then((request) => request(this.axios, this.basePath));

        if (loadingStateSetter) {
            loadingStateSetter(LoadingState.Loading);
            promise.then(q => loadingStateSetter(LoadingState.Loaded));
            promise.catch(q => loadingStateSetter(LoadingState.Failed));
        }

        return promise;
    }

    /**
     * 
     * @param {string} companyGuid 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MarketViewApi
     */
    public getCompany(loadingStateSetter: null | undefined | ((state: LoadingState) => void | undefined | null), companyGuid: string, options?: AxiosRequestConfig) {
        const promise = MarketViewApiFp(this.configuration).getCompany(companyGuid, options).then((request) => request(this.axios, this.basePath));

        if (loadingStateSetter) {
            loadingStateSetter(LoadingState.Loading);
            promise.then(q => loadingStateSetter(LoadingState.Loaded));
            promise.catch(q => loadingStateSetter(LoadingState.Failed));
        }

        return promise;
    }

    /**
     * 
     * @param {string} startDate 
     * @param {string} endDate 
     * @param {string} commodity 
     * @param {string} [markToMarketDate] 
     * @param {string} [sortColumn] 
     * @param {SortDirection} [sortDirection] 
     * @param {number} [take] 
     * @param {number} [skip] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MarketViewApi
     */
    public getDecisiveBasisPrices(loadingStateSetter: null | undefined | ((state: LoadingState) => void | undefined | null), startDate: string, endDate: string, commodity: string, markToMarketDate?: string, sortColumn?: string, sortDirection?: SortDirection, take?: number, skip?: number, options?: AxiosRequestConfig) {
        const promise = MarketViewApiFp(this.configuration).getDecisiveBasisPrices(startDate, endDate, commodity, markToMarketDate, sortColumn, sortDirection, take, skip, options).then((request) => request(this.axios, this.basePath));

        if (loadingStateSetter) {
            loadingStateSetter(LoadingState.Loading);
            promise.then(q => loadingStateSetter(LoadingState.Loaded));
            promise.catch(q => loadingStateSetter(LoadingState.Failed));
        }

        return promise;
    }

    /**
     * 
     * @param {string} startDate 
     * @param {string} endDate 
     * @param {string} commodity 
     * @param {string} [markToMarketDate] 
     * @param {string} [sortColumn] 
     * @param {SortDirection} [sortDirection] 
     * @param {number} [take] 
     * @param {number} [skip] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MarketViewApi
     */
    public getDecisiveFutureBasisPricesRangeByCommodity(loadingStateSetter: null | undefined | ((state: LoadingState) => void | undefined | null), startDate: string, endDate: string, commodity: string, markToMarketDate?: string, sortColumn?: string, sortDirection?: SortDirection, take?: number, skip?: number, options?: AxiosRequestConfig) {
        const promise = MarketViewApiFp(this.configuration).getDecisiveFutureBasisPricesRangeByCommodity(startDate, endDate, commodity, markToMarketDate, sortColumn, sortDirection, take, skip, options).then((request) => request(this.axios, this.basePath));

        if (loadingStateSetter) {
            loadingStateSetter(LoadingState.Loading);
            promise.then(q => loadingStateSetter(LoadingState.Loaded));
            promise.catch(q => loadingStateSetter(LoadingState.Failed));
        }

        return promise;
    }

    /**
     * 
     * @param {string} startDate 
     * @param {string} endDate 
     * @param {string} commodity 
     * @param {string} [markToMarketDate] 
     * @param {string} [sortColumn] 
     * @param {SortDirection} [sortDirection] 
     * @param {number} [take] 
     * @param {number} [skip] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MarketViewApi
     */
    public getDecisiveFuturePricesRangeByCommodity(loadingStateSetter: null | undefined | ((state: LoadingState) => void | undefined | null), startDate: string, endDate: string, commodity: string, markToMarketDate?: string, sortColumn?: string, sortDirection?: SortDirection, take?: number, skip?: number, options?: AxiosRequestConfig) {
        const promise = MarketViewApiFp(this.configuration).getDecisiveFuturePricesRangeByCommodity(startDate, endDate, commodity, markToMarketDate, sortColumn, sortDirection, take, skip, options).then((request) => request(this.axios, this.basePath));

        if (loadingStateSetter) {
            loadingStateSetter(LoadingState.Loading);
            promise.then(q => loadingStateSetter(LoadingState.Loaded));
            promise.catch(q => loadingStateSetter(LoadingState.Failed));
        }

        return promise;
    }

    /**
     * 
     * @param {string} startDate 
     * @param {string} endDate 
     * @param {string} commodity 
     * @param {string} [markToMarketDate] 
     * @param {string} [sortColumn] 
     * @param {SortDirection} [sortDirection] 
     * @param {number} [take] 
     * @param {number} [skip] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MarketViewApi
     */
    public getDecisiveSpecialtyCropPricesRangeByCommodity(loadingStateSetter: null | undefined | ((state: LoadingState) => void | undefined | null), startDate: string, endDate: string, commodity: string, markToMarketDate?: string, sortColumn?: string, sortDirection?: SortDirection, take?: number, skip?: number, options?: AxiosRequestConfig) {
        const promise = MarketViewApiFp(this.configuration).getDecisiveSpecialtyCropPricesRangeByCommodity(startDate, endDate, commodity, markToMarketDate, sortColumn, sortDirection, take, skip, options).then((request) => request(this.axios, this.basePath));

        if (loadingStateSetter) {
            loadingStateSetter(LoadingState.Loading);
            promise.then(q => loadingStateSetter(LoadingState.Loaded));
            promise.catch(q => loadingStateSetter(LoadingState.Failed));
        }

        return promise;
    }

    /**
     * 
     * @param {string} productId 
     * @param {number} [forecastHistoryYears] 
     * @param {string} [quoteDate] 
     * @param {number} [recentHistoryDays] 
     * @param {number} [historicalMedianYears] 
     * @param {number} [startContractDateYear] 
     * @param {number} [startContractDateMonth] 
     * @param {string} [startContractDateLabel] 
     * @param {number} [monthsAhead] 
     * @param {boolean} [applyPpi] 
     * @param {boolean} [refreshCache] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MarketViewApi
     */
    public getForecastInternal(loadingStateSetter: null | undefined | ((state: LoadingState) => void | undefined | null), productId: string, forecastHistoryYears?: number, quoteDate?: string, recentHistoryDays?: number, historicalMedianYears?: number, startContractDateYear?: number, startContractDateMonth?: number, startContractDateLabel?: string, monthsAhead?: number, applyPpi?: boolean, refreshCache?: boolean, options?: AxiosRequestConfig) {
        const promise = MarketViewApiFp(this.configuration).getForecastInternal(productId, forecastHistoryYears, quoteDate, recentHistoryDays, historicalMedianYears, startContractDateYear, startContractDateMonth, startContractDateLabel, monthsAhead, applyPpi, refreshCache, options).then((request) => request(this.axios, this.basePath));

        if (loadingStateSetter) {
            loadingStateSetter(LoadingState.Loading);
            promise.then(q => loadingStateSetter(LoadingState.Loaded));
            promise.catch(q => loadingStateSetter(LoadingState.Failed));
        }

        return promise;
    }

    /**
     * 
     * @param {string} productId 
     * @param {string} [quoteDate] 
     * @param {number} [recentHistoryDays] 
     * @param {number} [historicalMedianYears] 
     * @param {number} [forecastHistoryYears] 
     * @param {number} [startContractDateYear] 
     * @param {number} [startContractDateMonth] 
     * @param {string} [startContractDateLabel] 
     * @param {number} [monthsAhead] 
     * @param {boolean} [applyPpi] 
     * @param {boolean} [refreshCache] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MarketViewApi
     */
    public getForecastWithHistory(loadingStateSetter: null | undefined | ((state: LoadingState) => void | undefined | null), productId: string, quoteDate?: string, recentHistoryDays?: number, historicalMedianYears?: number, forecastHistoryYears?: number, startContractDateYear?: number, startContractDateMonth?: number, startContractDateLabel?: string, monthsAhead?: number, applyPpi?: boolean, refreshCache?: boolean, options?: AxiosRequestConfig) {
        const promise = MarketViewApiFp(this.configuration).getForecastWithHistory(productId, quoteDate, recentHistoryDays, historicalMedianYears, forecastHistoryYears, startContractDateYear, startContractDateMonth, startContractDateLabel, monthsAhead, applyPpi, refreshCache, options).then((request) => request(this.axios, this.basePath));

        if (loadingStateSetter) {
            loadingStateSetter(LoadingState.Loading);
            promise.then(q => loadingStateSetter(LoadingState.Loaded));
            promise.catch(q => loadingStateSetter(LoadingState.Failed));
        }

        return promise;
    }

    /**
     * 
     * @param {string} productId 
     * @param {string} [quoteDate] 
     * @param {number} [recentHistoryDays] 
     * @param {number} [historicalMedianYears] 
     * @param {number} [forecastHistoryYears] 
     * @param {number} [startContractDateYear] 
     * @param {number} [startContractDateMonth] 
     * @param {string} [startContractDateLabel] 
     * @param {number} [monthsAhead] 
     * @param {boolean} [applyPpi] 
     * @param {boolean} [refreshCache] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MarketViewApi
     */
    public getForecastWithHistoryInternal(loadingStateSetter: null | undefined | ((state: LoadingState) => void | undefined | null), productId: string, quoteDate?: string, recentHistoryDays?: number, historicalMedianYears?: number, forecastHistoryYears?: number, startContractDateYear?: number, startContractDateMonth?: number, startContractDateLabel?: string, monthsAhead?: number, applyPpi?: boolean, refreshCache?: boolean, options?: AxiosRequestConfig) {
        const promise = MarketViewApiFp(this.configuration).getForecastWithHistoryInternal(productId, quoteDate, recentHistoryDays, historicalMedianYears, forecastHistoryYears, startContractDateYear, startContractDateMonth, startContractDateLabel, monthsAhead, applyPpi, refreshCache, options).then((request) => request(this.axios, this.basePath));

        if (loadingStateSetter) {
            loadingStateSetter(LoadingState.Loading);
            promise.then(q => loadingStateSetter(LoadingState.Loaded));
            promise.catch(q => loadingStateSetter(LoadingState.Failed));
        }

        return promise;
    }

    /**
     * 
     * @param {string} symbolId 
     * @param {string} [asOfDate] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MarketViewApi
     */
    public getMarketViewLastQuoteDate(loadingStateSetter: null | undefined | ((state: LoadingState) => void | undefined | null), symbolId: string, asOfDate?: string, options?: AxiosRequestConfig) {
        const promise = MarketViewApiFp(this.configuration).getMarketViewLastQuoteDate(symbolId, asOfDate, options).then((request) => request(this.axios, this.basePath));

        if (loadingStateSetter) {
            loadingStateSetter(LoadingState.Loading);
            promise.then(q => loadingStateSetter(LoadingState.Loaded));
            promise.catch(q => loadingStateSetter(LoadingState.Failed));
        }

        return promise;
    }

    /**
     * 
     * @param {string} symbolId 
     * @param {string} [asOfDate] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MarketViewApi
     */
    public getMarketViewLastQuoteDateApi(loadingStateSetter: null | undefined | ((state: LoadingState) => void | undefined | null), symbolId: string, asOfDate?: string, options?: AxiosRequestConfig) {
        const promise = MarketViewApiFp(this.configuration).getMarketViewLastQuoteDateApi(symbolId, asOfDate, options).then((request) => request(this.axios, this.basePath));

        if (loadingStateSetter) {
            loadingStateSetter(LoadingState.Loading);
            promise.then(q => loadingStateSetter(LoadingState.Loaded));
            promise.catch(q => loadingStateSetter(LoadingState.Failed));
        }

        return promise;
    }

    /**
     * 
     * @param {string} marketViewUserGuid 
     * @param {string} [stoneXUserGuid] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MarketViewApi
     */
    public getMarketViewUser(loadingStateSetter: null | undefined | ((state: LoadingState) => void | undefined | null), marketViewUserGuid: string, stoneXUserGuid?: string, options?: AxiosRequestConfig) {
        const promise = MarketViewApiFp(this.configuration).getMarketViewUser(marketViewUserGuid, stoneXUserGuid, options).then((request) => request(this.axios, this.basePath));

        if (loadingStateSetter) {
            loadingStateSetter(LoadingState.Loading);
            promise.then(q => loadingStateSetter(LoadingState.Loaded));
            promise.catch(q => loadingStateSetter(LoadingState.Failed));
        }

        return promise;
    }

    /**
     * 
     * @param {string} siteGuid 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MarketViewApi
     */
    public listCommodityManagementSiteUsers(loadingStateSetter: null | undefined | ((state: LoadingState) => void | undefined | null), siteGuid: string, options?: AxiosRequestConfig) {
        const promise = MarketViewApiFp(this.configuration).listCommodityManagementSiteUsers(siteGuid, options).then((request) => request(this.axios, this.basePath));

        if (loadingStateSetter) {
            loadingStateSetter(LoadingState.Loading);
            promise.then(q => loadingStateSetter(LoadingState.Loaded));
            promise.catch(q => loadingStateSetter(LoadingState.Failed));
        }

        return promise;
    }

    /**
     * 
     * @param {boolean} [includeUserSiteAccess] 
     * @param {string} [sortColumn] 
     * @param {SortDirection} [sortDirection] 
     * @param {number} [take] 
     * @param {number} [skip] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MarketViewApi
     */
    public listCommodityManagementSites(loadingStateSetter: null | undefined | ((state: LoadingState) => void | undefined | null), includeUserSiteAccess?: boolean, sortColumn?: string, sortDirection?: SortDirection, take?: number, skip?: number, options?: AxiosRequestConfig) {
        const promise = MarketViewApiFp(this.configuration).listCommodityManagementSites(includeUserSiteAccess, sortColumn, sortDirection, take, skip, options).then((request) => request(this.axios, this.basePath));

        if (loadingStateSetter) {
            loadingStateSetter(LoadingState.Loading);
            promise.then(q => loadingStateSetter(LoadingState.Loaded));
            promise.catch(q => loadingStateSetter(LoadingState.Failed));
        }

        return promise;
    }

    /**
     * 
     * @param {string} [sortColumn] 
     * @param {SortDirection} [sortDirection] 
     * @param {number} [take] 
     * @param {number} [skip] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MarketViewApi
     */
    public listCompanies(loadingStateSetter: null | undefined | ((state: LoadingState) => void | undefined | null), sortColumn?: string, sortDirection?: SortDirection, take?: number, skip?: number, options?: AxiosRequestConfig) {
        const promise = MarketViewApiFp(this.configuration).listCompanies(sortColumn, sortDirection, take, skip, options).then((request) => request(this.axios, this.basePath));

        if (loadingStateSetter) {
            loadingStateSetter(LoadingState.Loading);
            promise.then(q => loadingStateSetter(LoadingState.Loaded));
            promise.catch(q => loadingStateSetter(LoadingState.Failed));
        }

        return promise;
    }

    /**
     * 
     * @param {EmailScheduleSource} [source] 
     * @param {number} [sourceId] 
     * @param {string} [sortColumn] 
     * @param {SortDirection} [sortDirection] 
     * @param {number} [take] 
     * @param {number} [skip] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MarketViewApi
     */
    public listEmailSchedules(loadingStateSetter: null | undefined | ((state: LoadingState) => void | undefined | null), source?: EmailScheduleSource, sourceId?: number, sortColumn?: string, sortDirection?: SortDirection, take?: number, skip?: number, options?: AxiosRequestConfig) {
        const promise = MarketViewApiFp(this.configuration).listEmailSchedules(source, sourceId, sortColumn, sortDirection, take, skip, options).then((request) => request(this.axios, this.basePath));

        if (loadingStateSetter) {
            loadingStateSetter(LoadingState.Loading);
            promise.then(q => loadingStateSetter(LoadingState.Loaded));
            promise.catch(q => loadingStateSetter(LoadingState.Failed));
        }

        return promise;
    }

    /**
     * 
     * @param {ListMarketViewContractPricesRequest} [listMarketViewContractPricesRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MarketViewApi
     */
    public listMarketViewContractPricesApi(loadingStateSetter: null | undefined | ((state: LoadingState) => void | undefined | null), listMarketViewContractPricesRequest?: ListMarketViewContractPricesRequest, options?: AxiosRequestConfig) {
        const promise = MarketViewApiFp(this.configuration).listMarketViewContractPricesApi(listMarketViewContractPricesRequest, options).then((request) => request(this.axios, this.basePath));

        if (loadingStateSetter) {
            loadingStateSetter(LoadingState.Loading);
            promise.then(q => loadingStateSetter(LoadingState.Loaded));
            promise.catch(q => loadingStateSetter(LoadingState.Failed));
        }

        return promise;
    }

    /**
     * 
     * @param {string} quoteDate 
     * @param {Array<Currency>} currencies 
     * @param {Array<ContractDate>} contractMonths 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MarketViewApi
     */
    public listMarketViewCurrencySpotRates(loadingStateSetter: null | undefined | ((state: LoadingState) => void | undefined | null), quoteDate: string, currencies: Array<Currency>, contractMonths: Array<ContractDate>, options?: AxiosRequestConfig) {
        const promise = MarketViewApiFp(this.configuration).listMarketViewCurrencySpotRates(quoteDate, currencies, contractMonths, options).then((request) => request(this.axios, this.basePath));

        if (loadingStateSetter) {
            loadingStateSetter(LoadingState.Loading);
            promise.then(q => loadingStateSetter(LoadingState.Loaded));
            promise.catch(q => loadingStateSetter(LoadingState.Failed));
        }

        return promise;
    }

    /**
     * 
     * @param {string} quoteDate 
     * @param {Array<Currency>} currencies 
     * @param {Array<ContractDate>} contractMonths 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MarketViewApi
     */
    public listMarketViewCurrencySpotRatesApi(loadingStateSetter: null | undefined | ((state: LoadingState) => void | undefined | null), quoteDate: string, currencies: Array<Currency>, contractMonths: Array<ContractDate>, options?: AxiosRequestConfig) {
        const promise = MarketViewApiFp(this.configuration).listMarketViewCurrencySpotRatesApi(quoteDate, currencies, contractMonths, options).then((request) => request(this.axios, this.basePath));

        if (loadingStateSetter) {
            loadingStateSetter(LoadingState.Loading);
            promise.then(q => loadingStateSetter(LoadingState.Loaded));
            promise.catch(q => loadingStateSetter(LoadingState.Failed));
        }

        return promise;
    }

    /**
     * 
     * @param {string} productId 
     * @param {string} [quoteDateRangeStart] 
     * @param {string} [quoteDateRangeEnd] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MarketViewApi
     */
    public listMarketViewDailyPrices(loadingStateSetter: null | undefined | ((state: LoadingState) => void | undefined | null), productId: string, quoteDateRangeStart?: string, quoteDateRangeEnd?: string, options?: AxiosRequestConfig) {
        const promise = MarketViewApiFp(this.configuration).listMarketViewDailyPrices(productId, quoteDateRangeStart, quoteDateRangeEnd, options).then((request) => request(this.axios, this.basePath));

        if (loadingStateSetter) {
            loadingStateSetter(LoadingState.Loading);
            promise.then(q => loadingStateSetter(LoadingState.Loaded));
            promise.catch(q => loadingStateSetter(LoadingState.Failed));
        }

        return promise;
    }

    /**
     * 
     * @param {Array<number>} productIds 
     * @param {boolean} [refreshCache] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MarketViewApi
     */
    public listMarketViewExpirationDates(loadingStateSetter: null | undefined | ((state: LoadingState) => void | undefined | null), productIds: Array<number>, refreshCache?: boolean, options?: AxiosRequestConfig) {
        const promise = MarketViewApiFp(this.configuration).listMarketViewExpirationDates(productIds, refreshCache, options).then((request) => request(this.axios, this.basePath));

        if (loadingStateSetter) {
            loadingStateSetter(LoadingState.Loading);
            promise.then(q => loadingStateSetter(LoadingState.Loaded));
            promise.catch(q => loadingStateSetter(LoadingState.Failed));
        }

        return promise;
    }

    /**
     * 
     * @param {Array<number>} productIds 
     * @param {boolean} [refreshCache] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MarketViewApi
     */
    public listMarketViewExpirationDatesApi(loadingStateSetter: null | undefined | ((state: LoadingState) => void | undefined | null), productIds: Array<number>, refreshCache?: boolean, options?: AxiosRequestConfig) {
        const promise = MarketViewApiFp(this.configuration).listMarketViewExpirationDatesApi(productIds, refreshCache, options).then((request) => request(this.axios, this.basePath));

        if (loadingStateSetter) {
            loadingStateSetter(LoadingState.Loading);
            promise.then(q => loadingStateSetter(LoadingState.Loaded));
            promise.catch(q => loadingStateSetter(LoadingState.Failed));
        }

        return promise;
    }

    /**
     * 
     * @param {string} productId 
     * @param {string} quoteDate 
     * @param {number} [numberOfMonths] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MarketViewApi
     */
    public listMarketViewForwardCurveQuery(loadingStateSetter: null | undefined | ((state: LoadingState) => void | undefined | null), productId: string, quoteDate: string, numberOfMonths?: number, options?: AxiosRequestConfig) {
        const promise = MarketViewApiFp(this.configuration).listMarketViewForwardCurveQuery(productId, quoteDate, numberOfMonths, options).then((request) => request(this.axios, this.basePath));

        if (loadingStateSetter) {
            loadingStateSetter(LoadingState.Loading);
            promise.then(q => loadingStateSetter(LoadingState.Loaded));
            promise.catch(q => loadingStateSetter(LoadingState.Failed));
        }

        return promise;
    }

    /**
     * 
     * @param {string} productId 
     * @param {string} quoteDate 
     * @param {number} [numberOfMonths] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MarketViewApi
     */
    public listMarketViewForwardCurveQueryApi(loadingStateSetter: null | undefined | ((state: LoadingState) => void | undefined | null), productId: string, quoteDate: string, numberOfMonths?: number, options?: AxiosRequestConfig) {
        const promise = MarketViewApiFp(this.configuration).listMarketViewForwardCurveQueryApi(productId, quoteDate, numberOfMonths, options).then((request) => request(this.axios, this.basePath));

        if (loadingStateSetter) {
            loadingStateSetter(LoadingState.Loading);
            promise.then(q => loadingStateSetter(LoadingState.Loaded));
            promise.catch(q => loadingStateSetter(LoadingState.Failed));
        }

        return promise;
    }

    /**
     * 
     * @param {Array<number>} symbolIds 
     * @param {string} [asOfDate] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MarketViewApi
     */
    public listMarketViewLastQuoteDate(loadingStateSetter: null | undefined | ((state: LoadingState) => void | undefined | null), symbolIds: Array<number>, asOfDate?: string, options?: AxiosRequestConfig) {
        const promise = MarketViewApiFp(this.configuration).listMarketViewLastQuoteDate(symbolIds, asOfDate, options).then((request) => request(this.axios, this.basePath));

        if (loadingStateSetter) {
            loadingStateSetter(LoadingState.Loading);
            promise.then(q => loadingStateSetter(LoadingState.Loaded));
            promise.catch(q => loadingStateSetter(LoadingState.Failed));
        }

        return promise;
    }

    /**
     * 
     * @param {Array<number>} symbolIds 
     * @param {string} [asOfDate] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MarketViewApi
     */
    public listMarketViewLastQuoteDateApi(loadingStateSetter: null | undefined | ((state: LoadingState) => void | undefined | null), symbolIds: Array<number>, asOfDate?: string, options?: AxiosRequestConfig) {
        const promise = MarketViewApiFp(this.configuration).listMarketViewLastQuoteDateApi(symbolIds, asOfDate, options).then((request) => request(this.axios, this.basePath));

        if (loadingStateSetter) {
            loadingStateSetter(LoadingState.Loading);
            promise.then(q => loadingStateSetter(LoadingState.Loaded));
            promise.catch(q => loadingStateSetter(LoadingState.Failed));
        }

        return promise;
    }

    /**
     * 
     * @param {string} productId 
     * @param {Array<number>} years 
     * @param {string} [quoteDateRangeStart] 
     * @param {string} [quoteDateRangeEnd] 
     * @param {number} [userVolumeId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MarketViewApi
     */
    public listMarketViewPriceQueryCalendarStripAvearge(loadingStateSetter: null | undefined | ((state: LoadingState) => void | undefined | null), productId: string, years: Array<number>, quoteDateRangeStart?: string, quoteDateRangeEnd?: string, userVolumeId?: number, options?: AxiosRequestConfig) {
        const promise = MarketViewApiFp(this.configuration).listMarketViewPriceQueryCalendarStripAvearge(productId, years, quoteDateRangeStart, quoteDateRangeEnd, userVolumeId, options).then((request) => request(this.axios, this.basePath));

        if (loadingStateSetter) {
            loadingStateSetter(LoadingState.Loading);
            promise.then(q => loadingStateSetter(LoadingState.Loaded));
            promise.catch(q => loadingStateSetter(LoadingState.Failed));
        }

        return promise;
    }

    /**
     * 
     * @param {string} productId 
     * @param {Array<number>} years 
     * @param {string} [quoteDateRangeStart] 
     * @param {string} [quoteDateRangeEnd] 
     * @param {number} [userVolumeId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MarketViewApi
     */
    public listMarketViewPriceQueryCalendarStripAverageApi(loadingStateSetter: null | undefined | ((state: LoadingState) => void | undefined | null), productId: string, years: Array<number>, quoteDateRangeStart?: string, quoteDateRangeEnd?: string, userVolumeId?: number, options?: AxiosRequestConfig) {
        const promise = MarketViewApiFp(this.configuration).listMarketViewPriceQueryCalendarStripAverageApi(productId, years, quoteDateRangeStart, quoteDateRangeEnd, userVolumeId, options).then((request) => request(this.axios, this.basePath));

        if (loadingStateSetter) {
            loadingStateSetter(LoadingState.Loading);
            promise.then(q => loadingStateSetter(LoadingState.Loaded));
            promise.catch(q => loadingStateSetter(LoadingState.Failed));
        }

        return promise;
    }

    /**
     * 
     * @param {string} productId 
     * @param {number} monthsAhead 
     * @param {string} [quoteDateRangeStart] 
     * @param {string} [quoteDateRangeEnd] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MarketViewApi
     */
    public listMarketViewPriceQueryRollingMonthAhead(loadingStateSetter: null | undefined | ((state: LoadingState) => void | undefined | null), productId: string, monthsAhead: number, quoteDateRangeStart?: string, quoteDateRangeEnd?: string, options?: AxiosRequestConfig) {
        const promise = MarketViewApiFp(this.configuration).listMarketViewPriceQueryRollingMonthAhead(productId, monthsAhead, quoteDateRangeStart, quoteDateRangeEnd, options).then((request) => request(this.axios, this.basePath));

        if (loadingStateSetter) {
            loadingStateSetter(LoadingState.Loading);
            promise.then(q => loadingStateSetter(LoadingState.Loaded));
            promise.catch(q => loadingStateSetter(LoadingState.Failed));
        }

        return promise;
    }

    /**
     * 
     * @param {string} productId 
     * @param {number} monthsAhead 
     * @param {string} [quoteDateRangeStart] 
     * @param {string} [quoteDateRangeEnd] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MarketViewApi
     */
    public listMarketViewPriceQueryRollingMonthAheadApi(loadingStateSetter: null | undefined | ((state: LoadingState) => void | undefined | null), productId: string, monthsAhead: number, quoteDateRangeStart?: string, quoteDateRangeEnd?: string, options?: AxiosRequestConfig) {
        const promise = MarketViewApiFp(this.configuration).listMarketViewPriceQueryRollingMonthAheadApi(productId, monthsAhead, quoteDateRangeStart, quoteDateRangeEnd, options).then((request) => request(this.axios, this.basePath));

        if (loadingStateSetter) {
            loadingStateSetter(LoadingState.Loading);
            promise.then(q => loadingStateSetter(LoadingState.Loaded));
            promise.catch(q => loadingStateSetter(LoadingState.Failed));
        }

        return promise;
    }

    /**
     * 
     * @param {string} productId 
     * @param {Array<number>} years 
     * @param {Array<number>} months 
     * @param {string} [quoteDateRangeStart] 
     * @param {string} [quoteDateRangeEnd] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MarketViewApi
     */
    public listMarketViewPrices(loadingStateSetter: null | undefined | ((state: LoadingState) => void | undefined | null), productId: string, years: Array<number>, months: Array<number>, quoteDateRangeStart?: string, quoteDateRangeEnd?: string, options?: AxiosRequestConfig) {
        const promise = MarketViewApiFp(this.configuration).listMarketViewPrices(productId, years, months, quoteDateRangeStart, quoteDateRangeEnd, options).then((request) => request(this.axios, this.basePath));

        if (loadingStateSetter) {
            loadingStateSetter(LoadingState.Loading);
            promise.then(q => loadingStateSetter(LoadingState.Loaded));
            promise.catch(q => loadingStateSetter(LoadingState.Failed));
        }

        return promise;
    }

    /**
     * 
     * @param {string} productId 
     * @param {Array<number>} years 
     * @param {Array<number>} months 
     * @param {string} [quoteDateRangeStart] 
     * @param {string} [quoteDateRangeEnd] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MarketViewApi
     */
    public listMarketViewPricesApi(loadingStateSetter: null | undefined | ((state: LoadingState) => void | undefined | null), productId: string, years: Array<number>, months: Array<number>, quoteDateRangeStart?: string, quoteDateRangeEnd?: string, options?: AxiosRequestConfig) {
        const promise = MarketViewApiFp(this.configuration).listMarketViewPricesApi(productId, years, months, quoteDateRangeStart, quoteDateRangeEnd, options).then((request) => request(this.axios, this.basePath));

        if (loadingStateSetter) {
            loadingStateSetter(LoadingState.Loading);
            promise.then(q => loadingStateSetter(LoadingState.Loaded));
            promise.catch(q => loadingStateSetter(LoadingState.Failed));
        }

        return promise;
    }

    /**
     * 
     * @param {string} symbolId 
     * @param {string} contractYear 
     * @param {string} contractMonth 
     * @param {string} [sortColumn] 
     * @param {SortDirection} [sortDirection] 
     * @param {number} [take] 
     * @param {number} [skip] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MarketViewApi
     */
    public listMarketViewPricesBySymbol(loadingStateSetter: null | undefined | ((state: LoadingState) => void | undefined | null), symbolId: string, contractYear: string, contractMonth: string, sortColumn?: string, sortDirection?: SortDirection, take?: number, skip?: number, options?: AxiosRequestConfig) {
        const promise = MarketViewApiFp(this.configuration).listMarketViewPricesBySymbol(symbolId, contractYear, contractMonth, sortColumn, sortDirection, take, skip, options).then((request) => request(this.axios, this.basePath));

        if (loadingStateSetter) {
            loadingStateSetter(LoadingState.Loading);
            promise.then(q => loadingStateSetter(LoadingState.Loaded));
            promise.catch(q => loadingStateSetter(LoadingState.Failed));
        }

        return promise;
    }

    /**
     * 
     * @param {string} symbolId 
     * @param {string} contractYear 
     * @param {string} contractMonth 
     * @param {string} [sortColumn] 
     * @param {SortDirection} [sortDirection] 
     * @param {number} [take] 
     * @param {number} [skip] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MarketViewApi
     */
    public listMarketViewPricesBySymbolApi(loadingStateSetter: null | undefined | ((state: LoadingState) => void | undefined | null), symbolId: string, contractYear: string, contractMonth: string, sortColumn?: string, sortDirection?: SortDirection, take?: number, skip?: number, options?: AxiosRequestConfig) {
        const promise = MarketViewApiFp(this.configuration).listMarketViewPricesBySymbolApi(symbolId, contractYear, contractMonth, sortColumn, sortDirection, take, skip, options).then((request) => request(this.axios, this.basePath));

        if (loadingStateSetter) {
            loadingStateSetter(LoadingState.Loading);
            promise.then(q => loadingStateSetter(LoadingState.Loaded));
            promise.catch(q => loadingStateSetter(LoadingState.Failed));
        }

        return promise;
    }

    /**
     * 
     * @param {string} productId 
     * @param {Array<number>} years 
     * @param {Array<number>} months 
     * @param {string} [quoteDateRangeStart] 
     * @param {string} [quoteDateRangeEnd] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MarketViewApi
     */
    public listMarketViewPricesInternal(loadingStateSetter: null | undefined | ((state: LoadingState) => void | undefined | null), productId: string, years: Array<number>, months: Array<number>, quoteDateRangeStart?: string, quoteDateRangeEnd?: string, options?: AxiosRequestConfig) {
        const promise = MarketViewApiFp(this.configuration).listMarketViewPricesInternal(productId, years, months, quoteDateRangeStart, quoteDateRangeEnd, options).then((request) => request(this.axios, this.basePath));

        if (loadingStateSetter) {
            loadingStateSetter(LoadingState.Loading);
            promise.then(q => loadingStateSetter(LoadingState.Loaded));
            promise.catch(q => loadingStateSetter(LoadingState.Failed));
        }

        return promise;
    }

    /**
     * 
     * @param {string} productId 
     * @param {string} [quoteDateRangeStart] 
     * @param {string} [quoteDateRangeEnd] 
     * @param {number} [contractDateRangeStartYear] 
     * @param {number} [contractDateRangeStartMonth] 
     * @param {number} [contractDateRangeEndYear] 
     * @param {number} [contractDateRangeEndMonth] 
     * @param {number} [contractDateRangeStartContractDateYear] 
     * @param {number} [contractDateRangeStartContractDateMonth] 
     * @param {string} [contractDateRangeStartContractDateLabel] 
     * @param {number} [contractDateRangeEndContractDateYear] 
     * @param {number} [contractDateRangeEndContractDateMonth] 
     * @param {string} [contractDateRangeEndContractDateLabel] 
     * @param {number} [userVolumeId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MarketViewApi
     */
    public listMarketViewPricesStripAverage(loadingStateSetter: null | undefined | ((state: LoadingState) => void | undefined | null), productId: string, quoteDateRangeStart?: string, quoteDateRangeEnd?: string, contractDateRangeStartYear?: number, contractDateRangeStartMonth?: number, contractDateRangeEndYear?: number, contractDateRangeEndMonth?: number, contractDateRangeStartContractDateYear?: number, contractDateRangeStartContractDateMonth?: number, contractDateRangeStartContractDateLabel?: string, contractDateRangeEndContractDateYear?: number, contractDateRangeEndContractDateMonth?: number, contractDateRangeEndContractDateLabel?: string, userVolumeId?: number, options?: AxiosRequestConfig) {
        const promise = MarketViewApiFp(this.configuration).listMarketViewPricesStripAverage(productId, quoteDateRangeStart, quoteDateRangeEnd, contractDateRangeStartYear, contractDateRangeStartMonth, contractDateRangeEndYear, contractDateRangeEndMonth, contractDateRangeStartContractDateYear, contractDateRangeStartContractDateMonth, contractDateRangeStartContractDateLabel, contractDateRangeEndContractDateYear, contractDateRangeEndContractDateMonth, contractDateRangeEndContractDateLabel, userVolumeId, options).then((request) => request(this.axios, this.basePath));

        if (loadingStateSetter) {
            loadingStateSetter(LoadingState.Loading);
            promise.then(q => loadingStateSetter(LoadingState.Loaded));
            promise.catch(q => loadingStateSetter(LoadingState.Failed));
        }

        return promise;
    }

    /**
     * 
     * @param {string} productId 
     * @param {string} [quoteDateRangeStart] 
     * @param {string} [quoteDateRangeEnd] 
     * @param {number} [contractDateRangeStartYear] 
     * @param {number} [contractDateRangeStartMonth] 
     * @param {number} [contractDateRangeEndYear] 
     * @param {number} [contractDateRangeEndMonth] 
     * @param {number} [contractDateRangeStartContractDateYear] 
     * @param {number} [contractDateRangeStartContractDateMonth] 
     * @param {string} [contractDateRangeStartContractDateLabel] 
     * @param {number} [contractDateRangeEndContractDateYear] 
     * @param {number} [contractDateRangeEndContractDateMonth] 
     * @param {string} [contractDateRangeEndContractDateLabel] 
     * @param {number} [userVolumeId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MarketViewApi
     */
    public listMarketViewPricesStripAverageApi(loadingStateSetter: null | undefined | ((state: LoadingState) => void | undefined | null), productId: string, quoteDateRangeStart?: string, quoteDateRangeEnd?: string, contractDateRangeStartYear?: number, contractDateRangeStartMonth?: number, contractDateRangeEndYear?: number, contractDateRangeEndMonth?: number, contractDateRangeStartContractDateYear?: number, contractDateRangeStartContractDateMonth?: number, contractDateRangeStartContractDateLabel?: string, contractDateRangeEndContractDateYear?: number, contractDateRangeEndContractDateMonth?: number, contractDateRangeEndContractDateLabel?: string, userVolumeId?: number, options?: AxiosRequestConfig) {
        const promise = MarketViewApiFp(this.configuration).listMarketViewPricesStripAverageApi(productId, quoteDateRangeStart, quoteDateRangeEnd, contractDateRangeStartYear, contractDateRangeStartMonth, contractDateRangeEndYear, contractDateRangeEndMonth, contractDateRangeStartContractDateYear, contractDateRangeStartContractDateMonth, contractDateRangeStartContractDateLabel, contractDateRangeEndContractDateYear, contractDateRangeEndContractDateMonth, contractDateRangeEndContractDateLabel, userVolumeId, options).then((request) => request(this.axios, this.basePath));

        if (loadingStateSetter) {
            loadingStateSetter(LoadingState.Loading);
            promise.then(q => loadingStateSetter(LoadingState.Loaded));
            promise.catch(q => loadingStateSetter(LoadingState.Failed));
        }

        return promise;
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MarketViewApi
     */
    public listMarketViewProductTypes(loadingStateSetter: null | undefined | ((state: LoadingState) => void | undefined | null), options?: AxiosRequestConfig) {
        const promise = MarketViewApiFp(this.configuration).listMarketViewProductTypes(options).then((request) => request(this.axios, this.basePath));

        if (loadingStateSetter) {
            loadingStateSetter(LoadingState.Loading);
            promise.then(q => loadingStateSetter(LoadingState.Loaded));
            promise.catch(q => loadingStateSetter(LoadingState.Failed));
        }

        return promise;
    }

    /**
     * 
     * @param {CommodityType} [commodityType] 
     * @param {Array<number>} [productIds] 
     * @param {number} [minimumHistoryYears] 
     * @param {number} [lastQuoteDateThresholdDays] 
     * @param {boolean} [refreshCache] 
     * @param {string} [sortColumn] 
     * @param {SortDirection} [sortDirection] 
     * @param {number} [take] 
     * @param {number} [skip] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MarketViewApi
     */
    public listMarketViewProducts(loadingStateSetter: null | undefined | ((state: LoadingState) => void | undefined | null), commodityType?: CommodityType, productIds?: Array<number>, minimumHistoryYears?: number, lastQuoteDateThresholdDays?: number, refreshCache?: boolean, sortColumn?: string, sortDirection?: SortDirection, take?: number, skip?: number, options?: AxiosRequestConfig) {
        const promise = MarketViewApiFp(this.configuration).listMarketViewProducts(commodityType, productIds, minimumHistoryYears, lastQuoteDateThresholdDays, refreshCache, sortColumn, sortDirection, take, skip, options).then((request) => request(this.axios, this.basePath));

        if (loadingStateSetter) {
            loadingStateSetter(LoadingState.Loading);
            promise.then(q => loadingStateSetter(LoadingState.Loaded));
            promise.catch(q => loadingStateSetter(LoadingState.Failed));
        }

        return promise;
    }

    /**
     * 
     * @param {CommodityType} [commodityType] 
     * @param {PriceType} [priceType] 
     * @param {Array<number>} [productIds] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MarketViewApi
     */
    public listMarketViewProductsInternal(loadingStateSetter: null | undefined | ((state: LoadingState) => void | undefined | null), commodityType?: CommodityType, priceType?: PriceType, productIds?: Array<number>, options?: AxiosRequestConfig) {
        const promise = MarketViewApiFp(this.configuration).listMarketViewProductsInternal(commodityType, priceType, productIds, options).then((request) => request(this.axios, this.basePath));

        if (loadingStateSetter) {
            loadingStateSetter(LoadingState.Loading);
            promise.then(q => loadingStateSetter(LoadingState.Loaded));
            promise.catch(q => loadingStateSetter(LoadingState.Failed));
        }

        return promise;
    }

    /**
     * 
     * @param {string} [sortColumn] 
     * @param {SortDirection} [sortDirection] 
     * @param {number} [take] 
     * @param {number} [skip] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MarketViewApi
     */
    public listMarketViewSavedQuery(loadingStateSetter: null | undefined | ((state: LoadingState) => void | undefined | null), sortColumn?: string, sortDirection?: SortDirection, take?: number, skip?: number, options?: AxiosRequestConfig) {
        const promise = MarketViewApiFp(this.configuration).listMarketViewSavedQuery(sortColumn, sortDirection, take, skip, options).then((request) => request(this.axios, this.basePath));

        if (loadingStateSetter) {
            loadingStateSetter(LoadingState.Loading);
            promise.then(q => loadingStateSetter(LoadingState.Loaded));
            promise.catch(q => loadingStateSetter(LoadingState.Failed));
        }

        return promise;
    }

    /**
     * 
     * @param {string} productId 
     * @param {string} [quoteDateRangeStart] 
     * @param {string} [quoteDateRangeEnd] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MarketViewApi
     */
    public listMarketViewSettlementPrices(loadingStateSetter: null | undefined | ((state: LoadingState) => void | undefined | null), productId: string, quoteDateRangeStart?: string, quoteDateRangeEnd?: string, options?: AxiosRequestConfig) {
        const promise = MarketViewApiFp(this.configuration).listMarketViewSettlementPrices(productId, quoteDateRangeStart, quoteDateRangeEnd, options).then((request) => request(this.axios, this.basePath));

        if (loadingStateSetter) {
            loadingStateSetter(LoadingState.Loading);
            promise.then(q => loadingStateSetter(LoadingState.Loaded));
            promise.catch(q => loadingStateSetter(LoadingState.Failed));
        }

        return promise;
    }

    /**
     * 
     * @param {string} productId 
     * @param {string} [quoteDateRangeStart] 
     * @param {string} [quoteDateRangeEnd] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MarketViewApi
     */
    public listMarketViewSettlementPricesApi(loadingStateSetter: null | undefined | ((state: LoadingState) => void | undefined | null), productId: string, quoteDateRangeStart?: string, quoteDateRangeEnd?: string, options?: AxiosRequestConfig) {
        const promise = MarketViewApiFp(this.configuration).listMarketViewSettlementPricesApi(productId, quoteDateRangeStart, quoteDateRangeEnd, options).then((request) => request(this.axios, this.basePath));

        if (loadingStateSetter) {
            loadingStateSetter(LoadingState.Loading);
            promise.then(q => loadingStateSetter(LoadingState.Loaded));
            promise.catch(q => loadingStateSetter(LoadingState.Failed));
        }

        return promise;
    }

    /**
     * 
     * @param {Array<string>} [marketViewUserGuids] 
     * @param {string} [companyGuid] 
     * @param {boolean} [includeSites] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MarketViewApi
     */
    public listMarketViewUsers(loadingStateSetter: null | undefined | ((state: LoadingState) => void | undefined | null), marketViewUserGuids?: Array<string>, companyGuid?: string, includeSites?: boolean, options?: AxiosRequestConfig) {
        const promise = MarketViewApiFp(this.configuration).listMarketViewUsers(marketViewUserGuids, companyGuid, includeSites, options).then((request) => request(this.axios, this.basePath));

        if (loadingStateSetter) {
            loadingStateSetter(LoadingState.Loading);
            promise.then(q => loadingStateSetter(LoadingState.Loaded));
            promise.catch(q => loadingStateSetter(LoadingState.Failed));
        }

        return promise;
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MarketViewApi
     */
    public listMarketViewVolumes(loadingStateSetter: null | undefined | ((state: LoadingState) => void | undefined | null), options?: AxiosRequestConfig) {
        const promise = MarketViewApiFp(this.configuration).listMarketViewVolumes(options).then((request) => request(this.axios, this.basePath));

        if (loadingStateSetter) {
            loadingStateSetter(LoadingState.Loading);
            promise.then(q => loadingStateSetter(LoadingState.Loaded));
            promise.catch(q => loadingStateSetter(LoadingState.Failed));
        }

        return promise;
    }

    /**
     * 
     * @param {string} productId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MarketViewApi
     */
    public marketViewProductTradingMonths(loadingStateSetter: null | undefined | ((state: LoadingState) => void | undefined | null), productId: string, options?: AxiosRequestConfig) {
        const promise = MarketViewApiFp(this.configuration).marketViewProductTradingMonths(productId, options).then((request) => request(this.axios, this.basePath));

        if (loadingStateSetter) {
            loadingStateSetter(LoadingState.Loading);
            promise.then(q => loadingStateSetter(LoadingState.Loaded));
            promise.catch(q => loadingStateSetter(LoadingState.Failed));
        }

        return promise;
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MarketViewApi
     */
    public marketViewUserAuthorizationCallback(loadingStateSetter: null | undefined | ((state: LoadingState) => void | undefined | null), options?: AxiosRequestConfig) {
        const promise = MarketViewApiFp(this.configuration).marketViewUserAuthorizationCallback(options).then((request) => request(this.axios, this.basePath));

        if (loadingStateSetter) {
            loadingStateSetter(LoadingState.Loading);
            promise.then(q => loadingStateSetter(LoadingState.Loaded));
            promise.catch(q => loadingStateSetter(LoadingState.Failed));
        }

        return promise;
    }

    /**
     * 
     * @param {string} emailScheduleId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MarketViewApi
     */
    public sendEmailScheduleNow(loadingStateSetter: null | undefined | ((state: LoadingState) => void | undefined | null), emailScheduleId: string, options?: AxiosRequestConfig) {
        const promise = MarketViewApiFp(this.configuration).sendEmailScheduleNow(emailScheduleId, options).then((request) => request(this.axios, this.basePath));

        if (loadingStateSetter) {
            loadingStateSetter(LoadingState.Loading);
            promise.then(q => loadingStateSetter(LoadingState.Loaded));
            promise.catch(q => loadingStateSetter(LoadingState.Failed));
        }

        return promise;
    }

    /**
     * 
     * @param {string} savedQueryId 
     * @param {SendMarketViewSavedQueryEmailRequest} [sendMarketViewSavedQueryEmailRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MarketViewApi
     */
    public sendMarketViewSavedQueryEmail(loadingStateSetter: null | undefined | ((state: LoadingState) => void | undefined | null), savedQueryId: string, sendMarketViewSavedQueryEmailRequest?: SendMarketViewSavedQueryEmailRequest, options?: AxiosRequestConfig) {
        const promise = MarketViewApiFp(this.configuration).sendMarketViewSavedQueryEmail(savedQueryId, sendMarketViewSavedQueryEmailRequest, options).then((request) => request(this.axios, this.basePath));

        if (loadingStateSetter) {
            loadingStateSetter(LoadingState.Loading);
            promise.then(q => loadingStateSetter(LoadingState.Loaded));
            promise.catch(q => loadingStateSetter(LoadingState.Failed));
        }

        return promise;
    }

    /**
     * 
     * @param {string} siteGuid 
     * @param {string} siteName 
     * @param {string} companyGuid 
     * @param {Array<UserAccessUpdateModel>} userSiteAccesses 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MarketViewApi
     */
    public updateCommodityManagementSite(loadingStateSetter: null | undefined | ((state: LoadingState) => void | undefined | null), siteGuid: string, siteName: string, companyGuid: string, userSiteAccesses: Array<UserAccessUpdateModel>, options?: AxiosRequestConfig) {
        const promise = MarketViewApiFp(this.configuration).updateCommodityManagementSite(siteGuid, siteName, companyGuid, userSiteAccesses, options).then((request) => request(this.axios, this.basePath));

        if (loadingStateSetter) {
            loadingStateSetter(LoadingState.Loading);
            promise.then(q => loadingStateSetter(LoadingState.Loaded));
            promise.catch(q => loadingStateSetter(LoadingState.Failed));
        }

        return promise;
    }

    /**
     * 
     * @param {string} siteGuid 
     * @param {string} marketViewUserGuid 
     * @param {boolean} [isSiteManager] 
     * @param {Array<CommodityManagementUserPermissions>} [permissions] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MarketViewApi
     */
    public updateCommodityManagementUserSiteAccess(loadingStateSetter: null | undefined | ((state: LoadingState) => void | undefined | null), siteGuid: string, marketViewUserGuid: string, isSiteManager?: boolean, permissions?: Array<CommodityManagementUserPermissions>, options?: AxiosRequestConfig) {
        const promise = MarketViewApiFp(this.configuration).updateCommodityManagementUserSiteAccess(siteGuid, marketViewUserGuid, isSiteManager, permissions, options).then((request) => request(this.axios, this.basePath));

        if (loadingStateSetter) {
            loadingStateSetter(LoadingState.Loading);
            promise.then(q => loadingStateSetter(LoadingState.Loaded));
            promise.catch(q => loadingStateSetter(LoadingState.Failed));
        }

        return promise;
    }

    /**
     * 
     * @param {string} companyGuid 
     * @param {UpdateCompanyRequest} [updateCompanyRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MarketViewApi
     */
    public updateCompany(loadingStateSetter: null | undefined | ((state: LoadingState) => void | undefined | null), companyGuid: string, updateCompanyRequest?: UpdateCompanyRequest, options?: AxiosRequestConfig) {
        const promise = MarketViewApiFp(this.configuration).updateCompany(companyGuid, updateCompanyRequest, options).then((request) => request(this.axios, this.basePath));

        if (loadingStateSetter) {
            loadingStateSetter(LoadingState.Loading);
            promise.then(q => loadingStateSetter(LoadingState.Loaded));
            promise.catch(q => loadingStateSetter(LoadingState.Failed));
        }

        return promise;
    }

    /**
     * 
     * @param {string} companyGuid 
     * @param {boolean} isEnabled 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MarketViewApi
     */
    public updateCompanyEnabled(loadingStateSetter: null | undefined | ((state: LoadingState) => void | undefined | null), companyGuid: string, isEnabled: boolean, options?: AxiosRequestConfig) {
        const promise = MarketViewApiFp(this.configuration).updateCompanyEnabled(companyGuid, isEnabled, options).then((request) => request(this.axios, this.basePath));

        if (loadingStateSetter) {
            loadingStateSetter(LoadingState.Loading);
            promise.then(q => loadingStateSetter(LoadingState.Loaded));
            promise.catch(q => loadingStateSetter(LoadingState.Failed));
        }

        return promise;
    }

    /**
     * 
     * @param {string} marketViewUserGuid 
     * @param {UpdateMarketViewUserRequest} [updateMarketViewUserRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MarketViewApi
     */
    public updateMarketViewUser(loadingStateSetter: null | undefined | ((state: LoadingState) => void | undefined | null), marketViewUserGuid: string, updateMarketViewUserRequest?: UpdateMarketViewUserRequest, options?: AxiosRequestConfig) {
        const promise = MarketViewApiFp(this.configuration).updateMarketViewUser(marketViewUserGuid, updateMarketViewUserRequest, options).then((request) => request(this.axios, this.basePath));

        if (loadingStateSetter) {
            loadingStateSetter(LoadingState.Loading);
            promise.then(q => loadingStateSetter(LoadingState.Loaded));
            promise.catch(q => loadingStateSetter(LoadingState.Failed));
        }

        return promise;
    }

    /**
     * 
     * @param {string} marketViewUserGuid 
     * @param {boolean} isEnabled 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MarketViewApi
     */
    public updateMarketViewUserEnabled(loadingStateSetter: null | undefined | ((state: LoadingState) => void | undefined | null), marketViewUserGuid: string, isEnabled: boolean, options?: AxiosRequestConfig) {
        const promise = MarketViewApiFp(this.configuration).updateMarketViewUserEnabled(marketViewUserGuid, isEnabled, options).then((request) => request(this.axios, this.basePath));

        if (loadingStateSetter) {
            loadingStateSetter(LoadingState.Loading);
            promise.then(q => loadingStateSetter(LoadingState.Loaded));
            promise.catch(q => loadingStateSetter(LoadingState.Failed));
        }

        return promise;
    }

    /**
     * 
     * @param {UpsertEmailScheduleRequest} [upsertEmailScheduleRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MarketViewApi
     */
    public upsertEmailSchedule(loadingStateSetter: null | undefined | ((state: LoadingState) => void | undefined | null), upsertEmailScheduleRequest?: UpsertEmailScheduleRequest, options?: AxiosRequestConfig) {
        const promise = MarketViewApiFp(this.configuration).upsertEmailSchedule(upsertEmailScheduleRequest, options).then((request) => request(this.axios, this.basePath));

        if (loadingStateSetter) {
            loadingStateSetter(LoadingState.Loading);
            promise.then(q => loadingStateSetter(LoadingState.Loaded));
            promise.catch(q => loadingStateSetter(LoadingState.Failed));
        }

        return promise;
    }
}


